function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) {
      n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t["default"];
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 365);
}([function (t, e) {
  t.exports = require("react");
}, function (t, e, n) {
  t.exports = n(74)();
}, function (t, e, n) {
  t.exports = n(154)();
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0;
  var r,
      o = n(117),
      i = (r = o) && r.__esModule ? r : {
    "default": r
  };

  e["default"] = i["default"] || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  };
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0;
  var r,
      o = n(31),
      i = (r = o) && r.__esModule ? r : {
    "default": r
  };

  e["default"] = function (t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" !== (void 0 === e ? "undefined" : (0, i["default"])(e)) && "function" != typeof e ? t : e;
  };
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0, e["default"] = function (t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  };
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0;
  var r = a(n(144)),
      o = a(n(148)),
      i = a(n(31));

  function a(t) {
    return t && t.__esModule ? t : {
      "default": t
    };
  }

  e["default"] = function (t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + (void 0 === e ? "undefined" : (0, i["default"])(e)));
    t.prototype = (0, o["default"])(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (r["default"] ? (0, r["default"])(t, e) : t.__proto__ = e);
  };
}, function (t, e, n) {
  t.exports = n(203)();
}, function (t, e) {
  t.exports = require("react-dom");
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0;
  var r,
      o = n(85),
      i = (r = o) && r.__esModule ? r : {
    "default": r
  };

  e["default"] = function (t, e, n) {
    return e in t ? (0, i["default"])(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  };
}, function (t, e, n) {
  t.exports = n(163)();
}, function (t, e, n) {
  var r;
  !function () {
    "use strict";

    var n = {}.hasOwnProperty;

    function o() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        var r = arguments[e];

        if (r) {
          var i = _typeof(r);

          if ("string" === i || "number" === i) t.push(r);else if (Array.isArray(r) && r.length) {
            var a = o.apply(null, r);
            a && t.push(a);
          } else if ("object" === i) for (var s in r) {
            n.call(r, s) && r[s] && t.push(s);
          }
        }
      }

      return t.join(" ");
    }

    void 0 !== t && t.exports ? (o["default"] = o, t.exports = o) : void 0 === (r = function () {
      return o;
    }.apply(e, [])) || (t.exports = r);
  }();
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0;
  var r,
      o = n(85),
      i = (r = o) && r.__esModule ? r : {
    "default": r
  };

  e["default"] = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), (0, i["default"])(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();
}, function (t, e, n) {
  t.exports = n(165)();
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  e["default"] = function (t, e, n) {
    var r = Object.keys(e),
        o = n && n.handleMissingStyleName || "throw";
    return t.split(" ").filter(function (t) {
      return t;
    }).map(function (t) {
      if (function (t) {
        return -1 !== t.indexOf(".");
      }(t)) return function (t, e, n) {
        var r = t.split("."),
            o = r[0],
            i = r[1],
            a = n || "throw";

        if (!i) {
          if ("throw" === a) throw new Error("Invalid style name: " + t);
          if ("warn" !== a) return null;
        }

        if (!e[o]) {
          if ("throw" === a) throw new Error("CSS module import does not exist: " + o);
          if ("warn" !== a) return null;
        }

        if (!e[o][i]) {
          if ("throw" === a) throw new Error("CSS module does not exist: " + i);
          if ("warn" !== a) return null;
        }

        return e[o][i];
      }(t, e, o);
      if (0 === r.length) throw new Error("Cannot use styleName attribute for style name '" + t + "' without importing at least one stylesheet.");
      if (r.length > 1) throw new Error("Cannot use anonymous style name '" + t + "' with more than one stylesheet import.");
      var n = e[r[0]];
      if (!n[t] && "throw" === o) throw new Error("Could not resolve the styleName '" + t + "'.");
      return n[t];
    }).filter(function (t) {
      return t;
    }).join(" ");
  };
}, function (t, e, n) {
  "use strict";

  n.d(e, "a", function () {
    return s;
  });
  var r = n(95),
      o = n.n(r),
      i = n(8),
      a = n.n(i);

  function s(t, e, n) {
    var r = a.a.unstable_batchedUpdates ? function (t) {
      a.a.unstable_batchedUpdates(n, t);
    } : n;
    return o()(t, e, r);
  }
}, function (t, e) {
  var n = t.exports = {
    version: "2.5.3"
  };
  "number" == typeof __e && (__e = n);
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0, e["default"] = function (t, e) {
    var n = {};

    for (var r in t) {
      e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }

    return n;
  };
}, function (t, e, n) {
  "use strict";

  n.r(e);
  var r = n(14),
      o = n.n(r),
      i = n(0),
      a = n.n(i),
      s = n(1),
      c = n.n(s),
      u = n(11),
      l = n.n(u),
      f = (n(114), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }()),
      p = {
    "./styles.scss": {
      "c-icon": "vizzuality__c-icon",
      "-tiny": "vizzuality__-tiny",
      "-smaller": "vizzuality__-smaller",
      "-small": "vizzuality__-small",
      "-medium": "vizzuality__-medium",
      "-big": "vizzuality__-big",
      "-huge": "vizzuality__-huge",
      "-star": "vizzuality__-star"
    }
  };

  var h = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, a.a.PureComponent), f(e, [{
      key: "render",
      value: function value() {
        var t,
            e,
            n,
            r = this.props,
            i = r.name,
            s = r.className,
            c = r.style,
            u = l()((n = !!s, (e = s) in (t = {}) ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t));
        return a.a.createElement("svg", {
          style: c,
          className: o()("c-icon " + u, p)
        }, a.a.createElement("use", {
          xlinkHref: "#" + i
        }));
      }
    }]), e;
  }();

  h.propTypes = {
    name: c.a.string,
    className: c.a.string,
    style: c.a.object
  }, h.defaultProps = {
    name: "",
    className: "",
    style: {}
  }, e["default"] = h;
}, function (t, e, n) {
  var r = n(57)("wks"),
      o = n(45),
      i = n(22).Symbol,
      a = "function" == typeof i;
  (t.exports = function (t) {
    return r[t] || (r[t] = a && i[t] || (a ? i : o)("Symbol." + t));
  }).store = r;
}, function (t, e, n) {
  t.exports = n(159)();
}, function (t, e, n) {
  var r;
  !function () {
    "use strict";

    var n = {}.hasOwnProperty;

    function o() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        var r = arguments[e];

        if (r) {
          var i = _typeof(r);

          if ("string" === i || "number" === i) t.push(r);else if (Array.isArray(r)) t.push(o.apply(null, r));else if ("object" === i) for (var a in r) {
            n.call(r, a) && r[a] && t.push(a);
          }
        }
      }

      return t.join(" ");
    }

    void 0 !== t && t.exports ? t.exports = o : void 0 === (r = function () {
      return o;
    }.apply(e, [])) || (t.exports = r);
  }();
}, function (t, e) {
  var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
  "number" == typeof __g && (__g = n);
}, function (t, e, n) {
  var r = n(32),
      o = n(78),
      i = n(53),
      a = Object.defineProperty;
  e.f = n(26) ? Object.defineProperty : function (t, e, n) {
    if (r(t), e = i(e, !0), r(n), o) try {
      return a(t, e, n);
    } catch (t) {}
    if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
    return "value" in n && (t[e] = n.value), t;
  };
}, function (t, e, n) {
  "use strict";

  n.r(e), n.d(e, "Tooltip", function () {
    return l;
  });
  var r = n(0),
      o = n.n(r),
      i = n(1),
      a = n.n(i),
      s = n(94),
      c = n.n(s),
      u = (n(168), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }());

  var l = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, o.a.PureComponent), u(e, [{
      key: "render",
      value: function value() {
        var t = this.props.children;
        return o.a.createElement(c.a, this.props, t);
      }
    }]), e;
  }();

  l.propTypes = {
    children: a.a.node
  }, l.defaultProps = {
    children: []
  }, e["default"] = l;
}, function (t, e, n) {
  var r = n(22),
      o = n(16),
      i = n(68),
      a = n(29),
      s = function s(t, e, n) {
    var c,
        u,
        l,
        f = t & s.F,
        p = t & s.G,
        h = t & s.S,
        d = t & s.P,
        v = t & s.B,
        y = t & s.W,
        m = p ? o : o[e] || (o[e] = {}),
        g = m.prototype,
        b = p ? r : h ? r[e] : (r[e] || {}).prototype;

    for (c in p && (n = e), n) {
      (u = !f && b && void 0 !== b[c]) && c in m || (l = u ? b[c] : n[c], m[c] = p && "function" != typeof b[c] ? n[c] : v && u ? i(l, r) : y && b[c] == l ? function (t) {
        var e = function e(_e2, n, r) {
          if (this instanceof t) {
            switch (arguments.length) {
              case 0:
                return new t();

              case 1:
                return new t(_e2);

              case 2:
                return new t(_e2, n);
            }

            return new t(_e2, n, r);
          }

          return t.apply(this, arguments);
        };

        return e.prototype = t.prototype, e;
      }(l) : d && "function" == typeof l ? i(Function.call, l) : l, d && ((m.virtual || (m.virtual = {}))[c] = l, t & s.R && g && !g[c] && a(g, c, l)));
    }
  };

  s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, t.exports = s;
}, function (t, e, n) {
  t.exports = !n(33)(function () {
    return 7 != Object.defineProperty({}, "a", {
      get: function get() {
        return 7;
      }
    }).a;
  });
}, function (t, e) {
  var n = {}.hasOwnProperty;

  t.exports = function (t, e) {
    return n.call(t, e);
  };
}, function (t, e, n) {
  var r = n(81),
      o = n(54);

  t.exports = function (t) {
    return r(o(t));
  };
}, function (t, e, n) {
  var r = n(23),
      o = n(38);
  t.exports = n(26) ? function (t, e, n) {
    return r.f(t, e, o(1, n));
  } : function (t, e, n) {
    return t[e] = n, t;
  };
}, function (t, e) {
  t.exports = function (t) {
    return "object" == _typeof(t) ? null !== t : "function" == typeof t;
  };
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0;
  var r = a(n(124)),
      o = a(n(134)),
      i = "function" == typeof o["default"] && "symbol" == _typeof(r["default"]) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof o["default"] && t.constructor === o["default"] && t !== o["default"].prototype ? "symbol" : _typeof(t);
  };

  function a(t) {
    return t && t.__esModule ? t : {
      "default": t
    };
  }

  e["default"] = "function" == typeof o["default"] && "symbol" === i(r["default"]) ? function (t) {
    return void 0 === t ? "undefined" : i(t);
  } : function (t) {
    return t && "function" == typeof o["default"] && t.constructor === o["default"] && t !== o["default"].prototype ? "symbol" : void 0 === t ? "undefined" : i(t);
  };
}, function (t, e, n) {
  var r = n(30);

  t.exports = function (t) {
    if (!r(t)) throw TypeError(t + " is not an object!");
    return t;
  };
}, function (t, e) {
  t.exports = function (t) {
    try {
      return !!t();
    } catch (t) {
      return !0;
    }
  };
}, function (t, e, n) {
  "use strict";

  function r(t) {
    return function () {
      return t;
    };
  }

  var o = function o() {};

  o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
    return this;
  }, o.thatReturnsArgument = function (t) {
    return t;
  }, t.exports = o;
}, function (t, e, n) {
  "use strict";

  var r = function r(t) {};

  t.exports = function (t, e, n, o, i, a, s, c) {
    if (r(e), !t) {
      var u;
      if (void 0 === e) u = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
        var l = [n, o, i, a, s, c],
            f = 0;
        (u = new Error(e.replace(/%s/g, function () {
          return l[f++];
        }))).name = "Invariant Violation";
      }
      throw u.framesToPop = 1, u;
    }
  };
}, function (t, e, n) {
  var r = n(102),
      o = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
      i = r || o || Function("return this")();
  t.exports = i;
}, function (t, e, n) {
  (function (e, n, r) {
    t.exports = function () {
      var t, o, i;
      return function t(e, n, r) {
        function o(a, s) {
          if (!n[a]) {
            if (!e[a]) {
              var c = "function" == typeof _dereq_ && _dereq_;
              if (!s && c) return c(a, !0);
              if (i) return i(a, !0);
              var u = new Error("Cannot find module '" + a + "'");
              throw u.code = "MODULE_NOT_FOUND", u;
            }

            var l = n[a] = {
              exports: {}
            };
            e[a][0].call(l.exports, function (t) {
              var n = e[a][1][t];
              return o(n || t);
            }, l, l.exports, t, e, n, r);
          }

          return n[a].exports;
        }

        for (var i = "function" == typeof _dereq_ && _dereq_, a = 0; a < r.length; a++) {
          o(r[a]);
        }

        return o;
      }({
        1: [function (t, e, n) {
          "use strict";

          e.exports = function (t) {
            var e = t._SomePromiseArray;

            function n(t) {
              var n = new e(t),
                  r = n.promise();
              return n.setHowMany(1), n.setUnwrap(), n.init(), r;
            }

            t.any = function (t) {
              return n(t);
            }, t.prototype.any = function () {
              return n(this);
            };
          };
        }, {}],
        2: [function (t, n, r) {
          "use strict";

          var o;

          try {
            throw new Error();
          } catch (t) {
            o = t;
          }

          var i = t("./schedule"),
              a = t("./queue"),
              s = t("./util");

          function c() {
            this._customScheduler = !1, this._isTickUsed = !1, this._lateQueue = new a(16), this._normalQueue = new a(16), this._haveDrainedQueues = !1, this._trampolineEnabled = !0;
            var t = this;
            this.drainQueues = function () {
              t._drainQueues();
            }, this._schedule = i;
          }

          function u(t, e, n) {
            this._lateQueue.push(t, e, n), this._queueTick();
          }

          function l(t, e, n) {
            this._normalQueue.push(t, e, n), this._queueTick();
          }

          function f(t) {
            this._normalQueue._pushOne(t), this._queueTick();
          }

          function p(t) {
            for (; t.length() > 0;) {
              h(t);
            }
          }

          function h(t) {
            var e = t.shift();
            if ("function" != typeof e) e._settlePromises();else {
              var n = t.shift(),
                  r = t.shift();
              e.call(n, r);
            }
          }

          c.prototype.setScheduler = function (t) {
            var e = this._schedule;
            return this._schedule = t, this._customScheduler = !0, e;
          }, c.prototype.hasCustomScheduler = function () {
            return this._customScheduler;
          }, c.prototype.enableTrampoline = function () {
            this._trampolineEnabled = !0;
          }, c.prototype.disableTrampolineIfNecessary = function () {
            s.hasDevTools && (this._trampolineEnabled = !1);
          }, c.prototype.haveItemsQueued = function () {
            return this._isTickUsed || this._haveDrainedQueues;
          }, c.prototype.fatalError = function (t, n) {
            n ? (e.stderr.write("Fatal " + (t instanceof Error ? t.stack : t) + "\n"), e.exit(2)) : this.throwLater(t);
          }, c.prototype.throwLater = function (t, e) {
            if (1 === arguments.length && (e = t, t = function t() {
              throw e;
            }), "undefined" != typeof setTimeout) setTimeout(function () {
              t(e);
            }, 0);else try {
              this._schedule(function () {
                t(e);
              });
            } catch (t) {
              throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
            }
          }, s.hasDevTools ? (c.prototype.invokeLater = function (t, e, n) {
            this._trampolineEnabled ? u.call(this, t, e, n) : this._schedule(function () {
              setTimeout(function () {
                t.call(e, n);
              }, 100);
            });
          }, c.prototype.invoke = function (t, e, n) {
            this._trampolineEnabled ? l.call(this, t, e, n) : this._schedule(function () {
              t.call(e, n);
            });
          }, c.prototype.settlePromises = function (t) {
            this._trampolineEnabled ? f.call(this, t) : this._schedule(function () {
              t._settlePromises();
            });
          }) : (c.prototype.invokeLater = u, c.prototype.invoke = l, c.prototype.settlePromises = f), c.prototype._drainQueues = function () {
            p(this._normalQueue), this._reset(), this._haveDrainedQueues = !0, p(this._lateQueue);
          }, c.prototype._queueTick = function () {
            this._isTickUsed || (this._isTickUsed = !0, this._schedule(this.drainQueues));
          }, c.prototype._reset = function () {
            this._isTickUsed = !1;
          }, n.exports = c, n.exports.firstLineError = o;
        }, {
          "./queue": 26,
          "./schedule": 29,
          "./util": 36
        }],
        3: [function (t, e, n) {
          "use strict";

          e.exports = function (t, e, n, r) {
            var o = !1,
                i = function i(t, e) {
              this._reject(e);
            },
                a = function a(t, e) {
              e.promiseRejectionQueued = !0, e.bindingPromise._then(i, i, null, this, t);
            },
                s = function s(t, e) {
              0 == (50397184 & this._bitField) && this._resolveCallback(e.target);
            },
                c = function c(t, e) {
              e.promiseRejectionQueued || this._reject(t);
            };

            t.prototype.bind = function (i) {
              o || (o = !0, t.prototype._propagateFrom = r.propagateFromFunction(), t.prototype._boundValue = r.boundValueFunction());
              var u = n(i),
                  l = new t(e);

              l._propagateFrom(this, 1);

              var f = this._target();

              if (l._setBoundTo(u), u instanceof t) {
                var p = {
                  promiseRejectionQueued: !1,
                  promise: l,
                  target: f,
                  bindingPromise: u
                };
                f._then(e, a, void 0, l, p), u._then(s, c, void 0, l, p), l._setOnCancel(u);
              } else l._resolveCallback(f);

              return l;
            }, t.prototype._setBoundTo = function (t) {
              void 0 !== t ? (this._bitField = 2097152 | this._bitField, this._boundTo = t) : this._bitField = -2097153 & this._bitField;
            }, t.prototype._isBound = function () {
              return 2097152 == (2097152 & this._bitField);
            }, t.bind = function (e, n) {
              return t.resolve(n).bind(e);
            };
          };
        }, {}],
        4: [function (t, e, n) {
          "use strict";

          var r;
          "undefined" != typeof Promise && (r = Promise);
          var o = t("./promise")();
          o.noConflict = function () {
            try {
              Promise === o && (Promise = r);
            } catch (t) {}

            return o;
          }, e.exports = o;
        }, {
          "./promise": 22
        }],
        5: [function (t, e, n) {
          "use strict";

          var r = Object.create;

          if (r) {
            var o = r(null),
                i = r(null);
            o[" size"] = i[" size"] = 0;
          }

          e.exports = function (e) {
            var n = t("./util"),
                r = n.canEvaluate;

            function o(t) {
              var r = this.pop(),
                  o = function (t, r) {
                var o;

                if (null != t && (o = t[r]), "function" != typeof o) {
                  var i = "Object " + n.classString(t) + " has no method '" + n.toString(r) + "'";
                  throw new e.TypeError(i);
                }

                return o;
              }(t, r);

              return o.apply(t, this);
            }

            function i(t) {
              return t[this];
            }

            function a(t) {
              var e = +this;
              return e < 0 && (e = Math.max(0, e + t.length)), t[e];
            }

            n.isIdentifier, e.prototype.call = function (t) {
              var e = [].slice.call(arguments, 1);
              return e.push(t), this._then(o, void 0, void 0, e, void 0);
            }, e.prototype.get = function (t) {
              var e,
                  n = "number" == typeof t;
              if (n) e = a;else if (r) {
                var o = (void 0)(t);
                e = null !== o ? o : i;
              } else e = i;
              return this._then(e, void 0, void 0, t, void 0);
            };
          };
        }, {
          "./util": 36
        }],
        6: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o) {
            var i = t("./util"),
                a = i.tryCatch,
                s = i.errorObj,
                c = e._async;
            e.prototype["break"] = e.prototype.cancel = function () {
              if (!o.cancellation()) return this._warn("cancellation is disabled");

              for (var t = this, e = t; t._isCancellable();) {
                if (!t._cancelBy(e)) {
                  e._isFollowing() ? e._followee().cancel() : e._cancelBranched();
                  break;
                }

                var n = t._cancellationParent;

                if (null == n || !n._isCancellable()) {
                  t._isFollowing() ? t._followee().cancel() : t._cancelBranched();
                  break;
                }

                t._isFollowing() && t._followee().cancel(), t._setWillBeCancelled(), e = t, t = n;
              }
            }, e.prototype._branchHasCancelled = function () {
              this._branchesRemainingToCancel--;
            }, e.prototype._enoughBranchesHaveCancelled = function () {
              return void 0 === this._branchesRemainingToCancel || this._branchesRemainingToCancel <= 0;
            }, e.prototype._cancelBy = function (t) {
              return t === this ? (this._branchesRemainingToCancel = 0, this._invokeOnCancel(), !0) : (this._branchHasCancelled(), !!this._enoughBranchesHaveCancelled() && (this._invokeOnCancel(), !0));
            }, e.prototype._cancelBranched = function () {
              this._enoughBranchesHaveCancelled() && this._cancel();
            }, e.prototype._cancel = function () {
              this._isCancellable() && (this._setCancelled(), c.invoke(this._cancelPromises, this, void 0));
            }, e.prototype._cancelPromises = function () {
              this._length() > 0 && this._settlePromises();
            }, e.prototype._unsetOnCancel = function () {
              this._onCancelField = void 0;
            }, e.prototype._isCancellable = function () {
              return this.isPending() && !this._isCancelled();
            }, e.prototype.isCancellable = function () {
              return this.isPending() && !this.isCancelled();
            }, e.prototype._doInvokeOnCancel = function (t, e) {
              if (i.isArray(t)) for (var n = 0; n < t.length; ++n) {
                this._doInvokeOnCancel(t[n], e);
              } else if (void 0 !== t) if ("function" == typeof t) {
                if (!e) {
                  var r = a(t).call(this._boundValue());
                  r === s && (this._attachExtraTrace(r.e), c.throwLater(r.e));
                }
              } else t._resultCancelled(this);
            }, e.prototype._invokeOnCancel = function () {
              var t = this._onCancel();

              this._unsetOnCancel(), c.invoke(this._doInvokeOnCancel, this, t);
            }, e.prototype._invokeInternalOnCancel = function () {
              this._isCancellable() && (this._doInvokeOnCancel(this._onCancel(), !0), this._unsetOnCancel());
            }, e.prototype._resultCancelled = function () {
              this.cancel();
            };
          };
        }, {
          "./util": 36
        }],
        7: [function (t, e, n) {
          "use strict";

          e.exports = function (e) {
            var n = t("./util"),
                r = t("./es5").keys,
                o = n.tryCatch,
                i = n.errorObj;
            return function (t, a, s) {
              return function (c) {
                var u = s._boundValue();

                t: for (var l = 0; l < t.length; ++l) {
                  var f = t[l];

                  if (f === Error || null != f && f.prototype instanceof Error) {
                    if (c instanceof f) return o(a).call(u, c);
                  } else if ("function" == typeof f) {
                    var p = o(f).call(u, c);
                    if (p === i) return p;
                    if (p) return o(a).call(u, c);
                  } else if (n.isObject(c)) {
                    for (var h = r(f), d = 0; d < h.length; ++d) {
                      var v = h[d];
                      if (f[v] != c[v]) continue t;
                    }

                    return o(a).call(u, c);
                  }
                }

                return e;
              };
            };
          };
        }, {
          "./es5": 13,
          "./util": 36
        }],
        8: [function (t, e, n) {
          "use strict";

          e.exports = function (t) {
            var e = !1,
                n = [];

            function r() {
              this._trace = new r.CapturedTrace(o());
            }

            function o() {
              var t = n.length - 1;
              if (t >= 0) return n[t];
            }

            return t.prototype._promiseCreated = function () {}, t.prototype._pushContext = function () {}, t.prototype._popContext = function () {
              return null;
            }, t._peekContext = t.prototype._peekContext = function () {}, r.prototype._pushContext = function () {
              void 0 !== this._trace && (this._trace._promiseCreated = null, n.push(this._trace));
            }, r.prototype._popContext = function () {
              if (void 0 !== this._trace) {
                var t = n.pop(),
                    e = t._promiseCreated;
                return t._promiseCreated = null, e;
              }

              return null;
            }, r.CapturedTrace = null, r.create = function () {
              if (e) return new r();
            }, r.deactivateLongStackTraces = function () {}, r.activateLongStackTraces = function () {
              var n = t.prototype._pushContext,
                  i = t.prototype._popContext,
                  a = t._peekContext,
                  s = t.prototype._peekContext,
                  c = t.prototype._promiseCreated;
              r.deactivateLongStackTraces = function () {
                t.prototype._pushContext = n, t.prototype._popContext = i, t._peekContext = a, t.prototype._peekContext = s, t.prototype._promiseCreated = c, e = !1;
              }, e = !0, t.prototype._pushContext = r.prototype._pushContext, t.prototype._popContext = r.prototype._popContext, t._peekContext = t.prototype._peekContext = o, t.prototype._promiseCreated = function () {
                var t = this._peekContext();

                t && null == t._promiseCreated && (t._promiseCreated = this);
              };
            }, r;
          };
        }, {}],
        9: [function (t, n, r) {
          "use strict";

          n.exports = function (n, r) {
            var o,
                i,
                a,
                s = n._getDomain,
                c = n._async,
                u = t("./errors").Warning,
                l = t("./util"),
                f = t("./es5"),
                p = l.canAttachTrace,
                h = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,
                d = /\((?:timers\.js):\d+:\d+\)/,
                v = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,
                y = null,
                m = null,
                g = !1,
                b = !(0 == l.env("BLUEBIRD_DEBUG")),
                _ = !(0 == l.env("BLUEBIRD_WARNINGS") || !b && !l.env("BLUEBIRD_WARNINGS")),
                w = !(0 == l.env("BLUEBIRD_LONG_STACK_TRACES") || !b && !l.env("BLUEBIRD_LONG_STACK_TRACES")),
                x = 0 != l.env("BLUEBIRD_W_FORGOTTEN_RETURN") && (_ || !!l.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

            n.prototype.suppressUnhandledRejections = function () {
              var t = this._target();

              t._bitField = -1048577 & t._bitField | 524288;
            }, n.prototype._ensurePossibleRejectionHandled = function () {
              if (0 == (524288 & this._bitField)) {
                this._setRejectionIsUnhandled();

                var t = this;
                setTimeout(function () {
                  t._notifyUnhandledRejection();
                }, 1);
              }
            }, n.prototype._notifyUnhandledRejectionIsHandled = function () {
              q("rejectionHandled", o, void 0, this);
            }, n.prototype._setReturnedNonUndefined = function () {
              this._bitField = 268435456 | this._bitField;
            }, n.prototype._returnedNonUndefined = function () {
              return 0 != (268435456 & this._bitField);
            }, n.prototype._notifyUnhandledRejection = function () {
              if (this._isRejectionUnhandled()) {
                var t = this._settledValue();

                this._setUnhandledRejectionIsNotified(), q("unhandledRejection", i, t, this);
              }
            }, n.prototype._setUnhandledRejectionIsNotified = function () {
              this._bitField = 262144 | this._bitField;
            }, n.prototype._unsetUnhandledRejectionIsNotified = function () {
              this._bitField = -262145 & this._bitField;
            }, n.prototype._isUnhandledRejectionNotified = function () {
              return (262144 & this._bitField) > 0;
            }, n.prototype._setRejectionIsUnhandled = function () {
              this._bitField = 1048576 | this._bitField;
            }, n.prototype._unsetRejectionIsUnhandled = function () {
              this._bitField = -1048577 & this._bitField, this._isUnhandledRejectionNotified() && (this._unsetUnhandledRejectionIsNotified(), this._notifyUnhandledRejectionIsHandled());
            }, n.prototype._isRejectionUnhandled = function () {
              return (1048576 & this._bitField) > 0;
            }, n.prototype._warn = function (t, e, n) {
              return V(t, e, n || this);
            }, n.onPossiblyUnhandledRejection = function (t) {
              var e = s();
              i = "function" == typeof t ? null === e ? t : l.domainBind(e, t) : void 0;
            }, n.onUnhandledRejectionHandled = function (t) {
              var e = s();
              o = "function" == typeof t ? null === e ? t : l.domainBind(e, t) : void 0;
            };

            var O = function O() {};

            n.longStackTraces = function () {
              if (c.haveItemsQueued() && !J.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");

              if (!J.longStackTraces && K()) {
                var t = n.prototype._captureStackTrace,
                    e = n.prototype._attachExtraTrace,
                    o = n.prototype._dereferenceTrace;
                J.longStackTraces = !0, O = function O() {
                  if (c.haveItemsQueued() && !J.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                  n.prototype._captureStackTrace = t, n.prototype._attachExtraTrace = e, n.prototype._dereferenceTrace = o, r.deactivateLongStackTraces(), c.enableTrampoline(), J.longStackTraces = !1;
                }, n.prototype._captureStackTrace = I, n.prototype._attachExtraTrace = D, n.prototype._dereferenceTrace = B, r.activateLongStackTraces(), c.disableTrampolineIfNecessary();
              }
            }, n.hasLongStackTraces = function () {
              return J.longStackTraces && K();
            };

            var E = function () {
              try {
                if ("function" == typeof CustomEvent) {
                  var t = new CustomEvent("CustomEvent");
                  return l.global.dispatchEvent(t), function (t, e) {
                    var n = {
                      detail: e,
                      cancelable: !0
                    };
                    f.defineProperty(n, "promise", {
                      value: e.promise
                    }), f.defineProperty(n, "reason", {
                      value: e.reason
                    });
                    var r = new CustomEvent(t.toLowerCase(), n);
                    return !l.global.dispatchEvent(r);
                  };
                }

                if ("function" == typeof Event) {
                  var t = new Event("CustomEvent");
                  return l.global.dispatchEvent(t), function (t, e) {
                    var n = new Event(t.toLowerCase(), {
                      cancelable: !0
                    });
                    return n.detail = e, f.defineProperty(n, "promise", {
                      value: e.promise
                    }), f.defineProperty(n, "reason", {
                      value: e.reason
                    }), !l.global.dispatchEvent(n);
                  };
                }

                var t = document.createEvent("CustomEvent");
                return t.initCustomEvent("testingtheevent", !1, !0, {}), l.global.dispatchEvent(t), function (t, e) {
                  var n = document.createEvent("CustomEvent");
                  return n.initCustomEvent(t.toLowerCase(), !1, !0, e), !l.global.dispatchEvent(n);
                };
              } catch (t) {}

              return function () {
                return !1;
              };
            }(),
                C = l.isNode ? function () {
              return e.emit.apply(e, arguments);
            } : l.global ? function (t) {
              var e = "on" + t.toLowerCase(),
                  n = l.global[e];
              return !!n && (n.apply(l.global, [].slice.call(arguments, 1)), !0);
            } : function () {
              return !1;
            };

            function j(t, e) {
              return {
                promise: e
              };
            }

            var S = {
              promiseCreated: j,
              promiseFulfilled: j,
              promiseRejected: j,
              promiseResolved: j,
              promiseCancelled: j,
              promiseChained: function promiseChained(t, e, n) {
                return {
                  promise: e,
                  child: n
                };
              },
              warning: function warning(t, e) {
                return {
                  warning: e
                };
              },
              unhandledRejection: function unhandledRejection(t, e, n) {
                return {
                  reason: e,
                  promise: n
                };
              },
              rejectionHandled: j
            },
                T = function T(t) {
              var e = !1;

              try {
                e = C.apply(null, arguments);
              } catch (t) {
                c.throwLater(t), e = !0;
              }

              var n = !1;

              try {
                n = E(t, S[t].apply(null, arguments));
              } catch (t) {
                c.throwLater(t), n = !0;
              }

              return n || e;
            };

            function P() {
              return !1;
            }

            function k(t, e, n) {
              var r = this;

              try {
                t(e, n, function (t) {
                  if ("function" != typeof t) throw new TypeError("onCancel must be a function, got: " + l.toString(t));

                  r._attachCancellationCallback(t);
                });
              } catch (t) {
                return t;
              }
            }

            function M(t) {
              if (!this._isCancellable()) return this;

              var e = this._onCancel();

              void 0 !== e ? l.isArray(e) ? e.push(t) : this._setOnCancel([e, t]) : this._setOnCancel(t);
            }

            function z() {
              return this._onCancelField;
            }

            function L(t) {
              this._onCancelField = t;
            }

            function A() {
              this._cancellationParent = void 0, this._onCancelField = void 0;
            }

            function R(t, e) {
              if (0 != (1 & e)) {
                this._cancellationParent = t;
                var n = t._branchesRemainingToCancel;
                void 0 === n && (n = 0), t._branchesRemainingToCancel = n + 1;
              }

              0 != (2 & e) && t._isBound() && this._setBoundTo(t._boundTo);
            }

            n.config = function (t) {
              if ("longStackTraces" in (t = Object(t)) && (t.longStackTraces ? n.longStackTraces() : !t.longStackTraces && n.hasLongStackTraces() && O()), "warnings" in t) {
                var e = t.warnings;
                J.warnings = !!e, x = J.warnings, l.isObject(e) && "wForgottenReturn" in e && (x = !!e.wForgottenReturn);
              }

              if ("cancellation" in t && t.cancellation && !J.cancellation) {
                if (c.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
                n.prototype._clearCancellationData = A, n.prototype._propagateFrom = R, n.prototype._onCancel = z, n.prototype._setOnCancel = L, n.prototype._attachCancellationCallback = M, n.prototype._execute = k, N = R, J.cancellation = !0;
              }

              return "monitoring" in t && (t.monitoring && !J.monitoring ? (J.monitoring = !0, n.prototype._fireEvent = T) : !t.monitoring && J.monitoring && (J.monitoring = !1, n.prototype._fireEvent = P)), n;
            }, n.prototype._fireEvent = P, n.prototype._execute = function (t, e, n) {
              try {
                t(e, n);
              } catch (t) {
                return t;
              }
            }, n.prototype._onCancel = function () {}, n.prototype._setOnCancel = function (t) {}, n.prototype._attachCancellationCallback = function (t) {}, n.prototype._captureStackTrace = function () {}, n.prototype._attachExtraTrace = function () {}, n.prototype._dereferenceTrace = function () {}, n.prototype._clearCancellationData = function () {}, n.prototype._propagateFrom = function (t, e) {};

            var N = function N(t, e) {
              0 != (2 & e) && t._isBound() && this._setBoundTo(t._boundTo);
            };

            function F() {
              var t = this._boundTo;
              return void 0 !== t && t instanceof n ? t.isFulfilled() ? t.value() : void 0 : t;
            }

            function I() {
              this._trace = new X(this._peekContext());
            }

            function D(t, e) {
              if (p(t)) {
                var n = this._trace;
                if (void 0 !== n && e && (n = n._parent), void 0 !== n) n.attachExtraTrace(t);else if (!t.__stackCleaned__) {
                  var r = U(t);
                  l.notEnumerableProp(t, "stack", r.message + "\n" + r.stack.join("\n")), l.notEnumerableProp(t, "__stackCleaned__", !0);
                }
              }
            }

            function B() {
              this._trace = void 0;
            }

            function V(t, e, r) {
              if (J.warnings) {
                var o,
                    i = new u(t);
                if (e) r._attachExtraTrace(i);else if (J.longStackTraces && (o = n._peekContext())) o.attachExtraTrace(i);else {
                  var a = U(i);
                  i.stack = a.message + "\n" + a.stack.join("\n");
                }
                T("warning", i) || W(i, "", !0);
              }
            }

            function H(t) {
              for (var e = [], n = 0; n < t.length; ++n) {
                var r = t[n],
                    o = "    (No stack trace)" === r || y.test(r),
                    i = o && Z(r);
                o && !i && (g && " " !== r.charAt(0) && (r = "    " + r), e.push(r));
              }

              return e;
            }

            function U(t) {
              var e = t.stack,
                  n = t.toString();
              return e = "string" == typeof e && e.length > 0 ? function (t) {
                for (var e = t.stack.replace(/\s+$/g, "").split("\n"), n = 0; n < e.length; ++n) {
                  var r = e[n];
                  if ("    (No stack trace)" === r || y.test(r)) break;
                }

                return n > 0 && "SyntaxError" != t.name && (e = e.slice(n)), e;
              }(t) : ["    (No stack trace)"], {
                message: n,
                stack: "SyntaxError" == t.name ? e : H(e)
              };
            }

            function W(t, e, n) {
              if ("undefined" != typeof console) {
                var r;

                if (l.isObject(t)) {
                  var o = t.stack;
                  r = e + m(o, t);
                } else r = e + String(t);

                "function" == typeof a ? a(r, n) : "function" == typeof console.log || console.log;
              }
            }

            function q(t, e, n, r) {
              var o = !1;

              try {
                "function" == typeof e && (o = !0, "rejectionHandled" === t ? e(r) : e(n, r));
              } catch (t) {
                c.throwLater(t);
              }

              "unhandledRejection" === t ? T(t, n, r) || o || W(n, "Unhandled rejection ") : T(t, r);
            }

            function G(t) {
              var e;
              if ("function" == typeof t) e = "[function " + (t.name || "anonymous") + "]";else {
                if (e = t && "function" == typeof t.toString ? t.toString() : l.toString(t), /\[object [a-zA-Z0-9$_]+\]/.test(e)) try {
                  var n = JSON.stringify(t);
                  e = n;
                } catch (t) {}
                0 === e.length && (e = "(empty array)");
              }
              return "(<" + function (t) {
                return t.length < 41 ? t : t.substr(0, 38) + "...";
              }(e) + ">, no stack trace)";
            }

            function K() {
              return "function" == typeof Q;
            }

            var Z = function Z() {
              return !1;
            },
                Y = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;

            function $(t) {
              var e = t.match(Y);
              if (e) return {
                fileName: e[1],
                line: parseInt(e[2], 10)
              };
            }

            function X(t) {
              this._parent = t, this._promisesCreated = 0;
              var e = this._length = 1 + (void 0 === t ? 0 : t._length);
              Q(this, X), e > 32 && this.uncycle();
            }

            l.inherits(X, Error), r.CapturedTrace = X, X.prototype.uncycle = function () {
              var t = this._length;

              if (!(t < 2)) {
                for (var e = [], n = {}, r = 0, o = this; void 0 !== o; ++r) {
                  e.push(o), o = o._parent;
                }

                for (var r = (t = this._length = r) - 1; r >= 0; --r) {
                  var i = e[r].stack;
                  void 0 === n[i] && (n[i] = r);
                }

                for (var r = 0; r < t; ++r) {
                  var a = e[r].stack,
                      s = n[a];

                  if (void 0 !== s && s !== r) {
                    s > 0 && (e[s - 1]._parent = void 0, e[s - 1]._length = 1), e[r]._parent = void 0, e[r]._length = 1;
                    var c = r > 0 ? e[r - 1] : this;
                    s < t - 1 ? (c._parent = e[s + 1], c._parent.uncycle(), c._length = c._parent._length + 1) : (c._parent = void 0, c._length = 1);

                    for (var u = c._length + 1, l = r - 2; l >= 0; --l) {
                      e[l]._length = u, u++;
                    }

                    return;
                  }
                }
              }
            }, X.prototype.attachExtraTrace = function (t) {
              if (!t.__stackCleaned__) {
                this.uncycle();

                for (var e = U(t), n = e.message, r = [e.stack], o = this; void 0 !== o;) {
                  r.push(H(o.stack.split("\n"))), o = o._parent;
                }

                !function (t) {
                  for (var e = t[0], n = 1; n < t.length; ++n) {
                    for (var r = t[n], o = e.length - 1, i = e[o], a = -1, s = r.length - 1; s >= 0; --s) {
                      if (r[s] === i) {
                        a = s;
                        break;
                      }
                    }

                    for (var s = a; s >= 0; --s) {
                      var c = r[s];
                      if (e[o] !== c) break;
                      e.pop(), o--;
                    }

                    e = r;
                  }
                }(r), function (t) {
                  for (var e = 0; e < t.length; ++e) {
                    (0 === t[e].length || e + 1 < t.length && t[e][0] === t[e + 1][0]) && (t.splice(e, 1), e--);
                  }
                }(r), l.notEnumerableProp(t, "stack", function (t, e) {
                  for (var n = 0; n < e.length - 1; ++n) {
                    e[n].push("From previous event:"), e[n] = e[n].join("\n");
                  }

                  return n < e.length && (e[n] = e[n].join("\n")), t + "\n" + e.join("\n");
                }(n, r)), l.notEnumerableProp(t, "__stackCleaned__", !0);
              }
            };

            var Q = function () {
              var t = /^\s*at\s*/,
                  e = function e(t, _e3) {
                return "string" == typeof t ? t : void 0 !== _e3.name && void 0 !== _e3.message ? _e3.toString() : G(_e3);
              };

              if ("number" == typeof Error.stackTraceLimit && "function" == typeof Error.captureStackTrace) {
                Error.stackTraceLimit += 6, y = t, m = e;
                var n = Error.captureStackTrace;
                return Z = function Z(t) {
                  return h.test(t);
                }, function (t, e) {
                  Error.stackTraceLimit += 6, n(t, e), Error.stackTraceLimit -= 6;
                };
              }

              var r,
                  o = new Error();
              if ("string" == typeof o.stack && o.stack.split("\n")[0].indexOf("stackDetection@") >= 0) return y = /@/, m = e, g = !0, function (t) {
                t.stack = new Error().stack;
              };

              try {
                throw new Error();
              } catch (t) {
                r = "stack" in t;
              }

              return "stack" in o || !r || "number" != typeof Error.stackTraceLimit ? (m = function m(t, e) {
                return "string" == typeof t ? t : "object" != _typeof(e) && "function" != typeof e || void 0 === e.name || void 0 === e.message ? G(e) : e.toString();
              }, null) : (y = t, m = e, function (t) {
                Error.stackTraceLimit += 6;

                try {
                  throw new Error();
                } catch (e) {
                  t.stack = e.stack;
                }

                Error.stackTraceLimit -= 6;
              });
            }();

            "undefined" != typeof console && void 0 !== console.warn && (a = function a(t) {}, l.isNode && e.stderr.isTTY ? a = function a(t, e) {} : l.isNode || "string" != typeof new Error().stack || (a = function a(t, e) {}));
            var J = {
              warnings: _,
              longStackTraces: !1,
              cancellation: !1,
              monitoring: !1
            };
            return w && n.longStackTraces(), {
              longStackTraces: function longStackTraces() {
                return J.longStackTraces;
              },
              warnings: function warnings() {
                return J.warnings;
              },
              cancellation: function cancellation() {
                return J.cancellation;
              },
              monitoring: function monitoring() {
                return J.monitoring;
              },
              propagateFromFunction: function propagateFromFunction() {
                return N;
              },
              boundValueFunction: function boundValueFunction() {
                return F;
              },
              checkForgottenReturns: function checkForgottenReturns(t, e, n, r, o) {
                if (void 0 === t && null !== e && x) {
                  if (void 0 !== o && o._returnedNonUndefined()) return;
                  if (0 == (65535 & r._bitField)) return;
                  n && (n += " ");
                  var i = "",
                      a = "";

                  if (e._trace) {
                    for (var s = e._trace.stack.split("\n"), c = H(s), u = c.length - 1; u >= 0; --u) {
                      var l = c[u];

                      if (!d.test(l)) {
                        var f = l.match(v);
                        f && (i = "at " + f[1] + ":" + f[2] + ":" + f[3] + " ");
                        break;
                      }
                    }

                    if (c.length > 0) for (var p = c[0], u = 0; u < s.length; ++u) {
                      if (s[u] === p) {
                        u > 0 && (a = "\n" + s[u - 1]);
                        break;
                      }
                    }
                  }

                  var h = "a promise was created in a " + n + "handler " + i + "but was not returned from it, see http://goo.gl/rRqMUw" + a;

                  r._warn(h, !0, e);
                }
              },
              setBounds: function setBounds(t, e) {
                if (K()) {
                  for (var n, r, o = t.stack.split("\n"), i = e.stack.split("\n"), a = -1, s = -1, c = 0; c < o.length; ++c) {
                    var u = $(o[c]);

                    if (u) {
                      n = u.fileName, a = u.line;
                      break;
                    }
                  }

                  for (var c = 0; c < i.length; ++c) {
                    var u = $(i[c]);

                    if (u) {
                      r = u.fileName, s = u.line;
                      break;
                    }
                  }

                  a < 0 || s < 0 || !n || !r || n !== r || a >= s || (Z = function Z(t) {
                    if (h.test(t)) return !0;
                    var e = $(t);
                    return !!(e && e.fileName === n && a <= e.line && e.line <= s);
                  });
                }
              },
              warn: V,
              deprecated: function deprecated(t, e) {
                var n = t + " is deprecated and will be removed in a future version.";
                return e && (n += " Use " + e + " instead."), V(n);
              },
              CapturedTrace: X,
              fireDomEvent: E,
              fireGlobalEvent: C
            };
          };
        }, {
          "./errors": 12,
          "./es5": 13,
          "./util": 36
        }],
        10: [function (t, e, n) {
          "use strict";

          e.exports = function (t) {
            function e() {
              return this.value;
            }

            function n() {
              throw this.reason;
            }

            t.prototype["return"] = t.prototype.thenReturn = function (n) {
              return n instanceof t && n.suppressUnhandledRejections(), this._then(e, void 0, void 0, {
                value: n
              }, void 0);
            }, t.prototype["throw"] = t.prototype.thenThrow = function (t) {
              return this._then(n, void 0, void 0, {
                reason: t
              }, void 0);
            }, t.prototype.catchThrow = function (t) {
              if (arguments.length <= 1) return this._then(void 0, n, void 0, {
                reason: t
              }, void 0);
              var e = arguments[1];
              return this.caught(t, function () {
                throw e;
              });
            }, t.prototype.catchReturn = function (n) {
              if (arguments.length <= 1) return n instanceof t && n.suppressUnhandledRejections(), this._then(void 0, e, void 0, {
                value: n
              }, void 0);
              var r = arguments[1];
              return r instanceof t && r.suppressUnhandledRejections(), this.caught(n, function () {
                return r;
              });
            };
          };
        }, {}],
        11: [function (t, e, n) {
          "use strict";

          e.exports = function (t, e) {
            var n = t.reduce,
                r = t.all;

            function o() {
              return r(this);
            }

            t.prototype.each = function (t) {
              return n(this, t, e, 0)._then(o, void 0, void 0, this, void 0);
            }, t.prototype.mapSeries = function (t) {
              return n(this, t, e, e);
            }, t.each = function (t, r) {
              return n(t, r, e, 0)._then(o, void 0, void 0, t, void 0);
            }, t.mapSeries = function (t, r) {
              return n(t, r, e, e);
            };
          };
        }, {}],
        12: [function (t, e, n) {
          "use strict";

          var r,
              o,
              i = t("./es5"),
              a = i.freeze,
              s = t("./util"),
              c = s.inherits,
              u = s.notEnumerableProp;

          function l(t, e) {
            function n(r) {
              if (!(this instanceof n)) return new n(r);
              u(this, "message", "string" == typeof r ? r : e), u(this, "name", t), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : Error.call(this);
            }

            return c(n, Error), n;
          }

          var f = l("Warning", "warning"),
              p = l("CancellationError", "cancellation error"),
              h = l("TimeoutError", "timeout error"),
              d = l("AggregateError", "aggregate error");

          try {
            r = TypeError, o = RangeError;
          } catch (t) {
            r = l("TypeError", "type error"), o = l("RangeError", "range error");
          }

          for (var v = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "), y = 0; y < v.length; ++y) {
            "function" == typeof Array.prototype[v[y]] && (d.prototype[v[y]] = Array.prototype[v[y]]);
          }

          i.defineProperty(d.prototype, "length", {
            value: 0,
            configurable: !1,
            writable: !0,
            enumerable: !0
          }), d.prototype.isOperational = !0;
          var m = 0;

          function g(t) {
            if (!(this instanceof g)) return new g(t);
            u(this, "name", "OperationalError"), u(this, "message", t), this.cause = t, this.isOperational = !0, t instanceof Error ? (u(this, "message", t.message), u(this, "stack", t.stack)) : Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
          }

          d.prototype.toString = function () {
            var t = Array(4 * m + 1).join(" "),
                e = "\n" + t + "AggregateError of:\n";
            m++, t = Array(4 * m + 1).join(" ");

            for (var n = 0; n < this.length; ++n) {
              for (var r = this[n] === this ? "[Circular AggregateError]" : this[n] + "", o = r.split("\n"), i = 0; i < o.length; ++i) {
                o[i] = t + o[i];
              }

              r = o.join("\n"), e += r + "\n";
            }

            return m--, e;
          }, c(g, Error);
          var b = Error.__BluebirdErrorTypes__;
          b || (b = a({
            CancellationError: p,
            TimeoutError: h,
            OperationalError: g,
            RejectionError: g,
            AggregateError: d
          }), i.defineProperty(Error, "__BluebirdErrorTypes__", {
            value: b,
            writable: !1,
            enumerable: !1,
            configurable: !1
          })), e.exports = {
            Error: Error,
            TypeError: r,
            RangeError: o,
            CancellationError: b.CancellationError,
            OperationalError: b.OperationalError,
            TimeoutError: b.TimeoutError,
            AggregateError: b.AggregateError,
            Warning: f
          };
        }, {
          "./es5": 13,
          "./util": 36
        }],
        13: [function (t, e, n) {
          var r = function () {
            "use strict";

            return void 0 === this;
          }();

          if (r) e.exports = {
            freeze: Object.freeze,
            defineProperty: Object.defineProperty,
            getDescriptor: Object.getOwnPropertyDescriptor,
            keys: Object.keys,
            names: Object.getOwnPropertyNames,
            getPrototypeOf: Object.getPrototypeOf,
            isArray: Array.isArray,
            isES5: r,
            propertyIsWritable: function propertyIsWritable(t, e) {
              var n = Object.getOwnPropertyDescriptor(t, e);
              return !(n && !n.writable && !n.set);
            }
          };else {
            var o = {}.hasOwnProperty,
                i = {}.toString,
                a = {}.constructor.prototype,
                s = function s(t) {
              var e = [];

              for (var n in t) {
                o.call(t, n) && e.push(n);
              }

              return e;
            };

            e.exports = {
              isArray: function isArray(t) {
                try {
                  return "[object Array]" === i.call(t);
                } catch (t) {
                  return !1;
                }
              },
              keys: s,
              names: s,
              defineProperty: function defineProperty(t, e, n) {
                return t[e] = n.value, t;
              },
              getDescriptor: function getDescriptor(t, e) {
                return {
                  value: t[e]
                };
              },
              freeze: function freeze(t) {
                return t;
              },
              getPrototypeOf: function getPrototypeOf(t) {
                try {
                  return Object(t).constructor.prototype;
                } catch (t) {
                  return a;
                }
              },
              isES5: r,
              propertyIsWritable: function propertyIsWritable() {
                return !0;
              }
            };
          }
        }, {}],
        14: [function (t, e, n) {
          "use strict";

          e.exports = function (t, e) {
            var n = t.map;
            t.prototype.filter = function (t, r) {
              return n(this, t, r, e);
            }, t.filter = function (t, r, o) {
              return n(t, r, o, e);
            };
          };
        }, {}],
        15: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r) {
            var o = t("./util"),
                i = e.CancellationError,
                a = o.errorObj,
                s = t("./catch_filter")(r);

            function c(t, e, n) {
              this.promise = t, this.type = e, this.handler = n, this.called = !1, this.cancelPromise = null;
            }

            function u(t) {
              this.finallyHandler = t;
            }

            function l(t, e) {
              return null != t.cancelPromise && (arguments.length > 1 ? t.cancelPromise._reject(e) : t.cancelPromise._cancel(), t.cancelPromise = null, !0);
            }

            function f() {
              return h.call(this, this.promise._target()._settledValue());
            }

            function p(t) {
              if (!l(this, t)) return a.e = t, a;
            }

            function h(t) {
              var o = this.promise,
                  s = this.handler;

              if (!this.called) {
                this.called = !0;
                var c = this.isFinallyHandler() ? s.call(o._boundValue()) : s.call(o._boundValue(), t);
                if (c === r) return c;

                if (void 0 !== c) {
                  o._setReturnedNonUndefined();

                  var h = n(c, o);

                  if (h instanceof e) {
                    if (null != this.cancelPromise) {
                      if (h._isCancelled()) {
                        var d = new i("late cancellation observer");
                        return o._attachExtraTrace(d), a.e = d, a;
                      }

                      h.isPending() && h._attachCancellationCallback(new u(this));
                    }

                    return h._then(f, p, void 0, this, void 0);
                  }
                }
              }

              return o.isRejected() ? (l(this), a.e = t, a) : (l(this), t);
            }

            return c.prototype.isFinallyHandler = function () {
              return 0 === this.type;
            }, u.prototype._resultCancelled = function () {
              l(this.finallyHandler);
            }, e.prototype._passThrough = function (t, e, n, r) {
              return "function" != typeof t ? this.then() : this._then(n, r, void 0, new c(this, e, t), void 0);
            }, e.prototype.lastly = e.prototype["finally"] = function (t) {
              return this._passThrough(t, 0, h, h);
            }, e.prototype.tap = function (t) {
              return this._passThrough(t, 1, h);
            }, e.prototype.tapCatch = function (t) {
              var n = arguments.length;
              if (1 === n) return this._passThrough(t, 1, void 0, h);
              var r,
                  i = new Array(n - 1),
                  a = 0;

              for (r = 0; r < n - 1; ++r) {
                var c = arguments[r];
                if (!o.isObject(c)) return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + o.classString(c)));
                i[a++] = c;
              }

              i.length = a;
              var u = arguments[r];
              return this._passThrough(s(i, u, this), 1, void 0, h);
            }, c;
          };
        }, {
          "./catch_filter": 7,
          "./util": 36
        }],
        16: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i, a) {
            var s = t("./errors"),
                c = s.TypeError,
                u = t("./util"),
                l = u.errorObj,
                f = u.tryCatch,
                p = [];

            function h(t, n, o, i) {
              if (a.cancellation()) {
                var s = new e(r),
                    c = this._finallyPromise = new e(r);
                this._promise = s.lastly(function () {
                  return c;
                }), s._captureStackTrace(), s._setOnCancel(this);
              } else {
                var u = this._promise = new e(r);

                u._captureStackTrace();
              }

              this._stack = i, this._generatorFunction = t, this._receiver = n, this._generator = void 0, this._yieldHandlers = "function" == typeof o ? [o].concat(p) : p, this._yieldedPromise = null, this._cancellationPhase = !1;
            }

            u.inherits(h, i), h.prototype._isResolved = function () {
              return null === this._promise;
            }, h.prototype._cleanup = function () {
              this._promise = this._generator = null, a.cancellation() && null !== this._finallyPromise && (this._finallyPromise._fulfill(), this._finallyPromise = null);
            }, h.prototype._promiseCancelled = function () {
              if (!this._isResolved()) {
                var t,
                    n = void 0 !== this._generator["return"];
                if (n) this._promise._pushContext(), t = f(this._generator["return"]).call(this._generator, void 0), this._promise._popContext();else {
                  var r = new e.CancellationError("generator .return() sentinel");
                  e.coroutine.returnSentinel = r, this._promise._attachExtraTrace(r), this._promise._pushContext(), t = f(this._generator["throw"]).call(this._generator, r), this._promise._popContext();
                }
                this._cancellationPhase = !0, this._yieldedPromise = null, this._continue(t);
              }
            }, h.prototype._promiseFulfilled = function (t) {
              this._yieldedPromise = null, this._promise._pushContext();
              var e = f(this._generator.next).call(this._generator, t);
              this._promise._popContext(), this._continue(e);
            }, h.prototype._promiseRejected = function (t) {
              this._yieldedPromise = null, this._promise._attachExtraTrace(t), this._promise._pushContext();
              var e = f(this._generator["throw"]).call(this._generator, t);
              this._promise._popContext(), this._continue(e);
            }, h.prototype._resultCancelled = function () {
              if (this._yieldedPromise instanceof e) {
                var t = this._yieldedPromise;
                this._yieldedPromise = null, t.cancel();
              }
            }, h.prototype.promise = function () {
              return this._promise;
            }, h.prototype._run = function () {
              this._generator = this._generatorFunction.call(this._receiver), this._receiver = this._generatorFunction = void 0, this._promiseFulfilled(void 0);
            }, h.prototype._continue = function (t) {
              var n = this._promise;
              if (t === l) return this._cleanup(), this._cancellationPhase ? n.cancel() : n._rejectCallback(t.e, !1);
              var r = t.value;
              if (!0 === t.done) return this._cleanup(), this._cancellationPhase ? n.cancel() : n._resolveCallback(r);
              var i = o(r, this._promise);

              if (i instanceof e || null !== (i = function (t, n, r) {
                for (var i = 0; i < n.length; ++i) {
                  r._pushContext();

                  var a = f(n[i])(t);

                  if (r._popContext(), a === l) {
                    r._pushContext();

                    var s = e.reject(l.e);
                    return r._popContext(), s;
                  }

                  var c = o(a, r);
                  if (c instanceof e) return c;
                }

                return null;
              }(i, this._yieldHandlers, this._promise))) {
                var a = (i = i._target())._bitField;

                0 == (50397184 & a) ? (this._yieldedPromise = i, i._proxy(this, null)) : 0 != (33554432 & a) ? e._async.invoke(this._promiseFulfilled, this, i._value()) : 0 != (16777216 & a) ? e._async.invoke(this._promiseRejected, this, i._reason()) : this._promiseCancelled();
              } else this._promiseRejected(new c("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(r)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
            }, e.coroutine = function (t, e) {
              if ("function" != typeof t) throw new c("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
              var n = Object(e).yieldHandler,
                  r = h,
                  o = new Error().stack;
              return function () {
                var e = t.apply(this, arguments),
                    i = new r(void 0, void 0, n, o),
                    a = i.promise();
                return i._generator = e, i._promiseFulfilled(void 0), a;
              };
            }, e.coroutine.addYieldHandler = function (t) {
              if ("function" != typeof t) throw new c("expecting a function but got " + u.classString(t));
              p.push(t);
            }, e.spawn = function (t) {
              if (a.deprecated("Promise.spawn()", "Promise.coroutine()"), "function" != typeof t) return n("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
              var r = new h(t, this),
                  o = r.promise();
              return r._run(e.spawn), o;
            };
          };
        }, {
          "./errors": 12,
          "./util": 36
        }],
        17: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i, a) {
            var s = t("./util");
            s.canEvaluate, s.tryCatch, s.errorObj, e.join = function () {
              var t,
                  e = arguments.length - 1;
              e > 0 && "function" == typeof arguments[e] && (t = arguments[e]);
              var r = [].slice.call(arguments);
              t && r.pop();
              var o = new n(r).promise();
              return void 0 !== t ? o.spread(t) : o;
            };
          };
        }, {
          "./util": 36
        }],
        18: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i, a) {
            var s = e._getDomain,
                c = t("./util"),
                u = c.tryCatch,
                l = c.errorObj,
                f = e._async;

            function p(t, e, n, r) {
              this.constructor$(t), this._promise._captureStackTrace();
              var o = s();
              this._callback = null === o ? e : c.domainBind(o, e), this._preservedValues = r === i ? new Array(this.length()) : null, this._limit = n, this._inFlight = 0, this._queue = [], f.invoke(this._asyncInit, this, void 0);
            }

            function h(t, n, o, i) {
              if ("function" != typeof n) return r("expecting a function but got " + c.classString(n));
              var a = 0;

              if (void 0 !== o) {
                if ("object" != _typeof(o) || null === o) return e.reject(new TypeError("options argument must be an object but it is " + c.classString(o)));
                if ("number" != typeof o.concurrency) return e.reject(new TypeError("'concurrency' must be a number but it is " + c.classString(o.concurrency)));
                a = o.concurrency;
              }

              return a = "number" == typeof a && isFinite(a) && a >= 1 ? a : 0, new p(t, n, a, i).promise();
            }

            c.inherits(p, n), p.prototype._asyncInit = function () {
              this._init$(void 0, -2);
            }, p.prototype._init = function () {}, p.prototype._promiseFulfilled = function (t, n) {
              var r = this._values,
                  i = this.length(),
                  s = this._preservedValues,
                  c = this._limit;

              if (n < 0) {
                if (r[n = -1 * n - 1] = t, c >= 1 && (this._inFlight--, this._drainQueue(), this._isResolved())) return !0;
              } else {
                if (c >= 1 && this._inFlight >= c) return r[n] = t, this._queue.push(n), !1;
                null !== s && (s[n] = t);

                var f = this._promise,
                    p = this._callback,
                    h = f._boundValue();

                f._pushContext();

                var d = u(p).call(h, t, n, i),
                    v = f._popContext();

                if (a.checkForgottenReturns(d, v, null !== s ? "Promise.filter" : "Promise.map", f), d === l) return this._reject(d.e), !0;
                var y = o(d, this._promise);

                if (y instanceof e) {
                  var m = (y = y._target())._bitField;

                  if (0 == (50397184 & m)) return c >= 1 && this._inFlight++, r[n] = y, y._proxy(this, -1 * (n + 1)), !1;
                  if (0 == (33554432 & m)) return 0 != (16777216 & m) ? (this._reject(y._reason()), !0) : (this._cancel(), !0);
                  d = y._value();
                }

                r[n] = d;
              }

              var g = ++this._totalResolved;
              return g >= i && (null !== s ? this._filter(r, s) : this._resolve(r), !0);
            }, p.prototype._drainQueue = function () {
              for (var t = this._queue, e = this._limit, n = this._values; t.length > 0 && this._inFlight < e;) {
                if (this._isResolved()) return;
                var r = t.pop();

                this._promiseFulfilled(n[r], r);
              }
            }, p.prototype._filter = function (t, e) {
              for (var n = e.length, r = new Array(n), o = 0, i = 0; i < n; ++i) {
                t[i] && (r[o++] = e[i]);
              }

              r.length = o, this._resolve(r);
            }, p.prototype.preservedValues = function () {
              return this._preservedValues;
            }, e.prototype.map = function (t, e) {
              return h(this, t, e, null);
            }, e.map = function (t, e, n, r) {
              return h(t, e, n, r);
            };
          };
        }, {
          "./util": 36
        }],
        19: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i) {
            var a = t("./util"),
                s = a.tryCatch;
            e.method = function (t) {
              if ("function" != typeof t) throw new e.TypeError("expecting a function but got " + a.classString(t));
              return function () {
                var r = new e(n);
                r._captureStackTrace(), r._pushContext();

                var o = s(t).apply(this, arguments),
                    a = r._popContext();

                return i.checkForgottenReturns(o, a, "Promise.method", r), r._resolveFromSyncValue(o), r;
              };
            }, e.attempt = e["try"] = function (t) {
              if ("function" != typeof t) return o("expecting a function but got " + a.classString(t));
              var r,
                  c = new e(n);

              if (c._captureStackTrace(), c._pushContext(), arguments.length > 1) {
                i.deprecated("calling Promise.try with more than 1 argument");
                var u = arguments[1],
                    l = arguments[2];
                r = a.isArray(u) ? s(t).apply(l, u) : s(t).call(l, u);
              } else r = s(t)();

              var f = c._popContext();

              return i.checkForgottenReturns(r, f, "Promise.try", c), c._resolveFromSyncValue(r), c;
            }, e.prototype._resolveFromSyncValue = function (t) {
              t === a.errorObj ? this._rejectCallback(t.e, !1) : this._resolveCallback(t, !0);
            };
          };
        }, {
          "./util": 36
        }],
        20: [function (t, e, n) {
          "use strict";

          var r = t("./util"),
              o = r.maybeWrapAsError,
              i = t("./errors"),
              a = i.OperationalError,
              s = t("./es5"),
              c = /^(?:name|message|stack|cause)$/;

          function u(t) {
            var e;

            if (function (t) {
              return t instanceof Error && s.getPrototypeOf(t) === Error.prototype;
            }(t)) {
              (e = new a(t)).name = t.name, e.message = t.message, e.stack = t.stack;

              for (var n = s.keys(t), o = 0; o < n.length; ++o) {
                var i = n[o];
                c.test(i) || (e[i] = t[i]);
              }

              return e;
            }

            return r.markAsOriginatingFromRejection(t), t;
          }

          e.exports = function (t, e) {
            return function (n, r) {
              if (null !== t) {
                if (n) {
                  var i = u(o(n));
                  t._attachExtraTrace(i), t._reject(i);
                } else if (e) {
                  var a = [].slice.call(arguments, 1);

                  t._fulfill(a);
                } else t._fulfill(r);

                t = null;
              }
            };
          };
        }, {
          "./errors": 12,
          "./es5": 13,
          "./util": 36
        }],
        21: [function (t, e, n) {
          "use strict";

          e.exports = function (e) {
            var n = t("./util"),
                r = e._async,
                o = n.tryCatch,
                i = n.errorObj;

            function a(t, e) {
              if (!n.isArray(t)) return s.call(this, t, e);
              var a = o(e).apply(this._boundValue(), [null].concat(t));
              a === i && r.throwLater(a.e);
            }

            function s(t, e) {
              var n = this._boundValue(),
                  a = void 0 === t ? o(e).call(n, null) : o(e).call(n, null, t);

              a === i && r.throwLater(a.e);
            }

            function c(t, e) {
              if (!t) {
                var n = new Error(t + "");
                n.cause = t, t = n;
              }

              var a = o(e).call(this._boundValue(), t);
              a === i && r.throwLater(a.e);
            }

            e.prototype.asCallback = e.prototype.nodeify = function (t, e) {
              if ("function" == typeof t) {
                var n = s;
                void 0 !== e && Object(e).spread && (n = a), this._then(n, c, void 0, this, t);
              }

              return this;
            };
          };
        }, {
          "./util": 36
        }],
        22: [function (t, n, r) {
          "use strict";

          n.exports = function () {
            var r = function r() {
              return new d("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
            },
                o = function o() {
              return new P.PromiseInspection(this._target());
            },
                i = function i(t) {
              return P.reject(new d(t));
            };

            function a() {}

            var s,
                c = {},
                u = t("./util");
            s = u.isNode ? function () {
              var t = e.domain;
              return void 0 === t && (t = null), t;
            } : function () {
              return null;
            }, u.notEnumerableProp(P, "_getDomain", s);
            var l = t("./es5"),
                f = t("./async"),
                p = new f();
            l.defineProperty(P, "_async", {
              value: p
            });
            var h = t("./errors"),
                d = P.TypeError = h.TypeError;
            P.RangeError = h.RangeError;
            var v = P.CancellationError = h.CancellationError;
            P.TimeoutError = h.TimeoutError, P.OperationalError = h.OperationalError, P.RejectionError = h.OperationalError, P.AggregateError = h.AggregateError;

            var y = function y() {},
                m = {},
                g = {},
                b = t("./thenables")(P, y),
                _ = t("./promise_array")(P, y, b, i, a),
                w = t("./context")(P),
                x = w.create,
                O = t("./debuggability")(P, w),
                E = (O.CapturedTrace, t("./finally")(P, b, g)),
                C = t("./catch_filter")(g),
                j = t("./nodeback"),
                S = u.errorObj,
                T = u.tryCatch;

            function P(t) {
              t !== y && function (t, e) {
                if (null == t || t.constructor !== P) throw new d("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
                if ("function" != typeof e) throw new d("expecting a function but got " + u.classString(e));
              }(this, t), this._bitField = 0, this._fulfillmentHandler0 = void 0, this._rejectionHandler0 = void 0, this._promise0 = void 0, this._receiver0 = void 0, this._resolveFromExecutor(t), this._promiseCreated(), this._fireEvent("promiseCreated", this);
            }

            function k(t) {
              this.promise._resolveCallback(t);
            }

            function M(t) {
              this.promise._rejectCallback(t, !1);
            }

            function z(t) {
              var e = new P(y);
              e._fulfillmentHandler0 = t, e._rejectionHandler0 = t, e._promise0 = t, e._receiver0 = t;
            }

            return P.prototype.toString = function () {
              return "[object Promise]";
            }, P.prototype.caught = P.prototype["catch"] = function (t) {
              var e = arguments.length;

              if (e > 1) {
                var n,
                    r = new Array(e - 1),
                    o = 0;

                for (n = 0; n < e - 1; ++n) {
                  var a = arguments[n];
                  if (!u.isObject(a)) return i("Catch statement predicate: expecting an object but got " + u.classString(a));
                  r[o++] = a;
                }

                return r.length = o, t = arguments[n], this.then(void 0, C(r, t, this));
              }

              return this.then(void 0, t);
            }, P.prototype.reflect = function () {
              return this._then(o, o, void 0, this, void 0);
            }, P.prototype.then = function (t, e) {
              if (O.warnings() && arguments.length > 0 && "function" != typeof t && "function" != typeof e) {
                var n = ".then() only accepts functions but was passed: " + u.classString(t);
                arguments.length > 1 && (n += ", " + u.classString(e)), this._warn(n);
              }

              return this._then(t, e, void 0, void 0, void 0);
            }, P.prototype.done = function (t, e) {
              var n = this._then(t, e, void 0, void 0, void 0);

              n._setIsFinal();
            }, P.prototype.spread = function (t) {
              return "function" != typeof t ? i("expecting a function but got " + u.classString(t)) : this.all()._then(t, void 0, void 0, m, void 0);
            }, P.prototype.toJSON = function () {
              var t = {
                isFulfilled: !1,
                isRejected: !1,
                fulfillmentValue: void 0,
                rejectionReason: void 0
              };
              return this.isFulfilled() ? (t.fulfillmentValue = this.value(), t.isFulfilled = !0) : this.isRejected() && (t.rejectionReason = this.reason(), t.isRejected = !0), t;
            }, P.prototype.all = function () {
              return arguments.length > 0 && this._warn(".all() was passed arguments but it does not take any"), new _(this).promise();
            }, P.prototype.error = function (t) {
              return this.caught(u.originatesFromRejection, t);
            }, P.getNewLibraryCopy = n.exports, P.is = function (t) {
              return t instanceof P;
            }, P.fromNode = P.fromCallback = function (t) {
              var e = new P(y);

              e._captureStackTrace();

              var n = arguments.length > 1 && !!Object(arguments[1]).multiArgs,
                  r = T(t)(j(e, n));
              return r === S && e._rejectCallback(r.e, !0), e._isFateSealed() || e._setAsyncGuaranteed(), e;
            }, P.all = function (t) {
              return new _(t).promise();
            }, P.cast = function (t) {
              var e = b(t);
              return e instanceof P || ((e = new P(y))._captureStackTrace(), e._setFulfilled(), e._rejectionHandler0 = t), e;
            }, P.resolve = P.fulfilled = P.cast, P.reject = P.rejected = function (t) {
              var e = new P(y);
              return e._captureStackTrace(), e._rejectCallback(t, !0), e;
            }, P.setScheduler = function (t) {
              if ("function" != typeof t) throw new d("expecting a function but got " + u.classString(t));
              return p.setScheduler(t);
            }, P.prototype._then = function (t, e, n, r, o) {
              var i = void 0 !== o,
                  a = i ? o : new P(y),
                  c = this._target(),
                  l = c._bitField;

              i || (a._propagateFrom(this, 3), a._captureStackTrace(), void 0 === r && 0 != (2097152 & this._bitField) && (r = 0 != (50397184 & l) ? this._boundValue() : c === this ? void 0 : this._boundTo), this._fireEvent("promiseChained", this, a));
              var f = s();

              if (0 != (50397184 & l)) {
                var h,
                    d,
                    m = c._settlePromiseCtx;
                0 != (33554432 & l) ? (d = c._rejectionHandler0, h = t) : 0 != (16777216 & l) ? (d = c._fulfillmentHandler0, h = e, c._unsetRejectionIsUnhandled()) : (m = c._settlePromiseLateCancellationObserver, d = new v("late cancellation observer"), c._attachExtraTrace(d), h = e), p.invoke(m, c, {
                  handler: null === f ? h : "function" == typeof h && u.domainBind(f, h),
                  promise: a,
                  receiver: r,
                  value: d
                });
              } else c._addCallbacks(t, e, a, r, f);

              return a;
            }, P.prototype._length = function () {
              return 65535 & this._bitField;
            }, P.prototype._isFateSealed = function () {
              return 0 != (117506048 & this._bitField);
            }, P.prototype._isFollowing = function () {
              return 67108864 == (67108864 & this._bitField);
            }, P.prototype._setLength = function (t) {
              this._bitField = -65536 & this._bitField | 65535 & t;
            }, P.prototype._setFulfilled = function () {
              this._bitField = 33554432 | this._bitField, this._fireEvent("promiseFulfilled", this);
            }, P.prototype._setRejected = function () {
              this._bitField = 16777216 | this._bitField, this._fireEvent("promiseRejected", this);
            }, P.prototype._setFollowing = function () {
              this._bitField = 67108864 | this._bitField, this._fireEvent("promiseResolved", this);
            }, P.prototype._setIsFinal = function () {
              this._bitField = 4194304 | this._bitField;
            }, P.prototype._isFinal = function () {
              return (4194304 & this._bitField) > 0;
            }, P.prototype._unsetCancelled = function () {
              this._bitField = -65537 & this._bitField;
            }, P.prototype._setCancelled = function () {
              this._bitField = 65536 | this._bitField, this._fireEvent("promiseCancelled", this);
            }, P.prototype._setWillBeCancelled = function () {
              this._bitField = 8388608 | this._bitField;
            }, P.prototype._setAsyncGuaranteed = function () {
              p.hasCustomScheduler() || (this._bitField = 134217728 | this._bitField);
            }, P.prototype._receiverAt = function (t) {
              var e = 0 === t ? this._receiver0 : this[4 * t - 4 + 3];
              if (e !== c) return void 0 === e && this._isBound() ? this._boundValue() : e;
            }, P.prototype._promiseAt = function (t) {
              return this[4 * t - 4 + 2];
            }, P.prototype._fulfillmentHandlerAt = function (t) {
              return this[4 * t - 4 + 0];
            }, P.prototype._rejectionHandlerAt = function (t) {
              return this[4 * t - 4 + 1];
            }, P.prototype._boundValue = function () {}, P.prototype._migrateCallback0 = function (t) {
              t._bitField;

              var e = t._fulfillmentHandler0,
                  n = t._rejectionHandler0,
                  r = t._promise0,
                  o = t._receiverAt(0);

              void 0 === o && (o = c), this._addCallbacks(e, n, r, o, null);
            }, P.prototype._migrateCallbackAt = function (t, e) {
              var n = t._fulfillmentHandlerAt(e),
                  r = t._rejectionHandlerAt(e),
                  o = t._promiseAt(e),
                  i = t._receiverAt(e);

              void 0 === i && (i = c), this._addCallbacks(n, r, o, i, null);
            }, P.prototype._addCallbacks = function (t, e, n, r, o) {
              var i = this._length();

              if (i >= 65531 && (i = 0, this._setLength(0)), 0 === i) this._promise0 = n, this._receiver0 = r, "function" == typeof t && (this._fulfillmentHandler0 = null === o ? t : u.domainBind(o, t)), "function" == typeof e && (this._rejectionHandler0 = null === o ? e : u.domainBind(o, e));else {
                var a = 4 * i - 4;
                this[a + 2] = n, this[a + 3] = r, "function" == typeof t && (this[a + 0] = null === o ? t : u.domainBind(o, t)), "function" == typeof e && (this[a + 1] = null === o ? e : u.domainBind(o, e));
              }
              return this._setLength(i + 1), i;
            }, P.prototype._proxy = function (t, e) {
              this._addCallbacks(void 0, void 0, e, t, null);
            }, P.prototype._resolveCallback = function (t, e) {
              if (0 == (117506048 & this._bitField)) {
                if (t === this) return this._rejectCallback(r(), !1);
                var n = b(t, this);
                if (!(n instanceof P)) return this._fulfill(t);
                e && this._propagateFrom(n, 2);

                var o = n._target();

                if (o !== this) {
                  var i = o._bitField;

                  if (0 == (50397184 & i)) {
                    var a = this._length();

                    a > 0 && o._migrateCallback0(this);

                    for (var s = 1; s < a; ++s) {
                      o._migrateCallbackAt(this, s);
                    }

                    this._setFollowing(), this._setLength(0), this._setFollowee(o);
                  } else if (0 != (33554432 & i)) this._fulfill(o._value());else if (0 != (16777216 & i)) this._reject(o._reason());else {
                    var c = new v("late cancellation observer");
                    o._attachExtraTrace(c), this._reject(c);
                  }
                } else this._reject(r());
              }
            }, P.prototype._rejectCallback = function (t, e, n) {
              var r = u.ensureErrorObject(t),
                  o = r === t;

              if (!o && !n && O.warnings()) {
                var i = "a promise was rejected with a non-error: " + u.classString(t);

                this._warn(i, !0);
              }

              this._attachExtraTrace(r, !!e && o), this._reject(t);
            }, P.prototype._resolveFromExecutor = function (t) {
              if (t !== y) {
                var e = this;
                this._captureStackTrace(), this._pushContext();

                var n = !0,
                    r = this._execute(t, function (t) {
                  e._resolveCallback(t);
                }, function (t) {
                  e._rejectCallback(t, n);
                });

                n = !1, this._popContext(), void 0 !== r && e._rejectCallback(r, !0);
              }
            }, P.prototype._settlePromiseFromHandler = function (t, e, n, r) {
              var o = r._bitField;

              if (0 == (65536 & o)) {
                var i;
                r._pushContext(), e === m ? n && "number" == typeof n.length ? i = T(t).apply(this._boundValue(), n) : (i = S).e = new d("cannot .spread() a non-array: " + u.classString(n)) : i = T(t).call(e, n);

                var a = r._popContext();

                0 == (65536 & (o = r._bitField)) && (i === g ? r._reject(n) : i === S ? r._rejectCallback(i.e, !1) : (O.checkForgottenReturns(i, a, "", r, this), r._resolveCallback(i)));
              }
            }, P.prototype._target = function () {
              for (var t = this; t._isFollowing();) {
                t = t._followee();
              }

              return t;
            }, P.prototype._followee = function () {
              return this._rejectionHandler0;
            }, P.prototype._setFollowee = function (t) {
              this._rejectionHandler0 = t;
            }, P.prototype._settlePromise = function (t, e, n, r) {
              var i = t instanceof P,
                  s = this._bitField,
                  c = 0 != (134217728 & s);
              0 != (65536 & s) ? (i && t._invokeInternalOnCancel(), n instanceof E && n.isFinallyHandler() ? (n.cancelPromise = t, T(e).call(n, r) === S && t._reject(S.e)) : e === o ? t._fulfill(o.call(n)) : n instanceof a ? n._promiseCancelled(t) : i || t instanceof _ ? t._cancel() : n.cancel()) : "function" == typeof e ? i ? (c && t._setAsyncGuaranteed(), this._settlePromiseFromHandler(e, n, r, t)) : e.call(n, r, t) : n instanceof a ? n._isResolved() || (0 != (33554432 & s) ? n._promiseFulfilled(r, t) : n._promiseRejected(r, t)) : i && (c && t._setAsyncGuaranteed(), 0 != (33554432 & s) ? t._fulfill(r) : t._reject(r));
            }, P.prototype._settlePromiseLateCancellationObserver = function (t) {
              var e = t.handler,
                  n = t.promise,
                  r = t.receiver,
                  o = t.value;
              "function" == typeof e ? n instanceof P ? this._settlePromiseFromHandler(e, r, o, n) : e.call(r, o, n) : n instanceof P && n._reject(o);
            }, P.prototype._settlePromiseCtx = function (t) {
              this._settlePromise(t.promise, t.handler, t.receiver, t.value);
            }, P.prototype._settlePromise0 = function (t, e, n) {
              var r = this._promise0,
                  o = this._receiverAt(0);

              this._promise0 = void 0, this._receiver0 = void 0, this._settlePromise(r, t, o, e);
            }, P.prototype._clearCallbackDataAtIndex = function (t) {
              var e = 4 * t - 4;
              this[e + 2] = this[e + 3] = this[e + 0] = this[e + 1] = void 0;
            }, P.prototype._fulfill = function (t) {
              var e = this._bitField;

              if (!((117506048 & e) >>> 16)) {
                if (t === this) {
                  var n = r();
                  return this._attachExtraTrace(n), this._reject(n);
                }

                this._setFulfilled(), this._rejectionHandler0 = t, (65535 & e) > 0 && (0 != (134217728 & e) ? this._settlePromises() : p.settlePromises(this), this._dereferenceTrace());
              }
            }, P.prototype._reject = function (t) {
              var e = this._bitField;

              if (!((117506048 & e) >>> 16)) {
                if (this._setRejected(), this._fulfillmentHandler0 = t, this._isFinal()) return p.fatalError(t, u.isNode);
                (65535 & e) > 0 ? p.settlePromises(this) : this._ensurePossibleRejectionHandled();
              }
            }, P.prototype._fulfillPromises = function (t, e) {
              for (var n = 1; n < t; n++) {
                var r = this._fulfillmentHandlerAt(n),
                    o = this._promiseAt(n),
                    i = this._receiverAt(n);

                this._clearCallbackDataAtIndex(n), this._settlePromise(o, r, i, e);
              }
            }, P.prototype._rejectPromises = function (t, e) {
              for (var n = 1; n < t; n++) {
                var r = this._rejectionHandlerAt(n),
                    o = this._promiseAt(n),
                    i = this._receiverAt(n);

                this._clearCallbackDataAtIndex(n), this._settlePromise(o, r, i, e);
              }
            }, P.prototype._settlePromises = function () {
              var t = this._bitField,
                  e = 65535 & t;

              if (e > 0) {
                if (0 != (16842752 & t)) {
                  var n = this._fulfillmentHandler0;
                  this._settlePromise0(this._rejectionHandler0, n, t), this._rejectPromises(e, n);
                } else {
                  var r = this._rejectionHandler0;
                  this._settlePromise0(this._fulfillmentHandler0, r, t), this._fulfillPromises(e, r);
                }

                this._setLength(0);
              }

              this._clearCancellationData();
            }, P.prototype._settledValue = function () {
              var t = this._bitField;
              return 0 != (33554432 & t) ? this._rejectionHandler0 : 0 != (16777216 & t) ? this._fulfillmentHandler0 : void 0;
            }, P.defer = P.pending = function () {
              O.deprecated("Promise.defer", "new Promise");
              var t = new P(y);
              return {
                promise: t,
                resolve: k,
                reject: M
              };
            }, u.notEnumerableProp(P, "_makeSelfResolutionError", r), t("./method")(P, y, b, i, O), t("./bind")(P, y, b, O), t("./cancel")(P, _, i, O), t("./direct_resolve")(P), t("./synchronous_inspection")(P), t("./join")(P, _, b, y, p, s), P.Promise = P, P.version = "3.5.2", t("./map.js")(P, _, i, b, y, O), t("./call_get.js")(P), t("./using.js")(P, i, b, x, y, O), t("./timers.js")(P, y, O), t("./generators.js")(P, i, y, b, a, O), t("./nodeify.js")(P), t("./promisify.js")(P, y), t("./props.js")(P, _, b, i), t("./race.js")(P, y, b, i), t("./reduce.js")(P, _, i, b, y, O), t("./settle.js")(P, _, O), t("./some.js")(P, _, i), t("./filter.js")(P, y), t("./each.js")(P, y), t("./any.js")(P), u.toFastProperties(P), u.toFastProperties(P.prototype), z({
              a: 1
            }), z({
              b: 2
            }), z({
              c: 3
            }), z(1), z(function () {}), z(void 0), z(!1), z(new P(y)), O.setBounds(f.firstLineError, u.lastLineError), P;
          };
        }, {
          "./any.js": 1,
          "./async": 2,
          "./bind": 3,
          "./call_get.js": 5,
          "./cancel": 6,
          "./catch_filter": 7,
          "./context": 8,
          "./debuggability": 9,
          "./direct_resolve": 10,
          "./each.js": 11,
          "./errors": 12,
          "./es5": 13,
          "./filter.js": 14,
          "./finally": 15,
          "./generators.js": 16,
          "./join": 17,
          "./map.js": 18,
          "./method": 19,
          "./nodeback": 20,
          "./nodeify.js": 21,
          "./promise_array": 23,
          "./promisify.js": 24,
          "./props.js": 25,
          "./race.js": 27,
          "./reduce.js": 28,
          "./settle.js": 30,
          "./some.js": 31,
          "./synchronous_inspection": 32,
          "./thenables": 33,
          "./timers.js": 34,
          "./using.js": 35,
          "./util": 36
        }],
        23: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i) {
            var a = t("./util");

            function s(t) {
              var r = this._promise = new e(n);
              t instanceof e && r._propagateFrom(t, 3), r._setOnCancel(this), this._values = t, this._length = 0, this._totalResolved = 0, this._init(void 0, -2);
            }

            return a.isArray, a.inherits(s, i), s.prototype.length = function () {
              return this._length;
            }, s.prototype.promise = function () {
              return this._promise;
            }, s.prototype._init = function t(n, i) {
              var s = r(this._values, this._promise);

              if (s instanceof e) {
                var c = (s = s._target())._bitField;

                if (this._values = s, 0 == (50397184 & c)) return this._promise._setAsyncGuaranteed(), s._then(t, this._reject, void 0, this, i);
                if (0 == (33554432 & c)) return 0 != (16777216 & c) ? this._reject(s._reason()) : this._cancel();
                s = s._value();
              }

              if (null !== (s = a.asArray(s))) 0 !== s.length ? this._iterate(s) : -5 === i ? this._resolveEmptyArray() : this._resolve(function (t) {
                switch (t) {
                  case -2:
                    return [];

                  case -3:
                    return {};

                  case -6:
                    return new Map();
                }
              }(i));else {
                var u = o("expecting an array or an iterable object but got " + a.classString(s)).reason();

                this._promise._rejectCallback(u, !1);
              }
            }, s.prototype._iterate = function (t) {
              var n = this.getActualLength(t.length);
              this._length = n, this._values = this.shouldCopyValues() ? new Array(n) : this._values;

              for (var o = this._promise, i = !1, a = null, s = 0; s < n; ++s) {
                var c = r(t[s], o);
                c instanceof e ? (c = c._target(), a = c._bitField) : a = null, i ? null !== a && c.suppressUnhandledRejections() : null !== a ? 0 == (50397184 & a) ? (c._proxy(this, s), this._values[s] = c) : i = 0 != (33554432 & a) ? this._promiseFulfilled(c._value(), s) : 0 != (16777216 & a) ? this._promiseRejected(c._reason(), s) : this._promiseCancelled(s) : i = this._promiseFulfilled(c, s);
              }

              i || o._setAsyncGuaranteed();
            }, s.prototype._isResolved = function () {
              return null === this._values;
            }, s.prototype._resolve = function (t) {
              this._values = null, this._promise._fulfill(t);
            }, s.prototype._cancel = function () {
              !this._isResolved() && this._promise._isCancellable() && (this._values = null, this._promise._cancel());
            }, s.prototype._reject = function (t) {
              this._values = null, this._promise._rejectCallback(t, !1);
            }, s.prototype._promiseFulfilled = function (t, e) {
              this._values[e] = t;
              var n = ++this._totalResolved;
              return n >= this._length && (this._resolve(this._values), !0);
            }, s.prototype._promiseCancelled = function () {
              return this._cancel(), !0;
            }, s.prototype._promiseRejected = function (t) {
              return this._totalResolved++, this._reject(t), !0;
            }, s.prototype._resultCancelled = function () {
              if (!this._isResolved()) {
                var t = this._values;
                if (this._cancel(), t instanceof e) t.cancel();else for (var n = 0; n < t.length; ++n) {
                  t[n] instanceof e && t[n].cancel();
                }
              }
            }, s.prototype.shouldCopyValues = function () {
              return !0;
            }, s.prototype.getActualLength = function (t) {
              return t;
            }, s;
          };
        }, {
          "./util": 36
        }],
        24: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n) {
            var r = {},
                o = t("./util"),
                i = t("./nodeback"),
                a = o.withAppended,
                s = o.maybeWrapAsError,
                c = o.canEvaluate,
                u = t("./errors").TypeError,
                l = {
              __isPromisified__: !0
            },
                f = new RegExp("^(?:" + ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"].join("|") + ")$"),
                p = function p(t) {
              return o.isIdentifier(t) && "_" !== t.charAt(0) && "constructor" !== t;
            };

            function h(t) {
              return !f.test(t);
            }

            function d(t) {
              try {
                return !0 === t.__isPromisified__;
              } catch (t) {
                return !1;
              }
            }

            function v(t, e, n) {
              var r = o.getDataPropertyOrDefault(t, e + n, l);
              return !!r && d(r);
            }

            function y(t, e, n, r) {
              for (var i = o.inheritedDataKeys(t), a = [], s = 0; s < i.length; ++s) {
                var c = i[s],
                    l = t[c],
                    f = r === p || p(c, l, t);
                "function" != typeof l || d(l) || v(t, c, e) || !r(c, l, t, f) || a.push(c, l);
              }

              return function (t, e, n) {
                for (var r = 0; r < t.length; r += 2) {
                  var o = t[r];
                  if (n.test(o)) for (var i = o.replace(n, ""), a = 0; a < t.length; a += 2) {
                    if (t[a] === i) throw new u("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", e));
                  }
                }
              }(a, e, n), a;
            }

            var m = function m(t) {
              return t.replace(/([$])/, "\\$");
            },
                g = c ? void 0 : function (t, c, u, l, f, p) {
              var h = function () {
                return this;
              }(),
                  d = t;

              function v() {
                var o = c;
                c === r && (o = this);
                var u = new e(n);

                u._captureStackTrace();

                var l = "string" == typeof d && this !== h ? this[d] : t,
                    f = i(u, p);

                try {
                  l.apply(o, a(arguments, f));
                } catch (t) {
                  u._rejectCallback(s(t), !0, !0);
                }

                return u._isFateSealed() || u._setAsyncGuaranteed(), u;
              }

              return "string" == typeof d && (t = l), o.notEnumerableProp(v, "__isPromisified__", !0), v;
            };

            function b(t, e, n, i, a) {
              for (var s = new RegExp(m(e) + "$"), c = y(t, e, s, n), u = 0, l = c.length; u < l; u += 2) {
                var f = c[u],
                    p = c[u + 1],
                    h = f + e;
                if (i === g) t[h] = g(f, r, f, p, e, a);else {
                  var d = i(p, function () {
                    return g(f, r, f, p, e, a);
                  });
                  o.notEnumerableProp(d, "__isPromisified__", !0), t[h] = d;
                }
              }

              return o.toFastProperties(t), t;
            }

            e.promisify = function (t, e) {
              if ("function" != typeof t) throw new u("expecting a function but got " + o.classString(t));
              if (d(t)) return t;

              var n = void 0 === (e = Object(e)).context ? r : e.context,
                  i = !!e.multiArgs,
                  a = function (t, e, n) {
                return g(t, e, void 0, t, null, n);
              }(t, n, i);

              return o.copyDescriptors(t, a, h), a;
            }, e.promisifyAll = function (t, e) {
              if ("function" != typeof t && "object" != _typeof(t)) throw new u("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
              var n = !!(e = Object(e)).multiArgs,
                  r = e.suffix;
              "string" != typeof r && (r = "Async");
              var i = e.filter;
              "function" != typeof i && (i = p);
              var a = e.promisifier;
              if ("function" != typeof a && (a = g), !o.isIdentifier(r)) throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");

              for (var s = o.inheritedDataKeys(t), c = 0; c < s.length; ++c) {
                var l = t[s[c]];
                "constructor" !== s[c] && o.isClass(l) && (b(l.prototype, r, i, a, n), b(l, r, i, a, n));
              }

              return b(t, r, i, a, n);
            };
          };
        }, {
          "./errors": 12,
          "./nodeback": 20,
          "./util": 36
        }],
        25: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o) {
            var i,
                a = t("./util"),
                s = a.isObject,
                c = t("./es5");
            "function" == typeof Map && (i = Map);

            var u = function () {
              var t = 0,
                  e = 0;

              function n(n, r) {
                this[t] = n, this[t + e] = r, t++;
              }

              return function (r) {
                e = r.size, t = 0;
                var o = new Array(2 * r.size);
                return r.forEach(n, o), o;
              };
            }();

            function l(t) {
              var e,
                  n = !1;
              if (void 0 !== i && t instanceof i) e = u(t), n = !0;else {
                var r = c.keys(t),
                    o = r.length;
                e = new Array(2 * o);

                for (var a = 0; a < o; ++a) {
                  var s = r[a];
                  e[a] = t[s], e[a + o] = s;
                }
              }
              this.constructor$(e), this._isMap = n, this._init$(void 0, n ? -6 : -3);
            }

            function f(t) {
              var n,
                  i = r(t);
              return s(i) ? (n = i instanceof e ? i._then(e.props, void 0, void 0, void 0, void 0) : new l(i).promise(), i instanceof e && n._propagateFrom(i, 2), n) : o("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
            }

            a.inherits(l, n), l.prototype._init = function () {}, l.prototype._promiseFulfilled = function (t, e) {
              this._values[e] = t;
              var n = ++this._totalResolved;

              if (n >= this._length) {
                var r;
                if (this._isMap) r = function (t) {
                  for (var e = new i(), n = t.length / 2 | 0, r = 0; r < n; ++r) {
                    var o = t[n + r],
                        a = t[r];
                    e.set(o, a);
                  }

                  return e;
                }(this._values);else {
                  r = {};

                  for (var o = this.length(), a = 0, s = this.length(); a < s; ++a) {
                    r[this._values[a + o]] = this._values[a];
                  }
                }
                return this._resolve(r), !0;
              }

              return !1;
            }, l.prototype.shouldCopyValues = function () {
              return !1;
            }, l.prototype.getActualLength = function (t) {
              return t >> 1;
            }, e.prototype.props = function () {
              return f(this);
            }, e.props = function (t) {
              return f(t);
            };
          };
        }, {
          "./es5": 13,
          "./util": 36
        }],
        26: [function (t, e, n) {
          "use strict";

          function r(t) {
            this._capacity = t, this._length = 0, this._front = 0;
          }

          r.prototype._willBeOverCapacity = function (t) {
            return this._capacity < t;
          }, r.prototype._pushOne = function (t) {
            var e = this.length();

            this._checkCapacity(e + 1);

            var n = this._front + e & this._capacity - 1;
            this[n] = t, this._length = e + 1;
          }, r.prototype.push = function (t, e, n) {
            var r = this.length() + 3;
            if (this._willBeOverCapacity(r)) return this._pushOne(t), this._pushOne(e), void this._pushOne(n);
            var o = this._front + r - 3;

            this._checkCapacity(r);

            var i = this._capacity - 1;
            this[o + 0 & i] = t, this[o + 1 & i] = e, this[o + 2 & i] = n, this._length = r;
          }, r.prototype.shift = function () {
            var t = this._front,
                e = this[t];
            return this[t] = void 0, this._front = t + 1 & this._capacity - 1, this._length--, e;
          }, r.prototype.length = function () {
            return this._length;
          }, r.prototype._checkCapacity = function (t) {
            this._capacity < t && this._resizeTo(this._capacity << 1);
          }, r.prototype._resizeTo = function (t) {
            var e = this._capacity;
            this._capacity = t;
            var n = this._front,
                r = this._length,
                o = n + r & e - 1;
            !function (t, e, n, r, o) {
              for (var i = 0; i < o; ++i) {
                n[i + r] = t[i + e], t[i + e] = void 0;
              }
            }(this, 0, this, e, o);
          }, e.exports = r;
        }, {}],
        27: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o) {
            var i = t("./util"),
                a = function a(t) {
              return t.then(function (e) {
                return s(e, t);
              });
            };

            function s(t, s) {
              var c = r(t);
              if (c instanceof e) return a(c);
              if (null === (t = i.asArray(t))) return o("expecting an array or an iterable object but got " + i.classString(t));
              var u = new e(n);
              void 0 !== s && u._propagateFrom(s, 3);

              for (var l = u._fulfill, f = u._reject, p = 0, h = t.length; p < h; ++p) {
                var d = t[p];
                (void 0 !== d || p in t) && e.cast(d)._then(l, f, void 0, u, null);
              }

              return u;
            }

            e.race = function (t) {
              return s(t, void 0);
            }, e.prototype.race = function () {
              return s(this, void 0);
            };
          };
        }, {
          "./util": 36
        }],
        28: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i, a) {
            var s = e._getDomain,
                c = t("./util"),
                u = c.tryCatch;

            function l(t, n, r, o) {
              this.constructor$(t);
              var a = s();
              this._fn = null === a ? n : c.domainBind(a, n), void 0 !== r && (r = e.resolve(r))._attachCancellationCallback(this), this._initialValue = r, this._currentCancellable = null, this._eachValues = o === i ? Array(this._length) : 0 === o ? null : void 0, this._promise._captureStackTrace(), this._init$(void 0, -5);
            }

            function f(t, e) {
              this.isFulfilled() ? e._resolve(t) : e._reject(t);
            }

            function p(t, e, n, o) {
              if ("function" != typeof e) return r("expecting a function but got " + c.classString(e));
              var i = new l(t, e, n, o);
              return i.promise();
            }

            function h(t) {
              this.accum = t, this.array._gotAccum(t);
              var n = o(this.value, this.array._promise);
              return n instanceof e ? (this.array._currentCancellable = n, n._then(d, void 0, void 0, this, void 0)) : d.call(this, n);
            }

            function d(t) {
              var n,
                  r = this.array,
                  o = r._promise,
                  i = u(r._fn);
              o._pushContext(), (n = void 0 !== r._eachValues ? i.call(o._boundValue(), t, this.index, this.length) : i.call(o._boundValue(), this.accum, t, this.index, this.length)) instanceof e && (r._currentCancellable = n);

              var s = o._popContext();

              return a.checkForgottenReturns(n, s, void 0 !== r._eachValues ? "Promise.each" : "Promise.reduce", o), n;
            }

            c.inherits(l, n), l.prototype._gotAccum = function (t) {
              void 0 !== this._eachValues && null !== this._eachValues && t !== i && this._eachValues.push(t);
            }, l.prototype._eachComplete = function (t) {
              return null !== this._eachValues && this._eachValues.push(t), this._eachValues;
            }, l.prototype._init = function () {}, l.prototype._resolveEmptyArray = function () {
              this._resolve(void 0 !== this._eachValues ? this._eachValues : this._initialValue);
            }, l.prototype.shouldCopyValues = function () {
              return !1;
            }, l.prototype._resolve = function (t) {
              this._promise._resolveCallback(t), this._values = null;
            }, l.prototype._resultCancelled = function (t) {
              if (t === this._initialValue) return this._cancel();
              this._isResolved() || (this._resultCancelled$(), this._currentCancellable instanceof e && this._currentCancellable.cancel(), this._initialValue instanceof e && this._initialValue.cancel());
            }, l.prototype._iterate = function (t) {
              var n, r;
              this._values = t;
              var o = t.length;
              if (void 0 !== this._initialValue ? (n = this._initialValue, r = 0) : (n = e.resolve(t[0]), r = 1), this._currentCancellable = n, !n.isRejected()) for (; r < o; ++r) {
                var i = {
                  accum: null,
                  value: t[r],
                  index: r,
                  length: o,
                  array: this
                };
                n = n._then(h, void 0, void 0, i, void 0);
              }
              void 0 !== this._eachValues && (n = n._then(this._eachComplete, void 0, void 0, this, void 0)), n._then(f, f, void 0, n, this);
            }, e.prototype.reduce = function (t, e) {
              return p(this, t, e, null);
            }, e.reduce = function (t, e, n, r) {
              return p(t, e, n, r);
            };
          };
        }, {
          "./util": 36
        }],
        29: [function (t, o, i) {
          "use strict";

          var a,
              s,
              c,
              u,
              l,
              f = t("./util"),
              p = f.getNativePromise();

          if (f.isNode && "undefined" == typeof MutationObserver) {
            var h = n.setImmediate,
                d = e.nextTick;
            a = f.isRecentNode ? function (t) {
              h.call(n, t);
            } : function (t) {
              d.call(e, t);
            };
          } else if ("function" == typeof p && "function" == typeof p.resolve) {
            var v = p.resolve();

            a = function a(t) {
              v.then(t);
            };
          } else a = "undefined" == typeof MutationObserver || "undefined" != typeof window && window.navigator && (window.navigator.standalone || window.cordova) ? void 0 !== r ? function (t) {
            r(t);
          } : "undefined" != typeof setTimeout ? function (t) {
            setTimeout(t, 0);
          } : function () {
            throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
          } : (s = document.createElement("div"), c = {
            attributes: !0
          }, u = !1, l = document.createElement("div"), new MutationObserver(function () {
            s.classList.toggle("foo"), u = !1;
          }).observe(l, c), function (t) {
            var e = new MutationObserver(function () {
              e.disconnect(), t();
            });
            e.observe(s, c), u || (u = !0, l.classList.toggle("foo"));
          });

          o.exports = a;
        }, {
          "./util": 36
        }],
        30: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r) {
            var o = e.PromiseInspection,
                i = t("./util");

            function a(t) {
              this.constructor$(t);
            }

            i.inherits(a, n), a.prototype._promiseResolved = function (t, e) {
              this._values[t] = e;
              var n = ++this._totalResolved;
              return n >= this._length && (this._resolve(this._values), !0);
            }, a.prototype._promiseFulfilled = function (t, e) {
              var n = new o();
              return n._bitField = 33554432, n._settledValueField = t, this._promiseResolved(e, n);
            }, a.prototype._promiseRejected = function (t, e) {
              var n = new o();
              return n._bitField = 16777216, n._settledValueField = t, this._promiseResolved(e, n);
            }, e.settle = function (t) {
              return r.deprecated(".settle()", ".reflect()"), new a(t).promise();
            }, e.prototype.settle = function () {
              return e.settle(this);
            };
          };
        }, {
          "./util": 36
        }],
        31: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r) {
            var o = t("./util"),
                i = t("./errors").RangeError,
                a = t("./errors").AggregateError,
                s = o.isArray,
                c = {};

            function u(t) {
              this.constructor$(t), this._howMany = 0, this._unwrap = !1, this._initialized = !1;
            }

            function l(t, e) {
              if ((0 | e) !== e || e < 0) return r("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
              var n = new u(t),
                  o = n.promise();
              return n.setHowMany(e), n.init(), o;
            }

            o.inherits(u, n), u.prototype._init = function () {
              if (this._initialized) if (0 !== this._howMany) {
                this._init$(void 0, -5);

                var t = s(this._values);
                !this._isResolved() && t && this._howMany > this._canPossiblyFulfill() && this._reject(this._getRangeError(this.length()));
              } else this._resolve([]);
            }, u.prototype.init = function () {
              this._initialized = !0, this._init();
            }, u.prototype.setUnwrap = function () {
              this._unwrap = !0;
            }, u.prototype.howMany = function () {
              return this._howMany;
            }, u.prototype.setHowMany = function (t) {
              this._howMany = t;
            }, u.prototype._promiseFulfilled = function (t) {
              return this._addFulfilled(t), this._fulfilled() === this.howMany() && (this._values.length = this.howMany(), 1 === this.howMany() && this._unwrap ? this._resolve(this._values[0]) : this._resolve(this._values), !0);
            }, u.prototype._promiseRejected = function (t) {
              return this._addRejected(t), this._checkOutcome();
            }, u.prototype._promiseCancelled = function () {
              return this._values instanceof e || null == this._values ? this._cancel() : (this._addRejected(c), this._checkOutcome());
            }, u.prototype._checkOutcome = function () {
              if (this.howMany() > this._canPossiblyFulfill()) {
                for (var t = new a(), e = this.length(); e < this._values.length; ++e) {
                  this._values[e] !== c && t.push(this._values[e]);
                }

                return t.length > 0 ? this._reject(t) : this._cancel(), !0;
              }

              return !1;
            }, u.prototype._fulfilled = function () {
              return this._totalResolved;
            }, u.prototype._rejected = function () {
              return this._values.length - this.length();
            }, u.prototype._addRejected = function (t) {
              this._values.push(t);
            }, u.prototype._addFulfilled = function (t) {
              this._values[this._totalResolved++] = t;
            }, u.prototype._canPossiblyFulfill = function () {
              return this.length() - this._rejected();
            }, u.prototype._getRangeError = function (t) {
              var e = "Input array must contain at least " + this._howMany + " items but contains only " + t + " items";
              return new i(e);
            }, u.prototype._resolveEmptyArray = function () {
              this._reject(this._getRangeError(0));
            }, e.some = function (t, e) {
              return l(t, e);
            }, e.prototype.some = function (t) {
              return l(this, t);
            }, e._SomePromiseArray = u;
          };
        }, {
          "./errors": 12,
          "./util": 36
        }],
        32: [function (t, e, n) {
          "use strict";

          e.exports = function (t) {
            function e(t) {
              void 0 !== t ? (t = t._target(), this._bitField = t._bitField, this._settledValueField = t._isFateSealed() ? t._settledValue() : void 0) : (this._bitField = 0, this._settledValueField = void 0);
            }

            e.prototype._settledValue = function () {
              return this._settledValueField;
            };

            var n = e.prototype.value = function () {
              if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
              return this._settledValue();
            },
                r = e.prototype.error = e.prototype.reason = function () {
              if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
              return this._settledValue();
            },
                o = e.prototype.isFulfilled = function () {
              return 0 != (33554432 & this._bitField);
            },
                i = e.prototype.isRejected = function () {
              return 0 != (16777216 & this._bitField);
            },
                a = e.prototype.isPending = function () {
              return 0 == (50397184 & this._bitField);
            },
                s = e.prototype.isResolved = function () {
              return 0 != (50331648 & this._bitField);
            };

            e.prototype.isCancelled = function () {
              return 0 != (8454144 & this._bitField);
            }, t.prototype.__isCancelled = function () {
              return 65536 == (65536 & this._bitField);
            }, t.prototype._isCancelled = function () {
              return this._target().__isCancelled();
            }, t.prototype.isCancelled = function () {
              return 0 != (8454144 & this._target()._bitField);
            }, t.prototype.isPending = function () {
              return a.call(this._target());
            }, t.prototype.isRejected = function () {
              return i.call(this._target());
            }, t.prototype.isFulfilled = function () {
              return o.call(this._target());
            }, t.prototype.isResolved = function () {
              return s.call(this._target());
            }, t.prototype.value = function () {
              return n.call(this._target());
            }, t.prototype.reason = function () {
              var t = this._target();

              return t._unsetRejectionIsUnhandled(), r.call(t);
            }, t.prototype._value = function () {
              return this._settledValue();
            }, t.prototype._reason = function () {
              return this._unsetRejectionIsUnhandled(), this._settledValue();
            }, t.PromiseInspection = e;
          };
        }, {}],
        33: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n) {
            var r = t("./util"),
                o = r.errorObj,
                i = r.isObject,
                a = {}.hasOwnProperty;
            return function (t, s) {
              if (i(t)) {
                if (t instanceof e) return t;

                var c = function (t) {
                  try {
                    return function (t) {
                      return t.then;
                    }(t);
                  } catch (t) {
                    return o.e = t, o;
                  }
                }(t);

                if (c === o) {
                  s && s._pushContext();
                  var u = e.reject(c.e);
                  return s && s._popContext(), u;
                }

                if ("function" == typeof c) {
                  if (function (t) {
                    try {
                      return a.call(t, "_promise0");
                    } catch (t) {
                      return !1;
                    }
                  }(t)) {
                    var u = new e(n);
                    return t._then(u._fulfill, u._reject, void 0, u, null), u;
                  }

                  return function (t, i, a) {
                    var s = new e(n),
                        c = s;
                    a && a._pushContext(), s._captureStackTrace(), a && a._popContext();
                    var u = !0,
                        l = r.tryCatch(i).call(t, function (t) {
                      s && (s._resolveCallback(t), s = null);
                    }, function (t) {
                      s && (s._rejectCallback(t, u, !0), s = null);
                    });
                    return u = !1, s && l === o && (s._rejectCallback(l.e, !0, !0), s = null), c;
                  }(t, c, s);
                }
              }

              return t;
            };
          };
        }, {
          "./util": 36
        }],
        34: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r) {
            var o = t("./util"),
                i = e.TimeoutError;

            function a(t) {
              this.handle = t;
            }

            a.prototype._resultCancelled = function () {
              clearTimeout(this.handle);
            };

            var s = function s(t) {
              return c(+this).thenReturn(t);
            },
                c = e.delay = function (t, o) {
              var i, c;
              return void 0 !== o ? (i = e.resolve(o)._then(s, null, null, t, void 0), r.cancellation() && o instanceof e && i._setOnCancel(o)) : (i = new e(n), c = setTimeout(function () {
                i._fulfill();
              }, +t), r.cancellation() && i._setOnCancel(new a(c)), i._captureStackTrace()), i._setAsyncGuaranteed(), i;
            };

            function u(t) {
              return clearTimeout(this.handle), t;
            }

            function l(t) {
              throw clearTimeout(this.handle), t;
            }

            e.prototype.delay = function (t) {
              return c(t, this);
            }, e.prototype.timeout = function (t, e) {
              var n, s;
              t = +t;
              var c = new a(setTimeout(function () {
                n.isPending() && function (t, e, n) {
                  var r;
                  r = "string" != typeof e ? e instanceof Error ? e : new i("operation timed out") : new i(e), o.markAsOriginatingFromRejection(r), t._attachExtraTrace(r), t._reject(r), null != n && n.cancel();
                }(n, e, s);
              }, t));
              return r.cancellation() ? (s = this.then(), (n = s._then(u, l, void 0, c, void 0))._setOnCancel(c)) : n = this._then(u, l, void 0, c, void 0), n;
            };
          };
        }, {
          "./util": 36
        }],
        35: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i, a) {
            var s = t("./util"),
                c = t("./errors").TypeError,
                u = t("./util").inherits,
                l = s.errorObj,
                f = s.tryCatch,
                p = {};

            function h(t) {
              setTimeout(function () {
                throw t;
              }, 0);
            }

            function d(t, n) {
              var o = 0,
                  a = t.length,
                  s = new e(i);
              return function i() {
                if (o >= a) return s._fulfill();

                var c = function (t) {
                  var e = r(t);
                  return e !== t && "function" == typeof t._isDisposable && "function" == typeof t._getDisposer && t._isDisposable() && e._setDisposable(t._getDisposer()), e;
                }(t[o++]);

                if (c instanceof e && c._isDisposable()) {
                  try {
                    c = r(c._getDisposer().tryDispose(n), t.promise);
                  } catch (t) {
                    return h(t);
                  }

                  if (c instanceof e) return c._then(i, h, null, null, null);
                }

                i();
              }(), s;
            }

            function v(t, e, n) {
              this._data = t, this._promise = e, this._context = n;
            }

            function y(t, e, n) {
              this.constructor$(t, e, n);
            }

            function m(t) {
              return v.isDisposer(t) ? (this.resources[this.index]._setDisposable(t), t.promise()) : t;
            }

            function g(t) {
              this.length = t, this.promise = null, this[t - 1] = null;
            }

            v.prototype.data = function () {
              return this._data;
            }, v.prototype.promise = function () {
              return this._promise;
            }, v.prototype.resource = function () {
              return this.promise().isFulfilled() ? this.promise().value() : p;
            }, v.prototype.tryDispose = function (t) {
              var e = this.resource(),
                  n = this._context;
              void 0 !== n && n._pushContext();
              var r = e !== p ? this.doDispose(e, t) : null;
              return void 0 !== n && n._popContext(), this._promise._unsetDisposable(), this._data = null, r;
            }, v.isDisposer = function (t) {
              return null != t && "function" == typeof t.resource && "function" == typeof t.tryDispose;
            }, u(y, v), y.prototype.doDispose = function (t, e) {
              var n = this.data();
              return n.call(t, t, e);
            }, g.prototype._resultCancelled = function () {
              for (var t = this.length, n = 0; n < t; ++n) {
                var r = this[n];
                r instanceof e && r.cancel();
              }
            }, e.using = function () {
              var t = arguments.length;
              if (t < 2) return n("you must pass at least 2 arguments to Promise.using");
              var o,
                  i = arguments[t - 1];
              if ("function" != typeof i) return n("expecting a function but got " + s.classString(i));
              var c = !0;
              2 === t && Array.isArray(arguments[0]) ? (o = arguments[0], t = o.length, c = !1) : (o = arguments, t--);

              for (var u = new g(t), p = 0; p < t; ++p) {
                var h = o[p];

                if (v.isDisposer(h)) {
                  var y = h;

                  (h = h.promise())._setDisposable(y);
                } else {
                  var b = r(h);
                  b instanceof e && (h = b._then(m, null, null, {
                    resources: u,
                    index: p
                  }, void 0));
                }

                u[p] = h;
              }

              for (var _ = new Array(u.length), p = 0; p < _.length; ++p) {
                _[p] = e.resolve(u[p]).reflect();
              }

              var w = e.all(_).then(function (t) {
                for (var e = 0; e < t.length; ++e) {
                  var n = t[e];
                  if (n.isRejected()) return l.e = n.error(), l;
                  if (!n.isFulfilled()) return void w.cancel();
                  t[e] = n.value();
                }

                x._pushContext(), i = f(i);

                var r = c ? i.apply(void 0, t) : i(t),
                    o = x._popContext();

                return a.checkForgottenReturns(r, o, "Promise.using", x), r;
              }),
                  x = w.lastly(function () {
                var t = new e.PromiseInspection(w);
                return d(u, t);
              });
              return u.promise = x, x._setOnCancel(u), x;
            }, e.prototype._setDisposable = function (t) {
              this._bitField = 131072 | this._bitField, this._disposer = t;
            }, e.prototype._isDisposable = function () {
              return (131072 & this._bitField) > 0;
            }, e.prototype._getDisposer = function () {
              return this._disposer;
            }, e.prototype._unsetDisposable = function () {
              this._bitField = -131073 & this._bitField, this._disposer = void 0;
            }, e.prototype.disposer = function (t) {
              if ("function" == typeof t) return new y(t, this, o());
              throw new c();
            };
          };
        }, {
          "./errors": 12,
          "./util": 36
        }],
        36: [function (t, r, o) {
          "use strict";

          var i = t("./es5"),
              a = "undefined" == typeof navigator,
              s = {
            e: {}
          },
              c,
              u = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : void 0 !== this ? this : null;

          function l() {
            try {
              var t = c;
              return c = null, t.apply(this, arguments);
            } catch (t) {
              return s.e = t, s;
            }
          }

          function f(t) {
            return c = t, l;
          }

          var p = function p(t, e) {
            var n = {}.hasOwnProperty;

            function r() {
              for (var r in this.constructor = t, this.constructor$ = e, e.prototype) {
                n.call(e.prototype, r) && "$" !== r.charAt(r.length - 1) && (this[r + "$"] = e.prototype[r]);
              }
            }

            return r.prototype = e.prototype, t.prototype = new r(), t.prototype;
          };

          function h(t) {
            return null == t || !0 === t || !1 === t || "string" == typeof t || "number" == typeof t;
          }

          function d(t) {
            return "function" == typeof t || "object" == _typeof(t) && null !== t;
          }

          function v(t) {
            return h(t) ? new Error(S(t)) : t;
          }

          function y(t, e) {
            var n,
                r = t.length,
                o = new Array(r + 1);

            for (n = 0; n < r; ++n) {
              o[n] = t[n];
            }

            return o[n] = e, o;
          }

          function m(t, e, n) {
            if (!i.isES5) return {}.hasOwnProperty.call(t, e) ? t[e] : void 0;
            var r = Object.getOwnPropertyDescriptor(t, e);
            return null != r ? null == r.get && null == r.set ? r.value : n : void 0;
          }

          function g(t, e, n) {
            if (h(t)) return t;
            var r = {
              value: n,
              configurable: !0,
              enumerable: !1,
              writable: !0
            };
            return i.defineProperty(t, e, r), t;
          }

          function b(t) {
            throw t;
          }

          var _ = function () {
            var t = [Array.prototype, Object.prototype, Function.prototype],
                e = function e(_e4) {
              for (var n = 0; n < t.length; ++n) {
                if (t[n] === _e4) return !0;
              }

              return !1;
            };

            if (i.isES5) {
              var n = Object.getOwnPropertyNames;
              return function (t) {
                for (var r = [], o = Object.create(null); null != t && !e(t);) {
                  var a;

                  try {
                    a = n(t);
                  } catch (t) {
                    return r;
                  }

                  for (var s = 0; s < a.length; ++s) {
                    var c = a[s];

                    if (!o[c]) {
                      o[c] = !0;
                      var u = Object.getOwnPropertyDescriptor(t, c);
                      null != u && null == u.get && null == u.set && r.push(c);
                    }
                  }

                  t = i.getPrototypeOf(t);
                }

                return r;
              };
            }

            var r = {}.hasOwnProperty;
            return function (n) {
              if (e(n)) return [];
              var o = [];

              t: for (var i in n) {
                if (r.call(n, i)) o.push(i);else {
                  for (var a = 0; a < t.length; ++a) {
                    if (r.call(t[a], i)) continue t;
                  }

                  o.push(i);
                }
              }

              return o;
            };
          }(),
              w = /this\s*\.\s*\S+\s*=/;

          function x(t) {
            try {
              if ("function" == typeof t) {
                var e = i.names(t.prototype),
                    n = i.isES5 && e.length > 1,
                    r = e.length > 0 && !(1 === e.length && "constructor" === e[0]),
                    o = w.test(t + "") && i.names(t).length > 0;
                if (n || r || o) return !0;
              }

              return !1;
            } catch (t) {
              return !1;
            }
          }

          function O(t) {
            function e() {}

            e.prototype = t;
            var n = new e();

            function r() {
              return _typeof(n.foo);
            }

            return r(), r(), t;
          }

          var E = /^[a-z$_][a-z$_0-9]*$/i;

          function C(t) {
            return E.test(t);
          }

          function j(t, e, n) {
            for (var r = new Array(t), o = 0; o < t; ++o) {
              r[o] = e + o + n;
            }

            return r;
          }

          function S(t) {
            try {
              return t + "";
            } catch (t) {
              return "[no string representation]";
            }
          }

          function T(t) {
            return t instanceof Error || null !== t && "object" == _typeof(t) && "string" == typeof t.message && "string" == typeof t.name;
          }

          function P(t) {
            try {
              g(t, "isOperational", !0);
            } catch (t) {}
          }

          function k(t) {
            return null != t && (t instanceof Error.__BluebirdErrorTypes__.OperationalError || !0 === t.isOperational);
          }

          function M(t) {
            return T(t) && i.propertyIsWritable(t, "stack");
          }

          var z = "stack" in new Error() ? function (t) {
            return M(t) ? t : new Error(S(t));
          } : function (t) {
            if (M(t)) return t;

            try {
              throw new Error(S(t));
            } catch (t) {
              return t;
            }
          };

          function L(t) {
            return {}.toString.call(t);
          }

          function A(t, e, n) {
            for (var r = i.names(t), o = 0; o < r.length; ++o) {
              var a = r[o];
              if (n(a)) try {
                i.defineProperty(e, a, i.getDescriptor(t, a));
              } catch (t) {}
            }
          }

          var R = function R(t) {
            return i.isArray(t) ? t : null;
          };

          if ("undefined" != typeof Symbol && Symbol.iterator) {
            var N = "function" == typeof Array.from ? function (t) {
              return Array.from(t);
            } : function (t) {
              for (var e, n = [], r = t[Symbol.iterator](); !(e = r.next()).done;) {
                n.push(e.value);
              }

              return n;
            };

            R = function R(t) {
              return i.isArray(t) ? t : null != t && "function" == typeof t[Symbol.iterator] ? N(t) : null;
            };
          }

          var F = void 0 !== e && "[object process]" === L(e).toLowerCase(),
              I = void 0 !== e && void 0 !== e.env;

          function D(t) {
            return I ? e.env[t] : void 0;
          }

          function B() {
            if ("function" == typeof Promise) try {
              var t = new Promise(function () {});
              if ("[object Promise]" === {}.toString.call(t)) return Promise;
            } catch (t) {}
          }

          function V(t, e) {
            return t.bind(e);
          }

          var H = {
            isClass: x,
            isIdentifier: C,
            inheritedDataKeys: _,
            getDataPropertyOrDefault: m,
            thrower: b,
            isArray: i.isArray,
            asArray: R,
            notEnumerableProp: g,
            isPrimitive: h,
            isObject: d,
            isError: T,
            canEvaluate: a,
            errorObj: s,
            tryCatch: f,
            inherits: p,
            withAppended: y,
            maybeWrapAsError: v,
            toFastProperties: O,
            filledRange: j,
            toString: S,
            canAttachTrace: M,
            ensureErrorObject: z,
            originatesFromRejection: k,
            markAsOriginatingFromRejection: P,
            classString: L,
            copyDescriptors: A,
            hasDevTools: "undefined" != typeof chrome && chrome && "function" == typeof chrome.loadTimes,
            isNode: F,
            hasEnvVariables: I,
            env: D,
            global: u,
            getNativePromise: B,
            domainBind: V
          },
              U;
          H.isRecentNode = H.isNode && (U = e.versions.node.split(".").map(Number), 0 === U[0] && U[1] > 10 || U[0] > 0), H.isNode && H.toFastProperties(e);

          try {
            throw new Error();
          } catch (t) {
            H.lastLineError = t;
          }

          r.exports = H;
        }, {
          "./es5": 13
        }]
      }, {}, [4])(4);
    }(), "undefined" != typeof window && null !== window ? window.P = window.Promise : "undefined" != typeof self && null !== self && (self.P = self.Promise);
  }).call(this, n(278), n(71), n(338).setImmediate);
}, function (t, e) {
  t.exports = function (t, e) {
    return {
      enumerable: !(1 & t),
      configurable: !(2 & t),
      writable: !(4 & t),
      value: e
    };
  };
}, function (t, e, n) {
  var r = n(172);

  t.exports = function (t, e) {
    return r(t, e);
  };
}, function (t, e) {
  t.exports = {};
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0;
  var r,
      o = n(194),
      i = (r = o) && r.__esModule ? r : {
    "default": r
  };

  e["default"] = function (t) {
    if (Array.isArray(t)) {
      for (var e = 0, n = Array(t.length); e < t.length; e++) {
        n[e] = t[e];
      }

      return n;
    }

    return (0, i["default"])(t);
  };
}, function (t, e) {
  var n = Array.isArray;
  t.exports = n;
}, function (t, e, n) {
  "use strict";

  var r = n(0),
      o = n.n(r),
      i = n(1),
      a = n.n(i),
      s = n(18),
      c = n(24),
      u = n(77),
      l = n.n(u),
      f = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function p(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var h = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
        i[a] = arguments[a];
      }

      return n = r = p(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(i))), r.state = {
        visible: !1
      }, p(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), f(e, [{
      key: "componentWillReceiveProps",
      value: function value(t) {
        t.scrolling && this.setState({
          visible: !1
        });
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            e = this.props,
            n = e.activeLayer,
            r = e.tooltipOpened,
            i = e.icon,
            a = e.focusStyle,
            u = e.defaultStyle,
            l = e.tooltipText,
            f = this.state.visible;
        return n.layerConfig && !n.layerConfig.bbox ? null : o.a.createElement(c["default"], {
          overlay: l || "Fit to bounds",
          overlayClassName: "c-rc-tooltip -default",
          placement: "top",
          trigger: r ? "" : "hover",
          mouseLeaveDelay: 0,
          destroyTooltipOnHide: !0,
          onVisibleChange: function onVisibleChange(e) {
            return t.setState({
              visible: e
            });
          },
          visible: f
        }, o.a.createElement("button", {
          type: "button",
          className: "vizzuality__c-legend-button",
          "aria-label": "Fit to bounds",
          onClick: function onClick() {
            return t.props.onChangeBBox(n);
          }
        }, o.a.createElement(s["default"], {
          name: i || "icon-bbox",
          className: "-small",
          style: f ? a : u
        })));
      }
    }]), e;
  }();

  h.propTypes = {
    activeLayer: a.a.object,
    tooltipOpened: a.a.bool,
    icon: a.a.string,
    focusStyle: a.a.object,
    defaultStyle: a.a.object,
    tooltipText: a.a.string,
    scrolling: a.a.bool,
    onChangeBBox: a.a.func
  }, h.defaultProps = {
    activeLayer: {},
    icon: "",
    focusStyle: {},
    defaultStyle: {},
    tooltipOpened: !1,
    tooltipText: "",
    scrolling: !1,
    onChangeBBox: function onChangeBBox() {}
  };

  var d = h,
      v = n(282),
      y = n.n(v),
      m = n(14),
      g = n.n(m),
      b = n(11),
      _ = n.n(b),
      w = (n(332), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }()),
      x = {
    "./styles.scss": {
      "c-legend-item-button-layers-tooltip": "vizzuality__c-legend-item-button-layers-tooltip",
      "layers-list": "vizzuality__layers-list",
      "layers-list-item": "vizzuality__layers-list-item",
      "-active": "vizzuality__-active"
    }
  };

  var O = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), w(e, [{
      key: "render",
      value: function value() {
        var t = this,
            e = this.props,
            n = e.layers,
            r = e.activeLayer;
        return o.a.createElement("div", {
          className: "vizzuality__c-legend-item-button-layers-tooltip"
        }, "Layers", o.a.createElement("ul", {
          className: "vizzuality__layers-list"
        }, n.map(function (e) {
          return o.a.createElement("li", {
            key: e.id,
            onClick: function onClick() {
              return t.props.onChangeLayer(e);
            },
            className: g()(_()({
              "layers-list-item": !0,
              "-active": e.id === r.id
            }), x)
          }, e.name);
        })));
      }
    }]), e;
  }();

  O.propTypes = {
    layers: a.a.array.isRequired,
    activeLayer: a.a.object.isRequired,
    onChangeLayer: a.a.func.isRequired
  };

  var E = O,
      C = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  },
      j = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function S(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var T = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
        i[a] = arguments[a];
      }

      return n = r = S(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(i))), r.state = {
        visibilityHover: !1,
        visibilityClick: !1,
        multiLayersActive: 0 === r.props.i && r.props.layers.length > 1
      }, r.onTooltipVisibilityChange = function (t) {
        var e = r.props.onTooltipVisibilityChange,
            n = r.state.multiLayersActive;
        r.setState(C({
          visibilityHover: !1,
          visibilityClick: t
        }, n && {
          multiLayersActive: !1
        })), e(t);
      }, r.getTimelineLayers = function () {
        var t = r.props.layers;
        return y()(t.filter(function (t) {
          return t.layerConfig.timeline;
        }), function (t) {
          return t.layerConfig.order;
        });
      }, S(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), j(e, [{
      key: "componentWillReceiveProps",
      value: function value(t) {
        var e = this.props,
            n = e.scrolling,
            r = e.i,
            o = t.i;
        (n || r !== o) && this.onTooltipVisibilityChange(!1);
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            e = this.props,
            n = e.layers,
            r = e.activeLayer,
            i = e.icon,
            a = e.focusStyle,
            u = e.defaultStyle,
            l = e.tooltipText,
            f = e.onChangeLayer,
            p = e.tooltipOpened,
            h = this.state,
            d = h.visibilityClick,
            v = h.visibilityHover,
            y = h.multiLayersActive,
            m = this.getTimelineLayers();
        return 1 === n.length || m.length ? null : o.a.createElement(c["default"], {
          overlay: o.a.createElement(E, {
            layers: n,
            activeLayer: r,
            onChangeLayer: f
          }),
          overlayClassName: "c-rc-tooltip -default -layers",
          placement: "top",
          trigger: ["click"],
          visible: d,
          onVisibleChange: this.onTooltipVisibilityChange,
          destroyTooltipOnHide: !0
        }, o.a.createElement(c["default"], {
          visible: y || !d && v,
          overlay: l || n.length + " layers",
          overlayClassName: "c-rc-tooltip -default",
          placement: "top",
          trigger: p ? "" : "hover",
          onVisibleChange: function onVisibleChange(e) {
            return t.setState({
              visibilityHover: e,
              multiLayersActive: !1
            });
          },
          destroyTooltipOnHide: !0
        }, o.a.createElement("button", {
          type: "button",
          className: "vizzuality__c-legend-button vizzuality__layers",
          "aria-label": "Select other layer"
        }, o.a.createElement(s["default"], {
          name: i || "icon-layers",
          className: "-small",
          style: v || d ? a : u
        }))));
      }
    }]), e;
  }();

  T.propTypes = {
    layers: a.a.array,
    activeLayer: a.a.object,
    icon: a.a.string,
    focusStyle: a.a.object,
    defaultStyle: a.a.object,
    tooltipText: a.a.string,
    tooltipOpened: a.a.bool,
    scrolling: a.a.bool,
    onChangeLayer: a.a.func,
    onTooltipVisibilityChange: a.a.func
  }, T.defaultProps = {
    layers: [],
    activeLayer: {},
    icon: "",
    focusStyle: {},
    defaultStyle: {},
    tooltipOpened: !1,
    tooltipText: null,
    scrolling: !1,
    onChangeLayer: function onChangeLayer() {},
    onTooltipVisibilityChange: function onTooltipVisibilityChange() {}
  };

  var P = T,
      k = n(93),
      M = (n(334), Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }),
      z = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function L(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var A = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var n = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      R.call(n);
      var r = n.props.activeLayer,
          o = (void 0 === r ? {} : r).opacity;
      return n.state = {
        opacity: void 0 !== o ? o : 1
      }, n;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), z(e, [{
      key: "componentDidUpdate",
      value: function value(t, e) {
        var n = this.props.activeLayer.opacity,
            r = t.activeLayer.opacity,
            o = this.state.opacity,
            i = e.opacity;
        n !== r && o === i && this.setState({
          opacity: n
        });
      }
    }, {
      key: "render",
      value: function value() {
        var t,
            e = this,
            n = this.props,
            r = n.min,
            i = n.max,
            a = n.step,
            s = function (t, e) {
          var n = {};

          for (var r in t) {
            e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
          }

          return n;
        }(n, ["min", "max", "step"]),
            c = this.state.opacity;

        return o.a.createElement("div", {
          className: "vizzuality__c-legend-item-button-opacity-tooltip",
          ref: function ref(t) {
            e.el = t;
          }
        }, "Opacity", o.a.createElement("div", {
          className: "vizzuality__slider-tooltip-container"
        }, o.a.createElement(k["default"], M({
          marks: (t = {}, L(t, r, "0%"), L(t, i, "100%"), t),
          min: r,
          max: i,
          step: a,
          value: c,
          formatValue: function formatValue(t) {
            return Math.round(100 * t) + "%";
          },
          onChange: function onChange(t) {
            return e.setState({
              opacity: t
            });
          },
          onAfterChange: this.onChange,
          trackStyle: {
            backgroundColor: "#c32d7b",
            borderRadius: "0px"
          }
        }, s))));
      }
    }]), e;
  }();

  A.propTypes = {
    activeLayer: a.a.shape({}).isRequired,
    min: a.a.number,
    max: a.a.number,
    step: a.a.number,
    onChangeOpacity: a.a.func.isRequired
  }, A.defaultProps = {
    min: 0,
    max: 1,
    step: .01
  };

  var R = function R() {
    var t = this;

    this.onChange = function (e) {
      var n = t.props,
          r = n.activeLayer;
      (0, n.onChangeOpacity)(r, e);
    };
  },
      N = A,
      F = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  },
      I = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }(),
      D = {
    styles: {
      "c-legend-button": "vizzuality__c-legend-button",
      "-disabled": "vizzuality__-disabled",
      info: "vizzuality__info",
      close: "vizzuality__close",
      toggle: "vizzuality__toggle",
      opacity: "vizzuality__opacity",
      layers: "vizzuality__layers"
    }
  };

  function B(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var V = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
        i[a] = arguments[a];
      }

      return n = r = B(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(i))), r.state = {
        visibilityHover: !1,
        visibilityClick: !1
      }, r.onTooltipVisibilityChange = function (t) {
        var e = r.props,
            n = e.visibility,
            o = e.onTooltipVisibilityChange;
        n && (r.setState({
          visibilityHover: !1,
          visibilityClick: t
        }), o(t));
      }, r.setHoverText = function (t, e, n) {
        return t || (n ? "Opacity " + (void 0 !== e ? "(" + Math.round(100 * e) + "%)" : "") : "Opacity (disabled)");
      }, B(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), I(e, [{
      key: "componentWillReceiveProps",
      value: function value(t) {
        t.scrolling && this.onTooltipVisibilityChange(!1);
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            e = this.props,
            n = e.layers,
            r = e.visibility,
            i = e.activeLayer,
            a = e.tooltipOpened,
            u = e.icon,
            f = e.className,
            p = e.enabledStyle,
            h = e.defaultStyle,
            d = e.disabledStyle,
            v = e.focusStyle,
            y = e.tooltipText,
            m = (e.scrolling, e.onChangeOpacity),
            b = function (t, e) {
          var n = {};

          for (var r in t) {
            e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
          }

          return n;
        }(e, ["layers", "visibility", "activeLayer", "tooltipOpened", "icon", "className", "enabledStyle", "defaultStyle", "disabledStyle", "focusStyle", "tooltipText", "scrolling", "onChangeOpacity"]),
            w = this.state,
            x = w.visibilityClick,
            O = w.visibilityHover,
            E = i.opacity,
            C = r ? h : d;

        return r && (O || x) && (C = v), r && E < 1 && (C = p), o.a.createElement(c["default"], {
          overlay: r && o.a.createElement(N, F({
            layers: n,
            activeLayer: i,
            onChangeOpacity: m
          }, b)),
          visible: r && x,
          overlayClassName: "c-rc-tooltip " + _()({
            "-default": r
          }) + " " + (f || ""),
          placement: "top",
          trigger: ["click"],
          onVisibleChange: this.onTooltipVisibilityChange,
          destroyTooltipOnHide: !0
        }, o.a.createElement(c["default"], {
          visible: O && !x,
          overlay: this.setHoverText(y, E, r),
          overlayClassName: "c-rc-tooltip -default",
          placement: "top",
          trigger: a ? "" : "hover",
          onVisibleChange: function onVisibleChange(e) {
            return t.setState({
              visibilityHover: e
            });
          },
          destroyTooltipOnHide: !0,
          style: l.a.tooltip
        }, o.a.createElement("button", {
          type: "button",
          "aria-label": "Change opacity",
          className: g()("c-legend-button opacity " + _()({
            "-disabled": !r
          }), D)
        }, o.a.createElement(s["default"], {
          name: u || "icon-opacity",
          className: "-small",
          style: C
        }))));
      }
    }]), e;
  }();

  V.propTypes = {
    layers: a.a.arrayOf(a.a.shape({})),
    activeLayer: a.a.shape({}),
    visibility: a.a.bool,
    tooltipOpened: a.a.bool,
    icon: a.a.string,
    className: a.a.string,
    focusStyle: a.a.shape({}),
    defaultStyle: a.a.shape({}),
    enabledStyle: a.a.shape({}),
    disabledStyle: a.a.shape({}),
    tooltipText: a.a.string,
    scrolling: a.a.bool,
    onChangeOpacity: a.a.func,
    onTooltipVisibilityChange: a.a.func
  }, V.defaultProps = {
    layers: [],
    activeLayer: {},
    visibility: !0,
    icon: "",
    className: "",
    focusStyle: {},
    defaultStyle: {},
    enabledStyle: {},
    disabledStyle: {},
    tooltipOpened: !1,
    tooltipText: "",
    scrolling: !1,
    onChangeOpacity: function onChangeOpacity() {},
    onTooltipVisibilityChange: function onTooltipVisibilityChange() {}
  };

  var H = V,
      U = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function W(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var q = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
        i[a] = arguments[a];
      }

      return n = r = W(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(i))), r.state = {
        visible: !1
      }, W(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), U(e, [{
      key: "componentWillReceiveProps",
      value: function value(t) {
        t.scrolling && this.setState({
          visible: !1
        });
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            e = this.props,
            n = e.activeLayer,
            r = e.visibility,
            i = e.tooltipOpened,
            a = e.iconShow,
            u = e.iconHide,
            l = e.focusStyle,
            f = e.defaultStyle,
            p = e.tooltipText,
            h = this.state.visible,
            d = r ? u || "icon-hide" : a || "icon-show";
        return o.a.createElement(c["default"], {
          overlay: p || (r ? "Hide layer" : "Show layer"),
          overlayClassName: "c-rc-tooltip -default",
          placement: "top",
          trigger: i ? "" : "hover",
          mouseLeaveDelay: 0,
          destroyTooltipOnHide: !0,
          onVisibleChange: function onVisibleChange(e) {
            return t.setState({
              visible: e
            });
          },
          visible: h
        }, o.a.createElement("button", {
          type: "button",
          className: "vizzuality__c-legend-button vizzuality__toggle",
          onClick: function onClick() {
            return t.props.onChangeVisibility(n, !r);
          },
          "aria-label": "Toggle the visibility"
        }, o.a.createElement(s["default"], {
          name: d,
          className: "-small",
          style: h ? l : f
        })));
      }
    }]), e;
  }();

  q.propTypes = {
    activeLayer: a.a.object,
    visibility: a.a.bool,
    onChangeVisibility: a.a.func,
    iconShow: a.a.string,
    iconHide: a.a.string,
    focusStyle: a.a.object,
    defaultStyle: a.a.object,
    tooltipOpened: a.a.bool,
    tooltipText: a.a.string,
    scrolling: a.a.bool
  }, q.defaultProps = {
    activeLayer: {},
    visibility: !0,
    iconShow: "",
    iconHide: "",
    focusStyle: {},
    defaultStyle: {},
    tooltipOpened: !1,
    tooltipText: "",
    scrolling: !1,
    onChangeVisibility: function onChangeVisibility() {}
  };

  var G = q,
      K = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function Z(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var Y = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
        i[a] = arguments[a];
      }

      return n = r = Z(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(i))), r.state = {
        visible: !1
      }, Z(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), K(e, [{
      key: "componentWillReceiveProps",
      value: function value(t) {
        t.scrolling && this.setState({
          visible: !1
        });
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            e = this.props,
            n = e.activeLayer,
            r = e.tooltipOpened,
            i = e.icon,
            a = e.focusStyle,
            u = e.defaultStyle,
            l = e.tooltipText,
            f = this.state.visible;
        return o.a.createElement(c["default"], {
          overlay: l || "Layer info",
          overlayClassName: "c-rc-tooltip -default",
          placement: "top",
          trigger: r ? "" : "hover",
          mouseLeaveDelay: 0,
          destroyTooltipOnHide: !0,
          onVisibleChange: function onVisibleChange(e) {
            return t.setState({
              visible: e
            });
          },
          visible: f
        }, o.a.createElement("button", {
          type: "button",
          className: "vizzuality__c-legend-button",
          "aria-label": "More information",
          onClick: function onClick() {
            return t.props.onChangeInfo(n);
          }
        }, o.a.createElement(s["default"], {
          name: i || "icon-info",
          className: "-small",
          style: f ? a : u
        })));
      }
    }]), e;
  }();

  Y.propTypes = {
    activeLayer: a.a.object,
    icon: a.a.string,
    focusStyle: a.a.object,
    defaultStyle: a.a.object,
    tooltipOpened: a.a.bool,
    tooltipText: a.a.string,
    scrolling: a.a.bool,
    onChangeInfo: a.a.func
  }, Y.defaultProps = {
    activeLayer: {},
    icon: "",
    focusStyle: {},
    defaultStyle: {},
    tooltipOpened: !1,
    tooltipText: "",
    scrolling: !1,
    onChangeInfo: function onChangeInfo() {}
  };

  var $ = Y,
      X = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function Q(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var J = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
        i[a] = arguments[a];
      }

      return n = r = Q(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(i))), r.state = {
        visible: !1
      }, Q(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), X(e, [{
      key: "componentWillReceiveProps",
      value: function value(t) {
        t.scrolling && this.setState({
          visible: !1
        });
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            e = this.props,
            n = e.activeLayer,
            r = e.tooltipOpened,
            i = e.icon,
            a = e.focusStyle,
            u = e.defaultStyle,
            l = e.tooltipText,
            f = this.state.visible;
        return o.a.createElement(c["default"], {
          overlay: l || "Remove layer",
          overlayClassName: "c-rc-tooltip -default",
          placement: "top",
          trigger: r ? "" : "hover",
          mouseLeaveDelay: 0,
          destroyTooltipOnHide: !0,
          onVisibleChange: function onVisibleChange(e) {
            return t.setState({
              visible: e
            });
          },
          visible: f
        }, o.a.createElement("button", {
          type: "button",
          className: "vizzuality__c-legend-button vizzuality__close",
          onClick: function onClick() {
            return t.props.onRemoveLayer(n);
          },
          "aria-label": "Remove"
        }, o.a.createElement(s["default"], {
          name: i || "icon-cross",
          className: "-small",
          style: f ? a : u
        })));
      }
    }]), e;
  }();

  J.propTypes = {
    activeLayer: a.a.object,
    icon: a.a.string,
    focusStyle: a.a.object,
    defaultStyle: a.a.object,
    tooltipOpened: a.a.bool,
    tooltipText: a.a.string,
    scrolling: a.a.bool,
    onRemoveLayer: a.a.func
  }, J.defaultProps = {
    activeLayer: {},
    icon: "",
    focusStyle: {},
    defaultStyle: {},
    tooltipOpened: !1,
    tooltipText: "",
    scrolling: !1,
    onRemoveLayer: function onRemoveLayer() {}
  };
  var tt = J;
  n(336);
  n.d(e, "a", function () {
    return d;
  }), n.d(e, "c", function () {
    return P;
  }), n.d(e, "d", function () {
    return H;
  }), n.d(e, "f", function () {
    return G;
  }), n.d(e, "b", function () {
    return $;
  }), n.d(e, "e", function () {
    return tt;
  });

  var et = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  },
      nt = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function rt(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var ot = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
        i[a] = arguments[a];
      }

      return n = r = rt(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(i))), r.state = {
        tooltipOpened: !1
      }, r.onTooltipVisibilityChange = function (t) {
        r.setState({
          tooltipOpened: t
        });
      }, rt(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), nt(e, [{
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.children,
            n = function (t, e) {
          var n = {};

          for (var r in t) {
            e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
          }

          return n;
        }(t, ["children"]),
            r = this.state.tooltipOpened,
            i = et({}, n, {
          tooltipOpened: r,
          onTooltipVisibilityChange: this.onTooltipVisibilityChange
        });

        return o.a.createElement("div", {
          className: "vizzuality__c-legend-item-toolbar"
        }, !!o.a.Children.count(e) && o.a.Children.map(e, function (t) {
          return o.a.isValidElement(t) && "string" != typeof t.type ? o.a.cloneElement(t, et({}, i)) : t;
        }), !o.a.Children.count(e) && o.a.createElement(d, i), !o.a.Children.count(e) && o.a.createElement(P, i), !o.a.Children.count(e) && o.a.createElement(H, i), !o.a.Children.count(e) && o.a.createElement(G, i), !o.a.Children.count(e) && o.a.createElement($, i), !o.a.Children.count(e) && o.a.createElement(tt, i));
      }
    }]), e;
  }();

  ot.propTypes = {
    children: a.a.node,
    enabledStyle: a.a.object,
    defaultStyle: a.a.object,
    disabledStyle: a.a.object,
    focusStyle: a.a.object,
    onChangeBBox: a.a.func,
    onChangeLayer: a.a.func,
    onChangeOpacity: a.a.func,
    onChangeVisibility: a.a.func,
    onRemoveLayer: a.a.func,
    onChangeInfo: a.a.func
  }, ot.defaultProps = {
    children: [],
    defaultStyle: {
      fill: "#717171"
    },
    enabledStyle: {
      fill: "#2C75B0"
    },
    disabledStyle: {
      fill: "#CACCD0"
    },
    focusStyle: {
      fill: "#393f44"
    },
    onChangeBBox: function onChangeBBox(t) {},
    onChangeInfo: function onChangeInfo(t) {},
    onChangeLayer: function onChangeLayer(t) {},
    onChangeVisibility: function onChangeVisibility(t, e) {},
    onChangeOpacity: function onChangeOpacity(t, e) {},
    onRemoveLayer: function onRemoveLayer(t) {}
  };
  e.g = ot;
}, function (t, e, n) {
  var r = n(80),
      o = n(58);

  t.exports = Object.keys || function (t) {
    return r(t, o);
  };
}, function (t, e) {
  var n = 0,
      r = Math.random();

  t.exports = function (t) {
    return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
  };
}, function (t, e) {
  e.f = {}.propertyIsEnumerable;
}, function (t, e, n) {
  var r = n(54);

  t.exports = function (t) {
    return Object(r(t));
  };
}, function (t, e, n) {
  var r = n(51),
      o = n(170),
      i = n(171),
      a = "[object Null]",
      s = "[object Undefined]",
      c = r ? r.toStringTag : void 0;

  t.exports = function (t) {
    return null == t ? void 0 === t ? s : a : c && c in Object(t) ? o(t) : i(t);
  };
}, function (t, e, n) {
  var r = n(231),
      o = n(234);

  t.exports = function (t, e) {
    var n = o(t, e);
    return r(n) ? n : void 0;
  };
}, function (t, e) {
  t.exports = function (t) {
    var e = _typeof(t);

    return null != t && ("object" == e || "function" == e);
  };
}, function (t, e, n) {
  var r = n(36).Symbol;
  t.exports = r;
}, function (t, e) {
  t.exports = function (t) {
    return null != t && "object" == _typeof(t);
  };
}, function (t, e, n) {
  var r = n(30);

  t.exports = function (t, e) {
    if (!r(t)) return t;
    var n, o;
    if (e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
    if ("function" == typeof (n = t.valueOf) && !r(o = n.call(t))) return o;
    if (!e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
    throw TypeError("Can't convert object to primitive value");
  };
}, function (t, e) {
  t.exports = function (t) {
    if (void 0 == t) throw TypeError("Can't call method on  " + t);
    return t;
  };
}, function (t, e) {
  var n = Math.ceil,
      r = Math.floor;

  t.exports = function (t) {
    return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
  };
}, function (t, e, n) {
  var r = n(57)("keys"),
      o = n(45);

  t.exports = function (t) {
    return r[t] || (r[t] = o(t));
  };
}, function (t, e, n) {
  var r = n(22),
      o = r["__core-js_shared__"] || (r["__core-js_shared__"] = {});

  t.exports = function (t) {
    return o[t] || (o[t] = {});
  };
}, function (t, e) {
  t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
}, function (t, e) {
  e.f = Object.getOwnPropertySymbols;
}, function (t, e) {
  t.exports = !0;
}, function (t, e, n) {
  var r = n(32),
      o = n(128),
      i = n(58),
      a = n(56)("IE_PROTO"),
      s = function s() {},
      _c2 = function c() {
    var t,
        e = n(79)("iframe"),
        r = i.length;

    for (e.style.display = "none", n(129).appendChild(e), e.src = "javascript:", (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), _c2 = t.F; r--;) {
      delete _c2.prototype[i[r]];
    }

    return _c2();
  };

  t.exports = Object.create || function (t, e) {
    var n;
    return null !== t ? (s.prototype = r(t), n = new s(), s.prototype = null, n[a] = t) : n = _c2(), void 0 === e ? n : o(n, e);
  };
}, function (t, e, n) {
  var r = n(23).f,
      o = n(27),
      i = n(19)("toStringTag");

  t.exports = function (t, e, n) {
    t && !o(t = n ? t : t.prototype, i) && r(t, i, {
      configurable: !0,
      value: e
    });
  };
}, function (t, e, n) {
  e.f = n(19);
}, function (t, e, n) {
  var r = n(22),
      o = n(16),
      i = n(60),
      a = n(63),
      s = n(23).f;

  t.exports = function (t) {
    var e = o.Symbol || (o.Symbol = i ? {} : r.Symbol || {});
    "_" == t.charAt(0) || t in e || s(e, t, {
      value: a.f(t)
    });
  };
}, function (t, e, n) {
  "use strict";

  var r = n(0),
      o = n.n(r),
      i = n(1),
      a = n.n(i),
      s = n(216),
      c = n(217),
      u = n.n(c),
      l = n(39),
      f = n.n(l),
      p = n(177),
      h = n(14),
      d = n.n(h),
      v = (n(340), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }()),
      y = {
    "./styles.scss": {
      "c-legend-item-basic": "vizzuality__c-legend-item-basic",
      name: "vizzuality__name",
      unit: "vizzuality__unit",
      "icon-square": "vizzuality__icon-square",
      "icon-line": "vizzuality__icon-line",
      "icon-circle": "vizzuality__icon-circle",
      "icon-triangle": "vizzuality__icon-triangle",
      "custom-icon": "vizzuality__custom-icon"
    }
  };

  function m(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var g = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var i = arguments.length, a = Array(i), s = 0; s < i; s++) {
        a[s] = arguments[s];
      }

      return n = r = m(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(a))), r.getIconHtml = function (t) {
        var e = r.props,
            n = e.name,
            i = e.hideIcon,
            a = e.color,
            s = e.size,
            c = e.icon;
        return i ? null : "triangle" === t ? o.a.createElement("div", {
          style: {
            boderRightWidth: s / 2,
            boderLeftWidth: s / 2,
            boderBottomWidth: s,
            borderBottomColor: a
          },
          className: d()("icon-" + c, y)
        }) : "line" === t ? o.a.createElement("div", {
          style: {
            width: s,
            backgroundColor: a
          },
          className: d()("icon-" + c, y)
        }) : "square" === t || "circle" === t ? o.a.createElement("div", {
          style: {
            width: s,
            height: s,
            backgroundColor: a
          },
          className: d()("icon-" + c, y)
        }) : o.a.createElement("div", {
          className: "vizzuality__custom-icon"
        }, o.a.createElement("img", {
          src: c,
          alt: n
        }));
      }, m(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, o.a.PureComponent), v(e, [{
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.name,
            n = t.icon;
        return o.a.createElement("div", {
          className: "vizzuality__c-legend-item-basic"
        }, this.getIconHtml(n), o.a.createElement("span", {
          className: "vizzuality__name"
        }, e));
      }
    }]), e;
  }();

  g.propTypes = {
    size: a.a.number,
    color: a.a.string,
    name: a.a.string,
    icon: a.a.string,
    hideIcon: a.a.bool
  }, g.defaultProps = {
    size: 12,
    color: "transparent",
    name: "",
    icon: "square",
    hideIcon: !1
  };

  var b = g,
      _ = (n(342), Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }),
      w = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }(),
      x = {
    "./styles.scss": {
      "c-legend-type-basic": "vizzuality__c-legend-type-basic",
      columns: "vizzuality__columns",
      horizontal: "vizzuality__horizontal",
      vertical: "vizzuality__vertical",
      "legend-basic-group": "vizzuality__legend-basic-group"
    }
  };

  var O = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, o.a.PureComponent), w(e, [{
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.activeLayer,
            n = t.mode,
            r = e.legendConfig;
        return r && "basic" === r.type ? o.a.createElement("div", {
          className: "vizzuality__c-legend-type-basic"
        }, o.a.createElement("ul", {
          className: d()(n, x)
        }, r.items.map(function (t) {
          return o.a.createElement("li", {
            key: "legend-basic-item-" + t.name
          }, o.a.createElement(b, t), !!t.items && t.items.length && o.a.createElement("ul", {
            className: "vizzuality__legend-basic-group"
          }, t.items.map(function (t) {
            return o.a.createElement("li", {
              key: "legend-basic-item-" + t.name
            }, o.a.createElement(b, _({
              style: {
                borderBottom: 0
              }
            }, t)));
          })));
        }))) : null;
      }
    }]), e;
  }();

  O.propTypes = {
    activeLayer: a.a.shape({}),
    mode: a.a.oneOf(["horizontal", "vertical", "columns"])
  }, O.defaultProps = {
    activeLayer: {},
    mode: "vertical"
  };
  var E = O,
      C = (n(344), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }());

  var j = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, o.a.PureComponent), C(e, [{
      key: "render",
      value: function value() {
        var t = this.props.activeLayer.legendConfig;
        return t && "choropleth" === t.type ? o.a.createElement("div", {
          className: "vizzuality__c-legend-type-choropleth"
        }, o.a.createElement("ul", null, t.items.map(function (e, n) {
          var r = e.color;
          return o.a.createElement("li", {
            key: "legend-choropleth-item-" + r + "-" + n,
            style: {
              width: 100 / t.items.length + "%"
            }
          }, o.a.createElement("div", {
            className: "vizzuality__icon-choropleth",
            style: {
              backgroundColor: r
            }
          }));
        })), o.a.createElement("ul", null, t.items.filter(function (t) {
          return t.value || t.name;
        }).map(function (e, n) {
          var r = e.name,
              i = e.value,
              a = e.color,
              s = e.styles,
              c = void 0 === s ? {} : s;
          return o.a.createElement("li", {
            key: "legend-choropleth-item-" + a + "-" + n,
            style: {
              width: 100 / t.items.length + "%"
            }
          }, o.a.createElement("span", {
            className: "vizzuality__name",
            style: c
          }, r || i));
        }))) : null;
      }
    }]), e;
  }();

  j.propTypes = {
    activeLayer: a.a.shape({})
  }, j.defaultProps = {
    activeLayer: {}
  };
  var S = j,
      T = (n(346), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }());

  var P = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), T(e, [{
      key: "render",
      value: function value() {
        var t = this.props.activeLayer.legendConfig;
        if (!t || "gradient" !== t.type) return null;
        var e = t.items.filter(function (t) {
          return "transparent" !== t.color;
        }),
            n = t.items.find(function (t) {
          return "transparent" === t.color;
        }),
            r = e.map(function (t) {
          return t.color;
        });
        return o.a.createElement("div", {
          className: "vizzuality__c-legend-type-gradient"
        }, o.a.createElement("div", {
          className: "vizzuality__legend-gradient-icon"
        }, n && o.a.createElement("div", {
          style: {
            width: 1 / t.items.length * 100 + "%"
          },
          className: "vizzuality__icon-gradient-transparent"
        }), o.a.createElement("div", {
          className: "vizzuality__icon-gradient",
          style: {
            width: e.length / t.items.length * 100 + "%",
            backgroundImage: "linear-gradient(to right, " + r.join(",") + ")"
          }
        })), o.a.createElement("ul", null, t.items.map(function (t) {
          var e = t.name,
              n = t.color,
              r = t.value;
          return e || r ? o.a.createElement("li", {
            key: "legend-gradient-item-" + n + "-" + r + "-" + e
          }, o.a.createElement("span", {
            className: "vizzuality__name"
          }, e || r)) : null;
        })));
      }
    }]), e;
  }();

  P.propTypes = {
    activeLayer: a.a.shape({})
  }, P.defaultProps = {
    activeLayer: {}
  };
  var k = P,
      M = (n(348), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }());

  var z = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), M(e, [{
      key: "render",
      value: function value() {
        var t = this.props.activeLayer.legendConfig;
        return t && "proportional" === t.type ? o.a.createElement("ul", {
          className: "vizzuality__c-legend-type-proportional"
        }, t.items.map(function (t) {
          var e = t.name,
              n = t.color,
              r = t.size;
          return o.a.createElement("li", {
            key: "legend-proportional-item-" + e
          }, o.a.createElement("div", {
            className: "vizzuality__icon-proportional",
            style: {
              backgroundColor: n,
              width: r,
              height: r
            }
          }), o.a.createElement("span", {
            className: "vizzuality__name"
          }, e));
        })) : null;
      }
    }]), e;
  }();

  z.propTypes = {
    activeLayer: a.a.object
  }, z.defaultProps = {
    activeLayer: {}
  };
  var L = z;
  n(350);
  n.d(e, "a", function () {
    return E;
  }), n.d(e, "b", function () {
    return S;
  }), n.d(e, "c", function () {
    return k;
  }), n.d(e, "d", function () {
    return L;
  });

  var A = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  },
      R = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function N(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var F = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
        i[a] = arguments[a];
      }

      return n = r = N(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(i))), r.state = {
        activeLayer: {},
        loading: !1
      }, r.fetchLegend = function (t) {
        var e = r.props.activeLayer,
            n = ((e || {}).legendConfig || {}).dataParse;
        r.setState({
          loading: !0
        }), fetch(t).then(function (t) {
          if (t.ok) return t.json();
        }).then(function (t) {
          var o = "function" == typeof n ? n(e, t) : t;
          r.setState({
            activeLayer: o,
            loading: !1
          });
        })["catch"](function () {
          r.setState({
            loading: !1
          });
        });
      }, N(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), R(e, [{
      key: "componentDidMount",
      value: function value() {
        var t = (this.props.activeLayer || {}).legendConfig,
            e = t || {},
            n = e.params,
            r = void 0 === n ? {} : n,
            o = e.sqlParams,
            i = void 0 === o ? {} : o,
            a = Object(s.a)(JSON.stringify(t), r, i),
            c = JSON.parse(a).url;
        c && this.fetchLegend(c);
      }
    }, {
      key: "componentDidUpdate",
      value: function value(t) {
        var e = t.activeLayer.legendConfig,
            n = e.params,
            r = void 0 === n ? {} : n,
            o = e.sqlParams,
            i = void 0 === o ? {} : o,
            a = this.props.activeLayer.legendConfig,
            c = a.params,
            u = void 0 === c ? {} : c,
            l = a.sqlParams,
            p = void 0 === l ? {} : l;

        if (!f()(u, r) || !f()(p, i)) {
          var h = Object(s.a)(JSON.stringify(a), u, p),
              d = (JSON.parse(h) || {}).url;
          d && this.fetchLegend(d);
        }
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            e = this.props,
            n = e.children,
            r = e.activeLayer,
            i = this.state,
            a = i.loading,
            s = i.activeLayer,
            c = (((u()(s) ? r : s) || {}).legendConfig || {}).url,
            l = !c || c && !u()(s);
        return o.a.createElement("div", {
          className: "vizzuality__c-legend-item-types"
        }, c && a && o.a.createElement(p["default"], {
          position: "relative",
          style: {
            box: {
              width: 20,
              height: 20
            }
          }
        }), l && !!o.a.Children.count(n) && o.a.Children.map(n, function (e) {
          return o.a.isValidElement(e) && "string" != typeof e.type ? o.a.cloneElement(e, A({}, t.props)) : e;
        }), l && !o.a.Children.count(n) && o.a.createElement(E, this.props), l && !o.a.Children.count(n) && o.a.createElement(S, this.props), l && !o.a.Children.count(n) && o.a.createElement(k, this.props), l && !o.a.Children.count(n) && o.a.createElement(L, this.props));
      }
    }]), e;
  }();

  F.propTypes = {
    children: a.a.node,
    activeLayer: a.a.object
  }, F.defaultProps = {
    children: [],
    activeLayer: {}
  };
  e.e = F;
}, function (t, e, n) {
  "use strict";

  t.exports = function () {};
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0;
  var r = i(n(188)),
      o = i(n(191));

  function i(t) {
    return t && t.__esModule ? t : {
      "default": t
    };
  }

  e["default"] = function t(e, n, i) {
    null === e && (e = Function.prototype);
    var a = (0, o["default"])(e, n);

    if (void 0 === a) {
      var s = (0, r["default"])(e);
      return null === s ? void 0 : t(s, n, i);
    }

    if ("value" in a) return a.value;
    var c = a.get;
    return void 0 !== c ? c.call(i) : void 0;
  };
}, function (t, e, n) {
  var r = n(120);

  t.exports = function (t, e, n) {
    if (r(t), void 0 === e) return t;

    switch (n) {
      case 1:
        return function (n) {
          return t.call(e, n);
        };

      case 2:
        return function (n, r) {
          return t.call(e, n, r);
        };

      case 3:
        return function (n, r, o) {
          return t.call(e, n, r, o);
        };
    }

    return function () {
      return t.apply(e, arguments);
    };
  };
}, function (t, e) {
  var n = {}.toString;

  t.exports = function (t) {
    return n.call(t).slice(8, -1);
  };
}, function (t, e, n) {
  var r = n(46),
      o = n(38),
      i = n(28),
      a = n(53),
      s = n(27),
      c = n(78),
      u = Object.getOwnPropertyDescriptor;
  e.f = n(26) ? u : function (t, e) {
    if (t = i(t), e = a(e, !0), c) try {
      return u(t, e);
    } catch (t) {}
    if (s(t, e)) return o(!r.f.call(t, e), t[e]);
  };
}, function (t, e) {
  var n;

  n = function () {
    return this;
  }();

  try {
    n = n || Function("return this")() || (0, eval)("this");
  } catch (t) {
    "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
  }

  t.exports = n;
}, function (t, e, n) {
  var r = n(103),
      o = n(92);

  t.exports = function (t) {
    return null != t && o(t.length) && !r(t);
  };
}, function (t, e, n) {
  "use strict";

  n.r(e);
  var r = n(3),
      o = n.n(r),
      i = n(5),
      a = n.n(i),
      s = n(4),
      c = n.n(s),
      u = n(6),
      l = n.n(u),
      f = n(0),
      p = n.n(f),
      h = n(2),
      d = n.n(h),
      v = n(8),
      y = n.n(v);

  function m(t, e) {
    for (var n = e; n;) {
      if (n === t) return !0;
      n = n.parentNode;
    }

    return !1;
  }

  var g = n(15),
      b = n(20),
      _ = n.n(b),
      w = void 0,
      x = {
    Webkit: "-webkit-",
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-"
  };

  function O() {
    if (void 0 !== w) return w;
    w = "";
    var t = document.createElement("p").style;

    for (var e in x) {
      e + "Transform" in t && (w = e);
    }

    return w;
  }

  function E() {
    return O() ? O() + "TransitionProperty" : "transitionProperty";
  }

  function C() {
    return O() ? O() + "Transform" : "transform";
  }

  function j(t, e) {
    var n = E();
    n && (t.style[n] = e, "transitionProperty" !== n && (t.style.transitionProperty = e));
  }

  function S(t, e) {
    var n = C();
    n && (t.style[n] = e, "transform" !== n && (t.style.transform = e));
  }

  var T = /matrix\((.*)\)/,
      P = /matrix3d\((.*)\)/;
  var k = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
    return _typeof(t);
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
  },
      M = void 0;

  function z(t) {
    var e = t.style.display;
    t.style.display = "none", t.offsetHeight, t.style.display = e;
  }

  function L(t, e, n) {
    var r = n;
    if ("object" !== (void 0 === e ? "undefined" : k(e))) return void 0 !== r ? ("number" == typeof r && (r += "px"), void (t.style[e] = r)) : M(t, e);

    for (var o in e) {
      e.hasOwnProperty(o) && L(t, o, e[o]);
    }
  }

  function A(t, e) {
    var n = t["page" + (e ? "Y" : "X") + "Offset"],
        r = "scroll" + (e ? "Top" : "Left");

    if ("number" != typeof n) {
      var o = t.document;
      "number" != typeof (n = o.documentElement[r]) && (n = o.body[r]);
    }

    return n;
  }

  function R(t) {
    return A(t);
  }

  function N(t) {
    return A(t, !0);
  }

  function F(t) {
    var e = function (t) {
      var e,
          n = void 0,
          r = void 0,
          o = t.ownerDocument,
          i = o.body,
          a = o && o.documentElement;
      return n = (e = t.getBoundingClientRect()).left, r = e.top, {
        left: n -= a.clientLeft || i.clientLeft || 0,
        top: r -= a.clientTop || i.clientTop || 0
      };
    }(t),
        n = t.ownerDocument,
        r = n.defaultView || n.parentWindow;

    return e.left += R(r), e.top += N(r), e;
  }

  function I(t) {
    return null !== t && void 0 !== t && t == t.window;
  }

  function D(t) {
    return I(t) ? t.document : 9 === t.nodeType ? t : t.ownerDocument;
  }

  var B = new RegExp("^(" + /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source + ")(?!px)[a-z%]+$", "i"),
      V = /^(top|right|bottom|left)$/,
      H = "currentStyle",
      U = "runtimeStyle",
      W = "left",
      q = "px";

  function G(t, e) {
    return "left" === t ? e.useCssRight ? "right" : t : e.useCssBottom ? "bottom" : t;
  }

  function K(t) {
    return "left" === t ? "right" : "right" === t ? "left" : "top" === t ? "bottom" : "bottom" === t ? "top" : void 0;
  }

  function Z(t, e, n) {
    "static" === L(t, "position") && (t.style.position = "relative");
    var r = -999,
        o = -999,
        i = G("left", n),
        a = G("top", n),
        s = K(i),
        c = K(a);
    "left" !== i && (r = 999), "top" !== a && (o = 999);
    var u,
        l = "",
        f = F(t);
    ("left" in e || "top" in e) && (l = (u = t).style.transitionProperty || u.style[E()] || "", j(t, "none")), "left" in e && (t.style[s] = "", t.style[i] = r + "px"), "top" in e && (t.style[c] = "", t.style[a] = o + "px"), z(t);
    var p = F(t),
        h = {};

    for (var d in e) {
      if (e.hasOwnProperty(d)) {
        var v = G(d, n),
            y = "left" === d ? r : o,
            m = f[d] - p[d];
        h[v] = v === d ? y + m : y - m;
      }
    }

    L(t, h), z(t), ("left" in e || "top" in e) && j(t, l);
    var g = {};

    for (var b in e) {
      if (e.hasOwnProperty(b)) {
        var _ = G(b, n),
            w = e[b] - f[b];

        g[_] = b === _ ? h[_] + w : h[_] - w;
      }
    }

    L(t, g);
  }

  function Y(t, e) {
    var n = F(t),
        r = function (t) {
      var e = window.getComputedStyle(t, null),
          n = e.getPropertyValue("transform") || e.getPropertyValue(C());

      if (n && "none" !== n) {
        var r = n.replace(/[^0-9\-.,]/g, "").split(",");
        return {
          x: parseFloat(r[12] || r[4], 0),
          y: parseFloat(r[13] || r[5], 0)
        };
      }

      return {
        x: 0,
        y: 0
      };
    }(t),
        o = {
      x: r.x,
      y: r.y
    };

    "left" in e && (o.x = r.x + e.left - n.left), "top" in e && (o.y = r.y + e.top - n.top), function (t, e) {
      var n = window.getComputedStyle(t, null),
          r = n.getPropertyValue("transform") || n.getPropertyValue(C());

      if (r && "none" !== r) {
        var o = void 0,
            i = r.match(T);
        i ? ((o = (i = i[1]).split(",").map(function (t) {
          return parseFloat(t, 10);
        }))[4] = e.x, o[5] = e.y, S(t, "matrix(" + o.join(",") + ")")) : ((o = r.match(P)[1].split(",").map(function (t) {
          return parseFloat(t, 10);
        }))[12] = e.x, o[13] = e.y, S(t, "matrix3d(" + o.join(",") + ")"));
      } else S(t, "translateX(" + e.x + "px) translateY(" + e.y + "px) translateZ(0)");
    }(t, o);
  }

  function $(t, e) {
    for (var n = 0; n < t.length; n++) {
      e(t[n]);
    }
  }

  function X(t) {
    return "border-box" === M(t, "boxSizing");
  }

  "undefined" != typeof window && (M = window.getComputedStyle ? function (t, e, n) {
    var r = n,
        o = "",
        i = D(t);
    return (r = r || i.defaultView.getComputedStyle(t, null)) && (o = r.getPropertyValue(e) || r[e]), o;
  } : function (t, e) {
    var n = t[H] && t[H][e];

    if (B.test(n) && !V.test(e)) {
      var r = t.style,
          o = r[W],
          i = t[U][W];
      t[U][W] = t[H][W], r[W] = "fontSize" === e ? "1em" : n || 0, n = r.pixelLeft + q, r[W] = o, t[U][W] = i;
    }

    return "" === n ? "auto" : n;
  });
  var Q = ["margin", "border", "padding"],
      J = -1,
      tt = 2,
      et = 1;

  function nt(t, e, n) {
    var r = 0,
        o = void 0,
        i = void 0,
        a = void 0;

    for (i = 0; i < e.length; i++) {
      if (o = e[i]) for (a = 0; a < n.length; a++) {
        var s = void 0;
        s = "border" === o ? "" + o + n[a] + "Width" : o + n[a], r += parseFloat(M(t, s)) || 0;
      }
    }

    return r;
  }

  var rt = {};

  function ot(t, e, n) {
    var r = n;
    if (I(t)) return "width" === e ? rt.viewportWidth(t) : rt.viewportHeight(t);
    if (9 === t.nodeType) return "width" === e ? rt.docWidth(t) : rt.docHeight(t);
    var o = "width" === e ? ["Left", "Right"] : ["Top", "Bottom"],
        i = "width" === e ? t.getBoundingClientRect().width : t.getBoundingClientRect().height,
        a = (M(t), X(t)),
        s = 0;
    (null === i || void 0 === i || i <= 0) && (i = void 0, (null === (s = M(t, e)) || void 0 === s || Number(s) < 0) && (s = t.style[e] || 0), s = parseFloat(s) || 0), void 0 === r && (r = a ? et : J);
    var c = void 0 !== i || a,
        u = i || s;
    return r === J ? c ? u - nt(t, ["border", "padding"], o) : s : c ? r === et ? u : u + (r === tt ? -nt(t, ["border"], o) : nt(t, ["margin"], o)) : s + nt(t, Q.slice(r), o);
  }

  $(["Width", "Height"], function (t) {
    rt["doc" + t] = function (e) {
      var n = e.document;
      return Math.max(n.documentElement["scroll" + t], n.body["scroll" + t], rt["viewport" + t](n));
    }, rt["viewport" + t] = function (e) {
      var n = "client" + t,
          r = e.document,
          o = r.body,
          i = r.documentElement[n];
      return "CSS1Compat" === r.compatMode && i || o && o[n] || i;
    };
  });
  var it = {
    position: "absolute",
    visibility: "hidden",
    display: "block"
  };

  function at() {
    for (var t = arguments.length, e = Array(t), n = 0; n < t; n++) {
      e[n] = arguments[n];
    }

    var r = void 0,
        o = e[0];
    return 0 !== o.offsetWidth ? r = ot.apply(void 0, e) : function (t, e, n) {
      var r = {},
          o = t.style,
          i = void 0;

      for (i in e) {
        e.hasOwnProperty(i) && (r[i] = o[i], o[i] = e[i]);
      }

      for (i in n.call(t), e) {
        e.hasOwnProperty(i) && (o[i] = r[i]);
      }
    }(o, it, function () {
      r = ot.apply(void 0, e);
    }), r;
  }

  function st(t, e) {
    for (var n in e) {
      e.hasOwnProperty(n) && (t[n] = e[n]);
    }

    return t;
  }

  $(["width", "height"], function (t) {
    var e = t.charAt(0).toUpperCase() + t.slice(1);

    rt["outer" + e] = function (e, n) {
      return e && at(e, t, n ? 0 : et);
    };

    var n = "width" === t ? ["Left", "Right"] : ["Top", "Bottom"];

    rt[t] = function (e, r) {
      var o = r;
      if (void 0 === o) return e && at(e, t, J);

      if (e) {
        M(e);
        return X(e) && (o += nt(e, ["padding", "border"], n)), L(e, t, o);
      }
    };
  });
  var ct = {
    getWindow: function getWindow(t) {
      if (t && t.document && t.setTimeout) return t;
      var e = t.ownerDocument || t;
      return e.defaultView || e.parentWindow;
    },
    getDocument: D,
    offset: function offset(t, e, n) {
      if (void 0 === e) return F(t);
      !function (t, e, n) {
        n.useCssRight || n.useCssBottom ? Z(t, e, n) : n.useCssTransform && C() in document.body.style ? Y(t, e) : Z(t, e, n);
      }(t, e, n || {});
    },
    isWindow: I,
    each: $,
    css: L,
    clone: function clone(t) {
      var e = void 0,
          n = {};

      for (e in t) {
        t.hasOwnProperty(e) && (n[e] = t[e]);
      }

      if (t.overflow) for (e in t) {
        t.hasOwnProperty(e) && (n.overflow[e] = t.overflow[e]);
      }
      return n;
    },
    mix: st,
    getWindowScrollLeft: function getWindowScrollLeft(t) {
      return R(t);
    },
    getWindowScrollTop: function getWindowScrollTop(t) {
      return N(t);
    },
    merge: function merge() {
      for (var t = {}, e = arguments.length, n = Array(e), r = 0; r < e; r++) {
        n[r] = arguments[r];
      }

      for (var o = 0; o < n.length; o++) {
        ct.mix(t, n[o]);
      }

      return t;
    },
    viewportWidth: 0,
    viewportHeight: 0
  };
  st(ct, rt);
  var ut = ct;

  var lt = function lt(t) {
    if (ut.isWindow(t) || 9 === t.nodeType) return null;
    var e = ut.getDocument(t).body,
        n = void 0,
        r = ut.css(t, "position");
    if ("fixed" !== r && "absolute" !== r) return "html" === t.nodeName.toLowerCase() ? null : t.parentNode;

    for (n = t.parentNode; n && n !== e; n = n.parentNode) {
      if ("static" !== (r = ut.css(n, "position"))) return n;
    }

    return null;
  };

  var ft = function ft(t) {
    for (var e = {
      left: 0,
      right: 1 / 0,
      top: 0,
      bottom: 1 / 0
    }, n = lt(t), r = ut.getDocument(t), o = r.defaultView || r.parentWindow, i = r.body, a = r.documentElement; n;) {
      if (-1 !== navigator.userAgent.indexOf("MSIE") && 0 === n.clientWidth || n === i || n === a || "visible" === ut.css(n, "overflow")) {
        if (n === i || n === a) break;
      } else {
        var s = ut.offset(n);
        s.left += n.clientLeft, s.top += n.clientTop, e.top = Math.max(e.top, s.top), e.right = Math.min(e.right, s.left + n.clientWidth), e.bottom = Math.min(e.bottom, s.top + n.clientHeight), e.left = Math.max(e.left, s.left);
      }

      n = lt(n);
    }

    var c = null;
    ut.isWindow(t) || 9 === t.nodeType || (c = t.style.position, "absolute" === ut.css(t, "position") && (t.style.position = "fixed"));
    var u = ut.getWindowScrollLeft(o),
        l = ut.getWindowScrollTop(o),
        f = ut.viewportWidth(o),
        p = ut.viewportHeight(o),
        h = a.scrollWidth,
        d = a.scrollHeight;
    if (t.style && (t.style.position = c), function (t) {
      if (ut.isWindow(t) || 9 === t.nodeType) return !1;
      var e = ut.getDocument(t).body,
          n = null;

      for (n = t.parentNode; n && n !== e; n = n.parentNode) {
        if ("fixed" === ut.css(n, "position")) return !0;
      }

      return !1;
    }(t)) e.left = Math.max(e.left, u), e.top = Math.max(e.top, l), e.right = Math.min(e.right, u + f), e.bottom = Math.min(e.bottom, l + p);else {
      var v = Math.max(h, u + f);
      e.right = Math.min(e.right, v);
      var y = Math.max(d, l + p);
      e.bottom = Math.min(e.bottom, y);
    }
    return e.top >= 0 && e.left >= 0 && e.bottom > e.top && e.right > e.left ? e : null;
  };

  var pt = function pt(t, e, n, r) {
    var o = ut.clone(t),
        i = {
      width: e.width,
      height: e.height
    };
    return r.adjustX && o.left < n.left && (o.left = n.left), r.resizeWidth && o.left >= n.left && o.left + i.width > n.right && (i.width -= o.left + i.width - n.right), r.adjustX && o.left + i.width > n.right && (o.left = Math.max(n.right - i.width, n.left)), r.adjustY && o.top < n.top && (o.top = n.top), r.resizeHeight && o.top >= n.top && o.top + i.height > n.bottom && (i.height -= o.top + i.height - n.bottom), r.adjustY && o.top + i.height > n.bottom && (o.top = Math.max(n.bottom - i.height, n.top)), ut.mix(o, i);
  };

  var ht = function ht(t) {
    var e = void 0,
        n = void 0,
        r = void 0;

    if (ut.isWindow(t) || 9 === t.nodeType) {
      var o = ut.getWindow(t);
      e = {
        left: ut.getWindowScrollLeft(o),
        top: ut.getWindowScrollTop(o)
      }, n = ut.viewportWidth(o), r = ut.viewportHeight(o);
    } else e = ut.offset(t), n = ut.outerWidth(t), r = ut.outerHeight(t);

    return e.width = n, e.height = r, e;
  };

  var dt = function dt(t, e) {
    var n = e.charAt(0),
        r = e.charAt(1),
        o = t.width,
        i = t.height,
        a = t.left,
        s = t.top;
    return "c" === n ? s += i / 2 : "b" === n && (s += i), "c" === r ? a += o / 2 : "r" === r && (a += o), {
      left: a,
      top: s
    };
  };

  var vt = function vt(t, e, n, r, o) {
    var i = dt(e, n[1]),
        a = dt(t, n[0]),
        s = [a.left - i.left, a.top - i.top];
    return {
      left: t.left - s[0] + r[0] - o[0],
      top: t.top - s[1] + r[1] - o[1]
    };
  };

  function yt(t, e, n) {
    return t.left < n.left || t.left + e.width > n.right;
  }

  function mt(t, e, n) {
    return t.top < n.top || t.top + e.height > n.bottom;
  }

  function gt(t, e, n) {
    var r = [];
    return ut.each(t, function (t) {
      r.push(t.replace(e, function (t) {
        return n[t];
      }));
    }), r;
  }

  function bt(t, e) {
    return t[e] = -t[e], t;
  }

  function _t(t, e) {
    return (/%$/.test(t) ? parseInt(t.substring(0, t.length - 1), 10) / 100 * e : parseInt(t, 10)) || 0;
  }

  function wt(t, e) {
    t[0] = _t(t[0], e.width), t[1] = _t(t[1], e.height);
  }

  function xt(t, e, n) {
    var r = n.points,
        o = n.offset || [0, 0],
        i = n.targetOffset || [0, 0],
        a = n.overflow,
        s = n.target || e,
        c = n.source || t;
    o = [].concat(o), i = [].concat(i), a = a || {};
    var u = {},
        l = 0,
        f = ft(c),
        p = ht(c),
        h = ht(s);
    wt(o, p), wt(i, h);
    var d = vt(p, h, r, o, i),
        v = ut.merge(p, d),
        y = !function (t) {
      var e = ft(t),
          n = ht(t);
      return !e || n.left + n.width <= e.left || n.top + n.height <= e.top || n.left >= e.right || n.top >= e.bottom;
    }(s);

    if (f && (a.adjustX || a.adjustY) && y) {
      if (a.adjustX && yt(d, p, f)) {
        var m = gt(r, /[lr]/gi, {
          l: "r",
          r: "l"
        }),
            g = bt(o, 0),
            b = bt(i, 0);
        (function (t, e, n) {
          return t.left > n.right || t.left + e.width < n.left;
        })(vt(p, h, m, g, b), p, f) || (l = 1, r = m, o = g, i = b);
      }

      if (a.adjustY && mt(d, p, f)) {
        var _ = gt(r, /[tb]/gi, {
          t: "b",
          b: "t"
        }),
            w = bt(o, 1),
            x = bt(i, 1);

        (function (t, e, n) {
          return t.top > n.bottom || t.top + e.height < n.top;
        })(vt(p, h, _, w, x), p, f) || (l = 1, r = _, o = w, i = x);
      }

      l && (d = vt(p, h, r, o, i), ut.mix(v, d));
      var O = yt(d, p, f),
          E = mt(d, p, f);
      (O || E) && (r = n.points, o = n.offset || [0, 0], i = n.targetOffset || [0, 0]), u.adjustX = a.adjustX && O, u.adjustY = a.adjustY && E, (u.adjustX || u.adjustY) && (v = pt(d, p, f, u));
    }

    return v.width !== p.width && ut.css(c, "width", ut.width(c) + v.width - p.width), v.height !== p.height && ut.css(c, "height", ut.height(c) + v.height - p.height), ut.offset(c, {
      left: v.left,
      top: v.top
    }, {
      useCssRight: n.useCssRight,
      useCssBottom: n.useCssBottom,
      useCssTransform: n.useCssTransform
    }), {
      points: r,
      offset: o,
      targetOffset: i,
      overflow: u
    };
  }

  xt.__getOffsetParent = lt, xt.__getVisibleRectForElement = ft;
  var Ot = xt;

  function Et(t) {
    return null != t && t == t.window;
  }

  var Ct = function (t) {
    function e() {
      var n, r, o;
      a()(this, e);

      for (var i = arguments.length, s = Array(i), u = 0; u < i; u++) {
        s[u] = arguments[u];
      }

      return n = r = c()(this, t.call.apply(t, [this].concat(s))), r.forceAlign = function () {
        var t = r.props;

        if (!t.disabled) {
          var e = y.a.findDOMNode(r);
          t.onAlign(e, Ot(e, t.target(), t.align));
        }
      }, o = n, c()(r, o);
    }

    return l()(e, t), e.prototype.componentDidMount = function () {
      var t = this.props;
      this.forceAlign(), !t.disabled && t.monitorWindowResize && this.startMonitorWindowResize();
    }, e.prototype.componentDidUpdate = function (t) {
      var e = !1,
          n = this.props;
      if (!n.disabled) if (t.disabled || t.align !== n.align) e = !0;else {
        var r = t.target(),
            o = n.target();
        Et(r) && Et(o) ? e = !1 : r !== o && (e = !0);
      }
      e && this.forceAlign(), n.monitorWindowResize && !n.disabled ? this.startMonitorWindowResize() : this.stopMonitorWindowResize();
    }, e.prototype.componentWillUnmount = function () {
      this.stopMonitorWindowResize();
    }, e.prototype.startMonitorWindowResize = function () {
      this.resizeHandler || (this.bufferMonitor = function (t, e) {
        var n = void 0;

        function r() {
          n && (clearTimeout(n), n = null);
        }

        function o() {
          r(), n = setTimeout(t, e);
        }

        return o.clear = r, o;
      }(this.forceAlign, this.props.monitorBufferTime), this.resizeHandler = Object(g.a)(window, "resize", this.bufferMonitor));
    }, e.prototype.stopMonitorWindowResize = function () {
      this.resizeHandler && (this.bufferMonitor.clear(), this.resizeHandler.remove(), this.resizeHandler = null);
    }, e.prototype.render = function () {
      var t = this.props,
          e = t.childrenProps,
          n = t.children,
          r = p.a.Children.only(n);

      if (e) {
        var o = {};

        for (var i in e) {
          e.hasOwnProperty(i) && (o[i] = this.props[e[i]]);
        }

        return p.a.cloneElement(r, o);
      }

      return r;
    }, e;
  }(f.Component);

  Ct.propTypes = {
    childrenProps: _.a.object,
    align: _.a.object.isRequired,
    target: _.a.func,
    onAlign: _.a.func,
    monitorBufferTime: _.a.number,
    monitorWindowResize: _.a.bool,
    disabled: _.a.bool,
    children: _.a.any
  }, Ct.defaultProps = {
    target: function target() {
      return window;
    },
    onAlign: function onAlign() {},
    monitorBufferTime: 50,
    monitorWindowResize: !1,
    disabled: !1
  };
  var jt = Ct,
      St = n(9),
      Tt = n.n(St),
      Pt = n(12),
      kt = n.n(Pt),
      Mt = n(10),
      zt = n.n(Mt);

  function Lt(t) {
    var e = [];
    return p.a.Children.forEach(t, function (t) {
      e.push(t);
    }), e;
  }

  function At(t, e) {
    var n = null;
    return t && t.forEach(function (t) {
      n || t && t.key === e && (n = t);
    }), n;
  }

  function Rt(t, e, n) {
    var r = null;
    return t && t.forEach(function (t) {
      if (t && t.key === e && t.props[n]) {
        if (r) throw new Error("two child with same key for <rc-animate> children");
        r = t;
      }
    }), r;
  }

  var Nt = n(31),
      Ft = n.n(Nt),
      It = {
    transitionend: {
      transition: "transitionend",
      WebkitTransition: "webkitTransitionEnd",
      MozTransition: "mozTransitionEnd",
      OTransition: "oTransitionEnd",
      msTransition: "MSTransitionEnd"
    },
    animationend: {
      animation: "animationend",
      WebkitAnimation: "webkitAnimationEnd",
      MozAnimation: "mozAnimationEnd",
      OAnimation: "oAnimationEnd",
      msAnimation: "MSAnimationEnd"
    }
  },
      Dt = [];
  "undefined" != typeof window && "undefined" != typeof document && function () {
    var t = document.createElement("div").style;

    for (var e in "AnimationEvent" in window || delete It.animationend.animation, "TransitionEvent" in window || delete It.transitionend.transition, It) {
      if (It.hasOwnProperty(e)) {
        var n = It[e];

        for (var r in n) {
          if (r in t) {
            Dt.push(n[r]);
            break;
          }
        }
      }
    }
  }();
  var Bt = {
    addEndEventListener: function addEndEventListener(t, e) {
      0 !== Dt.length ? Dt.forEach(function (n) {
        !function (t, e, n) {
          t.addEventListener(e, n, !1);
        }(t, n, e);
      }) : window.setTimeout(e, 0);
    },
    endEvents: Dt,
    removeEndEventListener: function removeEndEventListener(t, e) {
      0 !== Dt.length && Dt.forEach(function (n) {
        !function (t, e, n) {
          t.removeEventListener(e, n, !1);
        }(t, n, e);
      });
    }
  },
      Vt = n(96),
      Ht = n.n(Vt),
      Ut = 0 !== Bt.endEvents.length,
      Wt = ["Webkit", "Moz", "O", "ms"],
      qt = ["-webkit-", "-moz-", "-o-", "ms-", ""];

  function Gt(t, e) {
    for (var n = window.getComputedStyle(t, null), r = "", o = 0; o < qt.length && !(r = n.getPropertyValue(qt[o] + e)); o++) {
      ;
    }

    return r;
  }

  function Kt(t) {
    if (Ut) {
      var e = parseFloat(Gt(t, "transition-delay")) || 0,
          n = parseFloat(Gt(t, "transition-duration")) || 0,
          r = parseFloat(Gt(t, "animation-delay")) || 0,
          o = parseFloat(Gt(t, "animation-duration")) || 0,
          i = Math.max(n + e, o + r);
      t.rcEndAnimTimeout = setTimeout(function () {
        t.rcEndAnimTimeout = null, t.rcEndListener && t.rcEndListener();
      }, 1e3 * i + 200);
    }
  }

  function Zt(t) {
    t.rcEndAnimTimeout && (clearTimeout(t.rcEndAnimTimeout), t.rcEndAnimTimeout = null);
  }

  var Yt = function Yt(t, e, n) {
    var r = "object" === (void 0 === e ? "undefined" : Ft()(e)),
        o = r ? e.name : e,
        i = r ? e.active : e + "-active",
        a = n,
        s = void 0,
        c = void 0,
        u = Ht()(t);
    return n && "[object Object]" === Object.prototype.toString.call(n) && (a = n.end, s = n.start, c = n.active), t.rcEndListener && t.rcEndListener(), t.rcEndListener = function (e) {
      e && e.target !== t || (t.rcAnimTimeout && (clearTimeout(t.rcAnimTimeout), t.rcAnimTimeout = null), Zt(t), u.remove(o), u.remove(i), Bt.removeEndEventListener(t, t.rcEndListener), t.rcEndListener = null, a && a());
    }, Bt.addEndEventListener(t, t.rcEndListener), s && s(), u.add(o), t.rcAnimTimeout = setTimeout(function () {
      t.rcAnimTimeout = null, u.add(i), c && setTimeout(c, 0), Kt(t);
    }, 30), {
      stop: function stop() {
        t.rcEndListener && t.rcEndListener();
      }
    };
  };

  Yt.style = function (t, e, n) {
    t.rcEndListener && t.rcEndListener(), t.rcEndListener = function (e) {
      e && e.target !== t || (t.rcAnimTimeout && (clearTimeout(t.rcAnimTimeout), t.rcAnimTimeout = null), Zt(t), Bt.removeEndEventListener(t, t.rcEndListener), t.rcEndListener = null, n && n());
    }, Bt.addEndEventListener(t, t.rcEndListener), t.rcAnimTimeout = setTimeout(function () {
      for (var n in e) {
        e.hasOwnProperty(n) && (t.style[n] = e[n]);
      }

      t.rcAnimTimeout = null, Kt(t);
    }, 0);
  }, Yt.setTransition = function (t, e, n) {
    var r = e,
        o = n;
    void 0 === n && (o = r, r = ""), r = r || "", Wt.forEach(function (e) {
      t.style[e + "Transition" + r] = o;
    });
  }, Yt.isCssAnimationSupported = Ut;

  var $t = Yt,
      Xt = {
    isAppearSupported: function isAppearSupported(t) {
      return t.transitionName && t.transitionAppear || t.animation.appear;
    },
    isEnterSupported: function isEnterSupported(t) {
      return t.transitionName && t.transitionEnter || t.animation.enter;
    },
    isLeaveSupported: function isLeaveSupported(t) {
      return t.transitionName && t.transitionLeave || t.animation.leave;
    },
    allowAppearCallback: function allowAppearCallback(t) {
      return t.transitionAppear || t.animation.appear;
    },
    allowEnterCallback: function allowEnterCallback(t) {
      return t.transitionEnter || t.animation.enter;
    },
    allowLeaveCallback: function allowLeaveCallback(t) {
      return t.transitionLeave || t.animation.leave;
    }
  },
      Qt = {
    enter: "transitionEnter",
    appear: "transitionAppear",
    leave: "transitionLeave"
  },
      Jt = function (t) {
    function e() {
      return a()(this, e), c()(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return l()(e, t), kt()(e, [{
      key: "componentWillUnmount",
      value: function value() {
        this.stop();
      }
    }, {
      key: "componentWillEnter",
      value: function value(t) {
        Xt.isEnterSupported(this.props) ? this.transition("enter", t) : t();
      }
    }, {
      key: "componentWillAppear",
      value: function value(t) {
        Xt.isAppearSupported(this.props) ? this.transition("appear", t) : t();
      }
    }, {
      key: "componentWillLeave",
      value: function value(t) {
        Xt.isLeaveSupported(this.props) ? this.transition("leave", t) : t();
      }
    }, {
      key: "transition",
      value: function value(t, e) {
        var n = this,
            r = y.a.findDOMNode(this),
            o = this.props,
            i = o.transitionName,
            a = "object" === (void 0 === i ? "undefined" : Ft()(i));
        this.stop();

        var s = function s() {
          n.stopper = null, e();
        };

        if ((Ut || !o.animation[t]) && i && o[Qt[t]]) {
          var c = a ? i[t] : i + "-" + t,
              u = c + "-active";
          a && i[t + "Active"] && (u = i[t + "Active"]), this.stopper = $t(r, {
            name: c,
            active: u
          }, s);
        } else this.stopper = o.animation[t](r, s);
      }
    }, {
      key: "stop",
      value: function value() {
        var t = this.stopper;
        t && (this.stopper = null, t.stop());
      }
    }, {
      key: "render",
      value: function value() {
        return this.props.children;
      }
    }]), e;
  }(p.a.Component);

  Jt.propTypes = {
    children: zt.a.any
  };
  var te = Jt,
      ee = "rc_animate_" + Date.now();

  function ne(t) {
    var e = t.children;
    return p.a.isValidElement(e) && !e.key ? p.a.cloneElement(e, {
      key: ee
    }) : e;
  }

  function re() {}

  var oe = function (t) {
    function e(t) {
      a()(this, e);
      var n = c()(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
      return ie.call(n), n.currentlyAnimatingKeys = {}, n.keysToEnter = [], n.keysToLeave = [], n.state = {
        children: Lt(ne(t))
      }, n.childrenRefs = {}, n;
    }

    return l()(e, t), kt()(e, [{
      key: "componentDidMount",
      value: function value() {
        var t = this,
            e = this.props.showProp,
            n = this.state.children;
        e && (n = n.filter(function (t) {
          return !!t.props[e];
        })), n.forEach(function (e) {
          e && t.performAppear(e.key);
        });
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(t) {
        var e = this;
        this.nextProps = t;
        var n = Lt(ne(t)),
            r = this.props;
        r.exclusive && Object.keys(this.currentlyAnimatingKeys).forEach(function (t) {
          e.stop(t);
        });
        var o,
            i,
            a,
            s,
            c = r.showProp,
            u = this.currentlyAnimatingKeys,
            l = r.exclusive ? Lt(ne(r)) : this.state.children,
            f = [];
        c ? (l.forEach(function (t) {
          var e = t && At(n, t.key),
              r = void 0;
          (r = e && e.props[c] || !t.props[c] ? e : p.a.cloneElement(e || t, Tt()({}, c, !0))) && f.push(r);
        }), n.forEach(function (t) {
          t && At(l, t.key) || f.push(t);
        })) : (o = n, i = [], a = {}, s = [], l.forEach(function (t) {
          t && At(o, t.key) ? s.length && (a[t.key] = s, s = []) : s.push(t);
        }), o.forEach(function (t) {
          t && a.hasOwnProperty(t.key) && (i = i.concat(a[t.key])), i.push(t);
        }), f = i = i.concat(s)), this.setState({
          children: f
        }), n.forEach(function (t) {
          var n = t && t.key;

          if (!t || !u[n]) {
            var r = t && At(l, n);

            if (c) {
              var o = t.props[c];
              if (r) !Rt(l, n, c) && o && e.keysToEnter.push(n);else o && e.keysToEnter.push(n);
            } else r || e.keysToEnter.push(n);
          }
        }), l.forEach(function (t) {
          var r = t && t.key;

          if (!t || !u[r]) {
            var o = t && At(n, r);

            if (c) {
              var i = t.props[c];
              if (o) !Rt(n, r, c) && i && e.keysToLeave.push(r);else i && e.keysToLeave.push(r);
            } else o || e.keysToLeave.push(r);
          }
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        var t = this.keysToEnter;
        this.keysToEnter = [], t.forEach(this.performEnter);
        var e = this.keysToLeave;
        this.keysToLeave = [], e.forEach(this.performLeave);
      }
    }, {
      key: "isValidChildByKey",
      value: function value(t, e) {
        var n = this.props.showProp;
        return n ? Rt(t, e, n) : At(t, e);
      }
    }, {
      key: "stop",
      value: function value(t) {
        delete this.currentlyAnimatingKeys[t];
        var e = this.childrenRefs[t];
        e && e.stop();
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            e = this.props;
        this.nextProps = e;
        var n = this.state.children,
            r = null;
        n && (r = n.map(function (n) {
          if (null === n || void 0 === n) return n;
          if (!n.key) throw new Error("must set key for <rc-animate> children");
          return p.a.createElement(te, {
            key: n.key,
            ref: function ref(e) {
              return t.childrenRefs[n.key] = e;
            },
            animation: e.animation,
            transitionName: e.transitionName,
            transitionEnter: e.transitionEnter,
            transitionAppear: e.transitionAppear,
            transitionLeave: e.transitionLeave
          }, n);
        }));
        var i = e.component;

        if (i) {
          var a = e;
          return "string" == typeof i && (a = o()({
            className: e.className,
            style: e.style
          }, e.componentProps)), p.a.createElement(i, a, r);
        }

        return r[0] || null;
      }
    }]), e;
  }(p.a.Component);

  oe.isAnimate = !0, oe.propTypes = {
    component: zt.a.any,
    componentProps: zt.a.object,
    animation: zt.a.object,
    transitionName: zt.a.oneOfType([zt.a.string, zt.a.object]),
    transitionEnter: zt.a.bool,
    transitionAppear: zt.a.bool,
    exclusive: zt.a.bool,
    transitionLeave: zt.a.bool,
    onEnd: zt.a.func,
    onEnter: zt.a.func,
    onLeave: zt.a.func,
    onAppear: zt.a.func,
    showProp: zt.a.string
  }, oe.defaultProps = {
    animation: {},
    component: "span",
    componentProps: {},
    transitionEnter: !0,
    transitionLeave: !0,
    transitionAppear: !1,
    onEnd: re,
    onEnter: re,
    onLeave: re,
    onAppear: re
  };

  var ie = function ie() {
    var t = this;
    this.performEnter = function (e) {
      t.childrenRefs[e] && (t.currentlyAnimatingKeys[e] = !0, t.childrenRefs[e].componentWillEnter(t.handleDoneAdding.bind(t, e, "enter")));
    }, this.performAppear = function (e) {
      t.childrenRefs[e] && (t.currentlyAnimatingKeys[e] = !0, t.childrenRefs[e].componentWillAppear(t.handleDoneAdding.bind(t, e, "appear")));
    }, this.handleDoneAdding = function (e, n) {
      var r = t.props;

      if (delete t.currentlyAnimatingKeys[e], !r.exclusive || r === t.nextProps) {
        var o = Lt(ne(r));
        t.isValidChildByKey(o, e) ? "appear" === n ? Xt.allowAppearCallback(r) && (r.onAppear(e), r.onEnd(e, !0)) : Xt.allowEnterCallback(r) && (r.onEnter(e), r.onEnd(e, !0)) : t.performLeave(e);
      }
    }, this.performLeave = function (e) {
      t.childrenRefs[e] && (t.currentlyAnimatingKeys[e] = !0, t.childrenRefs[e].componentWillLeave(t.handleDoneLeaving.bind(t, e)));
    }, this.handleDoneLeaving = function (e) {
      var n = t.props;

      if (delete t.currentlyAnimatingKeys[e], !n.exclusive || n === t.nextProps) {
        var r,
            o,
            i,
            a,
            s = Lt(ne(n));
        if (t.isValidChildByKey(s, e)) t.performEnter(e);else {
          var c = function c() {
            Xt.allowLeaveCallback(n) && (n.onLeave(e), n.onEnd(e, !1));
          };

          r = t.state.children, o = s, i = n.showProp, (a = r.length === o.length) && r.forEach(function (t, e) {
            var n = o[e];
            t && n && (t && !n || !t && n ? a = !1 : t.key !== n.key ? a = !1 : i && t.props[i] !== n.props[i] && (a = !1));
          }), a ? c() : t.setState({
            children: s
          }, c);
        }
      }
    };
  },
      ae = oe,
      se = n(17),
      ce = n.n(se),
      ue = function (t) {
    function e() {
      return a()(this, e), c()(this, t.apply(this, arguments));
    }

    return l()(e, t), e.prototype.shouldComponentUpdate = function (t) {
      return t.hiddenClassName || t.visible;
    }, e.prototype.render = function () {
      var t = this.props,
          e = t.hiddenClassName,
          n = t.visible,
          r = ce()(t, ["hiddenClassName", "visible"]);
      return e || p.a.Children.count(r.children) > 1 ? (!n && e && (r.className += " " + e), p.a.createElement("div", r)) : p.a.Children.only(r.children);
    }, e;
  }(f.Component);

  ue.propTypes = {
    children: d.a.any,
    className: d.a.string,
    visible: d.a.bool,
    hiddenClassName: d.a.string
  };

  var le = ue,
      fe = function (t) {
    function e() {
      return a()(this, e), c()(this, t.apply(this, arguments));
    }

    return l()(e, t), e.prototype.render = function () {
      var t = this.props,
          e = t.className;
      return t.visible || (e += " " + t.hiddenClassName), p.a.createElement("div", {
        className: e,
        onMouseEnter: t.onMouseEnter,
        onMouseLeave: t.onMouseLeave,
        style: t.style
      }, p.a.createElement(le, {
        className: t.prefixCls + "-content",
        visible: t.visible
      }, t.children));
    }, e;
  }(f.Component);

  fe.propTypes = {
    hiddenClassName: d.a.string,
    className: d.a.string,
    prefixCls: d.a.string,
    onMouseEnter: d.a.func,
    onMouseLeave: d.a.func,
    children: d.a.any
  };
  var pe = fe;

  function he(t, e) {
    this[t] = e;
  }

  var de = function (t) {
    function e(n) {
      a()(this, e);
      var r = c()(this, t.call(this, n));
      return ve.call(r), r.savePopupRef = he.bind(r, "popupInstance"), r.saveAlignRef = he.bind(r, "alignInstance"), r;
    }

    return l()(e, t), e.prototype.componentDidMount = function () {
      this.rootNode = this.getPopupDomNode();
    }, e.prototype.getPopupDomNode = function () {
      return y.a.findDOMNode(this.popupInstance);
    }, e.prototype.getMaskTransitionName = function () {
      var t = this.props,
          e = t.maskTransitionName,
          n = t.maskAnimation;
      return !e && n && (e = t.prefixCls + "-" + n), e;
    }, e.prototype.getTransitionName = function () {
      var t = this.props,
          e = t.transitionName;
      return !e && t.animation && (e = t.prefixCls + "-" + t.animation), e;
    }, e.prototype.getClassName = function (t) {
      return this.props.prefixCls + " " + this.props.className + " " + t;
    }, e.prototype.getPopupElement = function () {
      var t = this.savePopupRef,
          e = this.props,
          n = e.align,
          r = e.style,
          i = e.visible,
          a = e.prefixCls,
          s = e.destroyPopupOnHide,
          c = this.getClassName(this.currentAlignClassName || e.getClassNameFromAlign(n)),
          u = a + "-hidden";
      i || (this.currentAlignClassName = null);
      var l = o()({}, r, this.getZIndexStyle()),
          f = {
        className: c,
        prefixCls: a,
        ref: t,
        onMouseEnter: e.onMouseEnter,
        onMouseLeave: e.onMouseLeave,
        style: l
      };
      return s ? p.a.createElement(ae, {
        component: "",
        exclusive: !0,
        transitionAppear: !0,
        transitionName: this.getTransitionName()
      }, i ? p.a.createElement(jt, {
        target: this.getTarget,
        key: "popup",
        ref: this.saveAlignRef,
        monitorWindowResize: !0,
        align: n,
        onAlign: this.onAlign
      }, p.a.createElement(pe, o()({
        visible: !0
      }, f), e.children)) : null) : p.a.createElement(ae, {
        component: "",
        exclusive: !0,
        transitionAppear: !0,
        transitionName: this.getTransitionName(),
        showProp: "xVisible"
      }, p.a.createElement(jt, {
        target: this.getTarget,
        key: "popup",
        ref: this.saveAlignRef,
        monitorWindowResize: !0,
        xVisible: i,
        childrenProps: {
          visible: "xVisible"
        },
        disabled: !i,
        align: n,
        onAlign: this.onAlign
      }, p.a.createElement(pe, o()({
        hiddenClassName: u
      }, f), e.children)));
    }, e.prototype.getZIndexStyle = function () {
      var t = {},
          e = this.props;
      return void 0 !== e.zIndex && (t.zIndex = e.zIndex), t;
    }, e.prototype.getMaskElement = function () {
      var t = this.props,
          e = void 0;

      if (t.mask) {
        var n = this.getMaskTransitionName();
        e = p.a.createElement(le, {
          style: this.getZIndexStyle(),
          key: "mask",
          className: t.prefixCls + "-mask",
          hiddenClassName: t.prefixCls + "-mask-hidden",
          visible: t.visible
        }), n && (e = p.a.createElement(ae, {
          key: "mask",
          showProp: "visible",
          transitionAppear: !0,
          component: "",
          transitionName: n
        }, e));
      }

      return e;
    }, e.prototype.render = function () {
      return p.a.createElement("div", null, this.getMaskElement(), this.getPopupElement());
    }, e;
  }(f.Component);

  de.propTypes = {
    visible: d.a.bool,
    style: d.a.object,
    getClassNameFromAlign: d.a.func,
    onAlign: d.a.func,
    getRootDomNode: d.a.func,
    onMouseEnter: d.a.func,
    align: d.a.any,
    destroyPopupOnHide: d.a.bool,
    className: d.a.string,
    prefixCls: d.a.string,
    onMouseLeave: d.a.func
  };

  var ve = function ve() {
    var t = this;
    this.onAlign = function (e, n) {
      var r = t.props,
          o = r.getClassNameFromAlign(n);
      t.currentAlignClassName !== o && (t.currentAlignClassName = o, e.className = t.getClassName(o)), r.onAlign(e, n);
    }, this.getTarget = function () {
      return t.props.getRootDomNode();
    };
  },
      ye = de,
      me = n(13),
      ge = n.n(me),
      be = function (t) {
    function e() {
      var t, n, r, o;
      a()(this, e);

      for (var i = arguments.length, s = Array(i), u = 0; u < i; u++) {
        s[u] = arguments[u];
      }

      return n = r = c()(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(s))), r.removeContainer = function () {
        r.container && (y.a.unmountComponentAtNode(r.container), r.container.parentNode.removeChild(r.container), r.container = null);
      }, r.renderComponent = function (t, e) {
        var n = r.props,
            o = n.visible,
            i = n.getComponent,
            a = n.forceRender,
            s = n.getContainer,
            c = n.parent;
        (o || c._component || a) && (r.container || (r.container = s()), y.a.unstable_renderSubtreeIntoContainer(c, i(t), r.container, function () {
          e && e.call(this);
        }));
      }, o = n, c()(r, o);
    }

    return l()(e, t), kt()(e, [{
      key: "componentDidMount",
      value: function value() {
        this.props.autoMount && this.renderComponent();
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        this.props.autoMount && this.renderComponent();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.props.autoDestroy && this.removeContainer();
      }
    }, {
      key: "render",
      value: function value() {
        return this.props.children({
          renderComponent: this.renderComponent,
          removeContainer: this.removeContainer
        });
      }
    }]), e;
  }(p.a.Component);

  be.propTypes = {
    autoMount: ge.a.bool,
    autoDestroy: ge.a.bool,
    visible: ge.a.bool,
    forceRender: ge.a.bool,
    parent: ge.a.any,
    getComponent: ge.a.func.isRequired,
    getContainer: ge.a.func.isRequired,
    children: ge.a.func.isRequired
  }, be.defaultProps = {
    autoMount: !0,
    autoDestroy: !0,
    forceRender: !1
  };

  var _e = be,
      we = function (t) {
    function e() {
      return a()(this, e), c()(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return l()(e, t), kt()(e, [{
      key: "componentDidMount",
      value: function value() {
        this.createContainer();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(t) {
        var e = this.props.didUpdate;
        e && e(t);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.removeContainer();
      }
    }, {
      key: "createContainer",
      value: function value() {
        this._container = this.props.getContainer(), this.forceUpdate();
      }
    }, {
      key: "removeContainer",
      value: function value() {
        this._container && this._container.parentNode.removeChild(this._container);
      }
    }, {
      key: "render",
      value: function value() {
        return this._container ? y.a.createPortal(this.props.children, this._container) : null;
      }
    }]), e;
  }(p.a.Component);

  we.propTypes = {
    getContainer: ge.a.func.isRequired,
    children: ge.a.node.isRequired,
    didUpdate: ge.a.func
  };
  var xe = we;

  function Oe() {}

  var Ee = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "onContextMenu"],
      Ce = !!v.createPortal,
      je = function (t) {
    function e(n) {
      a()(this, e);
      var r = c()(this, t.call(this, n));
      Se.call(r);
      var o = void 0;
      return o = "popupVisible" in n ? !!n.popupVisible : !!n.defaultPopupVisible, r.prevPopupVisible = o, r.state = {
        popupVisible: o
      }, r;
    }

    return l()(e, t), e.prototype.componentWillMount = function () {
      var t = this;
      Ee.forEach(function (e) {
        t["fire" + e] = function (n) {
          t.fireEvents(e, n);
        };
      });
    }, e.prototype.componentDidMount = function () {
      this.componentDidUpdate({}, {
        popupVisible: this.state.popupVisible
      });
    }, e.prototype.componentWillReceiveProps = function (t) {
      var e = t.popupVisible;
      void 0 !== e && this.setState({
        popupVisible: e
      });
    }, e.prototype.componentDidUpdate = function (t, e) {
      var n = this.props,
          r = this.state;

      if (Ce || this.renderComponent(null, function () {
        e.popupVisible !== r.popupVisible && n.afterPopupVisibleChange(r.popupVisible);
      }), this.prevPopupVisible = e.popupVisible, r.popupVisible) {
        var o = void 0;
        return this.clickOutsideHandler || !this.isClickToHide() && !this.isContextMenuToShow() || (o = n.getDocument(), this.clickOutsideHandler = Object(g.a)(o, "mousedown", this.onDocumentClick)), this.touchOutsideHandler || (o = o || n.getDocument(), this.touchOutsideHandler = Object(g.a)(o, "touchstart", this.onDocumentClick)), !this.contextMenuOutsideHandler1 && this.isContextMenuToShow() && (o = o || n.getDocument(), this.contextMenuOutsideHandler1 = Object(g.a)(o, "scroll", this.onContextMenuClose)), void (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow() && (this.contextMenuOutsideHandler2 = Object(g.a)(window, "blur", this.onContextMenuClose)));
      }

      this.clearOutsideHandler();
    }, e.prototype.componentWillUnmount = function () {
      this.clearDelayTimer(), this.clearOutsideHandler();
    }, e.prototype.getPopupDomNode = function () {
      return this._component && this._component.getPopupDomNode ? this._component.getPopupDomNode() : null;
    }, e.prototype.getPopupAlign = function () {
      var t = this.props,
          e = t.popupPlacement,
          n = t.popupAlign,
          r = t.builtinPlacements;
      return e && r ? function (t, e, n) {
        var r = t[e] || {};
        return o()({}, r, n);
      }(r, e, n) : n;
    }, e.prototype.setPopupVisible = function (t) {
      this.clearDelayTimer(), this.state.popupVisible !== t && ("popupVisible" in this.props || this.setState({
        popupVisible: t
      }), this.props.onPopupVisibleChange(t));
    }, e.prototype.delaySetPopupVisible = function (t, e) {
      var n = this,
          r = 1e3 * e;
      this.clearDelayTimer(), r ? this.delayTimer = setTimeout(function () {
        n.setPopupVisible(t), n.clearDelayTimer();
      }, r) : this.setPopupVisible(t);
    }, e.prototype.clearDelayTimer = function () {
      this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
    }, e.prototype.clearOutsideHandler = function () {
      this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.contextMenuOutsideHandler1 && (this.contextMenuOutsideHandler1.remove(), this.contextMenuOutsideHandler1 = null), this.contextMenuOutsideHandler2 && (this.contextMenuOutsideHandler2.remove(), this.contextMenuOutsideHandler2 = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
    }, e.prototype.createTwoChains = function (t) {
      var e = this.props.children.props,
          n = this.props;
      return e[t] && n[t] ? this["fire" + t] : e[t] || n[t];
    }, e.prototype.isClickToShow = function () {
      var t = this.props,
          e = t.action,
          n = t.showAction;
      return -1 !== e.indexOf("click") || -1 !== n.indexOf("click");
    }, e.prototype.isContextMenuToShow = function () {
      var t = this.props,
          e = t.action,
          n = t.showAction;
      return -1 !== e.indexOf("contextMenu") || -1 !== n.indexOf("contextMenu");
    }, e.prototype.isClickToHide = function () {
      var t = this.props,
          e = t.action,
          n = t.hideAction;
      return -1 !== e.indexOf("click") || -1 !== n.indexOf("click");
    }, e.prototype.isMouseEnterToShow = function () {
      var t = this.props,
          e = t.action,
          n = t.showAction;
      return -1 !== e.indexOf("hover") || -1 !== n.indexOf("mouseEnter");
    }, e.prototype.isMouseLeaveToHide = function () {
      var t = this.props,
          e = t.action,
          n = t.hideAction;
      return -1 !== e.indexOf("hover") || -1 !== n.indexOf("mouseLeave");
    }, e.prototype.isFocusToShow = function () {
      var t = this.props,
          e = t.action,
          n = t.showAction;
      return -1 !== e.indexOf("focus") || -1 !== n.indexOf("focus");
    }, e.prototype.isBlurToHide = function () {
      var t = this.props,
          e = t.action,
          n = t.hideAction;
      return -1 !== e.indexOf("focus") || -1 !== n.indexOf("blur");
    }, e.prototype.forcePopupAlign = function () {
      this.state.popupVisible && this._component && this._component.alignInstance && this._component.alignInstance.forceAlign();
    }, e.prototype.fireEvents = function (t, e) {
      var n = this.props.children.props[t];
      n && n(e);
      var r = this.props[t];
      r && r(e);
    }, e.prototype.close = function () {
      this.setPopupVisible(!1);
    }, e.prototype.render = function () {
      var t = this,
          e = this.state.popupVisible,
          n = this.props,
          r = n.children,
          o = p.a.Children.only(r),
          i = {
        key: "trigger"
      };
      this.isContextMenuToShow() ? i.onContextMenu = this.onContextMenu : i.onContextMenu = this.createTwoChains("onContextMenu"), this.isClickToHide() || this.isClickToShow() ? (i.onClick = this.onClick, i.onMouseDown = this.onMouseDown, i.onTouchStart = this.onTouchStart) : (i.onClick = this.createTwoChains("onClick"), i.onMouseDown = this.createTwoChains("onMouseDown"), i.onTouchStart = this.createTwoChains("onTouchStart")), this.isMouseEnterToShow() ? i.onMouseEnter = this.onMouseEnter : i.onMouseEnter = this.createTwoChains("onMouseEnter"), this.isMouseLeaveToHide() ? i.onMouseLeave = this.onMouseLeave : i.onMouseLeave = this.createTwoChains("onMouseLeave"), this.isFocusToShow() || this.isBlurToHide() ? (i.onFocus = this.onFocus, i.onBlur = this.onBlur) : (i.onFocus = this.createTwoChains("onFocus"), i.onBlur = this.createTwoChains("onBlur"));
      var a = p.a.cloneElement(o, i);
      if (!Ce) return p.a.createElement(_e, {
        parent: this,
        visible: e,
        autoMount: !1,
        forceRender: n.forceRender,
        getComponent: this.getComponent,
        getContainer: this.getContainer
      }, function (e) {
        var n = e.renderComponent;
        return t.renderComponent = n, a;
      });
      var s = void 0;
      return (e || this._component || n.forceRender) && (s = p.a.createElement(xe, {
        key: "portal",
        getContainer: this.getContainer,
        didUpdate: this.handlePortalUpdate
      }, this.getComponent())), [a, s];
    }, e;
  }(p.a.Component);

  je.propTypes = {
    children: d.a.any,
    action: d.a.oneOfType([d.a.string, d.a.arrayOf(d.a.string)]),
    showAction: d.a.any,
    hideAction: d.a.any,
    getPopupClassNameFromAlign: d.a.any,
    onPopupVisibleChange: d.a.func,
    afterPopupVisibleChange: d.a.func,
    popup: d.a.oneOfType([d.a.node, d.a.func]).isRequired,
    popupStyle: d.a.object,
    prefixCls: d.a.string,
    popupClassName: d.a.string,
    popupPlacement: d.a.string,
    builtinPlacements: d.a.object,
    popupTransitionName: d.a.oneOfType([d.a.string, d.a.object]),
    popupAnimation: d.a.any,
    mouseEnterDelay: d.a.number,
    mouseLeaveDelay: d.a.number,
    zIndex: d.a.number,
    focusDelay: d.a.number,
    blurDelay: d.a.number,
    getPopupContainer: d.a.func,
    getDocument: d.a.func,
    forceRender: d.a.bool,
    destroyPopupOnHide: d.a.bool,
    mask: d.a.bool,
    maskClosable: d.a.bool,
    onPopupAlign: d.a.func,
    popupAlign: d.a.object,
    popupVisible: d.a.bool,
    defaultPopupVisible: d.a.bool,
    maskTransitionName: d.a.oneOfType([d.a.string, d.a.object]),
    maskAnimation: d.a.string
  }, je.defaultProps = {
    prefixCls: "rc-trigger-popup",
    getPopupClassNameFromAlign: function getPopupClassNameFromAlign() {
      return "";
    },
    getDocument: function getDocument() {
      return window.document;
    },
    onPopupVisibleChange: Oe,
    afterPopupVisibleChange: Oe,
    onPopupAlign: Oe,
    popupClassName: "",
    mouseEnterDelay: 0,
    mouseLeaveDelay: .1,
    focusDelay: 0,
    blurDelay: .15,
    popupStyle: {},
    destroyPopupOnHide: !1,
    popupAlign: {},
    defaultPopupVisible: !1,
    mask: !1,
    maskClosable: !0,
    action: [],
    showAction: [],
    hideAction: []
  };

  var Se = function Se() {
    var t = this;
    this.onMouseEnter = function (e) {
      t.fireEvents("onMouseEnter", e), t.delaySetPopupVisible(!0, t.props.mouseEnterDelay);
    }, this.onMouseLeave = function (e) {
      t.fireEvents("onMouseLeave", e), t.delaySetPopupVisible(!1, t.props.mouseLeaveDelay);
    }, this.onPopupMouseEnter = function () {
      t.clearDelayTimer();
    }, this.onPopupMouseLeave = function (e) {
      e.relatedTarget && !e.relatedTarget.setTimeout && t._component && t._component.getPopupDomNode && m(t._component.getPopupDomNode(), e.relatedTarget) || t.delaySetPopupVisible(!1, t.props.mouseLeaveDelay);
    }, this.onFocus = function (e) {
      t.fireEvents("onFocus", e), t.clearDelayTimer(), t.isFocusToShow() && (t.focusTime = Date.now(), t.delaySetPopupVisible(!0, t.props.focusDelay));
    }, this.onMouseDown = function (e) {
      t.fireEvents("onMouseDown", e), t.preClickTime = Date.now();
    }, this.onTouchStart = function (e) {
      t.fireEvents("onTouchStart", e), t.preTouchTime = Date.now();
    }, this.onBlur = function (e) {
      t.fireEvents("onBlur", e), t.clearDelayTimer(), t.isBlurToHide() && t.delaySetPopupVisible(!1, t.props.blurDelay);
    }, this.onContextMenu = function (e) {
      e.preventDefault(), t.fireEvents("onContextMenu", e), t.setPopupVisible(!0);
    }, this.onContextMenuClose = function () {
      t.isContextMenuToShow() && t.close();
    }, this.onClick = function (e) {
      if (t.fireEvents("onClick", e), t.focusTime) {
        var n = void 0;
        if (t.preClickTime && t.preTouchTime ? n = Math.min(t.preClickTime, t.preTouchTime) : t.preClickTime ? n = t.preClickTime : t.preTouchTime && (n = t.preTouchTime), Math.abs(n - t.focusTime) < 20) return;
        t.focusTime = 0;
      }

      t.preClickTime = 0, t.preTouchTime = 0, e.preventDefault();
      var r = !t.state.popupVisible;
      (t.isClickToHide() && !r || r && t.isClickToShow()) && t.setPopupVisible(!t.state.popupVisible);
    }, this.onDocumentClick = function (e) {
      if (!t.props.mask || t.props.maskClosable) {
        var n = e.target,
            r = Object(v.findDOMNode)(t),
            o = t.getPopupDomNode();
        m(r, n) || m(o, n) || t.close();
      }
    }, this.getRootDomNode = function () {
      return Object(v.findDOMNode)(t);
    }, this.getPopupClassNameFromAlign = function (e) {
      var n = [],
          r = t.props,
          o = r.popupPlacement,
          i = r.builtinPlacements,
          a = r.prefixCls;
      return o && i && n.push(function (t, e, n) {
        var r,
            o,
            i = n.points;

        for (var a in t) {
          if (t.hasOwnProperty(a) && (r = t[a].points, o = i, r[0] === o[0] && r[1] === o[1])) return e + "-placement-" + a;
        }

        return "";
      }(i, a, e)), r.getPopupClassNameFromAlign && n.push(r.getPopupClassNameFromAlign(e)), n.join(" ");
    }, this.getComponent = function () {
      var e = t.props,
          n = t.state,
          r = {};
      return t.isMouseEnterToShow() && (r.onMouseEnter = t.onPopupMouseEnter), t.isMouseLeaveToHide() && (r.onMouseLeave = t.onPopupMouseLeave), p.a.createElement(ye, o()({
        prefixCls: e.prefixCls,
        destroyPopupOnHide: e.destroyPopupOnHide,
        visible: n.popupVisible,
        className: e.popupClassName,
        action: e.action,
        align: t.getPopupAlign(),
        onAlign: e.onPopupAlign,
        animation: e.popupAnimation,
        getClassNameFromAlign: t.getPopupClassNameFromAlign
      }, r, {
        getRootDomNode: t.getRootDomNode,
        style: e.popupStyle,
        mask: e.mask,
        zIndex: e.zIndex,
        transitionName: e.popupTransitionName,
        maskAnimation: e.maskAnimation,
        maskTransitionName: e.maskTransitionName,
        ref: t.savePopup
      }), "function" == typeof e.popup ? e.popup() : e.popup);
    }, this.getContainer = function () {
      var e = t.props,
          n = document.createElement("div");
      return n.style.position = "absolute", n.style.top = "0", n.style.left = "0", n.style.width = "100%", (e.getPopupContainer ? e.getPopupContainer(Object(v.findDOMNode)(t)) : e.getDocument().body).appendChild(n), n;
    }, this.handlePortalUpdate = function () {
      t.prevPopupVisible !== t.state.popupVisible && t.props.afterPopupVisibleChange(t.state.popupVisible);
    }, this.savePopup = function (e) {
      t._component = e;
    };
  };

  e["default"] = je;
}, function (t, e, n) {
  "use strict";

  var r = n(75);

  function o() {}

  t.exports = function () {
    function t(t, e, n, o, i, a) {
      if (a !== r) {
        var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw s.name = "Invariant Violation", s;
      }
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var n = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e
    };
    return n.checkPropTypes = o, n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, n) {
  var r = n(48),
      o = n(52),
      i = "[object Symbol]";

  t.exports = function (t) {
    return "symbol" == _typeof(t) || o(t) && r(t) == i;
  };
}, function (t, e, n) {
  t.exports = {
    "c-legend-button": "vizzuality__c-legend-button",
    "-disabled": "vizzuality__-disabled",
    info: "vizzuality__info",
    close: "vizzuality__close",
    toggle: "vizzuality__toggle",
    opacity: "vizzuality__opacity",
    layers: "vizzuality__layers"
  };
}, function (t, e, n) {
  t.exports = !n(26) && !n(33)(function () {
    return 7 != Object.defineProperty(n(79)("div"), "a", {
      get: function get() {
        return 7;
      }
    }).a;
  });
}, function (t, e, n) {
  var r = n(30),
      o = n(22).document,
      i = r(o) && r(o.createElement);

  t.exports = function (t) {
    return i ? o.createElement(t) : {};
  };
}, function (t, e, n) {
  var r = n(27),
      o = n(28),
      i = n(122)(!1),
      a = n(56)("IE_PROTO");

  t.exports = function (t, e) {
    var n,
        s = o(t),
        c = 0,
        u = [];

    for (n in s) {
      n != a && r(s, n) && u.push(n);
    }

    for (; e.length > c;) {
      r(s, n = e[c++]) && (~i(u, n) || u.push(n));
    }

    return u;
  };
}, function (t, e, n) {
  var r = n(69);
  t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
    return "String" == r(t) ? t.split("") : Object(t);
  };
}, function (t, e, n) {
  "use strict";

  var r = n(60),
      o = n(25),
      i = n(83),
      a = n(29),
      s = n(27),
      c = n(40),
      u = n(127),
      l = n(62),
      f = n(99),
      p = n(19)("iterator"),
      h = !([].keys && "next" in [].keys()),
      d = function d() {
    return this;
  };

  t.exports = function (t, e, n, v, y, m, g) {
    u(n, e, v);

    var b,
        _,
        w,
        x = function x(t) {
      if (!h && t in j) return j[t];

      switch (t) {
        case "keys":
        case "values":
          return function () {
            return new n(this, t);
          };
      }

      return function () {
        return new n(this, t);
      };
    },
        O = e + " Iterator",
        E = "values" == y,
        C = !1,
        j = t.prototype,
        S = j[p] || j["@@iterator"] || y && j[y],
        T = !h && S || x(y),
        P = y ? E ? x("entries") : T : void 0,
        k = "Array" == e && j.entries || S;

    if (k && (w = f(k.call(new t()))) !== Object.prototype && w.next && (l(w, O, !0), r || s(w, p) || a(w, p, d)), E && S && "values" !== S.name && (C = !0, T = function T() {
      return S.call(this);
    }), r && !g || !h && !C && j[p] || a(j, p, T), c[e] = T, c[O] = d, y) if (b = {
      values: E ? T : x("values"),
      keys: m ? T : x("keys"),
      entries: P
    }, g) for (_ in b) {
      _ in j || i(j, _, b[_]);
    } else o(o.P + o.F * (h || C), e, b);
    return b;
  };
}, function (t, e, n) {
  t.exports = n(29);
}, function (t, e, n) {
  var r = n(80),
      o = n(58).concat("length", "prototype");

  e.f = Object.getOwnPropertyNames || function (t) {
    return r(t, o);
  };
}, function (t, e, n) {
  t.exports = {
    "default": n(161),
    __esModule: !0
  };
}, function (t, e) {
  t.exports = function (t, e) {
    if (t.indexOf) return t.indexOf(e);

    for (var n = 0; n < t.length; ++n) {
      if (t[n] === e) return n;
    }

    return -1;
  };
}, function (t, e, n) {
  var r = n(221),
      o = n(222),
      i = n(223),
      a = n(224),
      s = n(225);

  function c(t) {
    var e = -1,
        n = null == t ? 0 : t.length;

    for (this.clear(); ++e < n;) {
      var r = t[e];
      this.set(r[0], r[1]);
    }
  }

  c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = i, c.prototype.has = a, c.prototype.set = s, t.exports = c;
}, function (t, e, n) {
  var r = n(89);

  t.exports = function (t, e) {
    for (var n = t.length; n--;) {
      if (r(t[n][0], e)) return n;
    }

    return -1;
  };
}, function (t, e) {
  t.exports = function (t, e) {
    return t === e || t != t && e != e;
  };
}, function (t, e, n) {
  var r = n(49)(Object, "create");
  t.exports = r;
}, function (t, e, n) {
  var r = n(243);

  t.exports = function (t, e) {
    var n = t.__data__;
    return r(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
  };
}, function (t, e) {
  var n = 9007199254740991;

  t.exports = function (t) {
    return "number" == typeof t && t > -1 && t % 1 == 0 && t <= n;
  };
}, function (t, e, n) {
  "use strict";

  n.r(e);

  var r = n(0),
      o = n.n(r),
      i = n(1),
      a = n.n(i),
      s = n(11),
      c = n.n(s),
      u = n(3),
      l = n.n(u),
      f = n(5),
      p = n.n(f),
      h = n(12),
      d = n.n(h),
      v = n(4),
      y = n.n(v),
      m = n(6),
      g = n.n(m),
      b = n(66),
      _ = n.n(b),
      w = function w(t) {
    var e = t.className,
        n = t.included,
        r = t.vertical,
        i = t.offset,
        a = t.length,
        s = t.style,
        c = r ? {
      bottom: i + "%",
      height: a + "%"
    } : {
      left: i + "%",
      width: a + "%"
    },
        u = l()({}, s, c);
    return n ? o.a.createElement("div", {
      className: e,
      style: u
    }) : null;
  },
      x = n(17),
      O = n.n(x),
      E = n(9),
      C = n.n(E),
      j = n(67),
      S = n.n(j),
      T = n(15),
      P = n(21),
      k = n.n(P),
      M = function M(t) {
    var e = t.prefixCls,
        n = t.vertical,
        r = t.marks,
        i = t.dots,
        a = t.step,
        s = t.included,
        c = t.lowerBound,
        u = t.upperBound,
        f = t.max,
        p = t.min,
        h = t.dotStyle,
        d = t.activeDotStyle,
        v = f - p,
        y = function (t, e, n, r, o, i) {
      _()(!n || r > 0, "`Slider[step]` should be a positive number in order to make Slider[dots] work.");

      var a = Object.keys(e).map(parseFloat);
      if (n) for (var s = o; s <= i; s += r) {
        -1 === a.indexOf(s) && a.push(s);
      }
      return a;
    }(0, r, i, a, p, f).map(function (t) {
      var r,
          i = Math.abs(t - p) / v * 100 + "%",
          a = !s && t === u || s && t <= u && t >= c,
          f = n ? l()({
        bottom: i
      }, h) : l()({
        left: i
      }, h);
      a && (f = l()({}, f, d));
      var y = k()((r = {}, C()(r, e + "-dot", !0), C()(r, e + "-dot-active", a), r));
      return o.a.createElement("span", {
        className: y,
        style: f,
        key: t
      });
    });

    return o.a.createElement("div", {
      className: e + "-step"
    }, y);
  };

  M.propTypes = {
    prefixCls: a.a.string,
    activeDotStyle: a.a.object,
    dotStyle: a.a.object,
    min: a.a.number,
    max: a.a.number,
    upperBound: a.a.number,
    lowerBound: a.a.number,
    included: a.a.bool,
    dots: a.a.bool,
    step: a.a.number,
    marks: a.a.object,
    vertical: a.a.bool
  };

  var z = M,
      L = function L(t) {
    var e = t.className,
        n = t.vertical,
        r = t.marks,
        i = t.included,
        a = t.upperBound,
        s = t.lowerBound,
        c = t.max,
        u = t.min,
        f = t.onClickLabel,
        p = Object.keys(r),
        h = p.length,
        d = .9 * (h > 1 ? 100 / (h - 1) : 100),
        v = c - u,
        y = p.map(parseFloat).sort(function (t, e) {
      return t - e;
    }).map(function (t) {
      var c,
          p = r[t],
          h = "object" == _typeof(p) && !o.a.isValidElement(p),
          y = h ? p.label : p;
      if (!y && 0 !== y) return null;

      var m = !i && t === a || i && t <= a && t >= s,
          g = k()((c = {}, C()(c, e + "-text", !0), C()(c, e + "-text-active", m), c)),
          b = n ? {
        marginBottom: "-50%",
        bottom: (t - u) / v * 100 + "%"
      } : {
        width: d + "%",
        marginLeft: -d / 2 + "%",
        left: (t - u) / v * 100 + "%"
      },
          _ = h ? l()({}, b, p.style) : b;

      return o.a.createElement("span", {
        className: g,
        style: _,
        key: t,
        onMouseDown: function onMouseDown(e) {
          return f(e, t);
        },
        onTouchStart: function onTouchStart(e) {
          return f(e, t);
        }
      }, y);
    });
    return o.a.createElement("div", {
      className: e
    }, y);
  };

  L.propTypes = {
    className: a.a.string,
    vertical: a.a.bool,
    marks: a.a.object,
    included: a.a.bool,
    upperBound: a.a.number,
    lowerBound: a.a.number,
    max: a.a.number,
    min: a.a.number,
    onClickLabel: a.a.func
  };

  var A = L,
      R = function (t) {
    function e() {
      var t, n, r, o;
      p()(this, e);

      for (var i = arguments.length, a = Array(i), s = 0; s < i; s++) {
        a[s] = arguments[s];
      }

      return n = r = y()(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(a))), r.state = {
        clickFocused: !1
      }, r.setHandleRef = function (t) {
        r.handle = t;
      }, r.handleMouseUp = function () {
        document.activeElement === r.handle && r.setClickFocus(!0);
      }, r.handleBlur = function () {
        r.setClickFocus(!1);
      }, r.handleKeyDown = function () {
        r.setClickFocus(!1);
      }, o = n, y()(r, o);
    }

    return g()(e, t), d()(e, [{
      key: "componentDidMount",
      value: function value() {
        this.onMouseUpListener = Object(T.a)(document, "mouseup", this.handleMouseUp);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.onMouseUpListener && this.onMouseUpListener.remove();
      }
    }, {
      key: "setClickFocus",
      value: function value(t) {
        this.setState({
          clickFocused: t
        });
      }
    }, {
      key: "clickFocus",
      value: function value() {
        this.setClickFocus(!0), this.focus();
      }
    }, {
      key: "focus",
      value: function value() {
        this.handle.focus();
      }
    }, {
      key: "blur",
      value: function value() {
        this.handle.blur();
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.prefixCls,
            n = t.vertical,
            r = t.offset,
            i = t.style,
            a = t.disabled,
            s = t.min,
            c = t.max,
            u = t.value,
            f = t.tabIndex,
            p = O()(t, ["prefixCls", "vertical", "offset", "style", "disabled", "min", "max", "value", "tabIndex"]),
            h = k()(this.props.className, C()({}, e + "-handle-click-focused", this.state.clickFocused)),
            d = n ? {
          bottom: r + "%"
        } : {
          left: r + "%"
        },
            v = l()({}, i, d);
        return o.a.createElement("div", l()({
          ref: this.setHandleRef,
          tabIndex: a ? null : f || 0
        }, p, {
          className: h,
          style: v,
          onBlur: this.handleBlur,
          onKeyDown: this.handleKeyDown,
          role: "slider",
          "aria-valuemin": s,
          "aria-valuemax": c,
          "aria-valuenow": u,
          "aria-disabled": !!a
        }));
      }
    }]), e;
  }(o.a.Component),
      N = R;

  R.propTypes = {
    prefixCls: a.a.string,
    className: a.a.string,
    vertical: a.a.bool,
    offset: a.a.number,
    style: a.a.object,
    disabled: a.a.bool,
    min: a.a.number,
    max: a.a.number,
    value: a.a.number,
    tabIndex: a.a.number
  };
  var F = n(41),
      I = n.n(F),
      D = n(8),
      B = {
    MAC_ENTER: 3,
    BACKSPACE: 8,
    TAB: 9,
    NUM_CENTER: 12,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    PRINT_SCREEN: 44,
    INSERT: 45,
    DELETE: 46,
    ZERO: 48,
    ONE: 49,
    TWO: 50,
    THREE: 51,
    FOUR: 52,
    FIVE: 53,
    SIX: 54,
    SEVEN: 55,
    EIGHT: 56,
    NINE: 57,
    QUESTION_MARK: 63,
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    META: 91,
    WIN_KEY_RIGHT: 92,
    CONTEXT_MENU: 93,
    NUM_ZERO: 96,
    NUM_ONE: 97,
    NUM_TWO: 98,
    NUM_THREE: 99,
    NUM_FOUR: 100,
    NUM_FIVE: 101,
    NUM_SIX: 102,
    NUM_SEVEN: 103,
    NUM_EIGHT: 104,
    NUM_NINE: 105,
    NUM_MULTIPLY: 106,
    NUM_PLUS: 107,
    NUM_MINUS: 109,
    NUM_PERIOD: 110,
    NUM_DIVISION: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    NUMLOCK: 144,
    SEMICOLON: 186,
    DASH: 189,
    EQUALS: 187,
    COMMA: 188,
    PERIOD: 190,
    SLASH: 191,
    APOSTROPHE: 192,
    SINGLE_QUOTE: 222,
    OPEN_SQUARE_BRACKET: 219,
    BACKSLASH: 220,
    CLOSE_SQUARE_BRACKET: 221,
    WIN_KEY: 224,
    MAC_FF_META: 224,
    WIN_IME: 229,
    isTextModifyingKeyEvent: function isTextModifyingKeyEvent(t) {
      var e = t.keyCode;
      if (t.altKey && !t.ctrlKey || t.metaKey || e >= B.F1 && e <= B.F12) return !1;

      switch (e) {
        case B.ALT:
        case B.CAPS_LOCK:
        case B.CONTEXT_MENU:
        case B.CTRL:
        case B.DOWN:
        case B.END:
        case B.ESC:
        case B.HOME:
        case B.INSERT:
        case B.LEFT:
        case B.MAC_FF_META:
        case B.META:
        case B.NUMLOCK:
        case B.NUM_CENTER:
        case B.PAGE_DOWN:
        case B.PAGE_UP:
        case B.PAUSE:
        case B.PRINT_SCREEN:
        case B.RIGHT:
        case B.SHIFT:
        case B.UP:
        case B.WIN_KEY:
        case B.WIN_KEY_RIGHT:
          return !1;

        default:
          return !0;
      }
    },
    isCharacterKey: function isCharacterKey(t) {
      if (t >= B.ZERO && t <= B.NINE) return !0;
      if (t >= B.NUM_ZERO && t <= B.NUM_MULTIPLY) return !0;
      if (t >= B.A && t <= B.Z) return !0;
      if (-1 !== window.navigation.userAgent.indexOf("WebKit") && 0 === t) return !0;

      switch (t) {
        case B.SPACE:
        case B.QUESTION_MARK:
        case B.NUM_PLUS:
        case B.NUM_MINUS:
        case B.NUM_PERIOD:
        case B.NUM_DIVISION:
        case B.SEMICOLON:
        case B.DASH:
        case B.EQUALS:
        case B.COMMA:
        case B.PERIOD:
        case B.SLASH:
        case B.APOSTROPHE:
        case B.SINGLE_QUOTE:
        case B.OPEN_SQUARE_BRACKET:
        case B.BACKSLASH:
        case B.CLOSE_SQUARE_BRACKET:
          return !0;

        default:
          return !1;
      }
    }
  },
      V = B;

  function H(t, e) {
    return Object.keys(e).some(function (n) {
      return t.target === Object(D.findDOMNode)(e[n]);
    });
  }

  function U(t, e) {
    var n = e.min,
        r = e.max;
    return t < n || t > r;
  }

  function W(t) {
    return t.touches.length > 1 || "touchend" === t.type.toLowerCase() && t.touches.length > 0;
  }

  function q(t, e) {
    return t ? e.clientY : e.pageX;
  }

  function G(t, e) {
    return t ? e.touches[0].clientY : e.touches[0].pageX;
  }

  function K(t, e) {
    var n = e.getBoundingClientRect();
    return t ? n.top + .5 * n.height : n.left + .5 * n.width;
  }

  function Z(t, e) {
    var n = e.max,
        r = e.min;
    return t <= r ? r : t >= n ? n : t;
  }

  function Y(t, e) {
    var n = e.step,
        r = function (t, e) {
      var n = e.marks,
          r = e.step,
          o = e.min,
          i = Object.keys(n).map(parseFloat);

      if (null !== r) {
        var a = Math.round((t - o) / r) * r + o;
        i.push(a);
      }

      var s = i.map(function (e) {
        return Math.abs(t - e);
      });
      return i[s.indexOf(Math.min.apply(Math, I()(s)))];
    }(t, e);

    return null === n ? r : parseFloat(r.toFixed(function (t) {
      var e = t.toString(),
          n = 0;
      return e.indexOf(".") >= 0 && (n = e.length - e.indexOf(".") - 1), n;
    }(n)));
  }

  function $(t) {
    t.stopPropagation(), t.preventDefault();
  }

  function X(t) {
    switch (t.keyCode) {
      case V.UP:
      case V.RIGHT:
        return function (t, e) {
          return t + e.step;
        };

      case V.DOWN:
      case V.LEFT:
        return function (t, e) {
          return t - e.step;
        };

      case V.END:
        return function (t, e) {
          return e.max;
        };

      case V.HOME:
        return function (t, e) {
          return e.min;
        };

      case V.PAGE_UP:
        return function (t, e) {
          return t + 2 * e.step;
        };

      case V.PAGE_DOWN:
        return function (t, e) {
          return t - 2 * e.step;
        };

      default:
        return;
    }
  }

  function Q() {}

  function J(t) {
    var e, n;
    return n = e = function (t) {
      function e(t) {
        p()(this, e);
        var n = y()(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
        return n.onMouseDown = function (t) {
          if (0 === t.button) {
            var e = n.props.vertical,
                r = q(e, t);

            if (H(t, n.handlesRefs)) {
              var o = K(e, t.target);
              n.dragOffset = r - o, r = o;
            } else n.dragOffset = 0;

            n.removeDocumentEvents(), n.onStart(r), n.addDocumentMouseEvents();
          }
        }, n.onTouchStart = function (t) {
          if (!W(t)) {
            var e = n.props.vertical,
                r = G(e, t);

            if (H(t, n.handlesRefs)) {
              var o = K(e, t.target);
              n.dragOffset = r - o, r = o;
            } else n.dragOffset = 0;

            n.onStart(r), n.addDocumentTouchEvents(), $(t);
          }
        }, n.onFocus = function (t) {
          var e = n.props,
              r = e.onFocus,
              o = e.vertical;

          if (H(t, n.handlesRefs)) {
            var i = K(o, t.target);
            n.dragOffset = 0, n.onStart(i), $(t), r && r(t);
          }
        }, n.onBlur = function (t) {
          var e = n.props.onBlur;
          n.onEnd(t), e && e(t);
        }, n.onMouseUp = function () {
          n.handlesRefs[n.prevMovedHandleIndex] && n.handlesRefs[n.prevMovedHandleIndex].clickFocus();
        }, n.onMouseMove = function (t) {
          if (n.sliderRef) {
            var e = q(n.props.vertical, t);
            n.onMove(t, e - n.dragOffset);
          } else n.onEnd();
        }, n.onTouchMove = function (t) {
          if (!W(t) && n.sliderRef) {
            var e = G(n.props.vertical, t);
            n.onMove(t, e - n.dragOffset);
          } else n.onEnd();
        }, n.onKeyDown = function (t) {
          n.sliderRef && H(t, n.handlesRefs) && n.onKeyboard(t);
        }, n.onClickMarkLabel = function (t, e) {
          t.stopPropagation(), n.onChange({
            value: e
          });
        }, n.saveSlider = function (t) {
          n.sliderRef = t;
        }, n.handlesRefs = {}, n;
      }

      return g()(e, t), d()(e, [{
        key: "componentDidMount",
        value: function value() {
          this.document = this.sliderRef && this.sliderRef.ownerDocument;
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          S()(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "componentWillUnmount", this) && S()(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "componentWillUnmount", this).call(this), this.removeDocumentEvents();
        }
      }, {
        key: "getSliderStart",
        value: function value() {
          var t = this.sliderRef.getBoundingClientRect();
          return this.props.vertical ? t.top : t.left;
        }
      }, {
        key: "getSliderLength",
        value: function value() {
          var t = this.sliderRef;
          if (!t) return 0;
          var e = t.getBoundingClientRect();
          return this.props.vertical ? e.height : e.width;
        }
      }, {
        key: "addDocumentTouchEvents",
        value: function value() {
          this.onTouchMoveListener = Object(T.a)(this.document, "touchmove", this.onTouchMove), this.onTouchUpListener = Object(T.a)(this.document, "touchend", this.onEnd);
        }
      }, {
        key: "addDocumentMouseEvents",
        value: function value() {
          this.onMouseMoveListener = Object(T.a)(this.document, "mousemove", this.onMouseMove), this.onMouseUpListener = Object(T.a)(this.document, "mouseup", this.onEnd);
        }
      }, {
        key: "removeDocumentEvents",
        value: function value() {
          this.onTouchMoveListener && this.onTouchMoveListener.remove(), this.onTouchUpListener && this.onTouchUpListener.remove(), this.onMouseMoveListener && this.onMouseMoveListener.remove(), this.onMouseUpListener && this.onMouseUpListener.remove();
        }
      }, {
        key: "focus",
        value: function value() {
          this.props.disabled || this.handlesRefs[0].focus();
        }
      }, {
        key: "blur",
        value: function value() {
          var t = this;
          this.props.disabled || Object.keys(this.handlesRefs).forEach(function (e) {
            t.handlesRefs[e] && t.handlesRefs[e].blur && t.handlesRefs[e].blur();
          });
        }
      }, {
        key: "calcValue",
        value: function value(t) {
          var e = this.props,
              n = e.vertical,
              r = e.min,
              o = e.max,
              i = Math.abs(Math.max(t, 0) / this.getSliderLength());
          return n ? (1 - i) * (o - r) + r : i * (o - r) + r;
        }
      }, {
        key: "calcValueByPos",
        value: function value(t) {
          var e = t - this.getSliderStart();
          return this.trimAlignValue(this.calcValue(e));
        }
      }, {
        key: "calcOffset",
        value: function value(t) {
          var e = this.props,
              n = e.min;
          return 100 * ((t - n) / (e.max - n));
        }
      }, {
        key: "saveHandle",
        value: function value(t, e) {
          this.handlesRefs[t] = e;
        }
      }, {
        key: "render",
        value: function value() {
          var t,
              n = this.props,
              r = n.prefixCls,
              i = n.className,
              a = n.marks,
              s = n.dots,
              c = n.step,
              u = n.included,
              f = n.disabled,
              p = n.vertical,
              h = n.min,
              d = n.max,
              v = n.children,
              y = n.maximumTrackStyle,
              m = n.style,
              g = n.railStyle,
              b = n.dotStyle,
              _ = n.activeDotStyle,
              w = S()(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "render", this).call(this),
              x = w.tracks,
              O = w.handles,
              E = k()(r, (t = {}, C()(t, r + "-with-marks", Object.keys(a).length), C()(t, r + "-disabled", f), C()(t, r + "-vertical", p), C()(t, i, i), t));
          return o.a.createElement("div", {
            ref: this.saveSlider,
            className: E,
            onTouchStart: f ? Q : this.onTouchStart,
            onMouseDown: f ? Q : this.onMouseDown,
            onMouseUp: f ? Q : this.onMouseUp,
            onKeyDown: f ? Q : this.onKeyDown,
            onFocus: f ? Q : this.onFocus,
            onBlur: f ? Q : this.onBlur,
            style: m
          }, o.a.createElement("div", {
            className: r + "-rail",
            style: l()({}, y, g)
          }), x, o.a.createElement(z, {
            prefixCls: r,
            vertical: p,
            marks: a,
            dots: s,
            step: c,
            included: u,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: d,
            min: h,
            dotStyle: b,
            activeDotStyle: _
          }), O, o.a.createElement(A, {
            className: r + "-mark",
            onClickLabel: f ? Q : this.onClickMarkLabel,
            vertical: p,
            marks: a,
            included: u,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: d,
            min: h
          }), v);
        }
      }]), e;
    }(t), e.displayName = "ComponentEnhancer(" + t.displayName + ")", e.propTypes = l()({}, t.propTypes, {
      min: a.a.number,
      max: a.a.number,
      step: a.a.number,
      marks: a.a.object,
      included: a.a.bool,
      className: a.a.string,
      prefixCls: a.a.string,
      disabled: a.a.bool,
      children: a.a.any,
      onBeforeChange: a.a.func,
      onChange: a.a.func,
      onAfterChange: a.a.func,
      handle: a.a.func,
      dots: a.a.bool,
      vertical: a.a.bool,
      style: a.a.object,
      minimumTrackStyle: a.a.object,
      maximumTrackStyle: a.a.object,
      handleStyle: a.a.oneOfType([a.a.object, a.a.arrayOf(a.a.object)]),
      trackStyle: a.a.oneOfType([a.a.object, a.a.arrayOf(a.a.object)]),
      railStyle: a.a.object,
      dotStyle: a.a.object,
      activeDotStyle: a.a.object,
      autoFocus: a.a.bool,
      onFocus: a.a.func,
      onBlur: a.a.func
    }), e.defaultProps = l()({}, t.defaultProps, {
      prefixCls: "rc-slider",
      className: "",
      min: 0,
      max: 100,
      step: 1,
      marks: {},
      handle: function handle(t) {
        var e = t.index,
            n = O()(t, ["index"]);
        return delete n.dragging, o.a.createElement(N, l()({}, n, {
          key: e
        }));
      },
      onBeforeChange: Q,
      onChange: Q,
      onAfterChange: Q,
      included: !0,
      disabled: !1,
      dots: !1,
      vertical: !1,
      trackStyle: [{}],
      handleStyle: [{}],
      railStyle: {},
      dotStyle: {},
      activeDotStyle: {}
    }), n;
  }

  var tt = function (t) {
    function e(t) {
      p()(this, e);
      var n = y()(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      n.onEnd = function () {
        n.setState({
          dragging: !1
        }), n.removeDocumentEvents(), n.props.onAfterChange(n.getValue());
      };

      var r = void 0 !== t.defaultValue ? t.defaultValue : t.min,
          o = void 0 !== t.value ? t.value : r;
      return n.state = {
        value: n.trimAlignValue(o),
        dragging: !1
      }, n;
    }

    return g()(e, t), d()(e, [{
      key: "componentDidMount",
      value: function value() {
        var t = this.props,
            e = t.autoFocus,
            n = t.disabled;
        e && !n && this.focus();
      }
    }, {
      key: "componentWillReceiveProps",
      value: function value(t) {
        if ("value" in t || "min" in t || "max" in t) {
          var e = this.state.value,
              n = void 0 !== t.value ? t.value : e,
              r = this.trimAlignValue(n, t);
          r !== e && (this.setState({
            value: r
          }), U(n, t) && this.props.onChange(r));
        }
      }
    }, {
      key: "onChange",
      value: function value(t) {
        var e = this.props;
        !("value" in e) && this.setState(t);
        var n = t.value;
        e.onChange(n);
      }
    }, {
      key: "onStart",
      value: function value(t) {
        this.setState({
          dragging: !0
        });
        var e = this.props,
            n = this.getValue();
        e.onBeforeChange(n);
        var r = this.calcValueByPos(t);
        this.startValue = r, this.startPosition = t, r !== n && (this.prevMovedHandleIndex = 0, this.onChange({
          value: r
        }));
      }
    }, {
      key: "onMove",
      value: function value(t, e) {
        $(t);
        var n = this.state.value,
            r = this.calcValueByPos(e);
        r !== n && this.onChange({
          value: r
        });
      }
    }, {
      key: "onKeyboard",
      value: function value(t) {
        var e = X(t);

        if (e) {
          $(t);
          var n = this.state.value,
              r = e(n, this.props),
              o = this.trimAlignValue(r);
          if (o === n) return;
          this.onChange({
            value: o
          });
        }
      }
    }, {
      key: "getValue",
      value: function value() {
        return this.state.value;
      }
    }, {
      key: "getLowerBound",
      value: function value() {
        return this.props.min;
      }
    }, {
      key: "getUpperBound",
      value: function value() {
        return this.state.value;
      }
    }, {
      key: "trimAlignValue",
      value: function value(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = l()({}, this.props, e);
        return Y(Z(t, n), n);
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            e = this.props,
            n = e.prefixCls,
            r = e.vertical,
            i = e.included,
            a = e.disabled,
            s = e.minimumTrackStyle,
            c = e.trackStyle,
            u = e.handleStyle,
            f = e.tabIndex,
            p = e.min,
            h = e.max,
            d = e.handle,
            v = this.state,
            y = v.value,
            m = v.dragging,
            g = this.calcOffset(y),
            b = d({
          className: n + "-handle",
          prefixCls: n,
          vertical: r,
          offset: g,
          value: y,
          dragging: m,
          disabled: a,
          min: p,
          max: h,
          index: 0,
          tabIndex: f,
          style: u[0] || u,
          ref: function ref(e) {
            return t.saveHandle(0, e);
          }
        }),
            _ = c[0] || c;

        return {
          tracks: o.a.createElement(w, {
            className: n + "-track",
            vertical: r,
            included: i,
            offset: 0,
            length: g,
            style: l()({}, s, _)
          }),
          handles: b
        };
      }
    }]), e;
  }(o.a.Component);

  tt.propTypes = {
    defaultValue: a.a.number,
    value: a.a.number,
    disabled: a.a.bool,
    autoFocus: a.a.bool,
    tabIndex: a.a.number
  };

  var et = J(tt),
      nt = n(109),
      rt = n.n(nt),
      ot = function (t) {
    function e(t) {
      p()(this, e);
      var n = y()(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      n.onEnd = function () {
        n.setState({
          handle: null
        }, n.blur), n.removeDocumentEvents(), n.props.onAfterChange(n.getValue());
      };

      var r = t.count,
          o = t.min,
          i = t.max,
          a = Array.apply(void 0, I()(Array(r + 1))).map(function () {
        return o;
      }),
          s = "defaultValue" in t ? t.defaultValue : a,
          c = (void 0 !== t.value ? t.value : s).map(function (t, e) {
        return n.trimAlignValue(t, e);
      }),
          u = c[0] === i ? 0 : c.length - 1;
      return n.state = {
        handle: null,
        recent: u,
        bounds: c
      }, n;
    }

    return g()(e, t), d()(e, [{
      key: "componentWillReceiveProps",
      value: function value(t) {
        var e = this;

        if (("value" in t || "min" in t || "max" in t) && (this.props.min !== t.min || this.props.max !== t.max || !rt()(this.props.value, t.value))) {
          var n = this.state.bounds,
              r = t.value || n,
              o = r.map(function (n, r) {
            return e.trimAlignValue(n, r, t);
          });

          if ((o.length !== n.length || !o.every(function (t, e) {
            return t === n[e];
          })) && (this.setState({
            bounds: o
          }), n.some(function (e) {
            return U(e, t);
          }))) {
            var i = r.map(function (e) {
              return Z(e, t);
            });
            this.props.onChange(i);
          }
        }
      }
    }, {
      key: "onChange",
      value: function value(t) {
        var e = this.props;
        !("value" in e) ? this.setState(t) : void 0 !== t.handle && this.setState({
          handle: t.handle
        });
        var n = l()({}, this.state, t).bounds;
        e.onChange(n);
      }
    }, {
      key: "onStart",
      value: function value(t) {
        var e = this.props,
            n = this.state,
            r = this.getValue();
        e.onBeforeChange(r);
        var o = this.calcValueByPos(t);
        this.startValue = o, this.startPosition = t;
        var i = this.getClosestBound(o);

        if (this.prevMovedHandleIndex = this.getBoundNeedMoving(o, i), this.setState({
          handle: this.prevMovedHandleIndex,
          recent: this.prevMovedHandleIndex
        }), o !== r[this.prevMovedHandleIndex]) {
          var a = [].concat(I()(n.bounds));
          a[this.prevMovedHandleIndex] = o, this.onChange({
            bounds: a
          });
        }
      }
    }, {
      key: "onMove",
      value: function value(t, e) {
        $(t);
        var n = this.state,
            r = this.calcValueByPos(e);
        r !== n.bounds[n.handle] && this.moveTo(r);
      }
    }, {
      key: "onKeyboard",
      value: function value(t) {
        var e = X(t);

        if (e) {
          $(t);
          var n = this.state,
              r = this.props,
              o = n.bounds[n.handle],
              i = e(o, r),
              a = this.trimAlignValue(i);
          if (a === o) return;
          this.moveTo(a, !0);
        }
      }
    }, {
      key: "getValue",
      value: function value() {
        return this.state.bounds;
      }
    }, {
      key: "getClosestBound",
      value: function value(t) {
        for (var e = this.state.bounds, n = 0, r = 1; r < e.length - 1; ++r) {
          t > e[r] && (n = r);
        }

        return Math.abs(e[n + 1] - t) < Math.abs(e[n] - t) && (n += 1), n;
      }
    }, {
      key: "getBoundNeedMoving",
      value: function value(t, e) {
        var n = this.state,
            r = n.bounds,
            o = n.recent,
            i = e,
            a = r[e + 1] === r[e];
        return a && r[o] === r[e] && (i = o), a && t !== r[e + 1] && (i = t < r[e + 1] ? e : e + 1), i;
      }
    }, {
      key: "getLowerBound",
      value: function value() {
        return this.state.bounds[0];
      }
    }, {
      key: "getUpperBound",
      value: function value() {
        var t = this.state.bounds;
        return t[t.length - 1];
      }
    }, {
      key: "getPoints",
      value: function value() {
        var t = this.props,
            e = t.marks,
            n = t.step,
            r = t.min,
            o = t.max,
            i = this._getPointsCache;

        if (!i || i.marks !== e || i.step !== n) {
          var a = l()({}, e);
          if (null !== n) for (var s = r; s <= o; s += n) {
            a[s] = s;
          }
          var c = Object.keys(a).map(parseFloat);
          c.sort(function (t, e) {
            return t - e;
          }), this._getPointsCache = {
            marks: e,
            step: n,
            points: c
          };
        }

        return this._getPointsCache.points;
      }
    }, {
      key: "moveTo",
      value: function value(t, e) {
        var n = this,
            r = this.state,
            o = this.props,
            i = [].concat(I()(r.bounds));
        i[r.handle] = t;
        var a = r.handle;
        !1 !== o.pushable ? this.pushSurroundingHandles(i, a) : o.allowCross && (i.sort(function (t, e) {
          return t - e;
        }), a = i.indexOf(t)), this.onChange({
          handle: a,
          bounds: i
        }), e && this.setState({}, function () {
          n.handlesRefs[a].focus();
        });
      }
    }, {
      key: "pushSurroundingHandles",
      value: function value(t, e) {
        var n = t[e],
            r = this.props.pushable;
        r = Number(r);
        var o = 0;

        if (t[e + 1] - n < r && (o = 1), n - t[e - 1] < r && (o = -1), 0 !== o) {
          var i = e + o,
              a = o * (t[i] - n);
          this.pushHandle(t, i, o, r - a) || (t[e] = t[i] - o * r);
        }
      }
    }, {
      key: "pushHandle",
      value: function value(t, e, n, r) {
        for (var o = t[e], i = t[e]; n * (i - o) < r;) {
          if (!this.pushHandleOnePoint(t, e, n)) return t[e] = o, !1;
          i = t[e];
        }

        return !0;
      }
    }, {
      key: "pushHandleOnePoint",
      value: function value(t, e, n) {
        var r = this.getPoints(),
            o = r.indexOf(t[e]) + n;
        if (o >= r.length || o < 0) return !1;
        var i = e + n,
            a = r[o],
            s = this.props.pushable,
            c = n * (t[i] - a);
        return !!this.pushHandle(t, i, n, s - c) && (t[e] = a, !0);
      }
    }, {
      key: "trimAlignValue",
      value: function value(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = l()({}, this.props, n),
            o = Z(t, r);
        return Y(this.ensureValueNotConflict(e, o, r), r);
      }
    }, {
      key: "ensureValueNotConflict",
      value: function value(t, e, n) {
        var r = n.allowCross,
            o = n.pushable,
            i = this.state || {},
            a = i.bounds;

        if (t = void 0 === t ? i.handle : t, o = Number(o), !r && null != t && void 0 !== a) {
          if (t > 0 && e <= a[t - 1] + o) return a[t - 1] + o;
          if (t < a.length - 1 && e >= a[t + 1] - o) return a[t + 1] - o;
        }

        return e;
      }
    }, {
      key: "render",
      value: function value() {
        var t = this,
            e = this.state,
            n = e.handle,
            r = e.bounds,
            i = this.props,
            a = i.prefixCls,
            s = i.vertical,
            c = i.included,
            u = i.disabled,
            l = i.min,
            f = i.max,
            p = i.handle,
            h = i.trackStyle,
            d = i.handleStyle,
            v = i.tabIndex,
            y = r.map(function (e) {
          return t.calcOffset(e);
        }),
            m = a + "-handle",
            g = r.map(function (e, r) {
          var o;
          return p({
            className: k()((o = {}, C()(o, m, !0), C()(o, m + "-" + (r + 1), !0), o)),
            prefixCls: a,
            vertical: s,
            offset: y[r],
            value: e,
            dragging: n === r,
            index: r,
            tabIndex: v[r] || 0,
            min: l,
            max: f,
            disabled: u,
            style: d[r],
            ref: function ref(e) {
              return t.saveHandle(r, e);
            }
          });
        });
        return {
          tracks: r.slice(0, -1).map(function (t, e) {
            var n,
                r = e + 1,
                i = k()((n = {}, C()(n, a + "-track", !0), C()(n, a + "-track-" + r, !0), n));
            return o.a.createElement(w, {
              className: i,
              vertical: s,
              included: c,
              offset: y[r - 1],
              length: y[r] - y[r - 1],
              style: h[e],
              key: r
            });
          }),
          handles: g
        };
      }
    }]), e;
  }(o.a.Component);

  ot.displayName = "Range", ot.propTypes = {
    defaultValue: a.a.arrayOf(a.a.number),
    value: a.a.arrayOf(a.a.number),
    count: a.a.number,
    pushable: a.a.oneOfType([a.a.bool, a.a.number]),
    allowCross: a.a.bool,
    disabled: a.a.bool,
    tabIndex: a.a.arrayOf(a.a.number)
  }, ot.defaultProps = {
    count: 1,
    allowCross: !0,
    pushable: !1,
    tabIndex: []
  };

  var it = J(ot),
      at = n(7),
      st = n.n(at),
      ct = n(73),
      ut = {
    adjustX: 1,
    adjustY: 1
  },
      lt = [0, 0],
      ft = {
    left: {
      points: ["cr", "cl"],
      overflow: ut,
      offset: [-4, 0],
      targetOffset: lt
    },
    right: {
      points: ["cl", "cr"],
      overflow: ut,
      offset: [4, 0],
      targetOffset: lt
    },
    top: {
      points: ["bc", "tc"],
      overflow: ut,
      offset: [0, -4],
      targetOffset: lt
    },
    bottom: {
      points: ["tc", "bc"],
      overflow: ut,
      offset: [0, 4],
      targetOffset: lt
    },
    topLeft: {
      points: ["bl", "tl"],
      overflow: ut,
      offset: [0, -4],
      targetOffset: lt
    },
    leftTop: {
      points: ["tr", "tl"],
      overflow: ut,
      offset: [-4, 0],
      targetOffset: lt
    },
    topRight: {
      points: ["br", "tr"],
      overflow: ut,
      offset: [0, -4],
      targetOffset: lt
    },
    rightTop: {
      points: ["tl", "tr"],
      overflow: ut,
      offset: [4, 0],
      targetOffset: lt
    },
    bottomRight: {
      points: ["tr", "br"],
      overflow: ut,
      offset: [0, 4],
      targetOffset: lt
    },
    rightBottom: {
      points: ["bl", "br"],
      overflow: ut,
      offset: [4, 0],
      targetOffset: lt
    },
    bottomLeft: {
      points: ["tl", "bl"],
      overflow: ut,
      offset: [0, 4],
      targetOffset: lt
    },
    leftBottom: {
      points: ["br", "bl"],
      overflow: ut,
      offset: [-4, 0],
      targetOffset: lt
    }
  },
      pt = function (t) {
    function e() {
      return p()(this, e), y()(this, t.apply(this, arguments));
    }

    return g()(e, t), e.prototype.componentDidUpdate = function () {
      var t = this.props.trigger;
      t && t.forcePopupAlign();
    }, e.prototype.render = function () {
      var t = this.props,
          e = t.overlay,
          n = t.prefixCls,
          r = t.id;
      return o.a.createElement("div", {
        className: n + "-inner",
        id: r
      }, "function" == typeof e ? e() : e);
    }, e;
  }(o.a.Component);

  pt.propTypes = {
    prefixCls: st.a.string,
    overlay: st.a.oneOfType([st.a.node, st.a.func]).isRequired,
    id: st.a.string,
    trigger: st.a.any
  };

  var ht = pt,
      dt = function (t) {
    function e() {
      var n, r, i;
      p()(this, e);

      for (var a = arguments.length, s = Array(a), c = 0; c < a; c++) {
        s[c] = arguments[c];
      }

      return n = r = y()(this, t.call.apply(t, [this].concat(s))), r.getPopupElement = function () {
        var t = r.props,
            e = t.arrowContent,
            n = t.overlay,
            i = t.prefixCls,
            a = t.id;
        return [o.a.createElement("div", {
          className: i + "-arrow",
          key: "arrow"
        }, e), o.a.createElement(ht, {
          key: "content",
          trigger: r.trigger,
          prefixCls: i,
          id: a,
          overlay: n
        })];
      }, r.saveTrigger = function (t) {
        r.trigger = t;
      }, i = n, y()(r, i);
    }

    return g()(e, t), e.prototype.getPopupDomNode = function () {
      return this.trigger.getPopupDomNode();
    }, e.prototype.render = function () {
      var t = this.props,
          e = t.overlayClassName,
          n = t.trigger,
          r = t.mouseEnterDelay,
          i = t.mouseLeaveDelay,
          a = t.overlayStyle,
          s = t.prefixCls,
          c = t.children,
          u = t.onVisibleChange,
          f = t.afterVisibleChange,
          p = t.transitionName,
          h = t.animation,
          d = t.placement,
          v = t.align,
          y = t.destroyTooltipOnHide,
          m = t.defaultVisible,
          g = t.getTooltipContainer,
          b = O()(t, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer"]),
          _ = l()({}, b);

      return "visible" in this.props && (_.popupVisible = this.props.visible), o.a.createElement(ct["default"], l()({
        popupClassName: e,
        ref: this.saveTrigger,
        prefixCls: s,
        popup: this.getPopupElement,
        action: n,
        builtinPlacements: ft,
        popupPlacement: d,
        popupAlign: v,
        getPopupContainer: g,
        onPopupVisibleChange: u,
        afterPopupVisibleChange: f,
        popupTransitionName: p,
        popupAnimation: h,
        defaultPopupVisible: m,
        destroyPopupOnHide: y,
        mouseLeaveDelay: i,
        popupStyle: a,
        mouseEnterDelay: r
      }, _), c);
    }, e;
  }(r.Component);

  dt.propTypes = {
    trigger: st.a.any,
    children: st.a.any,
    defaultVisible: st.a.bool,
    visible: st.a.bool,
    placement: st.a.string,
    transitionName: st.a.oneOfType([st.a.string, st.a.object]),
    animation: st.a.any,
    onVisibleChange: st.a.func,
    afterVisibleChange: st.a.func,
    overlay: st.a.oneOfType([st.a.node, st.a.func]).isRequired,
    overlayStyle: st.a.object,
    overlayClassName: st.a.string,
    prefixCls: st.a.string,
    mouseEnterDelay: st.a.number,
    mouseLeaveDelay: st.a.number,
    getTooltipContainer: st.a.func,
    destroyTooltipOnHide: st.a.bool,
    align: st.a.object,
    arrowContent: st.a.any,
    id: st.a.string
  }, dt.defaultProps = {
    prefixCls: "rc-tooltip",
    mouseEnterDelay: 0,
    destroyTooltipOnHide: !1,
    mouseLeaveDelay: .1,
    align: {},
    placement: "right",
    trigger: ["hover"],
    arrowContent: null
  };
  var vt = dt;
  et.Range = it, et.Handle = N, et.createSliderWithTooltip = function (t) {
    var e, n;
    return n = e = function (e) {
      function n(t) {
        p()(this, n);
        var e = y()(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, t));
        return e.handleTooltipVisibleChange = function (t, n) {
          e.setState(function (e) {
            return {
              visibles: l()({}, e.visibles, C()({}, t, n))
            };
          });
        }, e.handleWithTooltip = function (t) {
          var n = t.value,
              r = t.dragging,
              i = t.index,
              a = t.disabled,
              s = O()(t, ["value", "dragging", "index", "disabled"]),
              c = e.props,
              u = c.tipFormatter,
              f = c.tipProps,
              p = c.handleStyle,
              h = f.prefixCls,
              d = void 0 === h ? "rc-slider-tooltip" : h,
              v = f.overlay,
              y = void 0 === v ? u(n) : v,
              m = f.placement,
              g = void 0 === m ? "top" : m,
              b = f.visible,
              _ = void 0 !== b && b,
              w = O()(f, ["prefixCls", "overlay", "placement", "visible"]),
              x = void 0;

          return x = Array.isArray(p) ? p[i] || p[0] : p, o.a.createElement(vt, l()({}, w, {
            prefixCls: d,
            overlay: y,
            placement: g,
            visible: !a && (e.state.visibles[i] || r) || _,
            key: i
          }), o.a.createElement(N, l()({}, s, {
            style: l()({}, x),
            value: n,
            onMouseEnter: function onMouseEnter() {
              return e.handleTooltipVisibleChange(i, !0);
            },
            onMouseLeave: function onMouseLeave() {
              return e.handleTooltipVisibleChange(i, !1);
            }
          })));
        }, e.state = {
          visibles: {}
        }, e;
      }

      return g()(n, e), d()(n, [{
        key: "render",
        value: function value() {
          return o.a.createElement(t, l()({}, this.props, {
            handle: this.handleWithTooltip
          }));
        }
      }]), n;
    }(o.a.Component), e.propTypes = {
      tipFormatter: a.a.func,
      handleStyle: a.a.oneOfType([a.a.object, a.a.arrayOf(a.a.object)]),
      tipProps: a.a.object
    }, e.defaultProps = {
      tipFormatter: function tipFormatter(t) {
        return t;
      },
      handleStyle: [{}],
      tipProps: {}
    }, n;
  };
  var yt = et,
      mt = n(110),
      gt = n.n(mt),
      bt = n(24);
  n(210);
  n.d(e, "Slider", function () {
    return Et;
  });

  var _t = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  },
      wt = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function xt(t, e) {
    var n = {};

    for (var r in t) {
      e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }

    return n;
  }

  function Ot(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var Et = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var i = arguments.length, a = Array(i), s = 0; s < i; s++) {
        a[s] = arguments[s];
      }

      return n = r = Ot(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(a))), r.renderHandle = function (t) {
        var e = r.props,
            n = e.formatValue,
            i = e.showTooltip,
            a = t.value,
            s = t.dragging,
            c = t.index,
            u = xt(t, ["value", "dragging", "index"]),
            l = n ? n(a) : a,
            f = !!i && i(c);
        return o.a.createElement(bt["default"], {
          key: c,
          overlay: l,
          overlayClassName: "c-rc-tooltip -default",
          overlayStyle: {
            color: "#fff"
          },
          placement: "top",
          mouseLeaveDelay: 0,
          destroyTooltipOnHide: !0,
          visible: !!s || !!f
        }, o.a.createElement(N, _t({
          className: "drag-handle",
          value: a
        }, u)));
      }, Ot(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), wt(e, [{
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.customClass,
            n = t.range,
            r = t.handleStyle,
            i = t.value,
            a = xt(t, ["customClass", "range", "handleStyle", "value"]),
            s = n ? it : yt,
            u = Array.isArray(i) ? i.length : 1,
            l = gt()(Array(u), {
          width: "1px",
          height: "10px",
          backgroundColor: "#808080",
          marginLeft: "-1px",
          marginTop: "-3px",
          borderRadius: 0,
          border: 0,
          zIndex: 1,
          pointerEvents: "none",
          touchAction: "none"
        });
        l[0] = r, l[u - 1] = r;
        var f = c()("vizzuality-slider", function (t, e, n) {
          return e in t ? Object.defineProperty(t, e, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = n, t;
        }({}, e, !!e));
        return o.a.createElement("div", {
          className: f
        }, o.a.createElement(s, _t({
          handle: this.renderHandle,
          handleStyle: l,
          value: i
        }, a)));
      }
    }]), e;
  }();

  Et.propTypes = {
    customClass: a.a.string,
    settings: a.a.shape({}),
    value: a.a.oneOfType([a.a.array, a.a.number]),
    dragging: a.a.bool,
    index: a.a.number,
    range: a.a.bool,
    trackStyle: a.a.oneOfType([a.a.array, a.a.shape({})]).isRequired,
    handleStyle: a.a.oneOfType([a.a.array, a.a.shape({})]),
    formatValue: a.a.func,
    showTooltip: a.a.func,
    railStyle: a.a.shape({}),
    dotStyle: a.a.shape({}),
    pushable: a.a.oneOfType([a.a.bool, a.a.number])
  }, Et.defaultProps = {
    customClass: null,
    settings: {},
    value: [0],
    dragging: !1,
    index: 0,
    range: !1,
    handleStyle: {
      backgroundColor: "#c32d7b",
      borderRadius: "10px",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.29)",
      border: "0px",
      zIndex: 2
    },
    formatValue: null,
    showTooltip: null,
    railStyle: {
      backgroundColor: "#d9d9d9"
    },
    dotStyle: {
      visibility: "hidden",
      border: "0px"
    },
    pushable: !0
  };
  e["default"] = Et;
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0;
  var r,
      o = n(116),
      i = (r = o) && r.__esModule ? r : {
    "default": r
  };
  e["default"] = i["default"], t.exports = e["default"];
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e["default"] = function (t, e, n) {
    function r(e) {
      var r = new i["default"](e);
      n.call(t, r);
    }

    if (t.addEventListener) return t.addEventListener(e, r, !1), {
      remove: function remove() {
        t.removeEventListener(e, r, !1);
      }
    };
    if (t.attachEvent) return t.attachEvent("on" + e, r), {
      remove: function remove() {
        t.detachEvent("on" + e, r);
      }
    };
  };
  var r,
      o = n(156),
      i = (r = o) && r.__esModule ? r : {
    "default": r
  };
  t.exports = e["default"];
}, function (t, e, n) {
  try {
    var r = n(86);
  } catch (t) {
    r = n(86);
  }

  var o = /\s+/,
      i = Object.prototype.toString;

  function a(t) {
    if (!t || !t.nodeType) throw new Error("A DOM element reference is required");
    this.el = t, this.list = t.classList;
  }

  t.exports = function (t) {
    return new a(t);
  }, a.prototype.add = function (t) {
    if (this.list) return this.list.add(t), this;
    var e = this.array();
    return ~r(e, t) || e.push(t), this.el.className = e.join(" "), this;
  }, a.prototype.remove = function (t) {
    if ("[object RegExp]" == i.call(t)) return this.removeMatching(t);
    if (this.list) return this.list.remove(t), this;
    var e = this.array(),
        n = r(e, t);
    return ~n && e.splice(n, 1), this.el.className = e.join(" "), this;
  }, a.prototype.removeMatching = function (t) {
    for (var e = this.array(), n = 0; n < e.length; n++) {
      t.test(e[n]) && this.remove(e[n]);
    }

    return this;
  }, a.prototype.toggle = function (t, e) {
    return this.list ? (void 0 !== e ? e !== this.list.toggle(t, e) && this.list.toggle(t) : this.list.toggle(t), this) : (void 0 !== e ? e ? this.add(t) : this.remove(t) : this.has(t) ? this.remove(t) : this.add(t), this);
  }, a.prototype.array = function () {
    var t = (this.el.getAttribute("class") || "").replace(/^\s+|\s+$/g, "").split(o);
    return "" === t[0] && t.shift(), t;
  }, a.prototype.has = a.prototype.contains = function (t) {
    return this.list ? this.list.contains(t) : !!~r(this.array(), t);
  };
}, function (t, e, n) {
  var r = n(55),
      o = Math.min;

  t.exports = function (t) {
    return t > 0 ? o(r(t), 9007199254740991) : 0;
  };
}, function (t, e, n) {
  "use strict";

  var r = n(126)(!0);
  n(82)(String, "String", function (t) {
    this._t = String(t), this._i = 0;
  }, function () {
    var t,
        e = this._t,
        n = this._i;
    return n >= e.length ? {
      value: void 0,
      done: !0
    } : (t = r(e, n), this._i += t.length, {
      value: t,
      done: !1
    });
  });
}, function (t, e, n) {
  var r = n(27),
      o = n(47),
      i = n(56)("IE_PROTO"),
      a = Object.prototype;

  t.exports = Object.getPrototypeOf || function (t) {
    return t = o(t), r(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null;
  };
}, function (t, e) {
  var n = 9007199254740991,
      r = /^(?:0|[1-9]\d*)$/;

  t.exports = function (t, e) {
    var o = _typeof(t);

    return !!(e = null == e ? n : e) && ("number" == o || "symbol" != o && r.test(t)) && t > -1 && t % 1 == 0 && t < e;
  };
}, function (t, e, n) {
  !function (t, e, n, r) {
    "use strict";

    function o(t, e) {
      return t(e = {
        exports: {}
      }, e.exports), e.exports;
    }

    n = n && n.hasOwnProperty("default") ? n["default"] : n;

    var i = o(function (t) {
      function e() {
        return t.exports = e = Object.assign || function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];

            for (var r in n) {
              Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
            }
          }

          return t;
        }, e.apply(this, arguments);
      }

      t.exports = e;
    }),
        a = function a(t) {
      if (Array.isArray(t)) return t;
    },
        s = function s(t, e) {
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, s = t[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !e || n.length !== e); r = !0) {
          ;
        }
      } catch (t) {
        o = !0, i = t;
      } finally {
        try {
          r || null == s["return"] || s["return"]();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    },
        c = function c() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
        u = function u(t, e) {
      return a(t) || s(t, e) || c();
    },
        l = function l(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    },
        f = function f(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {},
            r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
          return Object.getOwnPropertyDescriptor(n, t).enumerable;
        }))), r.forEach(function (e) {
          l(t, e, n[e]);
        });
      }

      return t;
    },
        p = function p(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };

    function h(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    var d = function d(t, e, n) {
      return e && h(t.prototype, e), n && h(t, n), t;
    },
        v = o(function (t) {
      function e(t) {
        return (e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
          return _typeof(t);
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
        })(t);
      }

      function n(r) {
        return "function" == typeof Symbol && "symbol" === e(Symbol.iterator) ? t.exports = n = function n(t) {
          return e(t);
        } : t.exports = n = function n(t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : e(t);
        }, n(r);
      }

      t.exports = n;
    }),
        y = function y(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    },
        m = function m(t, e) {
      return !e || "object" !== v(e) && "function" != typeof e ? y(t) : e;
    },
        g = o(function (t) {
      function e(n) {
        return t.exports = e = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, e(n);
      }

      t.exports = e;
    }),
        b = o(function (t) {
      function e(n, r) {
        return t.exports = e = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        }, e(n, r);
      }

      t.exports = e;
    }),
        _ = function _(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && b(t, e);
    },
        w = function w(t, e, n, r, o, i, a, s) {
      if (void 0 === e) throw new Error("invariant requires an error message argument");

      if (!t) {
        var c;
        if (void 0 === e) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var u = [n, r, o, i, a, s],
              l = 0;
          (c = new Error(e.replace(/%s/g, function () {
            return u[l++];
          }))).name = "Invariant Violation";
        }
        throw c.framesToPop = 1, c;
      }
    },
        x = function () {
      function t() {
        p(this, t), l(this, "refs", {});
      }

      return d(t, [{
        key: "add",
        value: function value(t, e) {
          this.refs[t] || (this.refs[t] = []), this.refs[t].push(e);
        }
      }, {
        key: "remove",
        value: function value(t, e) {
          var n = this.getIndex(t, e);
          -1 !== n && this.refs[t].splice(n, 1);
        }
      }, {
        key: "isActive",
        value: function value() {
          return this.active;
        }
      }, {
        key: "getActive",
        value: function value() {
          var t = this;
          return this.refs[this.active.collection].find(function (e) {
            var n = e.node;
            return n.sortableInfo.index == t.active.index;
          });
        }
      }, {
        key: "getIndex",
        value: function value(t, e) {
          return this.refs[t].indexOf(e);
        }
      }, {
        key: "getOrderedRefs",
        value: function value() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.active.collection;
          return this.refs[t].sort(O);
        }
      }]), t;
    }();

    function O(t, e) {
      var n = t.node.sortableInfo.index,
          r = e.node.sortableInfo.index;
      return n - r;
    }

    var E = function E(t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = new Array(t.length); e < t.length; e++) {
          n[e] = t[e];
        }

        return n;
      }
    },
        C = function C(t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    },
        j = function j() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    },
        S = function S(t) {
      return E(t) || C(t) || j();
    };

    function T(t) {
      for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) {
        n[r - 1] = arguments[r];
      }

      return Object.keys(t).reduce(function (e, r) {
        return -1 === n.indexOf(r) && (e[r] = t[r]), e;
      }, {});
    }

    var P = {
      end: ["touchend", "touchcancel", "mouseup"],
      move: ["touchmove", "mousemove"],
      start: ["touchstart", "mousedown"]
    },
        k = function () {
      if ("undefined" == typeof window || "undefined" == typeof document) return "";
      var t = window.getComputedStyle(document.documentElement, "") || ["-moz-hidden-iframe"],
          e = (Array.prototype.slice.call(t).join("").match(/-(moz|webkit|ms)-/) || "" === t.OLink && ["", "o"])[1];

      switch (e) {
        case "ms":
          return "ms";

        default:
          return e && e.length ? e[0].toUpperCase() + e.substr(1) : "";
      }
    }();

    function M(t, e) {
      Object.keys(e).forEach(function (n) {
        t.style[n] = e[n];
      });
    }

    function z(t, e) {
      t.style["".concat(k, "Transform")] = null == e ? "" : "translate3d(".concat(e.x, "px,").concat(e.y, "px,0)");
    }

    function L(t, e) {
      t.style["".concat(k, "TransitionDuration")] = null == e ? "" : "".concat(e, "ms");
    }

    function A(t, e) {
      for (; t;) {
        if (e(t)) return t;
        t = t.parentNode;
      }

      return null;
    }

    function R(t, e, n) {
      return Math.max(t, Math.min(n, e));
    }

    function N(t) {
      return "px" === t.substr(-2) ? parseFloat(t) : 0;
    }

    function F(t, e) {
      var n = e.displayName || e.name;
      return n ? "".concat(t, "(").concat(n, ")") : t;
    }

    function I(t, e) {
      var n = t.getBoundingClientRect();
      return {
        top: n.top + e.top,
        left: n.left + e.left
      };
    }

    function D(t) {
      return t.touches && t.touches.length ? {
        x: t.touches[0].pageX,
        y: t.touches[0].pageY
      } : t.changedTouches && t.changedTouches.length ? {
        x: t.changedTouches[0].pageX,
        y: t.changedTouches[0].pageY
      } : {
        x: t.pageX,
        y: t.pageY
      };
    }

    function B(t, e) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
        left: 0,
        top: 0
      };

      if (t) {
        var r = {
          left: n.left + t.offsetLeft,
          top: n.top + t.offsetTop
        };
        return t.parentNode === e ? r : B(t.parentNode, e, r);
      }
    }

    function V(t) {
      var e = t.lockOffset,
          n = t.width,
          r = t.height,
          o = e,
          i = e,
          a = "px";

      if ("string" == typeof e) {
        var s = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(e);
        w(null !== s, 'lockOffset value should be a number or a string of a number followed by "px" or "%". Given %s', e), o = parseFloat(e), i = parseFloat(e), a = s[1];
      }

      return w(isFinite(o) && isFinite(i), "lockOffset value should be a finite. Given %s", e), "%" === a && (o = o * n / 100, i = i * r / 100), {
        x: o,
        y: i
      };
    }

    function H(t) {
      return t instanceof HTMLElement ? function (t) {
        var e = window.getComputedStyle(t),
            n = /(auto|scroll)/;
        return ["overflow", "overflowX", "overflowY"].find(function (t) {
          return n.test(e[t]);
        });
      }(t) ? t : H(t.parentNode) : null;
    }

    var U = {
      TAB: 9,
      ESC: 27,
      SPACE: 32,
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40
    },
        W = {
      Anchor: "A",
      Button: "BUTTON",
      Canvas: "CANVAS",
      Input: "INPUT",
      Option: "OPTION",
      Textarea: "TEXTAREA",
      Select: "SELECT"
    };

    function q(t) {
      var n,
          o,
          a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        withRef: !1
      };
      return o = n = function (n) {
        function o() {
          return p(this, o), m(this, g(o).apply(this, arguments));
        }

        return _(o, n), d(o, [{
          key: "componentDidMount",
          value: function value() {
            var t = r.findDOMNode(this);
            t.sortableHandle = !0;
          }
        }, {
          key: "getWrappedInstance",
          value: function value() {
            return w(a.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call"), this.refs.wrappedInstance;
          }
        }, {
          key: "render",
          value: function value() {
            var n = a.withRef ? "wrappedInstance" : null;
            return e.createElement(t, i({
              ref: n
            }, this.props));
          }
        }]), o;
      }(e.Component), l(n, "displayName", F("sortableHandle", t)), o;
    }

    function G(t) {
      return null != t.sortableHandle;
    }

    var K = function () {
      function t(e, n) {
        p(this, t), this.container = e, this.onScrollCallback = n;
      }

      return d(t, [{
        key: "clear",
        value: function value() {
          clearInterval(this.interval), this.interval = null;
        }
      }, {
        key: "update",
        value: function value(t) {
          var e = this,
              n = t.translate,
              r = t.minTranslate,
              o = t.maxTranslate,
              i = t.width,
              a = t.height,
              s = {
            x: 0,
            y: 0
          },
              c = {
            x: 1,
            y: 1
          },
              u = {
            x: 10,
            y: 10
          },
              l = this.container,
              f = l.scrollTop,
              p = l.scrollLeft,
              h = l.scrollHeight,
              d = l.scrollWidth,
              v = l.clientHeight,
              y = l.clientWidth,
              m = 0 === f,
              g = h - f - v == 0,
              b = 0 === p,
              _ = d - p - y == 0;

          n.y >= o.y - a / 2 && !g ? (s.y = 1, c.y = u.y * Math.abs((o.y - a / 2 - n.y) / a)) : n.x >= o.x - i / 2 && !_ ? (s.x = 1, c.x = u.x * Math.abs((o.x - i / 2 - n.x) / i)) : n.y <= r.y + a / 2 && !m ? (s.y = -1, c.y = u.y * Math.abs((n.y - a / 2 - r.y) / a)) : n.x <= r.x + i / 2 && !b && (s.x = -1, c.x = u.x * Math.abs((n.x - i / 2 - r.x) / i)), this.interval && (this.clear(), this.isAutoScrolling = !1), 0 === s.x && 0 === s.y || (this.interval = setInterval(function () {
            e.isAutoScrolling = !0;
            var t = {
              left: c.x * s.x,
              top: c.y * s.y
            };
            e.container.scrollTop += t.top, e.container.scrollLeft += t.left, e.onScrollCallback(t);
          }, 5));
        }
      }]), t;
    }(),
        Z = {
      axis: n.oneOf(["x", "y", "xy"]),
      contentWindow: n.any,
      disableAutoscroll: n.bool,
      distance: n.number,
      getContainer: n.func,
      getHelperDimensions: n.func,
      helperClass: n.string,
      helperContainer: n.oneOfType([n.func, "undefined" == typeof HTMLElement ? n.any : n.instanceOf(HTMLElement)]),
      hideSortableGhost: n.bool,
      keyboardSortingTransitionDuration: n.number,
      lockAxis: n.string,
      lockOffset: n.oneOfType([n.number, n.string, n.arrayOf(n.oneOfType([n.number, n.string]))]),
      lockToContainerEdges: n.bool,
      onSortEnd: n.func,
      onSortMove: n.func,
      onSortOver: n.func,
      onSortStart: n.func,
      pressDelay: n.number,
      pressThreshold: n.number,
      shouldCancelStart: n.func,
      transitionDuration: n.number,
      updateBeforeSortStart: n.func,
      useDragHandle: n.bool,
      useWindowAsScrollContainer: n.bool
    },
        Y = {
      axis: "y",
      disableAutoscroll: !1,
      distance: 0,
      getHelperDimensions: function getHelperDimensions(t) {
        var e = t.node;
        return {
          height: e.offsetHeight,
          width: e.offsetWidth
        };
      },
      hideSortableGhost: !0,
      lockOffset: "50%",
      lockToContainerEdges: !1,
      pressDelay: 0,
      pressThreshold: 5,
      shouldCancelStart: function shouldCancelStart(t) {
        return -1 !== [W.Input, W.Textarea, W.Select, W.Option, W.Button].indexOf(t.target.tagName) || !!A(t.target, function (t) {
          return "true" === t.contentEditable;
        });
      },
      transitionDuration: 300,
      useWindowAsScrollContainer: !1
    },
        $ = Object.keys(Z);

    function X(t) {
      var o,
          a,
          s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        withRef: !1
      };
      return a = o = function (n) {
        function o(t) {
          var e;
          return p(this, o), e = m(this, g(o).call(this, t)), l(y(y(e)), "handleStart", function (t) {
            var n = e.props,
                r = n.distance,
                o = n.shouldCancelStart;

            if (2 !== t.button && !o(t)) {
              e.touched = !0, e.position = D(t);
              var i = A(t.target, function (t) {
                return null != t.sortableInfo;
              });

              if (i && i.sortableInfo && e.nodeIsChild(i) && !e.state.sorting) {
                var a = e.props.useDragHandle,
                    s = i.sortableInfo,
                    c = s.index,
                    u = s.collection,
                    l = s.disabled;
                if (l) return;
                if (a && !A(t.target, G)) return;
                e.manager.active = {
                  collection: u,
                  index: c
                }, function (t) {
                  return t.touches && t.touches.length || t.changedTouches && t.changedTouches.length;
                }(t) || t.target.tagName !== W.Anchor || t.preventDefault(), r || (0 === e.props.pressDelay ? e.handlePress(t) : e.pressTimer = setTimeout(function () {
                  return e.handlePress(t);
                }, e.props.pressDelay));
              }
            }
          }), l(y(y(e)), "nodeIsChild", function (t) {
            return t.sortableInfo.manager === e.manager;
          }), l(y(y(e)), "handleMove", function (t) {
            var n = e.props,
                r = n.distance,
                o = n.pressThreshold;

            if (!e.state.sorting && e.touched && !e._awaitingUpdateBeforeSortStart) {
              var i = D(t),
                  a = {
                x: e.position.x - i.x,
                y: e.position.y - i.y
              },
                  s = Math.abs(a.x) + Math.abs(a.y);
              e.delta = a, r || o && !(s >= o) ? r && s >= r && e.manager.isActive() && e.handlePress(t) : (clearTimeout(e.cancelTimer), e.cancelTimer = setTimeout(e.cancel, 0));
            }
          }), l(y(y(e)), "handleEnd", function () {
            e.touched = !1, e.cancel();
          }), l(y(y(e)), "cancel", function () {
            var t = e.props.distance,
                n = e.state.sorting;
            n || (t || clearTimeout(e.pressTimer), e.manager.active = null);
          }), l(y(y(e)), "handlePress", function (t) {
            try {
              var n = e.manager.getActive(),
                  r = function () {
                if (n) {
                  var r = function r() {
                    var n,
                        r,
                        o,
                        u,
                        y,
                        m,
                        g = h.sortableInfo.index,
                        b = (n = h, {
                      bottom: N((r = window.getComputedStyle(n)).marginBottom),
                      left: N(r.marginLeft),
                      right: N(r.marginRight),
                      top: N(r.marginTop)
                    }),
                        _ = e.scrollContainer.getBoundingClientRect(),
                        w = a({
                      collection: d,
                      index: g,
                      node: h
                    });

                    if (e.node = h, e.margin = b, e.width = w.width, e.height = w.height, e.marginOffset = {
                      x: e.margin.left + e.margin.right,
                      y: Math.max(e.margin.top, e.margin.bottom)
                    }, e.boundingClientRect = h.getBoundingClientRect(), e.containerBoundingRect = _, e.index = g, e.newIndex = g, e.axis = {
                      x: i.indexOf("x") >= 0,
                      y: i.indexOf("y") >= 0
                    }, e.offsetEdge = B(h, e.container), e.initialOffset = D(v ? f({}, t, {
                      pageX: e.boundingClientRect.left,
                      pageY: e.boundingClientRect.top
                    }) : t), e.initialScroll = {
                      left: e.scrollContainer.scrollLeft,
                      top: e.scrollContainer.scrollTop
                    }, e.initialWindowScroll = {
                      left: window.pageXOffset,
                      top: window.pageYOffset
                    }, e.helper = e.helperContainer.appendChild((u = "input, textarea, select, canvas, [contenteditable]", y = (o = h).querySelectorAll(u), m = o.cloneNode(!0), S(m.querySelectorAll(u)).forEach(function (t, e) {
                      "file" !== t.type && (t.value = y[e].value), "radio" === t.type && t.name && (t.name = "__sortableClone__".concat(t.name)), t.tagName === W.Canvas && y[e].width > 0 && y[e].height > 0 && t.getContext("2d").drawImage(y[e], 0, 0);
                    }), m)), M(e.helper, {
                      boxSizing: "border-box",
                      height: "".concat(e.height, "px"),
                      left: "".concat(e.boundingClientRect.left - b.left, "px"),
                      pointerEvents: "none",
                      position: "fixed",
                      top: "".concat(e.boundingClientRect.top - b.top, "px"),
                      width: "".concat(e.width, "px")
                    }), v && e.helper.focus(), c && (e.sortableGhost = h, M(h, {
                      opacity: 0,
                      visibility: "hidden"
                    })), e.minTranslate = {}, e.maxTranslate = {}, v) {
                      var x = p ? {
                        top: 0,
                        left: 0,
                        width: e.contentWindow.innerWidth,
                        height: e.contentWindow.innerHeight
                      } : e.containerBoundingRect,
                          O = x.top,
                          E = x.left,
                          C = x.width,
                          j = x.height,
                          T = O + j,
                          k = E + C;
                      e.axis.x && (e.minTranslate.x = E - e.boundingClientRect.left, e.maxTranslate.x = k - (e.boundingClientRect.left + e.width)), e.axis.y && (e.minTranslate.y = O - e.boundingClientRect.top, e.maxTranslate.y = T - (e.boundingClientRect.top + e.height));
                    } else e.axis.x && (e.minTranslate.x = (p ? 0 : _.left) - e.boundingClientRect.left - e.width / 2, e.maxTranslate.x = (p ? e.contentWindow.innerWidth : _.left + _.width) - e.boundingClientRect.left - e.width / 2), e.axis.y && (e.minTranslate.y = (p ? 0 : _.top) - e.boundingClientRect.top - e.height / 2, e.maxTranslate.y = (p ? e.contentWindow.innerHeight : _.top + _.height) - e.boundingClientRect.top - e.height / 2);

                    s && s.split(" ").forEach(function (t) {
                      return e.helper.classList.add(t);
                    }), e.listenerNode = t.touches ? h : e.contentWindow, v ? (e.listenerNode.addEventListener("wheel", e.handleKeyEnd, !0), e.listenerNode.addEventListener("mousedown", e.handleKeyEnd, !0), e.listenerNode.addEventListener("keydown", e.handleKeyDown)) : (P.move.forEach(function (t) {
                      return e.listenerNode.addEventListener(t, e.handleSortMove, !1);
                    }), P.end.forEach(function (t) {
                      return e.listenerNode.addEventListener(t, e.handleSortEnd, !1);
                    })), e.setState({
                      sorting: !0,
                      sortingIndex: g
                    }), l && l({
                      node: h,
                      index: g,
                      collection: d,
                      isKeySorting: v
                    }, t), v && e.keyMove(0);
                  },
                      o = e.props,
                      i = o.axis,
                      a = o.getHelperDimensions,
                      s = o.helperClass,
                      c = o.hideSortableGhost,
                      u = o.updateBeforeSortStart,
                      l = o.onSortStart,
                      p = o.useWindowAsScrollContainer,
                      h = n.node,
                      d = n.collection,
                      v = e.manager.isKeySorting,
                      y = function () {
                    if ("function" == typeof u) {
                      e._awaitingUpdateBeforeSortStart = !0;

                      var n = function (t, e) {
                        try {
                          var n = t();
                        } catch (t) {
                          return e(!0, t);
                        }

                        return n && n.then ? n.then(e.bind(null, !1), e.bind(null, !0)) : e(!1, value);
                      }(function () {
                        var e = h.sortableInfo.index;
                        return Promise.resolve(u({
                          collection: d,
                          index: e,
                          node: h,
                          isKeySorting: v
                        }, t)).then(function () {});
                      }, function (t, n) {
                        if (e._awaitingUpdateBeforeSortStart = !1, t) throw n;
                        return n;
                      });

                      if (n && n.then) return n.then(function () {});
                    }
                  }();

                  return y && y.then ? y.then(r) : r();
                }
              }();

              return Promise.resolve(r && r.then ? r.then(function () {}) : void 0);
            } catch (t) {
              return Promise.reject(t);
            }
          }), l(y(y(e)), "handleSortMove", function (t) {
            var n = e.props.onSortMove;
            "function" == typeof t.preventDefault && t.preventDefault(), e.updateHelperPosition(t), e.animateNodes(), e.autoscroll(), n && n(t);
          }), l(y(y(e)), "handleSortEnd", function (t) {
            var n = e.props,
                r = n.hideSortableGhost,
                o = n.onSortEnd,
                i = e.manager,
                a = i.active.collection,
                s = i.isKeySorting,
                c = e.manager.refs[a];
            e.listenerNode && (s ? (e.listenerNode.removeEventListener("wheel", e.handleKeyEnd, !0), e.listenerNode.removeEventListener("mousedown", e.handleKeyEnd, !0), e.listenerNode.removeEventListener("keydown", e.handleKeyDown)) : (P.move.forEach(function (t) {
              return e.listenerNode.removeEventListener(t, e.handleSortMove);
            }), P.end.forEach(function (t) {
              return e.listenerNode.removeEventListener(t, e.handleSortEnd);
            }))), e.helper.parentNode.removeChild(e.helper), r && e.sortableGhost && M(e.sortableGhost, {
              opacity: "",
              visibility: ""
            });

            for (var u = 0, l = c.length; u < l; u++) {
              var f = c[u],
                  p = f.node;
              f.edgeOffset = null, f.boundingClientRect = null, z(p, null), L(p, null), f.translate = null;
            }

            e.autoScroller.clear(), e.manager.active = null, e.manager.isKeySorting = !1, e.setState({
              sorting: !1,
              sortingIndex: null
            }), "function" == typeof o && o({
              collection: a,
              newIndex: e.newIndex,
              oldIndex: e.index,
              isKeySorting: s
            }, t), e.touched = !1;
          }), l(y(y(e)), "autoscroll", function () {
            var t = e.props.disableAutoscroll,
                n = e.manager.isKeySorting;

            if (!t) {
              if (n) {
                var r = f({}, e.translate),
                    o = 0,
                    i = 0;
                return e.axis.x && (r.x = Math.min(e.maxTranslate.x, Math.max(e.minTranslate.x, e.translate.x)), o = e.translate.x - r.x), e.axis.y && (r.y = Math.min(e.maxTranslate.y, Math.max(e.minTranslate.y, e.translate.y)), i = e.translate.y - r.y), e.translate = r, z(e.helper, e.translate), e.scrollContainer.scrollLeft += o, void (e.scrollContainer.scrollTop += i);
              }

              e.autoScroller.update({
                height: e.height,
                maxTranslate: e.maxTranslate,
                minTranslate: e.minTranslate,
                translate: e.translate,
                width: e.width
              });
            }
          }), l(y(y(e)), "onAutoScroll", function (t) {
            e.translate.x += t.left, e.translate.y += t.top, e.animateNodes();
          }), l(y(y(e)), "handleKeyDown", function (t) {
            var n = t.keyCode,
                r = e.props.shouldCancelStart;
            if ((!e.manager.active || e.manager.isKeySorting) && (e.manager.active || n === U.SPACE && !r(t) && e.isValidSortingTarget(t))) switch (t.stopPropagation(), t.preventDefault(), n) {
              case U.SPACE:
                e.manager.active ? e.keyDrop(t) : e.keyLift(t);
                break;

              case U.DOWN:
              case U.RIGHT:
                e.keyMove(1);
                break;

              case U.UP:
              case U.LEFT:
                e.keyMove(-1);
                break;

              case U.ESC:
                e.newIndex = e.manager.active.index, e.keyDrop(t);
            }
          }), l(y(y(e)), "keyLift", function (t) {
            var n = t.target,
                r = A(n, function (t) {
              return null != t.sortableInfo;
            }),
                o = r.sortableInfo,
                i = o.index,
                a = o.collection;
            e.initialFocusedNode = n, e.manager.isKeySorting = !0, e.manager.active = {
              index: i,
              collection: a
            }, e.handlePress(t);
          }), l(y(y(e)), "keyMove", function (t) {
            var n = e.manager.getOrderedRefs(),
                r = n[n.length - 1].node.sortableInfo.index,
                o = e.newIndex + t,
                i = e.newIndex;

            if (!(o < 0 || o > r)) {
              e.prevIndex = i, e.newIndex = o;

              var a = function (t, e, n) {
                return t < n && t > e ? t - 1 : t > n && t < e ? t + 1 : t;
              }(e.newIndex, e.prevIndex, e.index),
                  s = n.find(function (t) {
                var e = t.node;
                return e.sortableInfo.index === a;
              }),
                  c = s.node,
                  u = e.containerScrollDelta,
                  l = s.boundingClientRect || I(c, u),
                  f = s.translate || {
                x: 0,
                y: 0
              },
                  p = {
                top: l.top + f.y - u.top,
                left: l.left + f.x - u.left
              },
                  h = i < o,
                  d = {
                x: h && e.axis.x ? c.offsetWidth - e.width : 0,
                y: h && e.axis.y ? c.offsetHeight - e.height : 0
              };

              e.handleSortMove({
                pageX: p.left + d.x,
                pageY: p.top + d.y,
                ignoreTransition: 0 === t
              });
            }
          }), l(y(y(e)), "keyDrop", function (t) {
            e.handleSortEnd(t), e.initialFocusedNode && e.initialFocusedNode.focus();
          }), l(y(y(e)), "handleKeyEnd", function (t) {
            e.manager.active && e.keyDrop(t);
          }), l(y(y(e)), "isValidSortingTarget", function (t) {
            var n = e.props.useDragHandle,
                r = t.target,
                o = A(r, function (t) {
              return null != t.sortableInfo;
            });
            return o && o.sortableInfo && !o.sortableInfo.disabled && (n ? G(r) : r.sortableInfo);
          }), function (t) {
            w(!(t.distance && t.pressDelay), "Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.");
          }(t), e.state = {}, e.manager = new x(), e.events = {
            end: e.handleEnd,
            move: e.handleMove,
            start: e.handleStart
          }, e;
        }

        return _(o, n), d(o, [{
          key: "getChildContext",
          value: function value() {
            return {
              manager: this.manager
            };
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            var t = this,
                e = this.props.useWindowAsScrollContainer,
                n = this.getContainer();
            Promise.resolve(n).then(function (n) {
              t.container = n, t.document = t.container.ownerDocument || document;
              var r = t.props.contentWindow || t.document.defaultView || window;
              t.contentWindow = "function" == typeof r ? r() : r, t.scrollContainer = e ? t.document.scrollingElement || t.document.documentElement : H(t.container) || t.container, t.autoScroller = new K(t.scrollContainer, t.onAutoScroll), Object.keys(t.events).forEach(function (e) {
                return P[e].forEach(function (n) {
                  return t.container.addEventListener(n, t.events[e], !1);
                });
              }), t.container.addEventListener("keydown", t.handleKeyDown);
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            var t = this;
            this.helper && this.helper.parentNode && this.helper.parentNode.removeChild(this.helper), this.container && (Object.keys(this.events).forEach(function (e) {
              return P[e].forEach(function (n) {
                return t.container.removeEventListener(n, t.events[e]);
              });
            }), this.container.removeEventListener("keydown", this.handleKeyDown));
          }
        }, {
          key: "updateHelperPosition",
          value: function value(t) {
            var e = this.props,
                n = e.lockAxis,
                r = e.lockOffset,
                o = e.lockToContainerEdges,
                i = e.transitionDuration,
                a = e.keyboardSortingTransitionDuration,
                s = void 0 === a ? i : a,
                c = this.manager.isKeySorting,
                l = t.ignoreTransition,
                f = D(t),
                p = {
              x: f.x - this.initialOffset.x,
              y: f.y - this.initialOffset.y
            };

            if (p.y -= window.pageYOffset - this.initialWindowScroll.top, p.x -= window.pageXOffset - this.initialWindowScroll.left, this.translate = p, o) {
              var h = function (t) {
                var e = t.height,
                    n = t.width,
                    r = t.lockOffset,
                    o = Array.isArray(r) ? r : [r, r];
                w(2 === o.length, "lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given %s", r);
                var i = u(o, 2),
                    a = i[0],
                    s = i[1];
                return [V({
                  height: e,
                  lockOffset: a,
                  width: n
                }), V({
                  height: e,
                  lockOffset: s,
                  width: n
                })];
              }({
                height: this.height,
                lockOffset: r,
                width: this.width
              }),
                  d = u(h, 2),
                  v = d[0],
                  y = d[1],
                  m = {
                x: this.width / 2 - v.x,
                y: this.height / 2 - v.y
              },
                  g = {
                x: this.width / 2 - y.x,
                y: this.height / 2 - y.y
              };

              p.x = R(this.minTranslate.x + m.x, this.maxTranslate.x - g.x, p.x), p.y = R(this.minTranslate.y + m.y, this.maxTranslate.y - g.y, p.y);
            }

            "x" === n ? p.y = 0 : "y" === n && (p.x = 0), c && s && !l && L(this.helper, s), z(this.helper, p);
          }
        }, {
          key: "animateNodes",
          value: function value() {
            var t = this.props,
                e = t.transitionDuration,
                n = t.hideSortableGhost,
                r = t.onSortOver,
                o = this.containerScrollDelta,
                i = this.windowScrollDelta,
                a = this.manager.getOrderedRefs(),
                s = {
              left: this.offsetEdge.left + this.translate.x + o.left,
              top: this.offsetEdge.top + this.translate.y + o.top
            },
                c = this.manager.isKeySorting,
                u = this.newIndex;
            this.newIndex = null;

            for (var l = 0, f = a.length; l < f; l++) {
              var p = a[l].node,
                  h = p.sortableInfo.index,
                  d = p.offsetWidth,
                  v = p.offsetHeight,
                  y = {
                height: this.height > v ? v / 2 : this.height / 2,
                width: this.width > d ? d / 2 : this.width / 2
              },
                  m = c && h > this.index && h <= u,
                  g = c && h < this.index && h >= u,
                  b = {
                x: 0,
                y: 0
              },
                  _ = a[l].edgeOffset;
              _ || (_ = B(p, this.container), a[l].edgeOffset = _, c && (a[l].boundingClientRect = I(p, o)));
              var w = l < a.length - 1 && a[l + 1],
                  x = l > 0 && a[l - 1];
              w && !w.edgeOffset && (w.edgeOffset = B(w.node, this.container), c && (w.boundingClientRect = I(w.node, o))), h !== this.index ? (e && L(p, e), this.axis.x ? this.axis.y ? g || h < this.index && (s.left + i.left - y.width <= _.left && s.top + i.top <= _.top + y.height || s.top + i.top + y.height <= _.top) ? (b.x = this.width + this.marginOffset.x, _.left + b.x > this.containerBoundingRect.width - y.width && w && (b.x = w.edgeOffset.left - _.left, b.y = w.edgeOffset.top - _.top), null === this.newIndex && (this.newIndex = h)) : (m || h > this.index && (s.left + i.left + y.width >= _.left && s.top + i.top + y.height >= _.top || s.top + i.top + y.height >= _.top + v)) && (b.x = -(this.width + this.marginOffset.x), _.left + b.x < this.containerBoundingRect.left + y.width && x && (b.x = x.edgeOffset.left - _.left, b.y = x.edgeOffset.top - _.top), this.newIndex = h) : m || h > this.index && s.left + i.left + y.width >= _.left ? (b.x = -(this.width + this.marginOffset.x), this.newIndex = h) : (g || h < this.index && s.left + i.left <= _.left + y.width) && (b.x = this.width + this.marginOffset.x, null == this.newIndex && (this.newIndex = h)) : this.axis.y && (m || h > this.index && s.top + i.top + y.height >= _.top ? (b.y = -(this.height + this.marginOffset.y), this.newIndex = h) : (g || h < this.index && s.top + i.top <= _.top + y.height) && (b.y = this.height + this.marginOffset.y, null == this.newIndex && (this.newIndex = h))), z(p, b), a[l].translate = b) : n && (this.sortableGhost = p, M(p, {
                opacity: 0,
                visibility: "hidden"
              }));
            }

            null == this.newIndex && (this.newIndex = this.index), c && (this.newIndex = u);
            var O = c ? this.prevIndex : u;
            r && this.newIndex !== O && r({
              collection: this.manager.active.collection,
              index: this.index,
              newIndex: this.newIndex,
              oldIndex: O,
              isKeySorting: c
            });
          }
        }, {
          key: "getWrappedInstance",
          value: function value() {
            return w(s.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call"), this.refs.wrappedInstance;
          }
        }, {
          key: "getContainer",
          value: function value() {
            var t = this.props.getContainer;
            return "function" != typeof t ? r.findDOMNode(this) : t(s.withRef ? this.getWrappedInstance() : void 0);
          }
        }, {
          key: "render",
          value: function value() {
            var n = s.withRef ? "wrappedInstance" : null;
            return e.createElement(t, i({
              ref: n
            }, T(this.props, $)));
          }
        }, {
          key: "helperContainer",
          get: function get() {
            var t = this.props.helperContainer;
            return "function" == typeof t ? t() : this.props.helperContainer || this.document.body;
          }
        }, {
          key: "containerScrollDelta",
          get: function get() {
            var t = this.props.useWindowAsScrollContainer;
            return t ? {
              left: 0,
              top: 0
            } : {
              left: this.scrollContainer.scrollLeft - this.initialScroll.left,
              top: this.scrollContainer.scrollTop - this.initialScroll.top
            };
          }
        }, {
          key: "windowScrollDelta",
          get: function get() {
            return {
              left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
              top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
            };
          }
        }]), o;
      }(e.Component), l(o, "displayName", F("sortableList", t)), l(o, "defaultProps", Y), l(o, "propTypes", Z), l(o, "childContextTypes", {
        manager: n.object.isRequired
      }), a;
    }

    var Q = {
      index: n.number.isRequired,
      collection: n.oneOfType([n.number, n.string]),
      disabled: n.bool
    },
        J = Object.keys(Q);

    function tt(t) {
      var o,
          a,
          s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        withRef: !1
      };
      return a = o = function (n) {
        function o() {
          return p(this, o), m(this, g(o).apply(this, arguments));
        }

        return _(o, n), d(o, [{
          key: "componentDidMount",
          value: function value() {
            this.register();
          }
        }, {
          key: "componentDidUpdate",
          value: function value(t) {
            this.node && (t.index !== this.props.index && (this.node.sortableInfo.index = this.props.index), t.disabled !== this.props.disabled && (this.node.sortableInfo.disabled = this.props.disabled)), t.collection !== this.props.collection && (this.unregister(t.collection), this.register());
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.unregister();
          }
        }, {
          key: "register",
          value: function value() {
            var t = this.props,
                e = t.collection,
                n = t.disabled,
                o = t.index,
                i = r.findDOMNode(this);
            i.sortableInfo = {
              collection: e,
              disabled: n,
              index: o,
              manager: this.context.manager
            }, this.node = i, this.ref = {
              node: i
            }, this.context.manager.add(e, this.ref);
          }
        }, {
          key: "unregister",
          value: function value() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.collection;
            this.context.manager.remove(t, this.ref);
          }
        }, {
          key: "getWrappedInstance",
          value: function value() {
            return w(s.withRef, "To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call"), this.refs.wrappedInstance;
          }
        }, {
          key: "render",
          value: function value() {
            var n = s.withRef ? "wrappedInstance" : null;
            return e.createElement(t, i({
              ref: n
            }, T(this.props, J)));
          }
        }]), o;
      }(e.Component), l(o, "displayName", F("sortableElement", t)), l(o, "contextTypes", {
        manager: n.object.isRequired
      }), l(o, "propTypes", Q), l(o, "defaultProps", {
        collection: 0
      }), a;
    }

    t.SortableContainer = X, t.sortableContainer = X, t.SortableElement = tt, t.sortableElement = tt, t.SortableHandle = q, t.sortableHandle = q, t.arrayMove = function (t, e, n) {
      return (t = t.slice()).splice(n < 0 ? t.length + n : n, 0, t.splice(e, 1)[0]), t;
    }, Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }(e, n(0), n(1), n(8));
}, function (t, e, n) {
  (function (e) {
    var n = "object" == _typeof(e) && e && e.Object === Object && e;
    t.exports = n;
  }).call(this, n(71));
}, function (t, e, n) {
  var r = n(48),
      o = n(50),
      i = "[object AsyncFunction]",
      a = "[object Function]",
      s = "[object GeneratorFunction]",
      c = "[object Proxy]";

  t.exports = function (t) {
    if (!o(t)) return !1;
    var e = r(t);
    return e == a || e == s || e == i || e == c;
  };
}, function (t, e) {
  t.exports = require("moment");
}, function (t, e, n) {
  var r = n(219),
      o = n(52),
      i = Object.prototype,
      a = i.hasOwnProperty,
      s = i.propertyIsEnumerable,
      c = r(function () {
    return arguments;
  }()) ? r : function (t) {
    return o(t) && a.call(t, "callee") && !s.call(t, "callee");
  };
  t.exports = c;
}, function (t, e, n) {
  var r = n(49)(n(36), "Map");
  t.exports = r;
}, function (t, e, n) {
  var r = n(25),
      o = n(16),
      i = n(33);

  t.exports = function (t, e) {
    var n = (o.Object || {})[t] || Object[t],
        a = {};
    a[t] = e(n), r(r.S + r.F * i(function () {
      n(1);
    }), "Object", a);
  };
}, function (t, e, n) {
  var r = n(206);

  t.exports = function (t) {
    var e = r(t),
        n = e % 1;
    return e == e ? n ? e - n : e : 0;
  };
}, function (t, e) {
  t.exports = function (t, e, n, r) {
    var o = n ? n.call(r, t, e) : void 0;
    if (void 0 !== o) return !!o;
    if (t === e) return !0;
    if ("object" != _typeof(t) || !t || "object" != _typeof(e) || !e) return !1;
    var i = Object.keys(t),
        a = Object.keys(e);
    if (i.length !== a.length) return !1;

    for (var s = Object.prototype.hasOwnProperty.bind(e), c = 0; c < i.length; c++) {
      var u = i[c];
      if (!s(u)) return !1;
      var l = t[u],
          f = e[u];
      if (!1 === (o = n ? n.call(r, l, f, u) : void 0) || void 0 === o && l !== f) return !1;
    }

    return !0;
  };
}, function (t, e, n) {
  var r = n(205),
      o = n(176);

  t.exports = function (t, e, n, i) {
    var a = null == t ? 0 : t.length;
    return a ? (n && "number" != typeof n && o(t, e, n) && (n = 0, i = a), r(t, e, n, i)) : [];
  };
}, function (t, e, n) {
  var r = n(235),
      o = n(242),
      i = n(244),
      a = n(245),
      s = n(246);

  function c(t) {
    var e = -1,
        n = null == t ? 0 : t.length;

    for (this.clear(); ++e < n;) {
      var r = t[e];
      this.set(r[0], r[1]);
    }
  }

  c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = i, c.prototype.has = a, c.prototype.set = s, t.exports = c;
}, function (t, e, n) {
  (function (t) {
    var r = n(36),
        o = n(265),
        i = "object" == _typeof(e) && e && !e.nodeType && e,
        a = i && "object" == _typeof(t) && t && !t.nodeType && t,
        s = a && a.exports === i ? r.Buffer : void 0,
        c = (s ? s.isBuffer : void 0) || o;
    t.exports = c;
  }).call(this, n(180)(t));
}, function (t, e, n) {
  var r = n(266),
      o = n(183),
      i = n(267),
      a = i && i.isTypedArray,
      s = a ? o(a) : r;
  t.exports = s;
}, function (t, e, n) {
  t.exports = {
    "c-icon": "vizzuality__c-icon",
    "-tiny": "vizzuality__-tiny",
    "-smaller": "vizzuality__-smaller",
    "-small": "vizzuality__-small",
    "-medium": "vizzuality__-medium",
    "-big": "vizzuality__-big",
    "-huge": "vizzuality__-huge",
    "-star": "vizzuality__-star"
  };
},, function (t, e, n) {
  "use strict";

  e.__esModule = !0;
  var r = h(n(3)),
      o = h(n(17)),
      i = h(n(5)),
      a = h(n(4)),
      s = h(n(6)),
      c = n(0),
      u = h(c),
      l = h(n(151)),
      f = h(n(73)),
      p = n(167);

  function h(t) {
    return t && t.__esModule ? t : {
      "default": t
    };
  }

  var d = function (t) {
    function e() {
      var n, r, o;
      (0, i["default"])(this, e);

      for (var s = arguments.length, c = Array(s), l = 0; l < s; l++) {
        c[l] = arguments[l];
      }

      return n = r = (0, a["default"])(this, t.call.apply(t, [this].concat(c))), r.getPopupElement = function () {
        var t = r.props,
            e = t.arrowContent,
            n = t.overlay,
            o = t.prefixCls,
            i = t.id;
        return [u["default"].createElement("div", {
          className: o + "-arrow",
          key: "arrow"
        }, e), u["default"].createElement("div", {
          className: o + "-inner",
          key: "content",
          id: i
        }, "function" == typeof n ? n() : n)];
      }, r.saveTrigger = function (t) {
        r.trigger = t;
      }, o = n, (0, a["default"])(r, o);
    }

    return (0, s["default"])(e, t), e.prototype.getPopupDomNode = function () {
      return this.trigger.getPopupDomNode();
    }, e.prototype.render = function () {
      var t = this.props,
          e = t.overlayClassName,
          n = t.trigger,
          i = t.mouseEnterDelay,
          a = t.mouseLeaveDelay,
          s = t.overlayStyle,
          c = t.prefixCls,
          l = t.children,
          h = t.onVisibleChange,
          d = t.afterVisibleChange,
          v = t.transitionName,
          y = t.animation,
          m = t.placement,
          g = t.align,
          b = t.destroyTooltipOnHide,
          _ = t.defaultVisible,
          w = t.getTooltipContainer,
          x = (0, o["default"])(t, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer"]),
          O = (0, r["default"])({}, x);
      return "visible" in this.props && (O.popupVisible = this.props.visible), u["default"].createElement(f["default"], (0, r["default"])({
        popupClassName: e,
        ref: this.saveTrigger,
        prefixCls: c,
        popup: this.getPopupElement,
        action: n,
        builtinPlacements: p.placements,
        popupPlacement: m,
        popupAlign: g,
        getPopupContainer: w,
        onPopupVisibleChange: h,
        afterPopupVisibleChange: d,
        popupTransitionName: v,
        popupAnimation: y,
        defaultPopupVisible: _,
        destroyPopupOnHide: b,
        mouseLeaveDelay: a,
        popupStyle: s,
        mouseEnterDelay: i
      }, O), l);
    }, e;
  }(c.Component);

  d.propTypes = {
    trigger: l["default"].any,
    children: l["default"].any,
    defaultVisible: l["default"].bool,
    visible: l["default"].bool,
    placement: l["default"].string,
    transitionName: l["default"].oneOfType([l["default"].string, l["default"].object]),
    animation: l["default"].any,
    onVisibleChange: l["default"].func,
    afterVisibleChange: l["default"].func,
    overlay: l["default"].oneOfType([l["default"].node, l["default"].func]).isRequired,
    overlayStyle: l["default"].object,
    overlayClassName: l["default"].string,
    prefixCls: l["default"].string,
    mouseEnterDelay: l["default"].number,
    mouseLeaveDelay: l["default"].number,
    getTooltipContainer: l["default"].func,
    destroyTooltipOnHide: l["default"].bool,
    align: l["default"].object,
    arrowContent: l["default"].any,
    id: l["default"].string
  }, d.defaultProps = {
    prefixCls: "rc-tooltip",
    mouseEnterDelay: 0,
    destroyTooltipOnHide: !1,
    mouseLeaveDelay: .1,
    align: {},
    placement: "right",
    trigger: ["hover"],
    arrowContent: null
  }, e["default"] = d, t.exports = e["default"];
}, function (t, e, n) {
  t.exports = {
    "default": n(118),
    __esModule: !0
  };
}, function (t, e, n) {
  n(119), t.exports = n(16).Object.assign;
}, function (t, e, n) {
  var r = n(25);
  r(r.S + r.F, "Object", {
    assign: n(121)
  });
}, function (t, e) {
  t.exports = function (t) {
    if ("function" != typeof t) throw TypeError(t + " is not a function!");
    return t;
  };
}, function (t, e, n) {
  "use strict";

  var r = n(44),
      o = n(59),
      i = n(46),
      a = n(47),
      s = n(81),
      c = Object.assign;
  t.exports = !c || n(33)(function () {
    var t = {},
        e = {},
        n = Symbol(),
        r = "abcdefghijklmnopqrst";
    return t[n] = 7, r.split("").forEach(function (t) {
      e[t] = t;
    }), 7 != c({}, t)[n] || Object.keys(c({}, e)).join("") != r;
  }) ? function (t, e) {
    for (var n = a(t), c = arguments.length, u = 1, l = o.f, f = i.f; c > u;) {
      for (var p, h = s(arguments[u++]), d = l ? r(h).concat(l(h)) : r(h), v = d.length, y = 0; v > y;) {
        f.call(h, p = d[y++]) && (n[p] = h[p]);
      }
    }

    return n;
  } : c;
}, function (t, e, n) {
  var r = n(28),
      o = n(97),
      i = n(123);

  t.exports = function (t) {
    return function (e, n, a) {
      var s,
          c = r(e),
          u = o(c.length),
          l = i(a, u);

      if (t && n != n) {
        for (; u > l;) {
          if ((s = c[l++]) != s) return !0;
        }
      } else for (; u > l; l++) {
        if ((t || l in c) && c[l] === n) return t || l || 0;
      }

      return !t && -1;
    };
  };
}, function (t, e, n) {
  var r = n(55),
      o = Math.max,
      i = Math.min;

  t.exports = function (t, e) {
    return (t = r(t)) < 0 ? o(t + e, 0) : i(t, e);
  };
}, function (t, e, n) {
  t.exports = {
    "default": n(125),
    __esModule: !0
  };
}, function (t, e, n) {
  n(98), n(130), t.exports = n(63).f("iterator");
}, function (t, e, n) {
  var r = n(55),
      o = n(54);

  t.exports = function (t) {
    return function (e, n) {
      var i,
          a,
          s = String(o(e)),
          c = r(n),
          u = s.length;
      return c < 0 || c >= u ? t ? "" : void 0 : (i = s.charCodeAt(c)) < 55296 || i > 56319 || c + 1 === u || (a = s.charCodeAt(c + 1)) < 56320 || a > 57343 ? t ? s.charAt(c) : i : t ? s.slice(c, c + 2) : a - 56320 + (i - 55296 << 10) + 65536;
    };
  };
}, function (t, e, n) {
  "use strict";

  var r = n(61),
      o = n(38),
      i = n(62),
      a = {};
  n(29)(a, n(19)("iterator"), function () {
    return this;
  }), t.exports = function (t, e, n) {
    t.prototype = r(a, {
      next: o(1, n)
    }), i(t, e + " Iterator");
  };
}, function (t, e, n) {
  var r = n(23),
      o = n(32),
      i = n(44);
  t.exports = n(26) ? Object.defineProperties : function (t, e) {
    o(t);

    for (var n, a = i(e), s = a.length, c = 0; s > c;) {
      r.f(t, n = a[c++], e[n]);
    }

    return t;
  };
}, function (t, e, n) {
  var r = n(22).document;
  t.exports = r && r.documentElement;
}, function (t, e, n) {
  n(131);

  for (var r = n(22), o = n(29), i = n(40), a = n(19)("toStringTag"), s = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), c = 0; c < s.length; c++) {
    var u = s[c],
        l = r[u],
        f = l && l.prototype;
    f && !f[a] && o(f, a, u), i[u] = i.Array;
  }
}, function (t, e, n) {
  "use strict";

  var r = n(132),
      o = n(133),
      i = n(40),
      a = n(28);
  t.exports = n(82)(Array, "Array", function (t, e) {
    this._t = a(t), this._i = 0, this._k = e;
  }, function () {
    var t = this._t,
        e = this._k,
        n = this._i++;
    return !t || n >= t.length ? (this._t = void 0, o(1)) : o(0, "keys" == e ? n : "values" == e ? t[n] : [n, t[n]]);
  }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries");
}, function (t, e) {
  t.exports = function () {};
}, function (t, e) {
  t.exports = function (t, e) {
    return {
      value: e,
      done: !!t
    };
  };
}, function (t, e, n) {
  t.exports = {
    "default": n(135),
    __esModule: !0
  };
}, function (t, e, n) {
  n(136), n(141), n(142), n(143), t.exports = n(16).Symbol;
}, function (t, e, n) {
  "use strict";

  var r = n(22),
      o = n(27),
      i = n(26),
      a = n(25),
      s = n(83),
      c = n(137).KEY,
      u = n(33),
      l = n(57),
      f = n(62),
      p = n(45),
      h = n(19),
      d = n(63),
      v = n(64),
      y = n(138),
      m = n(139),
      g = n(32),
      b = n(30),
      _ = n(28),
      w = n(53),
      x = n(38),
      O = n(61),
      E = n(140),
      C = n(70),
      j = n(23),
      S = n(44),
      T = C.f,
      P = j.f,
      k = E.f,
      _M = r.Symbol,
      z = r.JSON,
      L = z && z.stringify,
      A = h("_hidden"),
      R = h("toPrimitive"),
      N = {}.propertyIsEnumerable,
      F = l("symbol-registry"),
      I = l("symbols"),
      D = l("op-symbols"),
      B = Object.prototype,
      V = "function" == typeof _M,
      H = r.QObject,
      U = !H || !H.prototype || !H.prototype.findChild,
      W = i && u(function () {
    return 7 != O(P({}, "a", {
      get: function get() {
        return P(this, "a", {
          value: 7
        }).a;
      }
    })).a;
  }) ? function (t, e, n) {
    var r = T(B, e);
    r && delete B[e], P(t, e, n), r && t !== B && P(B, e, r);
  } : P,
      q = function q(t) {
    var e = I[t] = O(_M.prototype);
    return e._k = t, e;
  },
      G = V && "symbol" == _typeof(_M.iterator) ? function (t) {
    return "symbol" == _typeof(t);
  } : function (t) {
    return t instanceof _M;
  },
      K = function K(t, e, n) {
    return t === B && K(D, e, n), g(t), e = w(e, !0), g(n), o(I, e) ? (n.enumerable ? (o(t, A) && t[A][e] && (t[A][e] = !1), n = O(n, {
      enumerable: x(0, !1)
    })) : (o(t, A) || P(t, A, x(1, {})), t[A][e] = !0), W(t, e, n)) : P(t, e, n);
  },
      Z = function Z(t, e) {
    g(t);

    for (var n, r = y(e = _(e)), o = 0, i = r.length; i > o;) {
      K(t, n = r[o++], e[n]);
    }

    return t;
  },
      Y = function Y(t) {
    var e = N.call(this, t = w(t, !0));
    return !(this === B && o(I, t) && !o(D, t)) && (!(e || !o(this, t) || !o(I, t) || o(this, A) && this[A][t]) || e);
  },
      $ = function $(t, e) {
    if (t = _(t), e = w(e, !0), t !== B || !o(I, e) || o(D, e)) {
      var n = T(t, e);
      return !n || !o(I, e) || o(t, A) && t[A][e] || (n.enumerable = !0), n;
    }
  },
      X = function X(t) {
    for (var e, n = k(_(t)), r = [], i = 0; n.length > i;) {
      o(I, e = n[i++]) || e == A || e == c || r.push(e);
    }

    return r;
  },
      Q = function Q(t) {
    for (var e, n = t === B, r = k(n ? D : _(t)), i = [], a = 0; r.length > a;) {
      !o(I, e = r[a++]) || n && !o(B, e) || i.push(I[e]);
    }

    return i;
  };

  V || (s((_M = function M() {
    if (this instanceof _M) throw TypeError("Symbol is not a constructor!");

    var t = p(arguments.length > 0 ? arguments[0] : void 0),
        e = function e(n) {
      this === B && e.call(D, n), o(this, A) && o(this[A], t) && (this[A][t] = !1), W(this, t, x(1, n));
    };

    return i && U && W(B, t, {
      configurable: !0,
      set: e
    }), q(t);
  }).prototype, "toString", function () {
    return this._k;
  }), C.f = $, j.f = K, n(84).f = E.f = X, n(46).f = Y, n(59).f = Q, i && !n(60) && s(B, "propertyIsEnumerable", Y, !0), d.f = function (t) {
    return q(h(t));
  }), a(a.G + a.W + a.F * !V, {
    Symbol: _M
  });

  for (var J = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), tt = 0; J.length > tt;) {
    h(J[tt++]);
  }

  for (var et = S(h.store), nt = 0; et.length > nt;) {
    v(et[nt++]);
  }

  a(a.S + a.F * !V, "Symbol", {
    "for": function _for(t) {
      return o(F, t += "") ? F[t] : F[t] = _M(t);
    },
    keyFor: function keyFor(t) {
      if (!G(t)) throw TypeError(t + " is not a symbol!");

      for (var e in F) {
        if (F[e] === t) return e;
      }
    },
    useSetter: function useSetter() {
      U = !0;
    },
    useSimple: function useSimple() {
      U = !1;
    }
  }), a(a.S + a.F * !V, "Object", {
    create: function create(t, e) {
      return void 0 === e ? O(t) : Z(O(t), e);
    },
    defineProperty: K,
    defineProperties: Z,
    getOwnPropertyDescriptor: $,
    getOwnPropertyNames: X,
    getOwnPropertySymbols: Q
  }), z && a(a.S + a.F * (!V || u(function () {
    var t = _M();

    return "[null]" != L([t]) || "{}" != L({
      a: t
    }) || "{}" != L(Object(t));
  })), "JSON", {
    stringify: function stringify(t) {
      for (var e, n, r = [t], o = 1; arguments.length > o;) {
        r.push(arguments[o++]);
      }

      if (n = e = r[1], (b(e) || void 0 !== t) && !G(t)) return m(e) || (e = function e(t, _e5) {
        if ("function" == typeof n && (_e5 = n.call(this, t, _e5)), !G(_e5)) return _e5;
      }), r[1] = e, L.apply(z, r);
    }
  }), _M.prototype[R] || n(29)(_M.prototype, R, _M.prototype.valueOf), f(_M, "Symbol"), f(Math, "Math", !0), f(r.JSON, "JSON", !0);
}, function (t, e, n) {
  var r = n(45)("meta"),
      o = n(30),
      i = n(27),
      a = n(23).f,
      s = 0,
      c = Object.isExtensible || function () {
    return !0;
  },
      u = !n(33)(function () {
    return c(Object.preventExtensions({}));
  }),
      l = function l(t) {
    a(t, r, {
      value: {
        i: "O" + ++s,
        w: {}
      }
    });
  },
      f = t.exports = {
    KEY: r,
    NEED: !1,
    fastKey: function fastKey(t, e) {
      if (!o(t)) return "symbol" == _typeof(t) ? t : ("string" == typeof t ? "S" : "P") + t;

      if (!i(t, r)) {
        if (!c(t)) return "F";
        if (!e) return "E";
        l(t);
      }

      return t[r].i;
    },
    getWeak: function getWeak(t, e) {
      if (!i(t, r)) {
        if (!c(t)) return !0;
        if (!e) return !1;
        l(t);
      }

      return t[r].w;
    },
    onFreeze: function onFreeze(t) {
      return u && f.NEED && c(t) && !i(t, r) && l(t), t;
    }
  };
}, function (t, e, n) {
  var r = n(44),
      o = n(59),
      i = n(46);

  t.exports = function (t) {
    var e = r(t),
        n = o.f;
    if (n) for (var a, s = n(t), c = i.f, u = 0; s.length > u;) {
      c.call(t, a = s[u++]) && e.push(a);
    }
    return e;
  };
}, function (t, e, n) {
  var r = n(69);

  t.exports = Array.isArray || function (t) {
    return "Array" == r(t);
  };
}, function (t, e, n) {
  var r = n(28),
      o = n(84).f,
      i = {}.toString,
      a = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

  t.exports.f = function (t) {
    return a && "[object Window]" == i.call(t) ? function (t) {
      try {
        return o(t);
      } catch (t) {
        return a.slice();
      }
    }(t) : o(r(t));
  };
}, function (t, e) {}, function (t, e, n) {
  n(64)("asyncIterator");
}, function (t, e, n) {
  n(64)("observable");
}, function (t, e, n) {
  t.exports = {
    "default": n(145),
    __esModule: !0
  };
}, function (t, e, n) {
  n(146), t.exports = n(16).Object.setPrototypeOf;
}, function (t, e, n) {
  var r = n(25);
  r(r.S, "Object", {
    setPrototypeOf: n(147).set
  });
}, function (t, e, n) {
  var r = n(30),
      o = n(32),
      i = function i(t, e) {
    if (o(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
  };

  t.exports = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, r) {
      try {
        (r = n(68)(Function.call, n(70).f(Object.prototype, "__proto__").set, 2))(t, []), e = !(t instanceof Array);
      } catch (t) {
        e = !0;
      }

      return function (t, n) {
        return i(t, n), e ? t.__proto__ = n : r(t, n), t;
      };
    }({}, !1) : void 0),
    check: i
  };
}, function (t, e, n) {
  t.exports = {
    "default": n(149),
    __esModule: !0
  };
}, function (t, e, n) {
  n(150);
  var r = n(16).Object;

  t.exports = function (t, e) {
    return r.create(t, e);
  };
}, function (t, e, n) {
  var r = n(25);
  r(r.S, "Object", {
    create: n(61)
  });
}, function (t, e, n) {
  t.exports = n(152)();
}, function (t, e, n) {
  "use strict";

  var r = n(34),
      o = n(35),
      i = n(153);

  t.exports = function () {
    function t(t, e, n, r, a, s) {
      s !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var n = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e
    };
    return n.checkPropTypes = r, n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, n) {
  "use strict";

  var r = n(34),
      o = n(35),
      i = n(155);

  t.exports = function () {
    function t(t, e, n, r, a, s) {
      s !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var n = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e
    };
    return n.checkPropTypes = r, n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = i(n(157)),
      o = i(n(158));

  function i(t) {
    return t && t.__esModule ? t : {
      "default": t
    };
  }

  var a = !0,
      s = !1,
      c = ["altKey", "bubbles", "cancelable", "ctrlKey", "currentTarget", "eventPhase", "metaKey", "shiftKey", "target", "timeStamp", "view", "type"];

  function u(t) {
    return null === t || void 0 === t;
  }

  var l = [{
    reg: /^key/,
    props: ["char", "charCode", "key", "keyCode", "which"],
    fix: function fix(t, e) {
      u(t.which) && (t.which = u(e.charCode) ? e.keyCode : e.charCode), void 0 === t.metaKey && (t.metaKey = t.ctrlKey);
    }
  }, {
    reg: /^touch/,
    props: ["touches", "changedTouches", "targetTouches"]
  }, {
    reg: /^hashchange$/,
    props: ["newURL", "oldURL"]
  }, {
    reg: /^gesturechange$/i,
    props: ["rotation", "scale"]
  }, {
    reg: /^(mousewheel|DOMMouseScroll)$/,
    props: [],
    fix: function fix(t, e) {
      var n = void 0,
          r = void 0,
          o = void 0,
          i = e.wheelDelta,
          a = e.axis,
          s = e.wheelDeltaY,
          c = e.wheelDeltaX,
          u = e.detail;
      i && (o = i / 120), u && (o = 0 - (u % 3 == 0 ? u / 3 : u)), void 0 !== a && (a === t.HORIZONTAL_AXIS ? (r = 0, n = 0 - o) : a === t.VERTICAL_AXIS && (n = 0, r = o)), void 0 !== s && (r = s / 120), void 0 !== c && (n = -1 * c / 120), n || r || (r = o), void 0 !== n && (t.deltaX = n), void 0 !== r && (t.deltaY = r), void 0 !== o && (t.delta = o);
    }
  }, {
    reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
    props: ["buttons", "clientX", "clientY", "button", "offsetX", "relatedTarget", "which", "fromElement", "toElement", "offsetY", "pageX", "pageY", "screenX", "screenY"],
    fix: function fix(t, e) {
      var n = void 0,
          r = void 0,
          o = void 0,
          i = t.target,
          a = e.button;
      return i && u(t.pageX) && !u(e.clientX) && (r = (n = i.ownerDocument || document).documentElement, o = n.body, t.pageX = e.clientX + (r && r.scrollLeft || o && o.scrollLeft || 0) - (r && r.clientLeft || o && o.clientLeft || 0), t.pageY = e.clientY + (r && r.scrollTop || o && o.scrollTop || 0) - (r && r.clientTop || o && o.clientTop || 0)), t.which || void 0 === a || (t.which = 1 & a ? 1 : 2 & a ? 3 : 4 & a ? 2 : 0), !t.relatedTarget && t.fromElement && (t.relatedTarget = t.fromElement === i ? t.toElement : t.fromElement), t;
    }
  }];

  function f() {
    return a;
  }

  function p() {
    return s;
  }

  function h(t) {
    var e = t.type,
        n = "function" == typeof t.stopPropagation || "boolean" == typeof t.cancelBubble;
    r["default"].call(this), this.nativeEvent = t;
    var o = p;
    "defaultPrevented" in t ? o = t.defaultPrevented ? f : p : "getPreventDefault" in t ? o = t.getPreventDefault() ? f : p : "returnValue" in t && (o = t.returnValue === s ? f : p), this.isDefaultPrevented = o;
    var i = [],
        a = void 0,
        u = void 0,
        h = c.concat();

    for (l.forEach(function (t) {
      e.match(t.reg) && (h = h.concat(t.props), t.fix && i.push(t.fix));
    }), a = h.length; a;) {
      this[u = h[--a]] = t[u];
    }

    for (!this.target && n && (this.target = t.srcElement || document), this.target && 3 === this.target.nodeType && (this.target = this.target.parentNode), a = i.length; a;) {
      (0, i[--a])(this, t);
    }

    this.timeStamp = t.timeStamp || Date.now();
  }

  var d = r["default"].prototype;
  (0, o["default"])(h.prototype, d, {
    constructor: h,
    preventDefault: function preventDefault() {
      var t = this.nativeEvent;
      t.preventDefault ? t.preventDefault() : t.returnValue = s, d.preventDefault.call(this);
    },
    stopPropagation: function stopPropagation() {
      var t = this.nativeEvent;
      t.stopPropagation ? t.stopPropagation() : t.cancelBubble = a, d.stopPropagation.call(this);
    }
  }), e["default"] = h, t.exports = e["default"];
}, function (t, e, n) {
  "use strict";

  function r() {
    return !1;
  }

  function o() {
    return !0;
  }

  function i() {
    this.timeStamp = Date.now(), this.target = void 0, this.currentTarget = void 0;
  }

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), i.prototype = {
    isEventObject: 1,
    constructor: i,
    isDefaultPrevented: r,
    isPropagationStopped: r,
    isImmediatePropagationStopped: r,
    preventDefault: function preventDefault() {
      this.isDefaultPrevented = o;
    },
    stopPropagation: function stopPropagation() {
      this.isPropagationStopped = o;
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      this.isImmediatePropagationStopped = o, this.stopPropagation();
    },
    halt: function halt(t) {
      t ? this.stopImmediatePropagation() : this.stopPropagation(), this.preventDefault();
    }
  }, e["default"] = i, t.exports = e["default"];
}, function (t, e, n) {
  "use strict";

  var r = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      i = Object.prototype.propertyIsEnumerable;
  t.exports = function () {
    try {
      if (!Object.assign) return !1;
      var t = new String("abc");
      if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

      for (var e = {}, n = 0; n < 10; n++) {
        e["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
        return e[t];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (t) {
        r[t] = t;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (t) {
      return !1;
    }
  }() ? Object.assign : function (t, e) {
    for (var n, a, s = function (t) {
      if (null === t || void 0 === t) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(t);
    }(t), c = 1; c < arguments.length; c++) {
      for (var u in n = Object(arguments[c])) {
        o.call(n, u) && (s[u] = n[u]);
      }

      if (r) {
        a = r(n);

        for (var l = 0; l < a.length; l++) {
          i.call(n, a[l]) && (s[a[l]] = n[a[l]]);
        }
      }
    }

    return s;
  };
}, function (t, e, n) {
  "use strict";

  var r = n(34),
      o = n(35),
      i = n(160);

  t.exports = function () {
    function t(t, e, n, r, a, s) {
      s !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var n = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e
    };
    return n.checkPropTypes = r, n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, n) {
  n(162);
  var r = n(16).Object;

  t.exports = function (t, e, n) {
    return r.defineProperty(t, e, n);
  };
}, function (t, e, n) {
  var r = n(25);
  r(r.S + r.F * !n(26), "Object", {
    defineProperty: n(23).f
  });
}, function (t, e, n) {
  "use strict";

  var r = n(34),
      o = n(35),
      i = n(164);

  t.exports = function () {
    function t(t, e, n, r, a, s) {
      s !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var n = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e
    };
    return n.checkPropTypes = r, n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, n) {
  "use strict";

  var r = n(34),
      o = n(35),
      i = n(166);

  t.exports = function () {
    function t(t, e, n, r, a, s) {
      s !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var n = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e
    };
    return n.checkPropTypes = r, n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, n) {
  "use strict";

  e.__esModule = !0;
  var r = {
    adjustX: 1,
    adjustY: 1
  },
      o = [0, 0],
      i = e.placements = {
    left: {
      points: ["cr", "cl"],
      overflow: r,
      offset: [-4, 0],
      targetOffset: o
    },
    right: {
      points: ["cl", "cr"],
      overflow: r,
      offset: [4, 0],
      targetOffset: o
    },
    top: {
      points: ["bc", "tc"],
      overflow: r,
      offset: [0, -4],
      targetOffset: o
    },
    bottom: {
      points: ["tc", "bc"],
      overflow: r,
      offset: [0, 4],
      targetOffset: o
    },
    topLeft: {
      points: ["bl", "tl"],
      overflow: r,
      offset: [0, -4],
      targetOffset: o
    },
    leftTop: {
      points: ["tr", "tl"],
      overflow: r,
      offset: [-4, 0],
      targetOffset: o
    },
    topRight: {
      points: ["br", "tr"],
      overflow: r,
      offset: [0, -4],
      targetOffset: o
    },
    rightTop: {
      points: ["tl", "tr"],
      overflow: r,
      offset: [4, 0],
      targetOffset: o
    },
    bottomRight: {
      points: ["tr", "br"],
      overflow: r,
      offset: [0, 4],
      targetOffset: o
    },
    rightBottom: {
      points: ["bl", "br"],
      overflow: r,
      offset: [4, 0],
      targetOffset: o
    },
    bottomLeft: {
      points: ["tl", "bl"],
      overflow: r,
      offset: [0, 4],
      targetOffset: o
    },
    leftBottom: {
      points: ["br", "bl"],
      overflow: r,
      offset: [-4, 0],
      targetOffset: o
    }
  };
  e["default"] = i;
}, function (t, e, n) {
  t.exports = {
    rcToolTipZoomIn: "vizzuality__rcToolTipZoomIn",
    rcToolTipZoomOut: "vizzuality__rcToolTipZoomOut"
  };
},, function (t, e, n) {
  var r = n(51),
      o = Object.prototype,
      i = o.hasOwnProperty,
      a = o.toString,
      s = r ? r.toStringTag : void 0;

  t.exports = function (t) {
    var e = i.call(t, s),
        n = t[s];

    try {
      t[s] = void 0;
      var r = !0;
    } catch (t) {}

    var o = a.call(t);
    return r && (e ? t[s] = n : delete t[s]), o;
  };
}, function (t, e) {
  var n = Object.prototype.toString;

  t.exports = function (t) {
    return n.call(t);
  };
}, function (t, e, n) {
  var r = n(247),
      o = n(52);

  t.exports = function t(e, n, i, a, s) {
    return e === n || (null == e || null == n || !o(e) && !o(n) ? e != e && n != n : r(e, n, i, a, t, s));
  };
}, function (t, e, n) {
  var r = n(263),
      o = n(184),
      i = n(72);

  t.exports = function (t) {
    return i(t) ? r(t) : o(t);
  };
}, function (t, e, n) {
  var r = n(76),
      o = 1 / 0;

  t.exports = function (t) {
    if ("string" == typeof t || r(t)) return t;
    var e = t + "";
    return "0" == e && 1 / t == -o ? "-0" : e;
  };
}, function (t, e) {
  t.exports = function (t) {
    return t;
  };
}, function (t, e, n) {
  var r = n(89),
      o = n(72),
      i = n(100),
      a = n(50);

  t.exports = function (t, e, n) {
    if (!a(n)) return !1;

    var s = _typeof(e);

    return !!("number" == s ? o(n) && i(e, n.length) : "string" == s && e in n) && r(n[e], t);
  };
}, function (t, e, n) {
  "use strict";

  n.r(e), n.d(e, "Spinner", function () {
    return m;
  });

  var r = n(14),
      o = n.n(r),
      i = n(0),
      a = n.n(i),
      s = n(1),
      c = n.n(s),
      u = n(11),
      l = n.n(u),
      f = (n(279), Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }),
      p = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }(),
      h = {
    "./styles.scss": {
      "c-spinner": "vizzuality__c-spinner",
      rotate: "vizzuality__rotate",
      dash: "vizzuality__dash",
      color: "vizzuality__color",
      "spinner-box": "vizzuality__spinner-box",
      "spinner-icon": "vizzuality__spinner-icon",
      "spinner-circle": "vizzuality__spinner-circle",
      "-absolute": "vizzuality__-absolute",
      "-fixed": "vizzuality__-fixed",
      "-relative": "vizzuality__-relative"
    }
  };

  function d(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var v = {
    width: 40,
    height: 40
  },
      y = {
    fill: "none",
    stroke: "#000",
    strokeWidth: 5,
    strokeMiterlimit: 10
  },
      m = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, i["PureComponent"]), p(e, [{
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.position,
            n = t.customClass,
            r = t.style,
            i = l()(d({
          "c-spinner": !0
        }, "-" + e, !0)),
            s = l()(d({
          "c-spinner": !0
        }, n, !!n)),
            c = f({}, v, r.box),
            u = f({}, y, r.circle);
        return a.a.createElement("div", {
          className: (s ? s + " " : "") + o()(i, h)
        }, a.a.createElement("div", {
          className: "vizzuality__spinner-box",
          style: c
        }, a.a.createElement("svg", {
          className: "vizzuality__spinner-icon",
          viewBox: "25 25 50 50"
        }, a.a.createElement("circle", f({}, u, {
          className: "vizzuality__spinner-circle",
          cx: 50,
          cy: 50,
          r: 20
        })))));
      }
    }]), e;
  }();

  m.propTypes = {
    position: c.a.oneOf(["relative", "absolute", "fixed"]),
    className: c.a.string,
    customClass: c.a.string,
    style: c.a.shape({
      box: c.a.object,
      circle: c.a.object
    })
  }, m.defaultProps = {
    position: "absolute",
    className: null,
    customClass: null,
    style: {
      box: {},
      circle: {}
    }
  }, e["default"] = m;
}, function (t, e) {
  var n = Function.prototype.toString;

  t.exports = function (t) {
    if (null != t) {
      try {
        return n.call(t);
      } catch (t) {}

      try {
        return t + "";
      } catch (t) {}
    }

    return "";
  };
}, function (t, e, n) {
  var r = n(248),
      o = n(251),
      i = n(252),
      a = 1,
      s = 2;

  t.exports = function (t, e, n, c, u, l) {
    var f = n & a,
        p = t.length,
        h = e.length;
    if (p != h && !(f && h > p)) return !1;
    var d = l.get(t);
    if (d && l.get(e)) return d == e;
    var v = -1,
        y = !0,
        m = n & s ? new r() : void 0;

    for (l.set(t, e), l.set(e, t); ++v < p;) {
      var g = t[v],
          b = e[v];
      if (c) var _ = f ? c(b, g, v, e, t, l) : c(g, b, v, t, e, l);

      if (void 0 !== _) {
        if (_) continue;
        y = !1;
        break;
      }

      if (m) {
        if (!o(e, function (t, e) {
          if (!i(m, e) && (g === t || u(g, t, n, c, l))) return m.push(e);
        })) {
          y = !1;
          break;
        }
      } else if (g !== b && !u(g, b, n, c, l)) {
        y = !1;
        break;
      }
    }

    return l["delete"](t), l["delete"](e), y;
  };
}, function (t, e) {
  t.exports = function (t) {
    return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
      enumerable: !0,
      get: function get() {
        return t.l;
      }
    }), Object.defineProperty(t, "id", {
      enumerable: !0,
      get: function get() {
        return t.i;
      }
    }), t.webpackPolyfill = 1), t;
  };
}, function (t, e) {
  t.exports = function (t, e) {
    for (var n = -1, r = e.length, o = t.length; ++n < r;) {
      t[o + n] = e[n];
    }

    return t;
  };
}, function (t, e, n) {
  var r = n(87),
      o = n(226),
      i = n(227),
      a = n(228),
      s = n(229),
      c = n(230);

  function u(t) {
    var e = this.__data__ = new r(t);
    this.size = e.size;
  }

  u.prototype.clear = o, u.prototype["delete"] = i, u.prototype.get = a, u.prototype.has = s, u.prototype.set = c, t.exports = u;
}, function (t, e) {
  t.exports = function (t) {
    return function (e) {
      return t(e);
    };
  };
}, function (t, e, n) {
  var r = n(185),
      o = n(268),
      i = Object.prototype.hasOwnProperty;

  t.exports = function (t) {
    if (!r(t)) return o(t);
    var e = [];

    for (var n in Object(t)) {
      i.call(t, n) && "constructor" != n && e.push(n);
    }

    return e;
  };
}, function (t, e) {
  var n = Object.prototype;

  t.exports = function (t) {
    var e = t && t.constructor;
    return t === ("function" == typeof e && e.prototype || n);
  };
}, function (t, e, n) {
  var r = n(270),
      o = n(106),
      i = n(271),
      a = n(272),
      s = n(273),
      c = n(48),
      u = n(178),
      l = u(r),
      f = u(o),
      p = u(i),
      h = u(a),
      d = u(s),
      v = c;
  (r && "[object DataView]" != v(new r(new ArrayBuffer(1))) || o && "[object Map]" != v(new o()) || i && "[object Promise]" != v(i.resolve()) || a && "[object Set]" != v(new a()) || s && "[object WeakMap]" != v(new s())) && (v = function v(t) {
    var e = c(t),
        n = "[object Object]" == e ? t.constructor : void 0,
        r = n ? u(n) : "";
    if (r) switch (r) {
      case l:
        return "[object DataView]";

      case f:
        return "[object Map]";

      case p:
        return "[object Promise]";

      case h:
        return "[object Set]";

      case d:
        return "[object WeakMap]";
    }
    return e;
  }), t.exports = v;
}, function (t, e, n) {
  var r = n(42),
      o = n(76),
      i = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      a = /^\w*$/;

  t.exports = function (t, e) {
    if (r(t)) return !1;

    var n = _typeof(t);

    return !("number" != n && "symbol" != n && "boolean" != n && null != t && !o(t)) || a.test(t) || !i.test(t) || null != e && t in Object(e);
  };
}, function (t, e, n) {
  t.exports = {
    "default": n(189),
    __esModule: !0
  };
}, function (t, e, n) {
  n(190), t.exports = n(16).Object.getPrototypeOf;
}, function (t, e, n) {
  var r = n(47),
      o = n(99);
  n(107)("getPrototypeOf", function () {
    return function (t) {
      return o(r(t));
    };
  });
}, function (t, e, n) {
  t.exports = {
    "default": n(192),
    __esModule: !0
  };
}, function (t, e, n) {
  n(193);
  var r = n(16).Object;

  t.exports = function (t, e) {
    return r.getOwnPropertyDescriptor(t, e);
  };
}, function (t, e, n) {
  var r = n(28),
      o = n(70).f;
  n(107)("getOwnPropertyDescriptor", function () {
    return function (t, e) {
      return o(r(t), e);
    };
  });
}, function (t, e, n) {
  t.exports = {
    "default": n(195),
    __esModule: !0
  };
}, function (t, e, n) {
  n(98), n(196), t.exports = n(16).Array.from;
}, function (t, e, n) {
  "use strict";

  var r = n(68),
      o = n(25),
      i = n(47),
      a = n(197),
      s = n(198),
      c = n(97),
      u = n(199),
      l = n(200);
  o(o.S + o.F * !n(202)(function (t) {
    Array.from(t);
  }), "Array", {
    from: function from(t) {
      var e,
          n,
          o,
          f,
          p = i(t),
          h = "function" == typeof this ? this : Array,
          d = arguments.length,
          v = d > 1 ? arguments[1] : void 0,
          y = void 0 !== v,
          m = 0,
          g = l(p);
      if (y && (v = r(v, d > 2 ? arguments[2] : void 0, 2)), void 0 == g || h == Array && s(g)) for (n = new h(e = c(p.length)); e > m; m++) {
        u(n, m, y ? v(p[m], m) : p[m]);
      } else for (f = g.call(p), n = new h(); !(o = f.next()).done; m++) {
        u(n, m, y ? a(f, v, [o.value, m], !0) : o.value);
      }
      return n.length = m, n;
    }
  });
}, function (t, e, n) {
  var r = n(32);

  t.exports = function (t, e, n, o) {
    try {
      return o ? e(r(n)[0], n[1]) : e(n);
    } catch (e) {
      var i = t["return"];
      throw void 0 !== i && r(i.call(t)), e;
    }
  };
}, function (t, e, n) {
  var r = n(40),
      o = n(19)("iterator"),
      i = Array.prototype;

  t.exports = function (t) {
    return void 0 !== t && (r.Array === t || i[o] === t);
  };
}, function (t, e, n) {
  "use strict";

  var r = n(23),
      o = n(38);

  t.exports = function (t, e, n) {
    e in t ? r.f(t, e, o(0, n)) : t[e] = n;
  };
}, function (t, e, n) {
  var r = n(201),
      o = n(19)("iterator"),
      i = n(40);

  t.exports = n(16).getIteratorMethod = function (t) {
    if (void 0 != t) return t[o] || t["@@iterator"] || i[r(t)];
  };
}, function (t, e, n) {
  var r = n(69),
      o = n(19)("toStringTag"),
      i = "Arguments" == r(function () {
    return arguments;
  }());

  t.exports = function (t) {
    var e, n, a;
    return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function (t, e) {
      try {
        return t[e];
      } catch (t) {}
    }(e = Object(t), o)) ? n : i ? r(e) : "Object" == (a = r(e)) && "function" == typeof e.callee ? "Arguments" : a;
  };
}, function (t, e, n) {
  var r = n(19)("iterator"),
      o = !1;

  try {
    var i = [7][r]();
    i["return"] = function () {
      o = !0;
    }, Array.from(i, function () {
      throw 2;
    });
  } catch (t) {}

  t.exports = function (t, e) {
    if (!e && !o) return !1;
    var n = !1;

    try {
      var i = [7],
          a = i[r]();
      a.next = function () {
        return {
          done: n = !0
        };
      }, i[r] = function () {
        return a;
      }, t(i);
    } catch (t) {}

    return n;
  };
}, function (t, e, n) {
  "use strict";

  var r = n(34),
      o = n(35),
      i = n(204);

  t.exports = function () {
    function t(t, e, n, r, a, s) {
      s !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var n = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e
    };
    return n.checkPropTypes = r, n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, n) {
  var r = n(108),
      o = n(208);

  t.exports = function (t, e, n, i) {
    var a = t.length;

    for ((n = r(n)) < 0 && (n = -n > a ? 0 : a + n), (i = void 0 === i || i > a ? a : r(i)) < 0 && (i += a), i = n > i ? 0 : o(i); n < i;) {
      t[n++] = e;
    }

    return t;
  };
}, function (t, e, n) {
  var r = n(207),
      o = 1 / 0,
      i = 1.7976931348623157e308;

  t.exports = function (t) {
    return t ? (t = r(t)) === o || t === -o ? (t < 0 ? -1 : 1) * i : t == t ? t : 0 : 0 === t ? t : 0;
  };
}, function (t, e, n) {
  var r = n(50),
      o = n(76),
      i = NaN,
      a = /^\s+|\s+$/g,
      s = /^[-+]0x[0-9a-f]+$/i,
      c = /^0b[01]+$/i,
      u = /^0o[0-7]+$/i,
      l = parseInt;

  t.exports = function (t) {
    if ("number" == typeof t) return t;
    if (o(t)) return i;

    if (r(t)) {
      var e = "function" == typeof t.valueOf ? t.valueOf() : t;
      t = r(e) ? e + "" : e;
    }

    if ("string" != typeof t) return 0 === t ? t : +t;
    t = t.replace(a, "");
    var n = c.test(t);
    return n || u.test(t) ? l(t.slice(2), n ? 2 : 8) : s.test(t) ? i : +t;
  };
}, function (t, e, n) {
  var r = n(209),
      o = n(108),
      i = 4294967295;

  t.exports = function (t) {
    return t ? r(o(t), 0, i) : 0;
  };
}, function (t, e) {
  t.exports = function (t, e, n) {
    return t == t && (void 0 !== n && (t = t <= n ? t : n), void 0 !== e && (t = t >= e ? t : e)), t;
  };
}, function (t, e, n) {
  t.exports = {
    "c-slider": "vizzuality__c-slider",
    "player-btn": "vizzuality__player-btn",
    "timestep-slider": "vizzuality__timestep-slider",
    "can-play": "vizzuality__can-play",
    rcSliderTooltipZoomDownIn: "vizzuality__rcSliderTooltipZoomDownIn",
    rcSliderTooltipZoomDownOut: "vizzuality__rcSliderTooltipZoomDownOut"
  };
},, function (t, e, n) {
  "use strict";

  var r = n(0),
      o = n.n(r),
      i = n(1),
      a = n.n(i),
      s = n(8),
      c = n(39),
      u = n.n(c),
      l = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  },
      f = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function p(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var h = ("undefined" != typeof window ? window : {}).L,
      d = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var i = arguments.length, a = Array(i), c = 0; c < i; c++) {
        a[c] = arguments[c];
      }

      return n = r = p(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(a))), r.setPopup = function () {
        var t = r.props,
            e = t.map,
            n = t.latlng;
        n && e || r.removePopup();
        var o = r.buildPopup();
        n && e && r.popup.setLatLng(n).setContent(o).openOn(e);
      }, r.buildPopup = function () {
        var t = r.props.children,
            e = document.createElement("div");
        return Object(s.render)(o.a.Children.map(t, function (t) {
          return o.a.isValidElement(t) && "string" != typeof t.type ? o.a.cloneElement(t, l({}, r.props, {
            popup: r.popup
          })) : t;
        }), e), e;
      }, r.updatePopup = function () {
        r.popup.setContent(r.buildPopup());
      }, r.removePopup = function () {
        r.popup && r.popup.remove();
      }, p(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["Component"]), f(e, [{
      key: "componentDidMount",
      value: function value() {
        void 0 !== h && (this.popup = this.popup || h.popup({
          maxWidth: 400,
          minWidth: 240
        }), this.props.onReady(this.popup));
      }
    }, {
      key: "componentDidUpdate",
      value: function value(t) {
        var e = t.latlng,
            n = t.data,
            r = this.props,
            o = r.latlng,
            i = r.data;
        u()(e, o) || this.setPopup(), !u()(n, i) && e && this.updatePopup();
      }
    }, {
      key: "render",
      value: function value() {
        return null;
      }
    }]), e;
  }();

  d.propTypes = {
    children: a.a.node.isRequired,
    map: a.a.object.isRequired,
    latlng: a.a.object,
    data: a.a.object,
    onReady: a.a.func
  }, d.defaultProps = {
    latlng: {},
    data: {},
    onReady: function onReady() {}
  }, e.a = d;
}, function (t, e, n) {
  "use strict";

  var r = n(0),
      o = n.n(r),
      i = n(11),
      a = n.n(i),
      s = n(1),
      c = n.n(s),
      u = (n(354), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }());

  var l = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["PureComponent"]), u(e, [{
      key: "render",
      value: function value() {
        var t,
            e,
            n,
            r = this.props,
            i = r.customClass,
            s = r.children,
            c = a()((n = !!i, (e = i) in (t = {}) ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t));
        return o.a.createElement("div", {
          className: (c ? c + " " : "") + "vizzuality__c-map-controls"
        }, o.a.createElement("ul", {
          className: "vizzuality__map-controls-list"
        }, o.a.Children.map(s, function (t, e) {
          return o.a.isValidElement(t) && o.a.createElement("li", {
            className: "vizzuality__map-controls-list-item",
            key: e
          }, o.a.cloneElement(t));
        })));
      }
    }]), e;
  }();

  l.propTypes = {
    children: c.a.node.isRequired,
    customClass: c.a.string
  }, l.defaultProps = {
    customClass: null
  }, e.a = l;
}, function (t, e, n) {
  "use strict";

  var r = n(14),
      o = n.n(r),
      i = n(0),
      a = n.n(i),
      s = n(1),
      c = n.n(s),
      u = n(11),
      l = n.n(u),
      f = n(18),
      p = (n(356), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }()),
      h = {
    "./styles.scss": {
      "c-zoom-control": "vizzuality__c-zoom-control",
      "zoom-control-btn": "vizzuality__zoom-control-btn",
      "-disabled": "vizzuality__-disabled"
    }
  };

  function d(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  function v(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var y = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
        i[a] = arguments[a];
      }

      return n = r = v(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(i))), r.state = {
        zoom: r.props.map.getZoom()
      }, r.getZoom = function () {
        r.setState({
          zoom: r.props.map.getZoom()
        });
      }, r.increaseZoom = function () {
        var t = r.props.map.getZoom(),
            e = r.props.map.getMaxZoom();
        r.setState({
          zoom: t === e ? t : t + 1
        }, function () {
          r.props.map.setZoom(r.state.zoom);
        });
      }, r.decreaseZoom = function () {
        var t = r.props.map.getZoom(),
            e = r.props.map.getMinZoom();
        r.setState({
          zoom: t === e ? t : t - 1
        }, function () {
          r.props.map.setZoom(r.state.zoom);
        });
      }, v(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, i["PureComponent"]), p(e, [{
      key: "componentWillMount",
      value: function value() {
        this.props.map.on("zoomend", this.getZoom);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.props.map.off("zoomend", this.getZoom);
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.className,
            n = t.customClass,
            r = this.state.zoom,
            i = this.props.map.getMaxZoom(),
            s = this.props.map.getMinZoom(),
            c = l()("c-zoom-control", d({}, e, !!e)),
            u = l()(d({}, n, !!n)),
            p = l()("zoom-control-btn", {
          "-disabled": r === i
        }),
            v = l()("zoom-control-btn", {
          "-disabled": r === s
        });
        return a.a.createElement("div", {
          className: (u ? u + " " : "") + o()(c, h)
        }, a.a.createElement("button", {
          type: "button",
          disabled: r === i,
          onClick: this.increaseZoom,
          className: o()(p, h)
        }, a.a.createElement(f["default"], {
          name: "icon-plus"
        })), a.a.createElement("button", {
          type: "button",
          disabled: r === s,
          onClick: this.decreaseZoom,
          className: o()(v, h)
        }, a.a.createElement(f["default"], {
          name: "icon-minus"
        })));
      }
    }]), e;
  }();

  y.propTypes = {
    map: c.a.object.isRequired,
    className: c.a.string,
    customClass: c.a.string
  }, y.defaultProps = {
    className: null,
    customClass: null
  }, e.a = y;
}, function (t, e, n) {
  "use strict";

  var r = n(14),
      o = n.n(r),
      i = n(0),
      a = n.n(i),
      s = n(1),
      c = n.n(s),
      u = n(11),
      l = n.n(u),
      f = n(101),
      p = n(18),
      h = (n(290), Object(f.SortableHandle)(function () {
    return a.a.createElement("span", {
      className: "vizzuality__c-legend-handler"
    }, a.a.createElement(p["default"], {
      name: "icon-drag-dots",
      className: "-small"
    }));
  })),
      d = (n(292), Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }),
      v = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }(),
      y = {
    "./styles.scss": {
      "c-legend-item": "vizzuality__c-legend-item",
      "legend-item-container": "vizzuality__legend-item-container",
      "-sortable": "vizzuality__-sortable",
      "legend-info": "vizzuality__legend-info",
      "legend-item-header": "vizzuality__legend-item-header",
      "-dark": "vizzuality__-dark",
      category: "vizzuality__category",
      "-sort": "vizzuality__-sort"
    }
  };

  function m(t, e) {
    var n = {};

    for (var r in t) {
      e.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }

    return n;
  }

  var g = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, i["PureComponent"]), v(e, [{
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.layers,
            n = t.sortable,
            r = t.children,
            i = t.toolbar,
            s = t.title,
            c = m(t, ["layers", "sortable", "children", "toolbar", "title"]),
            u = e.find(function (t) {
          return t.active;
        }) || e[0];
        return a.a.createElement("li", {
          className: o()(l()({
            "c-legend-item": !0,
            "-sortable": n
          }), y)
        }, a.a.createElement("div", {
          className: o()(l()({
            "legend-item-container": !0,
            "-sortable": n
          }), y)
        }, n && a.a.createElement(h, null), a.a.createElement("div", {
          className: "vizzuality__legend-info"
        }, a.a.createElement("header", {
          className: "vizzuality__legend-item-header"
        }, a.a.createElement("h3", null, a.a.isValidElement(s) && "string" != typeof s.type ? a.a.cloneElement(s, d({}, c, {
          layers: e,
          activeLayer: u
        })) : u && u.name), a.a.isValidElement(i) && "string" != typeof i.type && a.a.cloneElement(i, d({}, c, {
          layers: e,
          activeLayer: u
        }))), a.a.Children.map(r, function (t) {
          return a.a.isValidElement(t) && "string" != typeof t.type ? a.a.cloneElement(t, {
            layers: e,
            activeLayer: u
          }) : t;
        }))));
      }
    }]), e;
  }();

  g.propTypes = {
    dataset: c.a.string,
    layers: c.a.arrayOf(c.a.shape({})),
    sortable: c.a.bool,
    children: c.a.node,
    toolbar: c.a.node,
    title: c.a.node
  }, g.defaultProps = {
    dataset: "",
    layers: [],
    sortable: !0,
    children: [],
    toolbar: [],
    title: []
  };
  e.a = Object(f.SortableElement)(function (t) {
    var e = t.layerGroup,
        n = m(t, ["layerGroup"]);
    return a.a.createElement(g, d({
      key: n.dataset
    }, e, n));
  });
}, function (t, e, n) {
  "use strict";

  (function (t) {
    n.d(e, "a", function () {
      return Mu;
    });
    var r = n(37),
        o = n.n(r),
        i = "undefined" != typeof window ? window : void 0 !== t ? t : "undefined" != typeof self ? self : {};

    function a(t) {
      return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t["default"] : t;
    }

    function s(t, e) {
      return t(e = {
        exports: {}
      }, e.exports), e.exports;
    }

    var c = s(function (t) {
      var e = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = e);
    }),
        u = s(function (t) {
      var e = t.exports = {
        version: "2.5.7"
      };
      "number" == typeof __e && (__e = e);
    }),
        l = (u.version, function (t) {
      return "object" == _typeof(t) ? null !== t : "function" == typeof t;
    }),
        f = function f(t) {
      if (!l(t)) throw TypeError(t + " is not an object!");
      return t;
    },
        p = function p(t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    },
        h = !p(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    }),
        d = c.document,
        v = l(d) && l(d.createElement),
        y = function y(t) {
      return v ? d.createElement(t) : {};
    },
        m = !h && !p(function () {
      return 7 != Object.defineProperty(y("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    }),
        g = function g(t, e) {
      if (!l(t)) return t;
      var n, r;
      if (e && "function" == typeof (n = t.toString) && !l(r = n.call(t))) return r;
      if ("function" == typeof (n = t.valueOf) && !l(r = n.call(t))) return r;
      if (!e && "function" == typeof (n = t.toString) && !l(r = n.call(t))) return r;
      throw TypeError("Can't convert object to primitive value");
    },
        b = Object.defineProperty,
        _ = {
      f: h ? Object.defineProperty : function (t, e, n) {
        if (f(t), e = g(e, !0), f(n), m) try {
          return b(t, e, n);
        } catch (t) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
        return "value" in n && (t[e] = n.value), t;
      }
    },
        w = function w(t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    },
        x = h ? function (t, e, n) {
      return _.f(t, e, w(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    },
        O = {}.hasOwnProperty,
        E = function E(t, e) {
      return O.call(t, e);
    },
        C = 0,
        j = Math.random(),
        S = function S(t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++C + j).toString(36));
    },
        T = s(function (t) {
      var e = S("src"),
          n = Function.toString,
          r = ("" + n).split("toString");
      u.inspectSource = function (t) {
        return n.call(t);
      }, (t.exports = function (t, n, o, i) {
        var a = "function" == typeof o;
        a && (E(o, "name") || x(o, "name", n)), t[n] !== o && (a && (E(o, e) || x(o, e, t[n] ? "" + t[n] : r.join(String(n)))), t === c ? t[n] = o : i ? t[n] ? t[n] = o : x(t, n, o) : (delete t[n], x(t, n, o)));
      })(Function.prototype, "toString", function () {
        return "function" == typeof this && this[e] || n.call(this);
      });
    }),
        P = function P(t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    },
        k = function k(t, e, n) {
      if (P(t), void 0 === e) return t;

      switch (n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };

        case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };

        case 3:
          return function (n, r, o) {
            return t.call(e, n, r, o);
          };
      }

      return function () {
        return t.apply(e, arguments);
      };
    },
        M = function M(t, e, n) {
      var r,
          o,
          i,
          a,
          s = t & M.F,
          l = t & M.G,
          f = t & M.S,
          p = t & M.P,
          h = t & M.B,
          d = l ? c : f ? c[e] || (c[e] = {}) : (c[e] || {}).prototype,
          v = l ? u : u[e] || (u[e] = {}),
          y = v.prototype || (v.prototype = {});

      for (r in l && (n = e), n) {
        i = ((o = !s && d && void 0 !== d[r]) ? d : n)[r], a = h && o ? k(i, c) : p && "function" == typeof i ? k(Function.call, i) : i, d && T(d, r, i, t & M.U), v[r] != i && x(v, r, a), p && y[r] != i && (y[r] = i);
      }
    };

    c.core = u, M.F = 1, M.G = 2, M.S = 4, M.P = 8, M.B = 16, M.W = 32, M.U = 64, M.R = 128;

    for (var z, L = M, A = S("typed_array"), R = S("view"), N = !(!c.ArrayBuffer || !c.DataView), F = N, I = 0, D = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); I < 9;) {
      (z = c[D[I++]]) ? (x(z.prototype, A, !0), x(z.prototype, R, !0)) : F = !1;
    }

    var B = {
      ABV: N,
      CONSTR: F,
      TYPED: A,
      VIEW: R
    },
        V = function V(t, e, n) {
      for (var r in e) {
        T(t, r, e[r], n);
      }

      return t;
    },
        H = function H(t, e, n, r) {
      if (!(t instanceof e) || void 0 !== r && r in t) throw TypeError(n + ": incorrect invocation!");
      return t;
    },
        U = Math.ceil,
        W = Math.floor,
        q = function q(t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? W : U)(t);
    },
        G = Math.min,
        K = function K(t) {
      return t > 0 ? G(q(t), 9007199254740991) : 0;
    },
        Z = function Z(t) {
      if (void 0 === t) return 0;
      var e = q(t),
          n = K(e);
      if (e !== n) throw RangeError("Wrong length!");
      return n;
    },
        Y = {}.toString,
        $ = function $(t) {
      return Y.call(t).slice(8, -1);
    },
        X = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == $(t) ? t.split("") : Object(t);
    },
        Q = function Q(t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    },
        J = function J(t) {
      return X(Q(t));
    },
        tt = Math.max,
        et = Math.min,
        nt = function nt(t, e) {
      return (t = q(t)) < 0 ? tt(t + e, 0) : et(t, e);
    },
        rt = function rt(t) {
      return function (e, n, r) {
        var o,
            i = J(e),
            a = K(i.length),
            s = nt(r, a);

        if (t && n != n) {
          for (; a > s;) {
            if ((o = i[s++]) != o) return !0;
          }
        } else for (; a > s; s++) {
          if ((t || s in i) && i[s] === n) return t || s || 0;
        }

        return !t && -1;
      };
    },
        ot = s(function (t) {
      var e = c["__core-js_shared__"] || (c["__core-js_shared__"] = {});
      (t.exports = function (t, n) {
        return e[t] || (e[t] = void 0 !== n ? n : {});
      })("versions", []).push({
        version: u.version,
        mode: "global",
        copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
      });
    }),
        it = ot("keys"),
        at = function at(t) {
      return it[t] || (it[t] = S(t));
    },
        st = rt(!1),
        ct = at("IE_PROTO"),
        ut = function ut(t, e) {
      var n,
          r = J(t),
          o = 0,
          i = [];

      for (n in r) {
        n != ct && E(r, n) && i.push(n);
      }

      for (; e.length > o;) {
        E(r, n = e[o++]) && (~st(i, n) || i.push(n));
      }

      return i;
    },
        lt = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),
        ft = lt.concat("length", "prototype"),
        pt = {
      f: Object.getOwnPropertyNames || function (t) {
        return ut(t, ft);
      }
    },
        ht = function ht(t) {
      return Object(Q(t));
    },
        dt = function dt(t) {
      for (var e = ht(this), n = K(e.length), r = arguments.length, o = nt(r > 1 ? arguments[1] : void 0, n), i = r > 2 ? arguments[2] : void 0, a = void 0 === i ? n : nt(i, n); a > o;) {
        e[o++] = t;
      }

      return e;
    },
        vt = s(function (t) {
      var e = ot("wks"),
          n = c.Symbol,
          r = "function" == typeof n;
      (t.exports = function (t) {
        return e[t] || (e[t] = r && n[t] || (r ? n : S)("Symbol." + t));
      }).store = e;
    }),
        yt = _.f,
        mt = vt("toStringTag"),
        gt = function gt(t, e, n) {
      t && !E(t = n ? t : t.prototype, mt) && yt(t, mt, {
        configurable: !0,
        value: e
      });
    },
        bt = s(function (t, e) {
      var n = pt.f,
          r = _.f,
          o = "prototype",
          i = "Wrong index!",
          _a3 = c.ArrayBuffer,
          _s2 = c.DataView,
          u = c.Math,
          l = c.RangeError,
          f = c.Infinity,
          d = _a3,
          v = u.abs,
          y = u.pow,
          m = u.floor,
          g = u.log,
          b = u.LN2,
          w = h ? "_b" : "buffer",
          O = h ? "_l" : "byteLength",
          E = h ? "_o" : "byteOffset";

      function C(t, e, n) {
        var r,
            o,
            i,
            a = new Array(n),
            s = 8 * n - e - 1,
            c = (1 << s) - 1,
            u = c >> 1,
            l = 23 === e ? y(2, -24) - y(2, -77) : 0,
            p = 0,
            h = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;

        for ((t = v(t)) != t || t === f ? (o = t != t ? 1 : 0, r = c) : (r = m(g(t) / b), t * (i = y(2, -r)) < 1 && (r--, i *= 2), (t += r + u >= 1 ? l / i : l * y(2, 1 - u)) * i >= 2 && (r++, i /= 2), r + u >= c ? (o = 0, r = c) : r + u >= 1 ? (o = (t * i - 1) * y(2, e), r += u) : (o = t * y(2, u - 1) * y(2, e), r = 0)); e >= 8; a[p++] = 255 & o, o /= 256, e -= 8) {
          ;
        }

        for (r = r << e | o, s += e; s > 0; a[p++] = 255 & r, r /= 256, s -= 8) {
          ;
        }

        return a[--p] |= 128 * h, a;
      }

      function j(t, e, n) {
        var r,
            o = 8 * n - e - 1,
            i = (1 << o) - 1,
            a = i >> 1,
            s = o - 7,
            c = n - 1,
            u = t[c--],
            l = 127 & u;

        for (u >>= 7; s > 0; l = 256 * l + t[c], c--, s -= 8) {
          ;
        }

        for (r = l & (1 << -s) - 1, l >>= -s, s += e; s > 0; r = 256 * r + t[c], c--, s -= 8) {
          ;
        }

        if (0 === l) l = 1 - a;else {
          if (l === i) return r ? NaN : u ? -f : f;
          r += y(2, e), l -= a;
        }
        return (u ? -1 : 1) * r * y(2, l - e);
      }

      function S(t) {
        return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0];
      }

      function T(t) {
        return [255 & t];
      }

      function P(t) {
        return [255 & t, t >> 8 & 255];
      }

      function k(t) {
        return [255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255];
      }

      function M(t) {
        return C(t, 52, 8);
      }

      function z(t) {
        return C(t, 23, 4);
      }

      function L(t, e, n) {
        r(t[o], e, {
          get: function get() {
            return this[n];
          }
        });
      }

      function A(t, e, n, r) {
        var o = Z(+n);
        if (o + e > t[O]) throw l(i);
        var a = t[w]._b,
            s = o + t[E],
            c = a.slice(s, s + e);
        return r ? c : c.reverse();
      }

      function R(t, e, n, r, o, a) {
        var s = Z(+n);
        if (s + e > t[O]) throw l(i);

        for (var c = t[w]._b, u = s + t[E], f = r(+o), p = 0; p < e; p++) {
          c[u + p] = f[a ? p : e - p - 1];
        }
      }

      if (B.ABV) {
        if (!p(function () {
          _a3(1);
        }) || !p(function () {
          new _a3(-1);
        }) || p(function () {
          return new _a3(), new _a3(1.5), new _a3(NaN), "ArrayBuffer" != _a3.name;
        })) {
          for (var N, F = (_a3 = function a(t) {
            return H(this, _a3), new d(Z(t));
          })[o] = d[o], I = n(d), D = 0; I.length > D;) {
            (N = I[D++]) in _a3 || x(_a3, N, d[N]);
          }

          F.constructor = _a3;
        }

        var U = new _s2(new _a3(2)),
            W = _s2[o].setInt8;
        U.setInt8(0, 2147483648), U.setInt8(1, 2147483649), !U.getInt8(0) && U.getInt8(1) || V(_s2[o], {
          setInt8: function setInt8(t, e) {
            W.call(this, t, e << 24 >> 24);
          },
          setUint8: function setUint8(t, e) {
            W.call(this, t, e << 24 >> 24);
          }
        }, !0);
      } else _a3 = function _a2(t) {
        H(this, _a3, "ArrayBuffer");
        var e = Z(t);
        this._b = dt.call(new Array(e), 0), this[O] = e;
      }, _s2 = function s(t, e, n) {
        H(this, _s2, "DataView"), H(t, _a3, "DataView");
        var r = t[O],
            o = q(e);
        if (o < 0 || o > r) throw l("Wrong offset!");
        if (o + (n = void 0 === n ? r - o : K(n)) > r) throw l("Wrong length!");
        this[w] = t, this[E] = o, this[O] = n;
      }, h && (L(_a3, "byteLength", "_l"), L(_s2, "buffer", "_b"), L(_s2, "byteLength", "_l"), L(_s2, "byteOffset", "_o")), V(_s2[o], {
        getInt8: function getInt8(t) {
          return A(this, 1, t)[0] << 24 >> 24;
        },
        getUint8: function getUint8(t) {
          return A(this, 1, t)[0];
        },
        getInt16: function getInt16(t) {
          var e = A(this, 2, t, arguments[1]);
          return (e[1] << 8 | e[0]) << 16 >> 16;
        },
        getUint16: function getUint16(t) {
          var e = A(this, 2, t, arguments[1]);
          return e[1] << 8 | e[0];
        },
        getInt32: function getInt32(t) {
          return S(A(this, 4, t, arguments[1]));
        },
        getUint32: function getUint32(t) {
          return S(A(this, 4, t, arguments[1])) >>> 0;
        },
        getFloat32: function getFloat32(t) {
          return j(A(this, 4, t, arguments[1]), 23, 4);
        },
        getFloat64: function getFloat64(t) {
          return j(A(this, 8, t, arguments[1]), 52, 8);
        },
        setInt8: function setInt8(t, e) {
          R(this, 1, t, T, e);
        },
        setUint8: function setUint8(t, e) {
          R(this, 1, t, T, e);
        },
        setInt16: function setInt16(t, e) {
          R(this, 2, t, P, e, arguments[2]);
        },
        setUint16: function setUint16(t, e) {
          R(this, 2, t, P, e, arguments[2]);
        },
        setInt32: function setInt32(t, e) {
          R(this, 4, t, k, e, arguments[2]);
        },
        setUint32: function setUint32(t, e) {
          R(this, 4, t, k, e, arguments[2]);
        },
        setFloat32: function setFloat32(t, e) {
          R(this, 4, t, z, e, arguments[2]);
        },
        setFloat64: function setFloat64(t, e) {
          R(this, 8, t, M, e, arguments[2]);
        }
      });

      gt(_a3, "ArrayBuffer"), gt(_s2, "DataView"), x(_s2[o], B.VIEW, !0), e.ArrayBuffer = _a3, e.DataView = _s2;
    }),
        _t = vt("species"),
        wt = function wt(t, e) {
      var n,
          r = f(t).constructor;
      return void 0 === r || void 0 == (n = f(r)[_t]) ? e : P(n);
    },
        xt = vt("species"),
        Ot = function Ot(t) {
      var e = c[t];
      h && e && !e[xt] && _.f(e, xt, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    },
        Et = c.ArrayBuffer,
        Ct = bt.ArrayBuffer,
        jt = bt.DataView,
        St = B.ABV && Et.isView,
        Tt = Ct.prototype.slice,
        Pt = B.VIEW;

    L(L.G + L.W + L.F * (Et !== Ct), {
      ArrayBuffer: Ct
    }), L(L.S + L.F * !B.CONSTR, "ArrayBuffer", {
      isView: function isView(t) {
        return St && St(t) || l(t) && Pt in t;
      }
    }), L(L.P + L.U + L.F * p(function () {
      return !new Ct(2).slice(1, void 0).byteLength;
    }), "ArrayBuffer", {
      slice: function slice(t, e) {
        if (void 0 !== Tt && void 0 === e) return Tt.call(f(this), t);

        for (var n = f(this).byteLength, r = nt(t, n), o = nt(void 0 === e ? n : e, n), i = new (wt(this, Ct))(K(o - r)), a = new jt(this), s = new jt(i), c = 0; r < o;) {
          s.setUint8(c++, a.getUint8(r++));
        }

        return i;
      }
    }), Ot("ArrayBuffer");

    var kt = vt("toStringTag"),
        Mt = "Arguments" == $(function () {
      return arguments;
    }()),
        zt = function zt(t) {
      var e, n, r;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function (t, e) {
        try {
          return t[e];
        } catch (t) {}
      }(e = Object(t), kt)) ? n : Mt ? $(e) : "Object" == (r = $(e)) && "function" == typeof e.callee ? "Arguments" : r;
    },
        Lt = {},
        At = vt("iterator"),
        Rt = Array.prototype,
        Nt = function Nt(t) {
      return void 0 !== t && (Lt.Array === t || Rt[At] === t);
    },
        Ft = Object.keys || function (t) {
      return ut(t, lt);
    },
        It = h ? Object.defineProperties : function (t, e) {
      f(t);

      for (var n, r = Ft(e), o = r.length, i = 0; o > i;) {
        _.f(t, n = r[i++], e[n]);
      }

      return t;
    },
        Dt = c.document,
        Bt = Dt && Dt.documentElement,
        Vt = at("IE_PROTO"),
        Ht = function Ht() {},
        _Ut = function Ut() {
      var t,
          e = y("iframe"),
          n = lt.length;

      for (e.style.display = "none", Bt.appendChild(e), e.src = "javascript:", (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), _Ut = t.F; n--;) {
        delete _Ut.prototype[lt[n]];
      }

      return _Ut();
    },
        Wt = Object.create || function (t, e) {
      var n;
      return null !== t ? (Ht.prototype = f(t), n = new Ht(), Ht.prototype = null, n[Vt] = t) : n = _Ut(), void 0 === e ? n : It(n, e);
    },
        qt = at("IE_PROTO"),
        Gt = Object.prototype,
        Kt = Object.getPrototypeOf || function (t) {
      return t = ht(t), E(t, qt) ? t[qt] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? Gt : null;
    },
        Zt = vt("iterator"),
        Yt = u.getIteratorMethod = function (t) {
      if (void 0 != t) return t[Zt] || t["@@iterator"] || Lt[zt(t)];
    },
        $t = Array.isArray || function (t) {
      return "Array" == $(t);
    },
        Xt = vt("species"),
        Qt = function Qt(t, e) {
      return new (function (t) {
        var e;
        return $t(t) && ("function" != typeof (e = t.constructor) || e !== Array && !$t(e.prototype) || (e = void 0), l(e) && null === (e = e[Xt]) && (e = void 0)), void 0 === e ? Array : e;
      }(t))(e);
    },
        Jt = function Jt(t, e) {
      var n = 1 == t,
          r = 2 == t,
          o = 3 == t,
          i = 4 == t,
          a = 6 == t,
          s = 5 == t || a,
          c = e || Qt;
      return function (e, u, l) {
        for (var f, p, h = ht(e), d = X(h), v = k(u, l, 3), y = K(d.length), m = 0, g = n ? c(e, y) : r ? c(e, 0) : void 0; y > m; m++) {
          if ((s || m in d) && (p = v(f = d[m], m, h), t)) if (n) g[m] = p;else if (p) switch (t) {
            case 3:
              return !0;

            case 5:
              return f;

            case 6:
              return m;

            case 2:
              g.push(f);
          } else if (i) return !1;
        }

        return a ? -1 : o || i ? i : g;
      };
    },
        te = vt("unscopables"),
        ee = Array.prototype;

    void 0 == ee[te] && x(ee, te, {});

    var ne = function ne(t) {
      ee[te][t] = !0;
    },
        re = function re(t, e) {
      return {
        value: e,
        done: !!t
      };
    },
        oe = {};

    x(oe, vt("iterator"), function () {
      return this;
    });

    var ie = function ie(t, e, n) {
      t.prototype = Wt(oe, {
        next: w(1, n)
      }), gt(t, e + " Iterator");
    },
        ae = vt("iterator"),
        se = !([].keys && "next" in [].keys()),
        ce = function ce() {
      return this;
    },
        ue = function ue(t, e, n, r, o, i, a) {
      ie(n, e, r);

      var s,
          c,
          u,
          l = function l(t) {
        if (!se && t in d) return d[t];

        switch (t) {
          case "keys":
          case "values":
            return function () {
              return new n(this, t);
            };
        }

        return function () {
          return new n(this, t);
        };
      },
          f = e + " Iterator",
          p = "values" == o,
          h = !1,
          d = t.prototype,
          v = d[ae] || d["@@iterator"] || o && d[o],
          y = v || l(o),
          m = o ? p ? l("entries") : y : void 0,
          g = "Array" == e && d.entries || v;

      if (g && (u = Kt(g.call(new t()))) !== Object.prototype && u.next && (gt(u, f, !0), "function" != typeof u[ae] && x(u, ae, ce)), p && v && "values" !== v.name && (h = !0, y = function y() {
        return v.call(this);
      }), (se || h || !d[ae]) && x(d, ae, y), Lt[e] = y, Lt[f] = ce, o) if (s = {
        values: p ? y : l("values"),
        keys: i ? y : l("keys"),
        entries: m
      }, a) for (c in s) {
        c in d || T(d, c, s[c]);
      } else L(L.P + L.F * (se || h), e, s);
      return s;
    },
        le = ue(Array, "Array", function (t, e) {
      this._t = J(t), this._i = 0, this._k = e;
    }, function () {
      var t = this._t,
          e = this._k,
          n = this._i++;
      return !t || n >= t.length ? (this._t = void 0, re(1)) : re(0, "keys" == e ? n : "values" == e ? t[n] : [n, t[n]]);
    }, "values");

    Lt.Arguments = Lt.Array, ne("keys"), ne("values"), ne("entries");
    var fe = vt("iterator"),
        pe = !1;

    try {
      [7][fe]()["return"] = function () {
        pe = !0;
      };
    } catch (t) {}

    var he = function he(t, e) {
      if (!e && !pe) return !1;
      var n = !1;

      try {
        var r = [7],
            o = r[fe]();
        o.next = function () {
          return {
            done: n = !0
          };
        }, r[fe] = function () {
          return o;
        }, t(r);
      } catch (t) {}

      return n;
    },
        de = [].copyWithin || function (t, e) {
      var n = ht(this),
          r = K(n.length),
          o = nt(t, r),
          i = nt(e, r),
          a = arguments.length > 2 ? arguments[2] : void 0,
          s = Math.min((void 0 === a ? r : nt(a, r)) - i, r - o),
          c = 1;

      for (i < o && o < i + s && (c = -1, i += s - 1, o += s - 1); s-- > 0;) {
        i in n ? n[o] = n[i] : delete n[o], o += c, i += c;
      }

      return n;
    },
        ve = {
      f: {}.propertyIsEnumerable
    },
        ye = Object.getOwnPropertyDescriptor,
        me = {
      f: h ? ye : function (t, e) {
        if (t = J(t), e = g(e, !0), m) try {
          return ye(t, e);
        } catch (t) {}
        if (E(t, e)) return w(!ve.f.call(t, e), t[e]);
      }
    },
        ge = s(function (t) {
      if (h) {
        var e = c,
            n = p,
            r = L,
            o = B,
            i = bt,
            a = k,
            s = H,
            u = w,
            f = x,
            d = V,
            v = q,
            y = K,
            m = Z,
            b = nt,
            O = g,
            C = E,
            j = zt,
            T = l,
            P = ht,
            M = Nt,
            z = Wt,
            A = Kt,
            R = pt.f,
            N = Yt,
            F = S,
            I = vt,
            D = Jt,
            U = rt,
            W = wt,
            G = le,
            Y = Lt,
            $ = he,
            X = Ot,
            Q = dt,
            J = de,
            tt = _,
            et = me,
            ot = tt.f,
            it = et.f,
            at = e.RangeError,
            st = e.TypeError,
            ct = e.Uint8Array,
            ut = Array.prototype,
            lt = i.ArrayBuffer,
            ft = i.DataView,
            yt = D(0),
            mt = D(2),
            gt = D(3),
            _t = D(4),
            xt = D(5),
            Et = D(6),
            Ct = U(!0),
            jt = U(!1),
            St = G.values,
            Tt = G.keys,
            Pt = G.entries,
            kt = ut.lastIndexOf,
            Mt = ut.reduce,
            At = ut.reduceRight,
            Rt = ut.join,
            Ft = ut.sort,
            It = ut.slice,
            Dt = ut.toString,
            Bt = ut.toLocaleString,
            Vt = I("iterator"),
            Ht = I("toStringTag"),
            Ut = F("typed_constructor"),
            qt = F("def_constructor"),
            Gt = o.CONSTR,
            Zt = o.TYPED,
            $t = o.VIEW,
            Xt = D(1, function (t, e) {
          return re(W(t, t[qt]), e);
        }),
            Qt = n(function () {
          return 1 === new ct(new Uint16Array([1]).buffer)[0];
        }),
            te = !!ct && !!ct.prototype.set && n(function () {
          new ct(1).set({});
        }),
            ee = function ee(t, e) {
          var n = v(t);
          if (n < 0 || n % e) throw at("Wrong offset!");
          return n;
        },
            ne = function ne(t) {
          if (T(t) && Zt in t) return t;
          throw st(t + " is not a typed array!");
        },
            re = function re(t, e) {
          if (!(T(t) && Ut in t)) throw st("It is not a typed array constructor!");
          return new t(e);
        },
            oe = function oe(t, e) {
          return ie(W(t, t[qt]), e);
        },
            ie = function ie(t, e) {
          for (var n = 0, r = e.length, o = re(t, r); r > n;) {
            o[n] = e[n++];
          }

          return o;
        },
            ae = function ae(t, e, n) {
          ot(t, e, {
            get: function get() {
              return this._d[n];
            }
          });
        },
            se = function se(t) {
          var e,
              n,
              r,
              o,
              i,
              s,
              c = P(t),
              u = arguments.length,
              l = u > 1 ? arguments[1] : void 0,
              f = void 0 !== l,
              p = N(c);

          if (void 0 != p && !M(p)) {
            for (s = p.call(c), r = [], e = 0; !(i = s.next()).done; e++) {
              r.push(i.value);
            }

            c = r;
          }

          for (f && u > 2 && (l = a(l, arguments[2], 2)), e = 0, n = y(c.length), o = re(this, n); n > e; e++) {
            o[e] = f ? l(c[e], e) : c[e];
          }

          return o;
        },
            ce = function ce() {
          for (var t = 0, e = arguments.length, n = re(this, e); e > t;) {
            n[t] = arguments[t++];
          }

          return n;
        },
            ue = !!ct && n(function () {
          Bt.call(new ct(1));
        }),
            fe = function fe() {
          return Bt.apply(ue ? It.call(ne(this)) : ne(this), arguments);
        },
            pe = {
          copyWithin: function copyWithin(t, e) {
            return J.call(ne(this), t, e, arguments.length > 2 ? arguments[2] : void 0);
          },
          every: function every(t) {
            return _t(ne(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          fill: function fill(t) {
            return Q.apply(ne(this), arguments);
          },
          filter: function filter(t) {
            return oe(this, mt(ne(this), t, arguments.length > 1 ? arguments[1] : void 0));
          },
          find: function find(t) {
            return xt(ne(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          findIndex: function findIndex(t) {
            return Et(ne(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          forEach: function forEach(t) {
            yt(ne(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          indexOf: function indexOf(t) {
            return jt(ne(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          includes: function includes(t) {
            return Ct(ne(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          join: function join(t) {
            return Rt.apply(ne(this), arguments);
          },
          lastIndexOf: function lastIndexOf(t) {
            return kt.apply(ne(this), arguments);
          },
          map: function map(t) {
            return Xt(ne(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          reduce: function reduce(t) {
            return Mt.apply(ne(this), arguments);
          },
          reduceRight: function reduceRight(t) {
            return At.apply(ne(this), arguments);
          },
          reverse: function reverse() {
            for (var t, e = ne(this).length, n = Math.floor(e / 2), r = 0; r < n;) {
              t = this[r], this[r++] = this[--e], this[e] = t;
            }

            return this;
          },
          some: function some(t) {
            return gt(ne(this), t, arguments.length > 1 ? arguments[1] : void 0);
          },
          sort: function sort(t) {
            return Ft.call(ne(this), t);
          },
          subarray: function subarray(t, e) {
            var n = ne(this),
                r = n.length,
                o = b(t, r);
            return new (W(n, n[qt]))(n.buffer, n.byteOffset + o * n.BYTES_PER_ELEMENT, y((void 0 === e ? r : b(e, r)) - o));
          }
        },
            ve = function ve(t, e) {
          return oe(this, It.call(ne(this), t, e));
        },
            ye = function ye(t) {
          ne(this);
          var e = ee(arguments[1], 1),
              n = this.length,
              r = P(t),
              o = y(r.length),
              i = 0;
          if (o + e > n) throw at("Wrong length!");

          for (; i < o;) {
            this[e + i] = r[i++];
          }
        },
            ge = {
          entries: function entries() {
            return Pt.call(ne(this));
          },
          keys: function keys() {
            return Tt.call(ne(this));
          },
          values: function values() {
            return St.call(ne(this));
          }
        },
            be = function be(t, e) {
          return T(t) && t[Zt] && "symbol" != _typeof(e) && e in t && String(+e) == String(e);
        },
            _e = function _e(t, e) {
          return be(t, e = O(e, !0)) ? u(2, t[e]) : it(t, e);
        },
            we = function we(t, e, n) {
          return !(be(t, e = O(e, !0)) && T(n) && C(n, "value")) || C(n, "get") || C(n, "set") || n.configurable || C(n, "writable") && !n.writable || C(n, "enumerable") && !n.enumerable ? ot(t, e, n) : (t[e] = n.value, t);
        };

        Gt || (et.f = _e, tt.f = we), r(r.S + r.F * !Gt, "Object", {
          getOwnPropertyDescriptor: _e,
          defineProperty: we
        }), n(function () {
          Dt.call({});
        }) && (Dt = Bt = function Bt() {
          return Rt.call(this);
        });
        var xe = d({}, pe);
        d(xe, ge), f(xe, Vt, ge.values), d(xe, {
          slice: ve,
          set: ye,
          constructor: function constructor() {},
          toString: Dt,
          toLocaleString: fe
        }), ae(xe, "buffer", "b"), ae(xe, "byteOffset", "o"), ae(xe, "byteLength", "l"), ae(xe, "length", "e"), ot(xe, Ht, {
          get: function get() {
            return this[Zt];
          }
        }), t.exports = function (t, i, a, c) {
          var u = t + ((c = !!c) ? "Clamped" : "") + "Array",
              l = "get" + t,
              p = "set" + t,
              h = e[u],
              d = h || {},
              v = h && A(h),
              g = !h || !o.ABV,
              b = {},
              _ = h && h.prototype,
              w = function w(t, e) {
            ot(t, e, {
              get: function get() {
                return function (t, e) {
                  var n = t._d;
                  return n.v[l](e * i + n.o, Qt);
                }(this, e);
              },
              set: function set(t) {
                return function (t, e, n) {
                  var r = t._d;
                  c && (n = (n = Math.round(n)) < 0 ? 0 : n > 255 ? 255 : 255 & n), r.v[p](e * i + r.o, n, Qt);
                }(this, e, t);
              },
              enumerable: !0
            });
          };

          g ? (h = a(function (t, e, n, r) {
            s(t, h, u, "_d");
            var o,
                a,
                c,
                l,
                p = 0,
                d = 0;

            if (T(e)) {
              if (!(e instanceof lt || "ArrayBuffer" == (l = j(e)) || "SharedArrayBuffer" == l)) return Zt in e ? ie(h, e) : se.call(h, e);
              o = e, d = ee(n, i);
              var v = e.byteLength;

              if (void 0 === r) {
                if (v % i) throw at("Wrong length!");
                if ((a = v - d) < 0) throw at("Wrong length!");
              } else if ((a = y(r) * i) + d > v) throw at("Wrong length!");

              c = a / i;
            } else c = m(e), o = new lt(a = c * i);

            for (f(t, "_d", {
              b: o,
              o: d,
              l: a,
              e: c,
              v: new ft(o)
            }); p < c;) {
              w(t, p++);
            }
          }), _ = h.prototype = z(xe), f(_, "constructor", h)) : n(function () {
            h(1);
          }) && n(function () {
            new h(-1);
          }) && $(function (t) {
            new h(), new h(null), new h(1.5), new h(t);
          }, !0) || (h = a(function (t, e, n, r) {
            var o;
            return s(t, h, u), T(e) ? e instanceof lt || "ArrayBuffer" == (o = j(e)) || "SharedArrayBuffer" == o ? void 0 !== r ? new d(e, ee(n, i), r) : void 0 !== n ? new d(e, ee(n, i)) : new d(e) : Zt in e ? ie(h, e) : se.call(h, e) : new d(m(e));
          }), yt(v !== Function.prototype ? R(d).concat(R(v)) : R(d), function (t) {
            t in h || f(h, t, d[t]);
          }), h.prototype = _, _.constructor = h);
          var x = _[Vt],
              O = !!x && ("values" == x.name || void 0 == x.name),
              E = ge.values;
          f(h, Ut, !0), f(_, Zt, u), f(_, $t, !0), f(_, qt, h), (c ? new h(1)[Ht] == u : Ht in _) || ot(_, Ht, {
            get: function get() {
              return u;
            }
          }), b[u] = h, r(r.G + r.W + r.F * (h != d), b), r(r.S, u, {
            BYTES_PER_ELEMENT: i
          }), r(r.S + r.F * n(function () {
            d.of.call(h, 1);
          }), u, {
            from: se,
            of: ce
          }), "BYTES_PER_ELEMENT" in _ || f(_, "BYTES_PER_ELEMENT", i), r(r.P, u, pe), X(u), r(r.P + r.F * te, u, {
            set: ye
          }), r(r.P + r.F * !O, u, ge), _.toString != Dt && (_.toString = Dt), r(r.P + r.F * n(function () {
            new h(1).slice();
          }), u, {
            slice: ve
          }), r(r.P + r.F * (n(function () {
            return [1, 2].toLocaleString() != new h([1, 2]).toLocaleString();
          }) || !n(function () {
            _.toLocaleString.call([1, 2]);
          })), u, {
            toLocaleString: fe
          }), Y[u] = O ? x : E, O || f(_, Vt, E);
        };
      } else t.exports = function () {};
    });

    ge("Int8", 1, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    }), ge("Uint8", 1, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    }), ge("Uint8", 1, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    }, !0), ge("Int16", 2, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    }), ge("Uint16", 2, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    }), ge("Int32", 4, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    }), ge("Uint32", 4, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    }), ge("Float32", 4, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    }), ge("Float64", 8, function (t) {
      return function (e, n, r) {
        return t(this, e, n, r);
      };
    });

    var be = function be(t, e, n, r) {
      try {
        return r ? e(f(n)[0], n[1]) : e(n);
      } catch (e) {
        var o = t["return"];
        throw void 0 !== o && f(o.call(t)), e;
      }
    },
        _e = s(function (t) {
      var e = {},
          n = {},
          r = t.exports = function (t, r, o, i, a) {
        var s,
            c,
            u,
            l,
            p = a ? function () {
          return t;
        } : Yt(t),
            h = k(o, i, r ? 2 : 1),
            d = 0;
        if ("function" != typeof p) throw TypeError(t + " is not iterable!");

        if (Nt(p)) {
          for (s = K(t.length); s > d; d++) {
            if ((l = r ? h(f(c = t[d])[0], c[1]) : h(t[d])) === e || l === n) return l;
          }
        } else for (u = p.call(t); !(c = u.next()).done;) {
          if ((l = be(u, h, c.value, r)) === e || l === n) return l;
        }
      };

      r.BREAK = e, r.RETURN = n;
    }),
        we = s(function (t) {
      var e = S("meta"),
          n = _.f,
          r = 0,
          o = Object.isExtensible || function () {
        return !0;
      },
          i = !p(function () {
        return o(Object.preventExtensions({}));
      }),
          a = function a(t) {
        n(t, e, {
          value: {
            i: "O" + ++r,
            w: {}
          }
        });
      },
          s = t.exports = {
        KEY: e,
        NEED: !1,
        fastKey: function fastKey(t, n) {
          if (!l(t)) return "symbol" == _typeof(t) ? t : ("string" == typeof t ? "S" : "P") + t;

          if (!E(t, e)) {
            if (!o(t)) return "F";
            if (!n) return "E";
            a(t);
          }

          return t[e].i;
        },
        getWeak: function getWeak(t, n) {
          if (!E(t, e)) {
            if (!o(t)) return !0;
            if (!n) return !1;
            a(t);
          }

          return t[e].w;
        },
        onFreeze: function onFreeze(t) {
          return i && s.NEED && o(t) && !E(t, e) && a(t), t;
        }
      };
    }),
        xe = (we.KEY, we.NEED, we.fastKey, we.getWeak, we.onFreeze, function (t, e) {
      if (!l(t) || t._t !== e) throw TypeError("Incompatible receiver, " + e + " required!");
      return t;
    }),
        Oe = _.f,
        Ee = we.fastKey,
        Ce = h ? "_s" : "size",
        je = function je(t, e) {
      var n,
          r = Ee(e);
      if ("F" !== r) return t._i[r];

      for (n = t._f; n; n = n.n) {
        if (n.k == e) return n;
      }
    },
        Se = {
      getConstructor: function getConstructor(t, e, n, r) {
        var o = t(function (t, i) {
          H(t, o, e, "_i"), t._t = e, t._i = Wt(null), t._f = void 0, t._l = void 0, t[Ce] = 0, void 0 != i && _e(i, n, t[r], t);
        });
        return V(o.prototype, {
          clear: function clear() {
            for (var t = xe(this, e), n = t._i, r = t._f; r; r = r.n) {
              r.r = !0, r.p && (r.p = r.p.n = void 0), delete n[r.i];
            }

            t._f = t._l = void 0, t[Ce] = 0;
          },
          "delete": function _delete(t) {
            var n = xe(this, e),
                r = je(n, t);

            if (r) {
              var o = r.n,
                  i = r.p;
              delete n._i[r.i], r.r = !0, i && (i.n = o), o && (o.p = i), n._f == r && (n._f = o), n._l == r && (n._l = i), n[Ce]--;
            }

            return !!r;
          },
          forEach: function forEach(t) {
            xe(this, e);

            for (var n, r = k(t, arguments.length > 1 ? arguments[1] : void 0, 3); n = n ? n.n : this._f;) {
              for (r(n.v, n.k, this); n && n.r;) {
                n = n.p;
              }
            }
          },
          has: function has(t) {
            return !!je(xe(this, e), t);
          }
        }), h && Oe(o.prototype, "size", {
          get: function get() {
            return xe(this, e)[Ce];
          }
        }), o;
      },
      def: function def(t, e, n) {
        var r,
            o,
            i = je(t, e);
        return i ? i.v = n : (t._l = i = {
          i: o = Ee(e, !0),
          k: e,
          v: n,
          p: r = t._l,
          n: void 0,
          r: !1
        }, t._f || (t._f = i), r && (r.n = i), t[Ce]++, "F" !== o && (t._i[o] = i)), t;
      },
      getEntry: je,
      setStrong: function setStrong(t, e, n) {
        ue(t, e, function (t, n) {
          this._t = xe(t, e), this._k = n, this._l = void 0;
        }, function () {
          for (var t = this._k, e = this._l; e && e.r;) {
            e = e.p;
          }

          return this._t && (this._l = e = e ? e.n : this._t._f) ? re(0, "keys" == t ? e.k : "values" == t ? e.v : [e.k, e.v]) : (this._t = void 0, re(1));
        }, n ? "entries" : "values", !n, !0), Ot(e);
      }
    },
        Te = function Te(t, e) {
      if (f(t), !l(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
    },
        Pe = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, n) {
        try {
          (n = k(Function.call, me.f(Object.prototype, "__proto__").set, 2))(t, []), e = !(t instanceof Array);
        } catch (t) {
          e = !0;
        }

        return function (t, r) {
          return Te(t, r), e ? t.__proto__ = r : n(t, r), t;
        };
      }({}, !1) : void 0),
      check: Te
    },
        ke = Pe.set,
        Me = function Me(t, e, n, r, o, i) {
      var a = c[t],
          s = a,
          u = o ? "set" : "add",
          f = s && s.prototype,
          h = {},
          d = function d(t) {
        var e = f[t];
        T(f, t, "delete" == t ? function (t) {
          return !(i && !l(t)) && e.call(this, 0 === t ? 0 : t);
        } : "has" == t ? function (t) {
          return !(i && !l(t)) && e.call(this, 0 === t ? 0 : t);
        } : "get" == t ? function (t) {
          return i && !l(t) ? void 0 : e.call(this, 0 === t ? 0 : t);
        } : "add" == t ? function (t) {
          return e.call(this, 0 === t ? 0 : t), this;
        } : function (t, n) {
          return e.call(this, 0 === t ? 0 : t, n), this;
        });
      };

      if ("function" == typeof s && (i || f.forEach && !p(function () {
        new s().entries().next();
      }))) {
        var v = new s(),
            y = v[u](i ? {} : -0, 1) != v,
            m = p(function () {
          v.has(1);
        }),
            g = he(function (t) {
          new s(t);
        }),
            b = !i && p(function () {
          for (var t = new s(), e = 5; e--;) {
            t[u](e, e);
          }

          return !t.has(-0);
        });
        g || ((s = e(function (e, n) {
          H(e, s, t);

          var r = function (t, e, n) {
            var r,
                o = e.constructor;
            return o !== n && "function" == typeof o && (r = o.prototype) !== n.prototype && l(r) && ke && ke(t, r), t;
          }(new a(), e, s);

          return void 0 != n && _e(n, o, r[u], r), r;
        })).prototype = f, f.constructor = s), (m || b) && (d("delete"), d("has"), o && d("get")), (b || y) && d(u), i && f.clear && delete f.clear;
      } else s = r.getConstructor(e, t, o, u), V(s.prototype, n), we.NEED = !0;

      return gt(s, t), h[t] = s, L(L.G + L.W + L.F * (s != a), h), i || r.setStrong(s, t, o), s;
    },
        ze = (Me("Map", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, {
      get: function get(t) {
        var e = Se.getEntry(xe(this, "Map"), t);
        return e && e.v;
      },
      set: function set(t, e) {
        return Se.def(xe(this, "Map"), 0 === t ? 0 : t, e);
      }
    }, Se, !0), Me("Set", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, {
      add: function add(t) {
        return Se.def(xe(this, "Set"), t = 0 === t ? 0 : t, t);
      }
    }, Se), {
      f: Object.getOwnPropertySymbols
    }),
        Le = Object.assign,
        Ae = !Le || p(function () {
      var t = {},
          e = {},
          n = Symbol(),
          r = "abcdefghijklmnopqrst";
      return t[n] = 7, r.split("").forEach(function (t) {
        e[t] = t;
      }), 7 != Le({}, t)[n] || Object.keys(Le({}, e)).join("") != r;
    }) ? function (t, e) {
      for (var n = ht(t), r = arguments.length, o = 1, i = ze.f, a = ve.f; r > o;) {
        for (var s, c = X(arguments[o++]), u = i ? Ft(c).concat(i(c)) : Ft(c), l = u.length, f = 0; l > f;) {
          a.call(c, s = u[f++]) && (n[s] = c[s]);
        }
      }

      return n;
    } : Le,
        Re = we.getWeak,
        Ne = Jt(5),
        Fe = Jt(6),
        Ie = 0,
        De = function De(t) {
      return t._l || (t._l = new Be());
    },
        Be = function Be() {
      this.a = [];
    },
        Ve = function Ve(t, e) {
      return Ne(t.a, function (t) {
        return t[0] === e;
      });
    };

    Be.prototype = {
      get: function get(t) {
        var e = Ve(this, t);
        if (e) return e[1];
      },
      has: function has(t) {
        return !!Ve(this, t);
      },
      set: function set(t, e) {
        var n = Ve(this, t);
        n ? n[1] = e : this.a.push([t, e]);
      },
      "delete": function _delete(t) {
        var e = Fe(this.a, function (e) {
          return e[0] === t;
        });
        return ~e && this.a.splice(e, 1), !!~e;
      }
    };
    var He = {
      getConstructor: function getConstructor(t, e, n, r) {
        var o = t(function (t, i) {
          H(t, o, e, "_i"), t._t = e, t._i = Ie++, t._l = void 0, void 0 != i && _e(i, n, t[r], t);
        });
        return V(o.prototype, {
          "delete": function _delete(t) {
            if (!l(t)) return !1;
            var n = Re(t);
            return !0 === n ? De(xe(this, e))["delete"](t) : n && E(n, this._i) && delete n[this._i];
          },
          has: function has(t) {
            if (!l(t)) return !1;
            var n = Re(t);
            return !0 === n ? De(xe(this, e)).has(t) : n && E(n, this._i);
          }
        }), o;
      },
      def: function def(t, e, n) {
        var r = Re(f(e), !0);
        return !0 === r ? De(t).set(e, n) : r[t._i] = n, t;
      },
      ufstore: De
    };
    s(function (t) {
      var e,
          n = Jt(0),
          r = we.getWeak,
          o = Object.isExtensible,
          i = He.ufstore,
          a = {},
          s = function s(t) {
        return function () {
          return t(this, arguments.length > 0 ? arguments[0] : void 0);
        };
      },
          c = {
        get: function get(t) {
          if (l(t)) {
            var e = r(t);
            return !0 === e ? i(xe(this, "WeakMap")).get(t) : e ? e[this._i] : void 0;
          }
        },
        set: function set(t, e) {
          return He.def(xe(this, "WeakMap"), t, e);
        }
      },
          u = t.exports = Me("WeakMap", s, c, He, !0, !0);

      p(function () {
        return 7 != new u().set((Object.freeze || Object)(a), 7).get(a);
      }) && (e = He.getConstructor(s, "WeakMap"), Ae(e.prototype, c), we.NEED = !0, n(["delete", "has", "get", "set"], function (t) {
        var n = u.prototype,
            r = n[t];
        T(n, t, function (n, i) {
          if (l(n) && !o(n)) {
            this._f || (this._f = new e());

            var a = this._f[t](n, i);

            return "set" == t ? this : a;
          }

          return r.call(this, n, i);
        });
      }));
    });
    Me("WeakSet", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, {
      add: function add(t) {
        return He.def(xe(this, "WeakSet"), t, !0);
      }
    }, He, !1, !0);
    var Ue = (c.Reflect || {}).apply,
        We = Function.apply;
    L(L.S + L.F * !p(function () {
      Ue(function () {});
    }), "Reflect", {
      apply: function apply(t, e, n) {
        var r = P(t),
            o = f(n);
        return Ue ? Ue(r, e, o) : We.call(r, e, o);
      }
    });

    var qe = function qe(t, e, n) {
      var r = void 0 === n;

      switch (e.length) {
        case 0:
          return r ? t() : t.call(n);

        case 1:
          return r ? t(e[0]) : t.call(n, e[0]);

        case 2:
          return r ? t(e[0], e[1]) : t.call(n, e[0], e[1]);

        case 3:
          return r ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]);

        case 4:
          return r ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3]);
      }

      return t.apply(n, e);
    },
        Ge = [].slice,
        Ke = {},
        Ze = Function.bind || function (t) {
      var e = P(this),
          n = Ge.call(arguments, 1),
          r = function r() {
        var o = n.concat(Ge.call(arguments));
        return this instanceof r ? function (t, e, n) {
          if (!(e in Ke)) {
            for (var r = [], o = 0; o < e; o++) {
              r[o] = "a[" + o + "]";
            }

            Ke[e] = Function("F,a", "return new F(" + r.join(",") + ")");
          }

          return Ke[e](t, n);
        }(e, o.length, o) : qe(e, o, t);
      };

      return l(e.prototype) && (r.prototype = e.prototype), r;
    },
        Ye = (c.Reflect || {}).construct,
        $e = p(function () {
      function t() {}

      return !(Ye(function () {}, [], t) instanceof t);
    }),
        Xe = !p(function () {
      Ye(function () {});
    });

    L(L.S + L.F * ($e || Xe), "Reflect", {
      construct: function construct(t, e) {
        P(t), f(e);
        var n = arguments.length < 3 ? t : P(arguments[2]);
        if (Xe && !$e) return Ye(t, e, n);

        if (t == n) {
          switch (e.length) {
            case 0:
              return new t();

            case 1:
              return new t(e[0]);

            case 2:
              return new t(e[0], e[1]);

            case 3:
              return new t(e[0], e[1], e[2]);

            case 4:
              return new t(e[0], e[1], e[2], e[3]);
          }

          var r = [null];
          return r.push.apply(r, e), new (Ze.apply(t, r))();
        }

        var o = n.prototype,
            i = Wt(l(o) ? o : Object.prototype),
            a = Function.apply.call(t, i, e);
        return l(a) ? a : i;
      }
    }), L(L.S + L.F * p(function () {
      Reflect.defineProperty(_.f({}, 1, {
        value: 1
      }), 1, {
        value: 2
      });
    }), "Reflect", {
      defineProperty: function defineProperty(t, e, n) {
        f(t), e = g(e, !0), f(n);

        try {
          return _.f(t, e, n), !0;
        } catch (t) {
          return !1;
        }
      }
    });
    var Qe = me.f;
    L(L.S, "Reflect", {
      deleteProperty: function deleteProperty(t, e) {
        var n = Qe(f(t), e);
        return !(n && !n.configurable) && delete t[e];
      }
    }), L(L.S, "Reflect", {
      get: function t(e, n) {
        var r,
            o,
            i = arguments.length < 3 ? e : arguments[2];
        return f(e) === i ? e[n] : (r = me.f(e, n)) ? E(r, "value") ? r.value : void 0 !== r.get ? r.get.call(i) : void 0 : l(o = Kt(e)) ? t(o, n, i) : void 0;
      }
    }), L(L.S, "Reflect", {
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, e) {
        return me.f(f(t), e);
      }
    }), L(L.S, "Reflect", {
      getPrototypeOf: function getPrototypeOf(t) {
        return Kt(f(t));
      }
    }), L(L.S, "Reflect", {
      has: function has(t, e) {
        return e in t;
      }
    });
    var Je = Object.isExtensible;
    L(L.S, "Reflect", {
      isExtensible: function isExtensible(t) {
        return f(t), !Je || Je(t);
      }
    });

    var tn = c.Reflect,
        en = tn && tn.ownKeys || function (t) {
      var e = pt.f(f(t)),
          n = ze.f;
      return n ? e.concat(n(t)) : e;
    };

    L(L.S, "Reflect", {
      ownKeys: en
    });
    var nn = Object.preventExtensions;
    L(L.S, "Reflect", {
      preventExtensions: function preventExtensions(t) {
        f(t);

        try {
          return nn && nn(t), !0;
        } catch (t) {
          return !1;
        }
      }
    }), L(L.S, "Reflect", {
      set: function t(e, n, r) {
        var o,
            i,
            a = arguments.length < 4 ? e : arguments[3],
            s = me.f(f(e), n);

        if (!s) {
          if (l(i = Kt(e))) return t(i, n, r, a);
          s = w(0);
        }

        if (E(s, "value")) {
          if (!1 === s.writable || !l(a)) return !1;

          if (o = me.f(a, n)) {
            if (o.get || o.set || !1 === o.writable) return !1;
            o.value = r, _.f(a, n, o);
          } else _.f(a, n, w(0, r));

          return !0;
        }

        return void 0 !== s.set && (s.set.call(a, r), !0);
      }
    }), Pe && L(L.S, "Reflect", {
      setPrototypeOf: function setPrototypeOf(t, e) {
        Pe.check(t, e);

        try {
          return Pe.set(t, e), !0;
        } catch (t) {
          return !1;
        }
      }
    });

    var rn,
        on,
        an,
        sn = c.process,
        cn = c.setImmediate,
        un = c.clearImmediate,
        ln = c.MessageChannel,
        fn = c.Dispatch,
        pn = 0,
        hn = {},
        dn = function dn() {
      var t = +this;

      if (hn.hasOwnProperty(t)) {
        var e = hn[t];
        delete hn[t], e();
      }
    },
        vn = function vn(t) {
      dn.call(t.data);
    };

    cn && un || (cn = function cn(t) {
      for (var e = [], n = 1; arguments.length > n;) {
        e.push(arguments[n++]);
      }

      return hn[++pn] = function () {
        qe("function" == typeof t ? t : Function(t), e);
      }, rn(pn), pn;
    }, un = function un(t) {
      delete hn[t];
    }, "process" == $(sn) ? rn = function rn(t) {
      sn.nextTick(k(dn, t, 1));
    } : fn && fn.now ? rn = function rn(t) {
      fn.now(k(dn, t, 1));
    } : ln ? (an = (on = new ln()).port2, on.port1.onmessage = vn, rn = k(an.postMessage, an, 1)) : c.addEventListener && "function" == typeof postMessage && !c.importScripts ? (rn = function rn(t) {
      c.postMessage(t + "", "*");
    }, c.addEventListener("message", vn, !1)) : rn = "onreadystatechange" in y("script") ? function (t) {
      Bt.appendChild(y("script")).onreadystatechange = function () {
        Bt.removeChild(this), dn.call(t);
      };
    } : function (t) {
      setTimeout(k(dn, t, 1), 0);
    });
    var yn = {
      set: cn,
      clear: un
    },
        mn = yn.set,
        gn = c.MutationObserver || c.WebKitMutationObserver,
        bn = c.process,
        _n = c.Promise,
        wn = "process" == $(bn);

    var xn,
        On,
        En,
        Cn,
        jn = {
      f: function f(t) {
        return new function (t) {
          var e, n;
          this.promise = new t(function (t, r) {
            if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");
            e = t, n = r;
          }), this.resolve = P(e), this.reject = P(n);
        }(t);
      }
    },
        Sn = function Sn(t) {
      try {
        return {
          e: !1,
          v: t()
        };
      } catch (t) {
        return {
          e: !0,
          v: t
        };
      }
    },
        Tn = c.navigator,
        Pn = Tn && Tn.userAgent || "",
        kn = yn.set,
        Mn = function () {
      var t,
          e,
          n,
          r = function r() {
        var r, o;

        for (wn && (r = bn.domain) && r.exit(); t;) {
          o = t.fn, t = t.next;

          try {
            o();
          } catch (r) {
            throw t ? n() : e = void 0, r;
          }
        }

        e = void 0, r && r.enter();
      };

      if (wn) n = function n() {
        bn.nextTick(r);
      };else if (!gn || c.navigator && c.navigator.standalone) {
        if (_n && _n.resolve) {
          var o = _n.resolve(void 0);

          n = function n() {
            o.then(r);
          };
        } else n = function n() {
          mn.call(c, r);
        };
      } else {
        var i = !0,
            a = document.createTextNode("");
        new gn(r).observe(a, {
          characterData: !0
        }), n = function n() {
          a.data = i = !i;
        };
      }
      return function (r) {
        var o = {
          fn: r,
          next: void 0
        };
        e && (e.next = o), t || (t = o, n()), e = o;
      };
    }(),
        zn = c.TypeError,
        Ln = c.process,
        An = Ln && Ln.versions,
        Rn = An && An.v8 || "",
        _Nn = c.Promise,
        Fn = "process" == zt(Ln),
        In = function In() {},
        Dn = On = jn.f,
        Bn = !!function () {
      try {
        var t = _Nn.resolve(1),
            e = (t.constructor = {})[vt("species")] = function (t) {
          t(In, In);
        };

        return (Fn || "function" == typeof PromiseRejectionEvent) && t.then(In) instanceof e && 0 !== Rn.indexOf("6.6") && -1 === Pn.indexOf("Chrome/66");
      } catch (t) {}
    }(),
        Vn = function Vn(t) {
      var e;
      return !(!l(t) || "function" != typeof (e = t.then)) && e;
    },
        Hn = function Hn(t, e) {
      if (!t._n) {
        t._n = !0;
        var n = t._c;
        Mn(function () {
          for (var r = t._v, o = 1 == t._s, i = 0, a = function a(e) {
            var n,
                i,
                a,
                s = o ? e.ok : e.fail,
                c = e.resolve,
                u = e.reject,
                l = e.domain;

            try {
              s ? (o || (2 == t._h && qn(t), t._h = 1), !0 === s ? n = r : (l && l.enter(), n = s(r), l && (l.exit(), a = !0)), n === e.promise ? u(zn("Promise-chain cycle")) : (i = Vn(n)) ? i.call(n, c, u) : c(n)) : u(r);
            } catch (t) {
              l && !a && l.exit(), u(t);
            }
          }; n.length > i;) {
            a(n[i++]);
          }

          t._c = [], t._n = !1, e && !t._h && Un(t);
        });
      }
    },
        Un = function Un(t) {
      kn.call(c, function () {
        var e,
            n,
            r,
            o = t._v,
            i = Wn(t);
        if (i && (e = Sn(function () {
          Fn ? Ln.emit("unhandledRejection", o, t) : (n = c.onunhandledrejection) ? n({
            promise: t,
            reason: o
          }) : (r = c.console) && r.error && r.error("Unhandled promise rejection", o);
        }), t._h = Fn || Wn(t) ? 2 : 1), t._a = void 0, i && e.e) throw e.v;
      });
    },
        Wn = function Wn(t) {
      return 1 !== t._h && 0 === (t._a || t._c).length;
    },
        qn = function qn(t) {
      kn.call(c, function () {
        var e;
        Fn ? Ln.emit("rejectionHandled", t) : (e = c.onrejectionhandled) && e({
          promise: t,
          reason: t._v
        });
      });
    },
        Gn = function Gn(t) {
      var e = this;
      e._d || (e._d = !0, (e = e._w || e)._v = t, e._s = 2, e._a || (e._a = e._c.slice()), Hn(e, !0));
    },
        Kn = function Kn(t) {
      var e,
          n = this;

      if (!n._d) {
        n._d = !0, n = n._w || n;

        try {
          if (n === t) throw zn("Promise can't be resolved itself");
          (e = Vn(t)) ? Mn(function () {
            var r = {
              _w: n,
              _d: !1
            };

            try {
              e.call(t, k(Kn, r, 1), k(Gn, r, 1));
            } catch (t) {
              Gn.call(r, t);
            }
          }) : (n._v = t, n._s = 1, Hn(n, !1));
        } catch (t) {
          Gn.call({
            _w: n,
            _d: !1
          }, t);
        }
      }
    };

    Bn || (_Nn = function Nn(t) {
      H(this, _Nn, "Promise", "_h"), P(t), xn.call(this);

      try {
        t(k(Kn, this, 1), k(Gn, this, 1));
      } catch (t) {
        Gn.call(this, t);
      }
    }, (xn = function xn(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }).prototype = V(_Nn.prototype, {
      then: function then(t, e) {
        var n = Dn(wt(this, _Nn));
        return n.ok = "function" != typeof t || t, n.fail = "function" == typeof e && e, n.domain = Fn ? Ln.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && Hn(this, !1), n.promise;
      },
      "catch": function _catch(t) {
        return this.then(void 0, t);
      }
    }), En = function En() {
      var t = new xn();
      this.promise = t, this.resolve = k(Kn, t, 1), this.reject = k(Gn, t, 1);
    }, jn.f = Dn = function Dn(t) {
      return t === _Nn || t === Cn ? new En(t) : On(t);
    }), L(L.G + L.W + L.F * !Bn, {
      Promise: _Nn
    }), gt(_Nn, "Promise"), Ot("Promise"), Cn = u.Promise, L(L.S + L.F * !Bn, "Promise", {
      reject: function reject(t) {
        var e = Dn(this);
        return (0, e.reject)(t), e.promise;
      }
    }), L(L.S + L.F * !Bn, "Promise", {
      resolve: function resolve(t) {
        return function (t, e) {
          if (f(t), l(e) && e.constructor === t) return e;
          var n = jn.f(t);
          return (0, n.resolve)(e), n.promise;
        }(this, t);
      }
    }), L(L.S + L.F * !(Bn && he(function (t) {
      _Nn.all(t)["catch"](In);
    })), "Promise", {
      all: function all(t) {
        var e = this,
            n = Dn(e),
            r = n.resolve,
            o = n.reject,
            i = Sn(function () {
          var n = [],
              i = 0,
              a = 1;
          _e(t, !1, function (t) {
            var s = i++,
                c = !1;
            n.push(void 0), a++, e.resolve(t).then(function (t) {
              c || (c = !0, n[s] = t, --a || r(n));
            }, o);
          }), --a || r(n);
        });
        return i.e && o(i.v), n.promise;
      },
      race: function race(t) {
        var e = this,
            n = Dn(e),
            r = n.reject,
            o = Sn(function () {
          _e(t, !1, function (t) {
            e.resolve(t).then(n.resolve, r);
          });
        });
        return o.e && r(o.v), n.promise;
      }
    });

    var Zn = {
      f: vt
    },
        Yn = _.f,
        $n = function $n(t) {
      var e = u.Symbol || (u.Symbol = c.Symbol || {});
      "_" == t.charAt(0) || t in e || Yn(e, t, {
        value: Zn.f(t)
      });
    },
        Xn = pt.f,
        Qn = {}.toString,
        Jn = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
        tr = {
      f: function f(t) {
        return Jn && "[object Window]" == Qn.call(t) ? function (t) {
          try {
            return Xn(t);
          } catch (t) {
            return Jn.slice();
          }
        }(t) : Xn(J(t));
      }
    },
        er = we.KEY,
        nr = me.f,
        rr = _.f,
        or = tr.f,
        _ir = c.Symbol,
        ar = c.JSON,
        sr = ar && ar.stringify,
        cr = vt("_hidden"),
        ur = vt("toPrimitive"),
        lr = {}.propertyIsEnumerable,
        fr = ot("symbol-registry"),
        pr = ot("symbols"),
        hr = ot("op-symbols"),
        dr = Object.prototype,
        vr = "function" == typeof _ir,
        yr = c.QObject,
        mr = !yr || !yr.prototype || !yr.prototype.findChild,
        gr = h && p(function () {
      return 7 != Wt(rr({}, "a", {
        get: function get() {
          return rr(this, "a", {
            value: 7
          }).a;
        }
      })).a;
    }) ? function (t, e, n) {
      var r = nr(dr, e);
      r && delete dr[e], rr(t, e, n), r && t !== dr && rr(dr, e, r);
    } : rr,
        br = function br(t) {
      var e = pr[t] = Wt(_ir.prototype);
      return e._k = t, e;
    },
        _r = vr && "symbol" == _typeof(_ir.iterator) ? function (t) {
      return "symbol" == _typeof(t);
    } : function (t) {
      return t instanceof _ir;
    },
        wr = function wr(t, e, n) {
      return t === dr && wr(hr, e, n), f(t), e = g(e, !0), f(n), E(pr, e) ? (n.enumerable ? (E(t, cr) && t[cr][e] && (t[cr][e] = !1), n = Wt(n, {
        enumerable: w(0, !1)
      })) : (E(t, cr) || rr(t, cr, w(1, {})), t[cr][e] = !0), gr(t, e, n)) : rr(t, e, n);
    },
        xr = function xr(t, e) {
      f(t);

      for (var n, r = function (t) {
        var e = Ft(t),
            n = ze.f;
        if (n) for (var r, o = n(t), i = ve.f, a = 0; o.length > a;) {
          i.call(t, r = o[a++]) && e.push(r);
        }
        return e;
      }(e = J(e)), o = 0, i = r.length; i > o;) {
        wr(t, n = r[o++], e[n]);
      }

      return t;
    },
        Or = function Or(t) {
      var e = lr.call(this, t = g(t, !0));
      return !(this === dr && E(pr, t) && !E(hr, t)) && (!(e || !E(this, t) || !E(pr, t) || E(this, cr) && this[cr][t]) || e);
    },
        Er = function Er(t, e) {
      if (t = J(t), e = g(e, !0), t !== dr || !E(pr, e) || E(hr, e)) {
        var n = nr(t, e);
        return !n || !E(pr, e) || E(t, cr) && t[cr][e] || (n.enumerable = !0), n;
      }
    },
        Cr = function Cr(t) {
      for (var e, n = or(J(t)), r = [], o = 0; n.length > o;) {
        E(pr, e = n[o++]) || e == cr || e == er || r.push(e);
      }

      return r;
    },
        jr = function jr(t) {
      for (var e, n = t === dr, r = or(n ? hr : J(t)), o = [], i = 0; r.length > i;) {
        !E(pr, e = r[i++]) || n && !E(dr, e) || o.push(pr[e]);
      }

      return o;
    };

    vr || (T((_ir = function ir() {
      if (this instanceof _ir) throw TypeError("Symbol is not a constructor!");

      var t = S(arguments.length > 0 ? arguments[0] : void 0),
          e = function e(n) {
        this === dr && e.call(hr, n), E(this, cr) && E(this[cr], t) && (this[cr][t] = !1), gr(this, t, w(1, n));
      };

      return h && mr && gr(dr, t, {
        configurable: !0,
        set: e
      }), br(t);
    }).prototype, "toString", function () {
      return this._k;
    }), me.f = Er, _.f = wr, pt.f = tr.f = Cr, ve.f = Or, ze.f = jr, h && T(dr, "propertyIsEnumerable", Or, !0), Zn.f = function (t) {
      return br(vt(t));
    }), L(L.G + L.W + L.F * !vr, {
      Symbol: _ir
    });

    for (var Sr = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), Tr = 0; Sr.length > Tr;) {
      vt(Sr[Tr++]);
    }

    for (var Pr = Ft(vt.store), kr = 0; Pr.length > kr;) {
      $n(Pr[kr++]);
    }

    L(L.S + L.F * !vr, "Symbol", {
      "for": function _for(t) {
        return E(fr, t += "") ? fr[t] : fr[t] = _ir(t);
      },
      keyFor: function keyFor(t) {
        if (!_r(t)) throw TypeError(t + " is not a symbol!");

        for (var e in fr) {
          if (fr[e] === t) return e;
        }
      },
      useSetter: function useSetter() {
        mr = !0;
      },
      useSimple: function useSimple() {
        mr = !1;
      }
    }), L(L.S + L.F * !vr, "Object", {
      create: function create(t, e) {
        return void 0 === e ? Wt(t) : xr(Wt(t), e);
      },
      defineProperty: wr,
      defineProperties: xr,
      getOwnPropertyDescriptor: Er,
      getOwnPropertyNames: Cr,
      getOwnPropertySymbols: jr
    }), ar && L(L.S + L.F * (!vr || p(function () {
      var t = _ir();

      return "[null]" != sr([t]) || "{}" != sr({
        a: t
      }) || "{}" != sr(Object(t));
    })), "JSON", {
      stringify: function stringify(t) {
        for (var e, n, r = [t], o = 1; arguments.length > o;) {
          r.push(arguments[o++]);
        }

        if (n = e = r[1], (l(e) || void 0 !== t) && !_r(t)) return $t(e) || (e = function e(t, _e6) {
          if ("function" == typeof n && (_e6 = n.call(this, t, _e6)), !_r(_e6)) return _e6;
        }), r[1] = e, sr.apply(ar, r);
      }
    }), _ir.prototype[ur] || x(_ir.prototype, ur, _ir.prototype.valueOf), gt(_ir, "Symbol"), gt(Math, "Math", !0), gt(c.JSON, "JSON", !0);

    var Mr = function Mr(t, e) {
      var n = (u.Object || {})[t] || Object[t],
          r = {};
      r[t] = e(n), L(L.S + L.F * p(function () {
        n(1);
      }), "Object", r);
    },
        zr = we.onFreeze;

    Mr("freeze", function (t) {
      return function (e) {
        return t && l(e) ? t(zr(e)) : e;
      };
    });
    var Lr = we.onFreeze;
    Mr("seal", function (t) {
      return function (e) {
        return t && l(e) ? t(Lr(e)) : e;
      };
    });
    var Ar = we.onFreeze;
    Mr("preventExtensions", function (t) {
      return function (e) {
        return t && l(e) ? t(Ar(e)) : e;
      };
    }), Mr("isFrozen", function (t) {
      return function (e) {
        return !l(e) || !!t && t(e);
      };
    }), Mr("isSealed", function (t) {
      return function (e) {
        return !l(e) || !!t && t(e);
      };
    }), Mr("isExtensible", function (t) {
      return function (e) {
        return !!l(e) && (!t || t(e));
      };
    });
    var Rr = me.f;
    Mr("getOwnPropertyDescriptor", function () {
      return function (t, e) {
        return Rr(J(t), e);
      };
    }), Mr("getPrototypeOf", function () {
      return function (t) {
        return Kt(ht(t));
      };
    }), Mr("keys", function () {
      return function (t) {
        return Ft(ht(t));
      };
    }), Mr("getOwnPropertyNames", function () {
      return tr.f;
    }), L(L.S + L.F, "Object", {
      assign: Ae
    });

    var Nr = Object.is || function (t, e) {
      return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
    };

    L(L.S, "Object", {
      is: Nr
    }), L(L.S, "Object", {
      setPrototypeOf: Pe.set
    });
    var Fr = _.f,
        Ir = Function.prototype,
        Dr = /^\s*function ([^ (]*)/;
    "name" in Ir || h && Fr(Ir, "name", {
      configurable: !0,
      get: function get() {
        try {
          return ("" + this).match(Dr)[1];
        } catch (t) {
          return "";
        }
      }
    }), L(L.S, "String", {
      raw: function raw(t) {
        for (var e = J(t.raw), n = K(e.length), r = arguments.length, o = [], i = 0; n > i;) {
          o.push(String(e[i++])), i < r && o.push(String(arguments[i]));
        }

        return o.join("");
      }
    });
    var Br = String.fromCharCode,
        Vr = String.fromCodePoint;
    L(L.S + L.F * (!!Vr && 1 != Vr.length), "String", {
      fromCodePoint: function fromCodePoint(t) {
        for (var e, n = [], r = arguments.length, o = 0; r > o;) {
          if (e = +arguments[o++], nt(e, 1114111) !== e) throw RangeError(e + " is not a valid code point");
          n.push(e < 65536 ? Br(e) : Br(55296 + ((e -= 65536) >> 10), e % 1024 + 56320));
        }

        return n.join("");
      }
    });
    var Hr,
        Ur = (Hr = !1, function (t, e) {
      var n,
          r,
          o = String(Q(t)),
          i = q(e),
          a = o.length;
      return i < 0 || i >= a ? Hr ? "" : void 0 : (n = o.charCodeAt(i)) < 55296 || n > 56319 || i + 1 === a || (r = o.charCodeAt(i + 1)) < 56320 || r > 57343 ? Hr ? o.charAt(i) : n : Hr ? o.slice(i, i + 2) : r - 56320 + (n - 55296 << 10) + 65536;
    });
    L(L.P, "String", {
      codePointAt: function codePointAt(t) {
        return Ur(this, t);
      }
    });

    var Wr = function Wr(t) {
      var e = String(Q(this)),
          n = "",
          r = q(t);
      if (r < 0 || r == 1 / 0) throw RangeError("Count can't be negative");

      for (; r > 0; (r >>>= 1) && (e += e)) {
        1 & r && (n += e);
      }

      return n;
    };

    L(L.P, "String", {
      repeat: Wr
    });

    var qr = vt("match"),
        Gr = function Gr(t) {
      var e;
      return l(t) && (void 0 !== (e = t[qr]) ? !!e : "RegExp" == $(t));
    },
        Kr = function Kr(t, e, n) {
      if (Gr(e)) throw TypeError("String#" + n + " doesn't accept regex!");
      return String(Q(t));
    },
        Zr = vt("match"),
        Yr = function Yr(t) {
      var e = /./;

      try {
        "/./"[t](e);
      } catch (n) {
        try {
          return e[Zr] = !1, !"/./"[t](e);
        } catch (t) {}
      }

      return !0;
    },
        $r = "".startsWith;

    L(L.P + L.F * Yr("startsWith"), "String", {
      startsWith: function startsWith(t) {
        var e = Kr(this, t, "startsWith"),
            n = K(Math.min(arguments.length > 1 ? arguments[1] : void 0, e.length)),
            r = String(t);
        return $r ? $r.call(e, r, n) : e.slice(n, n + r.length) === r;
      }
    });
    var Xr = "".endsWith;
    L(L.P + L.F * Yr("endsWith"), "String", {
      endsWith: function endsWith(t) {
        var e = Kr(this, t, "endsWith"),
            n = arguments.length > 1 ? arguments[1] : void 0,
            r = K(e.length),
            o = void 0 === n ? r : Math.min(K(n), r),
            i = String(t);
        return Xr ? Xr.call(e, i, o) : e.slice(o - i.length, o) === i;
      }
    });
    L(L.P + L.F * Yr("includes"), "String", {
      includes: function includes(t) {
        return !!~Kr(this, t, "includes").indexOf(t, arguments.length > 1 ? arguments[1] : void 0);
      }
    });
    h && "g" != /./g.flags && _.f(RegExp.prototype, "flags", {
      configurable: !0,
      get: function get() {
        var t = f(this),
            e = "";
        return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
      }
    });

    var Qr = function Qr(t, e, n) {
      var r = vt(t),
          o = n(Q, r, ""[t]),
          i = o[0],
          a = o[1];
      p(function () {
        var e = {};
        return e[r] = function () {
          return 7;
        }, 7 != ""[t](e);
      }) && (T(String.prototype, t, i), x(RegExp.prototype, r, 2 == e ? function (t, e) {
        return a.call(t, this, e);
      } : function (t) {
        return a.call(t, this);
      }));
    };

    Qr("match", 1, function (t, e, n) {
      return [function (n) {
        var r = t(this),
            o = void 0 == n ? void 0 : n[e];
        return void 0 !== o ? o.call(n, r) : new RegExp(n)[e](String(r));
      }, n];
    }), Qr("replace", 2, function (t, e, n) {
      return [function (r, o) {
        var i = t(this),
            a = void 0 == r ? void 0 : r[e];
        return void 0 !== a ? a.call(r, i, o) : n.call(String(i), r, o);
      }, n];
    }), Qr("split", 2, function (t, e, n) {
      var r = Gr,
          o = n,
          i = [].push;

      if ("c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length) {
        var a = void 0 === /()??/.exec("")[1];

        n = function n(t, e) {
          var n = String(this);
          if (void 0 === t && 0 === e) return [];
          if (!r(t)) return o.call(n, t, e);
          var s,
              c,
              u,
              l,
              f,
              p = [],
              h = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""),
              d = 0,
              v = void 0 === e ? 4294967295 : e >>> 0,
              y = new RegExp(t.source, h + "g");

          for (a || (s = new RegExp("^" + y.source + "$(?!\\s)", h)); (c = y.exec(n)) && !((u = c.index + c[0].length) > d && (p.push(n.slice(d, c.index)), !a && c.length > 1 && c[0].replace(s, function () {
            for (f = 1; f < arguments.length - 2; f++) {
              void 0 === arguments[f] && (c[f] = void 0);
            }
          }), c.length > 1 && c.index < n.length && i.apply(p, c.slice(1)), l = c[0].length, d = u, p.length >= v));) {
            y.lastIndex === c.index && y.lastIndex++;
          }

          return d === n.length ? !l && y.test("") || p.push("") : p.push(n.slice(d)), p.length > v ? p.slice(0, v) : p;
        };
      } else "0".split(void 0, 0).length && (n = function n(t, e) {
        return void 0 === t && 0 === e ? [] : o.call(this, t, e);
      });

      return [function (r, o) {
        var i = t(this),
            a = void 0 == r ? void 0 : r[e];
        return void 0 !== a ? a.call(r, i, o) : n.call(String(i), r, o);
      }, n];
    }), Qr("search", 1, function (t, e, n) {
      return [function (n) {
        var r = t(this),
            o = void 0 == n ? void 0 : n[e];
        return void 0 !== o ? o.call(n, r) : new RegExp(n)[e](String(r));
      }, n];
    });

    var Jr = function Jr(t, e, n) {
      e in t ? _.f(t, e, w(0, n)) : t[e] = n;
    };

    L(L.S + L.F * !he(function (t) {}), "Array", {
      from: function from(t) {
        var e,
            n,
            r,
            o,
            i = ht(t),
            a = "function" == typeof this ? this : Array,
            s = arguments.length,
            c = s > 1 ? arguments[1] : void 0,
            u = void 0 !== c,
            l = 0,
            f = Yt(i);
        if (u && (c = k(c, s > 2 ? arguments[2] : void 0, 2)), void 0 == f || a == Array && Nt(f)) for (n = new a(e = K(i.length)); e > l; l++) {
          Jr(n, l, u ? c(i[l], l) : i[l]);
        } else for (o = f.call(i), n = new a(); !(r = o.next()).done; l++) {
          Jr(n, l, u ? be(o, c, [r.value, l], !0) : r.value);
        }
        return n.length = l, n;
      }
    }), L(L.S + L.F * p(function () {
      function t() {}

      return !(Array.of.call(t) instanceof t);
    }), "Array", {
      of: function of() {
        for (var t = 0, e = arguments.length, n = new ("function" == typeof this ? this : Array)(e); e > t;) {
          Jr(n, t, arguments[t++]);
        }

        return n.length = e, n;
      }
    }), L(L.P, "Array", {
      copyWithin: de
    }), ne("copyWithin");
    var to = Jt(5),
        eo = !0;
    "find" in [] && Array(1).find(function () {
      eo = !1;
    }), L(L.P + L.F * eo, "Array", {
      find: function find(t) {
        return to(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), ne("find");
    var no = Jt(6),
        ro = !0;
    "findIndex" in [] && Array(1).findIndex(function () {
      ro = !1;
    }), L(L.P + L.F * ro, "Array", {
      findIndex: function findIndex(t) {
        return no(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), ne("findIndex"), L(L.P, "Array", {
      fill: dt
    }), ne("fill");
    var oo = c.isFinite;
    L(L.S, "Number", {
      isFinite: function isFinite(t) {
        return "number" == typeof t && oo(t);
      }
    });

    var io = Math.floor,
        ao = function ao(t) {
      return !l(t) && isFinite(t) && io(t) === t;
    };

    L(L.S, "Number", {
      isInteger: ao
    });
    var so = Math.abs;
    L(L.S, "Number", {
      isSafeInteger: function isSafeInteger(t) {
        return ao(t) && so(t) <= 9007199254740991;
      }
    }), L(L.S, "Number", {
      isNaN: function isNaN(t) {
        return t != t;
      }
    }), L(L.S, "Number", {
      EPSILON: Math.pow(2, -52)
    }), L(L.S, "Number", {
      MIN_SAFE_INTEGER: -9007199254740991
    }), L(L.S, "Number", {
      MAX_SAFE_INTEGER: 9007199254740991
    });

    var co = Math.log1p || function (t) {
      return (t = +t) > -1e-8 && t < 1e-8 ? t - t * t / 2 : Math.log(1 + t);
    },
        uo = Math.sqrt,
        lo = Math.acosh;

    L(L.S + L.F * !(lo && 710 == Math.floor(lo(Number.MAX_VALUE)) && lo(1 / 0) == 1 / 0), "Math", {
      acosh: function acosh(t) {
        return (t = +t) < 1 ? NaN : t > 94906265.62425156 ? Math.log(t) + Math.LN2 : co(t - 1 + uo(t - 1) * uo(t + 1));
      }
    });
    var fo = Math.asinh;
    L(L.S + L.F * !(fo && 1 / fo(0) > 0), "Math", {
      asinh: function t(e) {
        return isFinite(e = +e) && 0 != e ? e < 0 ? -t(-e) : Math.log(e + Math.sqrt(e * e + 1)) : e;
      }
    });
    var po = Math.atanh;
    L(L.S + L.F * !(po && 1 / po(-0) < 0), "Math", {
      atanh: function atanh(t) {
        return 0 == (t = +t) ? t : Math.log((1 + t) / (1 - t)) / 2;
      }
    });

    var ho = Math.sign || function (t) {
      return 0 == (t = +t) || t != t ? t : t < 0 ? -1 : 1;
    };

    L(L.S, "Math", {
      cbrt: function cbrt(t) {
        return ho(t = +t) * Math.pow(Math.abs(t), 1 / 3);
      }
    }), L(L.S, "Math", {
      clz32: function clz32(t) {
        return (t >>>= 0) ? 31 - Math.floor(Math.log(t + .5) * Math.LOG2E) : 32;
      }
    });
    var vo = Math.exp;
    L(L.S, "Math", {
      cosh: function cosh(t) {
        return (vo(t = +t) + vo(-t)) / 2;
      }
    });
    var yo = Math.expm1,
        mo = !yo || yo(10) > 22025.465794806718 || yo(10) < 22025.465794806718 || -2e-17 != yo(-2e-17) ? function (t) {
      return 0 == (t = +t) ? t : t > -1e-6 && t < 1e-6 ? t + t * t / 2 : Math.exp(t) - 1;
    } : yo;
    L(L.S + L.F * (mo != Math.expm1), "Math", {
      expm1: mo
    });

    var go = Math.pow,
        bo = go(2, -52),
        _o = go(2, -23),
        wo = go(2, 127) * (2 - _o),
        xo = go(2, -126),
        Oo = Math.fround || function (t) {
      var e,
          n,
          r = Math.abs(t),
          o = ho(t);
      return r < xo ? o * (r / xo / _o + 1 / bo - 1 / bo) * xo * _o : (n = (e = (1 + _o / bo) * r) - (e - r)) > wo || n != n ? o * (1 / 0) : o * n;
    };

    L(L.S, "Math", {
      fround: Oo
    });
    var Eo = Math.abs;
    L(L.S, "Math", {
      hypot: function hypot(t, e) {
        for (var n, r, o = 0, i = 0, a = arguments.length, s = 0; i < a;) {
          s < (n = Eo(arguments[i++])) ? (o = o * (r = s / n) * r + 1, s = n) : o += n > 0 ? (r = n / s) * r : n;
        }

        return s === 1 / 0 ? 1 / 0 : s * Math.sqrt(o);
      }
    });
    var Co = Math.imul;
    L(L.S + L.F * p(function () {
      return -5 != Co(4294967295, 5) || 2 != Co.length;
    }), "Math", {
      imul: function imul(t, e) {
        var n = +t,
            r = +e,
            o = 65535 & n,
            i = 65535 & r;
        return 0 | o * i + ((65535 & n >>> 16) * i + o * (65535 & r >>> 16) << 16 >>> 0);
      }
    }), L(L.S, "Math", {
      log1p: co
    }), L(L.S, "Math", {
      log10: function log10(t) {
        return Math.log(t) * Math.LOG10E;
      }
    }), L(L.S, "Math", {
      log2: function log2(t) {
        return Math.log(t) / Math.LN2;
      }
    }), L(L.S, "Math", {
      sign: ho
    });
    var jo = Math.exp;
    L(L.S + L.F * p(function () {
      return -2e-17 != !Math.sinh(-2e-17);
    }), "Math", {
      sinh: function sinh(t) {
        return Math.abs(t = +t) < 1 ? (mo(t) - mo(-t)) / 2 : (jo(t - 1) - jo(-t - 1)) * (Math.E / 2);
      }
    });
    var So = Math.exp;
    L(L.S, "Math", {
      tanh: function tanh(t) {
        var e = mo(t = +t),
            n = mo(-t);
        return e == 1 / 0 ? 1 : n == 1 / 0 ? -1 : (e - n) / (So(t) + So(-t));
      }
    }), L(L.S, "Math", {
      trunc: function trunc(t) {
        return (t > 0 ? Math.floor : Math.ceil)(t);
      }
    });
    var To = rt(!0);
    L(L.P, "Array", {
      includes: function includes(t) {
        return To(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), ne("includes");

    var Po = ve.f,
        ko = function ko(t) {
      return function (e) {
        for (var n, r = J(e), o = Ft(r), i = o.length, a = 0, s = []; i > a;) {
          Po.call(r, n = o[a++]) && s.push(t ? [n, r[n]] : r[n]);
        }

        return s;
      };
    },
        Mo = ko(!1);

    L(L.S, "Object", {
      values: function values(t) {
        return Mo(t);
      }
    });
    var zo = ko(!0);
    L(L.S, "Object", {
      entries: function entries(t) {
        return zo(t);
      }
    }), L(L.S, "Object", {
      getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
        for (var e, n, r = J(t), o = me.f, i = en(r), a = {}, s = 0; i.length > s;) {
          void 0 !== (n = o(r, e = i[s++])) && Jr(a, e, n);
        }

        return a;
      }
    });

    var Lo = function Lo(t, e, n, r) {
      var o = String(Q(t)),
          i = o.length,
          a = void 0 === n ? " " : String(n),
          s = K(e);
      if (s <= i || "" == a) return o;
      var c = s - i,
          u = Wr.call(a, Math.ceil(c / a.length));
      return u.length > c && (u = u.slice(0, c)), r ? u + o : o + u;
    };

    L(L.P + L.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(Pn), "String", {
      padStart: function padStart(t) {
        return Lo(this, t, arguments.length > 1 ? arguments[1] : void 0, !0);
      }
    }), L(L.P + L.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(Pn), "String", {
      padEnd: function padEnd(t) {
        return Lo(this, t, arguments.length > 1 ? arguments[1] : void 0, !1);
      }
    });

    var Ao = [].slice,
        Ro = /MSIE .\./.test(Pn),
        No = function No(t) {
      return function (e, n) {
        var r = arguments.length > 2,
            o = !!r && Ao.call(arguments, 2);
        return t(r ? function () {
          ("function" == typeof e ? e : Function(e)).apply(this, o);
        } : e, n);
      };
    };

    L(L.G + L.B + L.F * Ro, {
      setTimeout: No(c.setTimeout),
      setInterval: No(c.setInterval)
    }), L(L.G + L.B, {
      setImmediate: yn.set,
      clearImmediate: yn.clear
    });

    for (var Fo = vt("iterator"), Io = vt("toStringTag"), Do = Lt.Array, Bo = {
      CSSRuleList: !0,
      CSSStyleDeclaration: !1,
      CSSValueList: !1,
      ClientRectList: !1,
      DOMRectList: !1,
      DOMStringList: !1,
      DOMTokenList: !0,
      DataTransferItemList: !1,
      FileList: !1,
      HTMLAllCollection: !1,
      HTMLCollection: !1,
      HTMLFormElement: !1,
      HTMLSelectElement: !1,
      MediaList: !0,
      MimeTypeArray: !1,
      NamedNodeMap: !1,
      NodeList: !0,
      PaintRequestList: !1,
      Plugin: !1,
      PluginArray: !1,
      SVGLengthList: !1,
      SVGNumberList: !1,
      SVGPathSegList: !1,
      SVGPointList: !1,
      SVGStringList: !1,
      SVGTransformList: !1,
      SourceBufferList: !1,
      StyleSheetList: !0,
      TextTrackCueList: !1,
      TextTrackList: !1,
      TouchList: !1
    }, Vo = Ft(Bo), Ho = 0; Ho < Vo.length; Ho++) {
      var Uo,
          Wo = Vo[Ho],
          qo = Bo[Wo],
          Go = c[Wo],
          Ko = Go && Go.prototype;
      if (Ko && (Ko[Fo] || x(Ko, Fo, Do), Ko[Io] || x(Ko, Io, Wo), Lt[Wo] = Do, qo)) for (Uo in le) {
        Ko[Uo] || T(Ko, Uo, le[Uo], !0);
      }
    }

    s(function (t) {
      !function (e) {
        var n,
            r = Object.prototype,
            o = r.hasOwnProperty,
            i = "function" == typeof Symbol ? Symbol : {},
            a = i.iterator || "@@iterator",
            s = i.asyncIterator || "@@asyncIterator",
            c = i.toStringTag || "@@toStringTag",
            u = e.regeneratorRuntime;
        if (u) t.exports = u;else {
          (u = e.regeneratorRuntime = t.exports).wrap = b;
          var l = "suspendedStart",
              f = "suspendedYield",
              p = "executing",
              h = "completed",
              d = {},
              v = {};

          v[a] = function () {
            return this;
          };

          var y = Object.getPrototypeOf,
              m = y && y(y(k([])));
          m && m !== r && o.call(m, a) && (v = m);
          var g = O.prototype = w.prototype = Object.create(v);
          x.prototype = g.constructor = O, O.constructor = x, O[c] = x.displayName = "GeneratorFunction", u.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === x || "GeneratorFunction" === (e.displayName || e.name));
          }, u.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, O) : (t.__proto__ = O, c in t || (t[c] = "GeneratorFunction")), t.prototype = Object.create(g), t;
          }, u.awrap = function (t) {
            return {
              __await: t
            };
          }, E(C.prototype), C.prototype[s] = function () {
            return this;
          }, u.AsyncIterator = C, u.async = function (t, e, n, r) {
            var o = new C(b(t, e, n, r));
            return u.isGeneratorFunction(e) ? o : o.next().then(function (t) {
              return t.done ? t.value : o.next();
            });
          }, E(g), g[c] = "Generator", g[a] = function () {
            return this;
          }, g.toString = function () {
            return "[object Generator]";
          }, u.keys = function (t) {
            var e = [];

            for (var n in t) {
              e.push(n);
            }

            return e.reverse(), function n() {
              for (; e.length;) {
                var r = e.pop();
                if (r in t) return n.value = r, n.done = !1, n;
              }

              return n.done = !0, n;
            };
          }, u.values = k, P.prototype = {
            constructor: P,
            reset: function reset(t) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = n, this.done = !1, this.delegate = null, this.method = "next", this.arg = n, this.tryEntries.forEach(T), !t) for (var e in this) {
                "t" === e.charAt(0) && o.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = n);
              }
            },
            stop: function stop() {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function dispatchException(t) {
              if (this.done) throw t;
              var e = this;

              function r(r, o) {
                return s.type = "throw", s.arg = t, e.next = r, o && (e.method = "next", e.arg = n), !!o;
              }

              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var a = this.tryEntries[i],
                    s = a.completion;
                if ("root" === a.tryLoc) return r("end");

                if (a.tryLoc <= this.prev) {
                  var c = o.call(a, "catchLoc"),
                      u = o.call(a, "finallyLoc");

                  if (c && u) {
                    if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                  } else if (c) {
                    if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                  } else {
                    if (!u) throw new Error("try statement without catch or finally");
                    if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                  }
                }
              }
            },
            abrupt: function abrupt(t, e) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var r = this.tryEntries[n];

                if (r.tryLoc <= this.prev && o.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                  var i = r;
                  break;
                }
              }

              i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
              var a = i ? i.completion : {};
              return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, d) : this.complete(a);
            },
            complete: function complete(t, e) {
              if ("throw" === t.type) throw t.arg;
              return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), d;
            },
            finish: function finish(t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];
                if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), T(n), d;
              }
            },
            "catch": function _catch(t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var n = this.tryEntries[e];

                if (n.tryLoc === t) {
                  var r = n.completion;

                  if ("throw" === r.type) {
                    var o = r.arg;
                    T(n);
                  }

                  return o;
                }
              }

              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(t, e, r) {
              return this.delegate = {
                iterator: k(t),
                resultName: e,
                nextLoc: r
              }, "next" === this.method && (this.arg = n), d;
            }
          };
        }

        function b(t, e, n, r) {
          var o = e && e.prototype instanceof w ? e : w,
              i = Object.create(o.prototype),
              a = new P(r || []);
          return i._invoke = function (t, e, n) {
            var r = l;
            return function (o, i) {
              if (r === p) throw new Error("Generator is already running");

              if (r === h) {
                if ("throw" === o) throw i;
                return M();
              }

              for (n.method = o, n.arg = i;;) {
                var a = n.delegate;

                if (a) {
                  var s = j(a, n);

                  if (s) {
                    if (s === d) continue;
                    return s;
                  }
                }

                if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                  if (r === l) throw r = h, n.arg;
                  n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                r = p;

                var c = _(t, e, n);

                if ("normal" === c.type) {
                  if (r = n.done ? h : f, c.arg === d) continue;
                  return {
                    value: c.arg,
                    done: n.done
                  };
                }

                "throw" === c.type && (r = h, n.method = "throw", n.arg = c.arg);
              }
            };
          }(t, n, a), i;
        }

        function _(t, e, n) {
          try {
            return {
              type: "normal",
              arg: t.call(e, n)
            };
          } catch (t) {
            return {
              type: "throw",
              arg: t
            };
          }
        }

        function w() {}

        function x() {}

        function O() {}

        function E(t) {
          ["next", "throw", "return"].forEach(function (e) {
            t[e] = function (t) {
              return this._invoke(e, t);
            };
          });
        }

        function C(t) {
          function n(e, r, i, a) {
            var s = _(t[e], t, r);

            if ("throw" !== s.type) {
              var c = s.arg,
                  u = c.value;
              return u && "object" == _typeof(u) && o.call(u, "__await") ? Promise.resolve(u.__await).then(function (t) {
                n("next", t, i, a);
              }, function (t) {
                n("throw", t, i, a);
              }) : Promise.resolve(u).then(function (t) {
                c.value = t, i(c);
              }, a);
            }

            a(s.arg);
          }

          var r;
          "object" == _typeof(e.process) && e.process.domain && (n = e.process.domain.bind(n)), this._invoke = function (t, e) {
            function o() {
              return new Promise(function (r, o) {
                n(t, e, r, o);
              });
            }

            return r = r ? r.then(o, o) : o();
          };
        }

        function j(t, e) {
          var r = t.iterator[e.method];

          if (r === n) {
            if (e.delegate = null, "throw" === e.method) {
              if (t.iterator["return"] && (e.method = "return", e.arg = n, j(t, e), "throw" === e.method)) return d;
              e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return d;
          }

          var o = _(r, t.iterator, e.arg);

          if ("throw" === o.type) return e.method = "throw", e.arg = o.arg, e.delegate = null, d;
          var i = o.arg;
          return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = n), e.delegate = null, d) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, d);
        }

        function S(t) {
          var e = {
            tryLoc: t[0]
          };
          1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
        }

        function T(t) {
          var e = t.completion || {};
          e.type = "normal", delete e.arg, t.completion = e;
        }

        function P(t) {
          this.tryEntries = [{
            tryLoc: "root"
          }], t.forEach(S, this), this.reset(!0);
        }

        function k(t) {
          if (t) {
            var e = t[a];
            if (e) return e.call(t);
            if ("function" == typeof t.next) return t;

            if (!isNaN(t.length)) {
              var r = -1,
                  i = function e() {
                for (; ++r < t.length;) {
                  if (o.call(t, r)) return e.value = t[r], e.done = !1, e;
                }

                return e.value = n, e.done = !0, e;
              };

              return i.next = i;
            }
          }

          return {
            next: M
          };
        }

        function M() {
          return {
            value: n,
            done: !0
          };
        }
      }("object" == _typeof(i) ? i : "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) ? window : "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) ? self : i);
    });

    var Zo = s(function (t) {
      var e = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
      "number" == typeof __g && (__g = e);
    }),
        Yo = s(function (t) {
      var e = t.exports = {
        version: "2.5.7"
      };
      "number" == typeof __e && (__e = e);
    }),
        $o = (Yo.version, function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    }),
        Xo = function Xo(t, e, n) {
      if ($o(t), void 0 === e) return t;

      switch (n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };

        case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };

        case 3:
          return function (n, r, o) {
            return t.call(e, n, r, o);
          };
      }

      return function () {
        return t.apply(e, arguments);
      };
    },
        Qo = function Qo(t) {
      return "object" == _typeof(t) ? null !== t : "function" == typeof t;
    },
        Jo = function Jo(t) {
      if (!Qo(t)) throw TypeError(t + " is not an object!");
      return t;
    },
        ti = function ti(t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    },
        ei = !ti(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    }),
        ni = Zo.document,
        ri = Qo(ni) && Qo(ni.createElement),
        oi = function oi(t) {
      return ri ? ni.createElement(t) : {};
    },
        ii = !ei && !ti(function () {
      return 7 != Object.defineProperty(oi("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    }),
        ai = Object.defineProperty,
        si = {
      f: ei ? Object.defineProperty : function (t, e, n) {
        if (Jo(t), e = function (t, e) {
          if (!Qo(t)) return t;
          var n, r;
          if (e && "function" == typeof (n = t.toString) && !Qo(r = n.call(t))) return r;
          if ("function" == typeof (n = t.valueOf) && !Qo(r = n.call(t))) return r;
          if (!e && "function" == typeof (n = t.toString) && !Qo(r = n.call(t))) return r;
          throw TypeError("Can't convert object to primitive value");
        }(e, !0), Jo(n), ii) try {
          return ai(t, e, n);
        } catch (t) {}
        if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
        return "value" in n && (t[e] = n.value), t;
      }
    },
        ci = function ci(t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    },
        ui = ei ? function (t, e, n) {
      return si.f(t, e, ci(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    },
        li = {}.hasOwnProperty,
        fi = function fi(t, e) {
      return li.call(t, e);
    },
        pi = function pi(t, e, n) {
      var r,
          o,
          i,
          a = t & pi.F,
          s = t & pi.G,
          c = t & pi.S,
          u = t & pi.P,
          l = t & pi.B,
          f = t & pi.W,
          p = s ? Yo : Yo[e] || (Yo[e] = {}),
          h = p.prototype,
          d = s ? Zo : c ? Zo[e] : (Zo[e] || {}).prototype;

      for (r in s && (n = e), n) {
        (o = !a && d && void 0 !== d[r]) && fi(p, r) || (i = o ? d[r] : n[r], p[r] = s && "function" != typeof d[r] ? n[r] : l && o ? Xo(i, Zo) : f && d[r] == i ? function (t) {
          var e = function e(_e7, n, r) {
            if (this instanceof t) {
              switch (arguments.length) {
                case 0:
                  return new t();

                case 1:
                  return new t(_e7);

                case 2:
                  return new t(_e7, n);
              }

              return new t(_e7, n, r);
            }

            return t.apply(this, arguments);
          };

          return e.prototype = t.prototype, e;
        }(i) : u && "function" == typeof i ? Xo(Function.call, i) : i, u && ((p.virtual || (p.virtual = {}))[r] = i, t & pi.R && h && !h[r] && ui(h, r, i)));
      }
    };

    pi.F = 1, pi.G = 2, pi.S = 4, pi.P = 8, pi.B = 16, pi.W = 32, pi.U = 64, pi.R = 128;

    var hi,
        di = pi,
        vi = {}.toString,
        yi = function yi(t) {
      return vi.call(t).slice(8, -1);
    },
        mi = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == yi(t) ? t.split("") : Object(t);
    },
        gi = function gi(t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    },
        bi = function bi(t) {
      return mi(gi(t));
    },
        _i = Math.ceil,
        wi = Math.floor,
        xi = function xi(t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? wi : _i)(t);
    },
        Oi = Math.min,
        Ei = function Ei(t) {
      return t > 0 ? Oi(xi(t), 9007199254740991) : 0;
    },
        Ci = Math.max,
        ji = Math.min,
        Si = s(function (t) {
      var e = Zo["__core-js_shared__"] || (Zo["__core-js_shared__"] = {});
      (t.exports = function (t, n) {
        return e[t] || (e[t] = void 0 !== n ? n : {});
      })("versions", []).push({
        version: Yo.version,
        mode: "pure",
        copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
      });
    }),
        Ti = 0,
        Pi = Math.random(),
        ki = function ki(t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++Ti + Pi).toString(36));
    },
        Mi = Si("keys"),
        zi = function zi(t) {
      return Mi[t] || (Mi[t] = ki(t));
    },
        Li = (hi = !1, function (t, e, n) {
      var r,
          o = bi(t),
          i = Ei(o.length),
          a = function (t, e) {
        return (t = xi(t)) < 0 ? Ci(t + e, 0) : ji(t, e);
      }(n, i);

      if (hi && e != e) {
        for (; i > a;) {
          if ((r = o[a++]) != r) return !0;
        }
      } else for (; i > a; a++) {
        if ((hi || a in o) && o[a] === e) return hi || a || 0;
      }

      return !hi && -1;
    }),
        Ai = zi("IE_PROTO"),
        Ri = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),
        Ni = Object.keys || function (t) {
      return function (t, e) {
        var n,
            r = bi(t),
            o = 0,
            i = [];

        for (n in r) {
          n != Ai && fi(r, n) && i.push(n);
        }

        for (; e.length > o;) {
          fi(r, n = e[o++]) && (~Li(i, n) || i.push(n));
        }

        return i;
      }(t, Ri);
    },
        Fi = {
      f: Object.getOwnPropertySymbols
    },
        Ii = {
      f: {}.propertyIsEnumerable
    },
        Di = function Di(t) {
      return Object(gi(t));
    },
        Bi = Object.assign,
        Vi = !Bi || ti(function () {
      var t = {},
          e = {},
          n = Symbol(),
          r = "abcdefghijklmnopqrst";
      return t[n] = 7, r.split("").forEach(function (t) {
        e[t] = t;
      }), 7 != Bi({}, t)[n] || Object.keys(Bi({}, e)).join("") != r;
    }) ? function (t, e) {
      for (var n = Di(t), r = arguments.length, o = 1, i = Fi.f, a = Ii.f; r > o;) {
        for (var s, c = mi(arguments[o++]), u = i ? Ni(c).concat(i(c)) : Ni(c), l = u.length, f = 0; l > f;) {
          a.call(c, s = u[f++]) && (n[s] = c[s]);
        }
      }

      return n;
    } : Bi;

    di(di.S + di.F, "Object", {
      assign: Vi
    });
    var Hi,
        Ui = Yo.Object.assign,
        Wi = s(function (t) {
      t.exports = {
        "default": Ui,
        __esModule: !0
      };
    }),
        qi = a(Wi),
        Gi = a(s(function (t, e) {
      e.__esModule = !0;
      var n,
          r = (n = Wi) && n.__esModule ? n : {
        "default": n
      };

      e["default"] = r["default"] || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
        }

        return t;
      };
    })),
        Ki = Ii.f,
        Zi = (Hi = !1, function (t) {
      for (var e, n = bi(t), r = Ni(n), o = r.length, i = 0, a = []; o > i;) {
        Ki.call(n, e = r[i++]) && a.push(Hi ? [e, n[e]] : n[e]);
      }

      return a;
    });
    di(di.S, "Object", {
      values: function values(t) {
        return Zi(t);
      }
    });
    var Yi = Yo.Object.values,
        $i = a(s(function (t) {
      t.exports = {
        "default": Yi,
        __esModule: !0
      };
    })),
        Xi = a(s(function (t, e) {
      e.__esModule = !0, e["default"] = function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      };
    }));
    di(di.S + di.F * !ei, "Object", {
      defineProperty: si.f
    });

    var Qi = Yo.Object,
        Ji = function Ji(t, e, n) {
      return Qi.defineProperty(t, e, n);
    },
        ta = s(function (t) {
      t.exports = {
        "default": Ji,
        __esModule: !0
      };
    });

    a(ta);
    var ea = a(s(function (t, e) {
      e.__esModule = !0;
      var n,
          r = (n = ta) && n.__esModule ? n : {
        "default": n
      };

      e["default"] = function () {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var o = e[n];
            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), (0, r["default"])(t, o.key, o);
          }
        }

        return function (e, n, r) {
          return n && t(e.prototype, n), r && t(e, r), e;
        };
      }();
    })),
        na = Object.prototype;

    var ra = function ra(t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || na);
    };

    var oa = function (t, e) {
      return function (n) {
        return t(e(n));
      };
    }(Object.keys, Object),
        ia = Object.prototype.hasOwnProperty;

    var aa = function aa(t) {
      if (!ra(t)) return oa(t);
      var e = [];

      for (var n in Object(t)) {
        ia.call(t, n) && "constructor" != n && e.push(n);
      }

      return e;
    },
        sa = "object" == _typeof(i) && i && i.Object === Object && i,
        ca = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
        ua = sa || ca || Function("return this")(),
        la = ua.Symbol,
        fa = Object.prototype,
        pa = fa.hasOwnProperty,
        ha = fa.toString,
        da = la ? la.toStringTag : void 0;

    var va = function va(t) {
      var e = pa.call(t, da),
          n = t[da];

      try {
        t[da] = void 0;
      } catch (t) {}

      var r = ha.call(t);
      return e ? t[da] = n : delete t[da], r;
    },
        ya = Object.prototype.toString;

    var ma = function ma(t) {
      return ya.call(t);
    },
        ga = "[object Null]",
        ba = "[object Undefined]",
        _a = la ? la.toStringTag : void 0;

    var wa = function wa(t) {
      return null == t ? void 0 === t ? ba : ga : _a && _a in Object(t) ? va(t) : ma(t);
    };

    var xa = function xa(t) {
      var e = _typeof(t);

      return null != t && ("object" == e || "function" == e);
    },
        Oa = "[object AsyncFunction]",
        Ea = "[object Function]",
        Ca = "[object GeneratorFunction]",
        ja = "[object Proxy]";

    var Sa,
        Ta = function Ta(t) {
      if (!xa(t)) return !1;
      var e = wa(t);
      return e == Ea || e == Ca || e == Oa || e == ja;
    },
        Pa = ua["__core-js_shared__"],
        ka = (Sa = /[^.]+$/.exec(Pa && Pa.keys && Pa.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Sa : "";

    var Ma = function Ma(t) {
      return !!ka && ka in t;
    },
        za = Function.prototype.toString;

    var La = function La(t) {
      if (null != t) {
        try {
          return za.call(t);
        } catch (t) {}

        try {
          return t + "";
        } catch (t) {}
      }

      return "";
    },
        Aa = /^\[object .+?Constructor\]$/,
        Ra = Function.prototype,
        Na = Object.prototype,
        Fa = Ra.toString,
        Ia = Na.hasOwnProperty,
        Da = RegExp("^" + Fa.call(Ia).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    var Ba = function Ba(t) {
      return !(!xa(t) || Ma(t)) && (Ta(t) ? Da : Aa).test(La(t));
    };

    var Va = function Va(t, e) {
      return null == t ? void 0 : t[e];
    };

    var Ha = function Ha(t, e) {
      var n = Va(t, e);
      return Ba(n) ? n : void 0;
    },
        Ua = Ha(ua, "DataView"),
        Wa = Ha(ua, "Map"),
        qa = Ha(ua, "Promise"),
        Ga = Ha(ua, "Set"),
        Ka = Ha(ua, "WeakMap"),
        Za = La(Ua),
        Ya = La(Wa),
        $a = La(qa),
        Xa = La(Ga),
        Qa = La(Ka),
        Ja = wa;

    (Ua && "[object DataView]" != Ja(new Ua(new ArrayBuffer(1))) || Wa && "[object Map]" != Ja(new Wa()) || qa && "[object Promise]" != Ja(qa.resolve()) || Ga && "[object Set]" != Ja(new Ga()) || Ka && "[object WeakMap]" != Ja(new Ka())) && (Ja = function Ja(t) {
      var e = wa(t),
          n = "[object Object]" == e ? t.constructor : void 0,
          r = n ? La(n) : "";
      if (r) switch (r) {
        case Za:
          return "[object DataView]";

        case Ya:
          return "[object Map]";

        case $a:
          return "[object Promise]";

        case Xa:
          return "[object Set]";

        case Qa:
          return "[object WeakMap]";
      }
      return e;
    });
    var ts = Ja;

    var es = function es(t) {
      return null != t && "object" == _typeof(t);
    },
        ns = "[object Arguments]";

    var rs = function rs(t) {
      return es(t) && wa(t) == ns;
    },
        os = Object.prototype,
        is = os.hasOwnProperty,
        as = os.propertyIsEnumerable,
        ss = rs(function () {
      return arguments;
    }()) ? rs : function (t) {
      return es(t) && is.call(t, "callee") && !as.call(t, "callee");
    },
        cs = Array.isArray,
        us = 9007199254740991;

    var ls = function ls(t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= us;
    };

    var fs = function fs(t) {
      return null != t && ls(t.length) && !Ta(t);
    };

    var ps = function ps() {
      return !1;
    },
        hs = s(function (t, e) {
      var n = e && !e.nodeType && e,
          r = n && t && !t.nodeType && t,
          o = r && r.exports === n ? ua.Buffer : void 0,
          i = (o ? o.isBuffer : void 0) || ps;
      t.exports = i;
    }),
        ds = {};

    ds["[object Float32Array]"] = ds["[object Float64Array]"] = ds["[object Int8Array]"] = ds["[object Int16Array]"] = ds["[object Int32Array]"] = ds["[object Uint8Array]"] = ds["[object Uint8ClampedArray]"] = ds["[object Uint16Array]"] = ds["[object Uint32Array]"] = !0, ds["[object Arguments]"] = ds["[object Array]"] = ds["[object ArrayBuffer]"] = ds["[object Boolean]"] = ds["[object DataView]"] = ds["[object Date]"] = ds["[object Error]"] = ds["[object Function]"] = ds["[object Map]"] = ds["[object Number]"] = ds["[object Object]"] = ds["[object RegExp]"] = ds["[object Set]"] = ds["[object String]"] = ds["[object WeakMap]"] = !1;

    var vs = function vs(t) {
      return es(t) && ls(t.length) && !!ds[wa(t)];
    };

    var ys = function ys(t) {
      return function (e) {
        return t(e);
      };
    },
        ms = s(function (t, e) {
      var n = e && !e.nodeType && e,
          r = n && t && !t.nodeType && t,
          o = r && r.exports === n && sa.process,
          i = function () {
        try {
          var t = r && r.require && r.require("util").types;

          return t || o && o.binding && o.binding("util");
        } catch (t) {}
      }();

      t.exports = i;
    }),
        gs = ms && ms.isTypedArray,
        bs = gs ? ys(gs) : vs,
        _s = "[object Map]",
        ws = "[object Set]",
        xs = Object.prototype.hasOwnProperty;

    var Os = function Os(t) {
      if (null == t) return !0;
      if (fs(t) && (cs(t) || "string" == typeof t || "function" == typeof t.splice || hs(t) || bs(t) || ss(t))) return !t.length;
      var e = ts(t);
      if (e == _s || e == ws) return !t.size;
      if (ra(t)) return !aa(t).length;

      for (var n in t) {
        if (xs.call(t, n)) return !1;
      }

      return !0;
    };

    !function (t, e) {
      var n = (Yo.Object || {})[t] || Object[t],
          r = {};
      r[t] = e(n), di(di.S + di.F * ti(function () {
        n(1);
      }), "Object", r);
    }("keys", function () {
      return function (t) {
        return Ni(Di(t));
      };
    });
    var Es = Yo.Object.keys,
        Cs = a(s(function (t) {
      t.exports = {
        "default": Es,
        __esModule: !0
      };
    }));

    var js = function js() {
      this.__data__ = [], this.size = 0;
    };

    var Ss = function Ss(t, e) {
      return t === e || t != t && e != e;
    };

    var Ts = function Ts(t, e) {
      for (var n = t.length; n--;) {
        if (Ss(t[n][0], e)) return n;
      }

      return -1;
    },
        Ps = Array.prototype.splice;

    var ks = function ks(t) {
      var e = this.__data__,
          n = Ts(e, t);
      return !(n < 0 || (n == e.length - 1 ? e.pop() : Ps.call(e, n, 1), --this.size, 0));
    };

    var Ms = function Ms(t) {
      var e = this.__data__,
          n = Ts(e, t);
      return n < 0 ? void 0 : e[n][1];
    };

    var zs = function zs(t) {
      return Ts(this.__data__, t) > -1;
    };

    var Ls = function Ls(t, e) {
      var n = this.__data__,
          r = Ts(n, t);
      return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
    };

    function As(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    As.prototype.clear = js, As.prototype["delete"] = ks, As.prototype.get = Ms, As.prototype.has = zs, As.prototype.set = Ls;
    var Rs = As;

    var Ns = function Ns() {
      this.__data__ = new Rs(), this.size = 0;
    };

    var Fs = function Fs(t) {
      var e = this.__data__,
          n = e["delete"](t);
      return this.size = e.size, n;
    };

    var Is = function Is(t) {
      return this.__data__.get(t);
    };

    var Ds = function Ds(t) {
      return this.__data__.has(t);
    },
        Bs = Ha(Object, "create");

    var Vs = function Vs() {
      this.__data__ = Bs ? Bs(null) : {}, this.size = 0;
    };

    var Hs = function Hs(t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    },
        Us = "__lodash_hash_undefined__",
        Ws = Object.prototype.hasOwnProperty;

    var qs = function qs(t) {
      var e = this.__data__;

      if (Bs) {
        var n = e[t];
        return n === Us ? void 0 : n;
      }

      return Ws.call(e, t) ? e[t] : void 0;
    },
        Gs = Object.prototype.hasOwnProperty;

    var Ks = function Ks(t) {
      var e = this.__data__;
      return Bs ? void 0 !== e[t] : Gs.call(e, t);
    },
        Zs = "__lodash_hash_undefined__";

    var Ys = function Ys(t, e) {
      var n = this.__data__;
      return this.size += this.has(t) ? 0 : 1, n[t] = Bs && void 0 === e ? Zs : e, this;
    };

    function $s(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    $s.prototype.clear = Vs, $s.prototype["delete"] = Hs, $s.prototype.get = qs, $s.prototype.has = Ks, $s.prototype.set = Ys;
    var Xs = $s;

    var Qs = function Qs() {
      this.size = 0, this.__data__ = {
        hash: new Xs(),
        map: new (Wa || Rs)(),
        string: new Xs()
      };
    };

    var Js = function Js(t) {
      var e = _typeof(t);

      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    };

    var tc = function tc(t, e) {
      var n = t.__data__;
      return Js(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    };

    var ec = function ec(t) {
      var e = tc(this, t)["delete"](t);
      return this.size -= e ? 1 : 0, e;
    };

    var nc = function nc(t) {
      return tc(this, t).get(t);
    };

    var rc = function rc(t) {
      return tc(this, t).has(t);
    };

    var oc = function oc(t, e) {
      var n = tc(this, t),
          r = n.size;
      return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
    };

    function ic(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var r = t[e];
        this.set(r[0], r[1]);
      }
    }

    ic.prototype.clear = Qs, ic.prototype["delete"] = ec, ic.prototype.get = nc, ic.prototype.has = rc, ic.prototype.set = oc;
    var ac = ic,
        sc = 200;

    var cc = function cc(t, e) {
      var n = this.__data__;

      if (n instanceof Rs) {
        var r = n.__data__;
        if (!Wa || r.length < sc - 1) return r.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new ac(r);
      }

      return n.set(t, e), this.size = n.size, this;
    };

    function uc(t) {
      var e = this.__data__ = new Rs(t);
      this.size = e.size;
    }

    uc.prototype.clear = Ns, uc.prototype["delete"] = Fs, uc.prototype.get = Is, uc.prototype.has = Ds, uc.prototype.set = cc;
    var lc = uc,
        fc = "__lodash_hash_undefined__";

    var pc = function pc(t) {
      return this.__data__.set(t, fc), this;
    };

    var hc = function hc(t) {
      return this.__data__.has(t);
    };

    function dc(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.__data__ = new ac(); ++e < n;) {
        this.add(t[e]);
      }
    }

    dc.prototype.add = dc.prototype.push = pc, dc.prototype.has = hc;
    var vc = dc;

    var yc = function yc(t, e) {
      for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
        if (e(t[n], n, t)) return !0;
      }

      return !1;
    };

    var mc = function mc(t, e) {
      return t.has(e);
    },
        gc = 1,
        bc = 2;

    var _c = function _c(t, e, n, r, o, i) {
      var a = n & gc,
          s = t.length,
          c = e.length;
      if (s != c && !(a && c > s)) return !1;
      var u = i.get(t);
      if (u && i.get(e)) return u == e;
      var l = -1,
          f = !0,
          p = n & bc ? new vc() : void 0;

      for (i.set(t, e), i.set(e, t); ++l < s;) {
        var h = t[l],
            d = e[l];
        if (r) var v = a ? r(d, h, l, e, t, i) : r(h, d, l, t, e, i);

        if (void 0 !== v) {
          if (v) continue;
          f = !1;
          break;
        }

        if (p) {
          if (!yc(e, function (t, e) {
            if (!mc(p, e) && (h === t || o(h, t, n, r, i))) return p.push(e);
          })) {
            f = !1;
            break;
          }
        } else if (h !== d && !o(h, d, n, r, i)) {
          f = !1;
          break;
        }
      }

      return i["delete"](t), i["delete"](e), f;
    },
        wc = ua.Uint8Array;

    var xc = function xc(t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t, r) {
        n[++e] = [r, t];
      }), n;
    };

    var Oc = function Oc(t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t) {
        n[++e] = t;
      }), n;
    },
        Ec = 1,
        Cc = 2,
        jc = "[object Boolean]",
        Sc = "[object Date]",
        Tc = "[object Error]",
        Pc = "[object Map]",
        kc = "[object Number]",
        Mc = "[object RegExp]",
        zc = "[object Set]",
        Lc = "[object String]",
        Ac = "[object Symbol]",
        Rc = "[object ArrayBuffer]",
        Nc = "[object DataView]",
        Fc = la ? la.prototype : void 0,
        Ic = Fc ? Fc.valueOf : void 0;

    var Dc = function Dc(t, e, n, r, o, i, a) {
      switch (n) {
        case Nc:
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
          t = t.buffer, e = e.buffer;

        case Rc:
          return !(t.byteLength != e.byteLength || !i(new wc(t), new wc(e)));

        case jc:
        case Sc:
        case kc:
          return Ss(+t, +e);

        case Tc:
          return t.name == e.name && t.message == e.message;

        case Mc:
        case Lc:
          return t == e + "";

        case Pc:
          var s = xc;

        case zc:
          var c = r & Ec;
          if (s || (s = Oc), t.size != e.size && !c) return !1;
          var u = a.get(t);
          if (u) return u == e;
          r |= Cc, a.set(t, e);

          var l = _c(s(t), s(e), r, o, i, a);

          return a["delete"](t), l;

        case Ac:
          if (Ic) return Ic.call(t) == Ic.call(e);
      }

      return !1;
    };

    var Bc = function Bc(t, e) {
      for (var n = -1, r = e.length, o = t.length; ++n < r;) {
        t[o + n] = e[n];
      }

      return t;
    };

    var Vc = function Vc(t, e, n) {
      var r = e(t);
      return cs(t) ? r : Bc(r, n(t));
    };

    var Hc = function Hc(t, e) {
      for (var n = -1, r = null == t ? 0 : t.length, o = 0, i = []; ++n < r;) {
        var a = t[n];
        e(a, n, t) && (i[o++] = a);
      }

      return i;
    };

    var Uc = function Uc() {
      return [];
    },
        Wc = Object.prototype.propertyIsEnumerable,
        qc = Object.getOwnPropertySymbols,
        Gc = qc ? function (t) {
      return null == t ? [] : (t = Object(t), Hc(qc(t), function (e) {
        return Wc.call(t, e);
      }));
    } : Uc;

    var Kc = function Kc(t, e) {
      for (var n = -1, r = Array(t); ++n < t;) {
        r[n] = e(n);
      }

      return r;
    },
        Zc = 9007199254740991,
        Yc = /^(?:0|[1-9]\d*)$/;

    var $c = function $c(t, e) {
      var n = _typeof(t);

      return !!(e = null == e ? Zc : e) && ("number" == n || "symbol" != n && Yc.test(t)) && t > -1 && t % 1 == 0 && t < e;
    },
        Xc = Object.prototype.hasOwnProperty;

    var Qc = function Qc(t, e) {
      var n = cs(t),
          r = !n && ss(t),
          o = !n && !r && hs(t),
          i = !n && !r && !o && bs(t),
          a = n || r || o || i,
          s = a ? Kc(t.length, String) : [],
          c = s.length;

      for (var u in t) {
        !e && !Xc.call(t, u) || a && ("length" == u || o && ("offset" == u || "parent" == u) || i && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || $c(u, c)) || s.push(u);
      }

      return s;
    };

    var Jc = function Jc(t) {
      return fs(t) ? Qc(t) : aa(t);
    };

    var tu = function tu(t) {
      return Vc(t, Jc, Gc);
    },
        eu = 1,
        nu = Object.prototype.hasOwnProperty;

    var ru = function ru(t, e, n, r, o, i) {
      var a = n & eu,
          s = tu(t),
          c = s.length;
      if (c != tu(e).length && !a) return !1;

      for (var u = c; u--;) {
        var l = s[u];
        if (!(a ? l in e : nu.call(e, l))) return !1;
      }

      var f = i.get(t);
      if (f && i.get(e)) return f == e;
      var p = !0;
      i.set(t, e), i.set(e, t);

      for (var h = a; ++u < c;) {
        var d = t[l = s[u]],
            v = e[l];
        if (r) var y = a ? r(v, d, l, e, t, i) : r(d, v, l, t, e, i);

        if (!(void 0 === y ? d === v || o(d, v, n, r, i) : y)) {
          p = !1;
          break;
        }

        h || (h = "constructor" == l);
      }

      if (p && !h) {
        var m = t.constructor,
            g = e.constructor;
        m != g && "constructor" in t && "constructor" in e && !("function" == typeof m && m instanceof m && "function" == typeof g && g instanceof g) && (p = !1);
      }

      return i["delete"](t), i["delete"](e), p;
    },
        ou = 1,
        iu = "[object Arguments]",
        au = "[object Array]",
        su = "[object Object]",
        cu = Object.prototype.hasOwnProperty;

    var uu = function uu(t, e, n, r, o, i) {
      var a = cs(t),
          s = cs(e),
          c = a ? au : ts(t),
          u = s ? au : ts(e),
          l = (c = c == iu ? su : c) == su,
          f = (u = u == iu ? su : u) == su,
          p = c == u;

      if (p && hs(t)) {
        if (!hs(e)) return !1;
        a = !0, l = !1;
      }

      if (p && !l) return i || (i = new lc()), a || bs(t) ? _c(t, e, n, r, o, i) : Dc(t, e, c, n, r, o, i);

      if (!(n & ou)) {
        var h = l && cu.call(t, "__wrapped__"),
            d = f && cu.call(e, "__wrapped__");

        if (h || d) {
          var v = h ? t.value() : t,
              y = d ? e.value() : e;
          return i || (i = new lc()), o(v, y, n, r, i);
        }
      }

      return !!p && (i || (i = new lc()), ru(t, e, n, r, o, i));
    };

    var lu = function t(e, n, r, o, i) {
      return e === n || (null == e || null == n || !es(e) && !es(n) ? e != e && n != n : uu(e, n, r, o, t, i));
    };

    var fu = function fu(t, e) {
      return lu(t, e);
    },
        pu = function () {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        Xi(this, t), Object.defineProperty(this, "opacity", {
          enumerable: !0,
          writable: !0,
          value: 1
        }), Object.defineProperty(this, "visibility", {
          enumerable: !0,
          writable: !0,
          value: !0
        }), qi(this, e, {
          changedAttributes: {}
        });
      }

      return ea(t, [{
        key: "get",
        value: function value(t) {
          return this[t];
        }
      }, {
        key: "set",
        value: function value(t, e) {
          return this[t] = e, this;
        }
      }, {
        key: "update",
        value: function value(t) {
          var e = this,
              n = Gi({}, this),
              r = Gi({}, t);
          this.set("changedAttributes", {}), Cs(r).forEach(function (t) {
            fu(n[t], r[t]) || (e.changedAttributes[t] = r[t], e.set(t, r[t]));
          });
        }
      }]), t;
    }();

    !function () {
      function t(e, n) {
        var r;
        Xi(this, t), this.map = e, this.plugin = new n(this.map), (r = this.plugin) && ["add", "remove", "setVisibility", "setOpacity", "setEvents", "setZIndex", "setLayerConfig", "setParams", "setDecodeParams", "getLayerByProvider"].forEach(function (t) {
          r[t];
        }), this.layers = [], this.promises = {};
      }

      ea(t, [{
        key: "renderLayers",
        value: function value() {
          var t = this;
          return this.layers.length > 0 ? (this.layers.map(function (e) {
            var n = e.changedAttributes,
                r = n.sqlParams,
                i = n.params,
                a = n.layerConfig,
                s = r || i || a;
            return e.mapLayer && !s ? (t.update(e), t.promises[e.id] = new o.a(function (e) {
              return e(t.layers);
            }), !1) : (e.mapLayer && s && t.update(e), t.promises[e.id] && t.promises[e.id].isPending && t.promises[e.id].isPending() && t.promises[e.id].cancel(), t.requestLayer(e), !1);
          }), o.a.all($i(this.promises)).then(function () {
            return t.layers;
          })["finally"](function () {
            t.promises = {};
          })) : new o.a(function (e) {
            return e(t.layers);
          });
        }
      }, {
        key: "add",
        value: function value(t) {
          var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            opacity: 1,
            visibility: !0,
            zIndex: 0,
            interactivity: null
          };
          return void 0 === t ? this : Array.isArray(t) ? (t.forEach(function (t) {
            var r = e.layers.find(function (e) {
              return e.id === t.id;
            }),
                o = Gi({}, t, n);
            r ? r.update(o) : e.layers.push(new pu(o));
          }), this.renderLayers()) : this;
        }
      }, {
        key: "update",
        value: function value(t) {
          var e = t.changedAttributes,
              n = e.opacity,
              r = e.visibility,
              o = e.zIndex,
              i = e.params,
              a = e.sqlParams,
              s = e.decodeParams,
              c = e.layerConfig,
              u = e.events;
          void 0 !== n && this.plugin.setOpacity(t, n), void 0 !== r && this.plugin.setOpacity(t, r ? t.opacity : 0), void 0 !== o && this.plugin.setZIndex(t, o), void 0 !== u && this.setEvents(t), Os(c) || this.plugin.setLayerConfig(t), Os(i) || this.plugin.setParams(t), Os(a) || this.plugin.setParams(t), Os(s) || this.plugin.setDecodeParams(t);
        }
      }, {
        key: "remove",
        value: function value(t) {
          var e = this,
              n = this.layers.slice(0),
              r = Array.isArray(t) ? t : [t];
          this.layers.forEach(function (t, o) {
            r ? r.includes(t.id) && (e.plugin.remove(t), n.splice(o, 1)) : e.plugin.remove(t);
          }), this.layers = r ? n : [];
        }
      }, {
        key: "setOpacity",
        value: function value(t, e) {
          var n = this,
              r = this.layers.filter(function (e) {
            return t.includes(e.id);
          });
          r.length && r.forEach(function (t) {
            n.plugin.setOpacity(t, e);
          });
        }
      }, {
        key: "setVisibility",
        value: function value(t, e) {
          var n = this,
              r = this.layers.filter(function (e) {
            return t.includes(e.id);
          });
          r.length && r.forEach(function (t) {
            n.plugin.setVisibility(t, e);
          });
        }
      }, {
        key: "setZIndex",
        value: function value(t, e) {
          var n = this,
              r = this.layers.filter(function (e) {
            return t.includes(e.id);
          });
          r.length && r.forEach(function (t) {
            n.plugin.setZIndex(t, e);
          });
        }
      }, {
        key: "setEvents",
        value: function value(t) {
          t.events && this.plugin.setEvents(t);
        }
      }, {
        key: "requestLayer",
        value: function value(t) {
          var e = this,
              n = t.provider,
              r = this.plugin.getLayerByProvider(n);
          return r ? (this.promises[t.id] = r.call(this, t).then(function (n) {
            t.set("mapLayer", n), e.plugin.add(t), e.plugin.setZIndex(t, t.zIndex), e.plugin.setOpacity(t, t.opacity), e.plugin.setVisibility(t, t.visibility), e.setEvents(t);
          }), this) : (this.promises[t.id] = new o.a(function (t, e) {
            return e(new Error(n + " provider is not yet supported."));
          }), !1);
        }
      }]);
    }();

    var hu = function hu() {
      return ua.Date.now();
    },
        du = "[object Symbol]";

    var vu = function vu(t) {
      return "symbol" == _typeof(t) || es(t) && wa(t) == du;
    },
        yu = NaN,
        mu = /^\s+|\s+$/g,
        gu = /^[-+]0x[0-9a-f]+$/i,
        bu = /^0b[01]+$/i,
        _u = /^0o[0-7]+$/i,
        wu = parseInt;

    var xu = function xu(t) {
      if ("number" == typeof t) return t;
      if (vu(t)) return yu;

      if (xa(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = xa(e) ? e + "" : e;
      }

      if ("string" != typeof t) return 0 === t ? t : +t;
      t = t.replace(mu, "");
      var n = bu.test(t);
      return n || _u.test(t) ? wu(t.slice(2), n ? 2 : 8) : gu.test(t) ? yu : +t;
    },
        Ou = "Expected a function",
        Eu = Math.max,
        Cu = Math.min;

    var ju = function ju(t, e, n) {
      var r,
          o,
          i,
          a,
          s,
          c,
          u = 0,
          l = !1,
          f = !1,
          p = !0;
      if ("function" != typeof t) throw new TypeError(Ou);

      function h(e) {
        var n = r,
            i = o;
        return r = o = void 0, u = e, a = t.apply(i, n);
      }

      function d(t) {
        var n = t - c;
        return void 0 === c || n >= e || n < 0 || f && t - u >= i;
      }

      function v() {
        var t = hu();
        if (d(t)) return y(t);
        s = setTimeout(v, function (t) {
          var n = e - (t - c);
          return f ? Cu(n, i - (t - u)) : n;
        }(t));
      }

      function y(t) {
        return s = void 0, p && r ? h(t) : (r = o = void 0, a);
      }

      function m() {
        var t = hu(),
            n = d(t);

        if (r = arguments, o = this, c = t, n) {
          if (void 0 === s) return function (t) {
            return u = t, s = setTimeout(v, e), l ? h(t) : a;
          }(c);
          if (f) return s = setTimeout(v, e), h(c);
        }

        return void 0 === s && (s = setTimeout(v, e)), a;
      }

      return e = xu(e) || 0, xa(n) && (l = !!n.leading, i = (f = "maxWait" in n) ? Eu(xu(n.maxWait) || 0, e) : i, p = "trailing" in n ? !!n.trailing : p), m.cancel = function () {
        void 0 !== s && clearTimeout(s), u = 0, r = c = o = s = void 0;
      }, m.flush = function () {
        return void 0 === s ? a : y(hu());
      }, m;
    },
        Su = Yo.JSON || (Yo.JSON = {
      stringify: JSON.stringify
    }),
        Tu = function Tu(t) {
      return Su.stringify.apply(Su, arguments);
    },
        Pu = a(s(function (t) {
      t.exports = {
        "default": Tu,
        __esModule: !0
      };
    }));

    o.a.config({
      cancellation: !0
    });

    var ku = function ku(t) {
      for (var e = -1, n = null == t ? 0 : t.length, r = 0, o = []; ++e < n;) {
        var i = t[e];
        i && (o[r++] = i);
      }

      return o;
    },
        Mu = function Mu(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = t;
      return "string" == typeof r && (r = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t,
            r = void 0;
        return Cs(e).forEach(function (t) {
          r = (r = "" + ku(Cs(e[t]).map(function (n) {
            var r = e[t][n];
            return Array.isArray(r) && r.length ? n + " IN (" + r.map(function (t) {
              return window.isNaN(t) ? "'" + t + "'" : t;
            }).join(", ") + ")" : r ? window.isNaN(r) ? n + " = '" + r + "'" : n + " = " + r : null;
          })).join(" AND ")) && t.startsWith("where") ? "WHERE " + r : r && t.startsWith("and") ? "AND " + r : "", n = (n = n.replace(new RegExp("{{" + t + "}}", "g"), r)).replace(new RegExp("{" + t + "}", "g"), r);
        }), n;
      }(r = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t;
        return Cs(e).forEach(function (t) {
          n = (n = n.replace(new RegExp("{{" + t + "}}", "g"), e[t])).replace(new RegExp("{" + t + "}", "g"), e[t]);
        }), n;
      }(r, e), n)), r;
    },
        zu = function zu(t) {
      var e = t.layerConfig,
          n = t.params,
          r = t.sqlParams,
          i = t.interactivity,
          a = t.layerRequest,
          s = !1 === e.parse ? e : JSON.parse(Mu(Pu(e), n, r)),
          c = Pu({
        version: "1.3.0",
        stat_tag: "API",
        layers: s.body.layers.map(function (t) {
          return i && i.length ? Gi({}, t, {
            options: Gi({}, t.options, {
              interactivity: i
            })
          }) : t;
        })
      }),
          u = "?stat_tag=API&config=" + encodeURIComponent(c),
          l = "https://" + s.account + ".carto.com/api/v1/map" + u;
      a && a instanceof o.a && a.cancel();

      var f = function (t) {
        return new o.a(function (e, n, r) {
          var o = new XMLHttpRequest();
          o.open("GET", t, !0), o.addEventListener("load", function () {
            return e(o);
          }), o.addEventListener("error", n), o.send(null), r(function () {
            return o.abort();
          });
        });
      }(l).then(function (t) {
        return !(t.status > 400) && JSON.parse(t.response);
      });

      return t.set("layerRequest", f), f;
    },
        Lu = ("undefined" != typeof window ? window : {}).L,
        Au = function Au(t) {
      if (!Lu) throw new Error("Leaflet must be defined.");
      var e = t.layerConfig,
          n = t.params,
          r = t.sqlParams,
          i = t.interactivity,
          a = !1 === e.parse ? e : JSON.parse(Mu(Pu(e), n, r));
      return new o.a(function (e, n) {
        zu(t).then(function (n) {
          var r = n.cdn_url.templates.https.url + "/" + a.account + "/api/v1/map/" + n.layergroupid + "/{z}/{x}/{y}.png",
              o = Lu.tileLayer(r);

          if (i && i.length) {
            var s = "https://" + a.account + ".carto.com/api/v1/map/" + n.layergroupid + "/0/{z}/{x}/{y}.grid.json",
                c = Lu.utfGrid(s),
                u = Lu.LayerGroup.extend({
              group: !0,
              setOpacity: function setOpacity(e) {
                t.mapLayer.getLayers().forEach(function (t) {
                  t.setOpacity(e);
                });
              }
            });
            return e(new u([o, c]));
          }

          return e(o);
        })["catch"](function (t) {
          return n(t);
        });
      });
    },
        Ru = ui,
        Nu = {},
        Fu = ei ? Object.defineProperties : function (t, e) {
      Jo(t);

      for (var n, r = Ni(e), o = r.length, i = 0; o > i;) {
        si.f(t, n = r[i++], e[n]);
      }

      return t;
    },
        Iu = Zo.document,
        Du = Iu && Iu.documentElement,
        Bu = zi("IE_PROTO"),
        Vu = function Vu() {},
        _Hu = function Hu() {
      var t,
          e = oi("iframe"),
          n = Ri.length;

      for (e.style.display = "none", Du.appendChild(e), e.src = "javascript:", (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), _Hu = t.F; n--;) {
        delete _Hu.prototype[Ri[n]];
      }

      return _Hu();
    },
        Uu = Object.create || function (t, e) {
      var n;
      return null !== t ? (Vu.prototype = Jo(t), n = new Vu(), Vu.prototype = null, n[Bu] = t) : n = _Hu(), void 0 === e ? n : Fu(n, e);
    },
        Wu = s(function (t) {
      var e = Si("wks"),
          n = Zo.Symbol,
          r = "function" == typeof n;
      (t.exports = function (t) {
        return e[t] || (e[t] = r && n[t] || (r ? n : ki)("Symbol." + t));
      }).store = e;
    }),
        qu = si.f,
        Gu = Wu("toStringTag"),
        Ku = function Ku(t, e, n) {
      t && !fi(t = n ? t : t.prototype, Gu) && qu(t, Gu, {
        configurable: !0,
        value: e
      });
    },
        Zu = {};

    ui(Zu, Wu("iterator"), function () {
      return this;
    });

    var Yu = zi("IE_PROTO"),
        $u = Object.prototype,
        Xu = Object.getPrototypeOf || function (t) {
      return t = Di(t), fi(t, Yu) ? t[Yu] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? $u : null;
    },
        Qu = Wu("iterator"),
        Ju = !([].keys && "next" in [].keys()),
        tl = function tl() {
      return this;
    },
        el = function el(t, e, n, r, o, i, a) {
      !function (t, e, n) {
        t.prototype = Uu(Zu, {
          next: ci(1, n)
        }), Ku(t, e + " Iterator");
      }(n, e, r);

      var s,
          c,
          u,
          l = function l(t) {
        if (!Ju && t in d) return d[t];

        switch (t) {
          case "keys":
          case "values":
            return function () {
              return new n(this, t);
            };
        }

        return function () {
          return new n(this, t);
        };
      },
          f = e + " Iterator",
          p = "values" == o,
          h = !1,
          d = t.prototype,
          v = d[Qu] || d["@@iterator"] || o && d[o],
          y = v || l(o),
          m = o ? p ? l("entries") : y : void 0,
          g = "Array" == e && d.entries || v;

      if (g && (u = Xu(g.call(new t()))) !== Object.prototype && u.next && Ku(u, f, !0), p && v && "values" !== v.name && (h = !0, y = function y() {
        return v.call(this);
      }), a && (Ju || h || !d[Qu]) && ui(d, Qu, y), Nu[e] = y, Nu[f] = tl, o) if (s = {
        values: p ? y : l("values"),
        keys: i ? y : l("keys"),
        entries: m
      }, a) for (c in s) {
        c in d || Ru(d, c, s[c]);
      } else di(di.P + di.F * (Ju || h), e, s);
      return s;
    },
        nl = function (t) {
      return function (e, n) {
        var r,
            o,
            i = String(gi(e)),
            a = xi(n),
            s = i.length;
        return a < 0 || a >= s ? t ? "" : void 0 : (r = i.charCodeAt(a)) < 55296 || r > 56319 || a + 1 === s || (o = i.charCodeAt(a + 1)) < 56320 || o > 57343 ? t ? i.charAt(a) : r : t ? i.slice(a, a + 2) : o - 56320 + (r - 55296 << 10) + 65536;
      };
    }(!0);

    el(String, "String", function (t) {
      this._t = String(t), this._i = 0;
    }, function () {
      var t,
          e = this._t,
          n = this._i;
      return n >= e.length ? {
        value: void 0,
        done: !0
      } : (t = nl(e, n), this._i += t.length, {
        value: t,
        done: !1
      });
    });

    var rl = function rl(t, e) {
      return {
        value: e,
        done: !!t
      };
    };

    el(Array, "Array", function (t, e) {
      this._t = bi(t), this._i = 0, this._k = e;
    }, function () {
      var t = this._t,
          e = this._k,
          n = this._i++;
      return !t || n >= t.length ? (this._t = void 0, rl(1)) : rl(0, "keys" == e ? n : "values" == e ? t[n] : [n, t[n]]);
    }, "values");
    Nu.Arguments = Nu.Array;

    for (var ol = Wu("toStringTag"), il = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), al = 0; al < il.length; al++) {
      var sl = il[al],
          cl = Zo[sl],
          ul = cl && cl.prototype;
      ul && !ul[ol] && ui(ul, ol, sl), Nu[sl] = Nu.Array;
    }

    var ll,
        fl,
        pl,
        hl = Wu("toStringTag"),
        dl = "Arguments" == yi(function () {
      return arguments;
    }()),
        vl = function vl(t) {
      var e, n, r;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function (t, e) {
        try {
          return t[e];
        } catch (t) {}
      }(e = Object(t), hl)) ? n : dl ? yi(e) : "Object" == (r = yi(e)) && "function" == typeof e.callee ? "Arguments" : r;
    },
        yl = function yl(t, e, n, r) {
      try {
        return r ? e(Jo(n)[0], n[1]) : e(n);
      } catch (e) {
        var o = t["return"];
        throw void 0 !== o && Jo(o.call(t)), e;
      }
    },
        ml = Wu("iterator"),
        gl = Array.prototype,
        bl = Wu("iterator"),
        _l = Yo.getIteratorMethod = function (t) {
      if (void 0 != t) return t[bl] || t["@@iterator"] || Nu[vl(t)];
    },
        wl = s(function (t) {
      var e = {},
          n = {},
          r = t.exports = function (t, r, o, i, a) {
        var s,
            c,
            u,
            l,
            f,
            p = a ? function () {
          return t;
        } : _l(t),
            h = Xo(o, i, r ? 2 : 1),
            d = 0;
        if ("function" != typeof p) throw TypeError(t + " is not iterable!");

        if (void 0 === (f = p) || Nu.Array !== f && gl[ml] !== f) {
          for (u = p.call(t); !(c = u.next()).done;) {
            if ((l = yl(u, h, c.value, r)) === e || l === n) return l;
          }
        } else for (s = Ei(t.length); s > d; d++) {
          if ((l = r ? h(Jo(c = t[d])[0], c[1]) : h(t[d])) === e || l === n) return l;
        }
      };

      r.BREAK = e, r.RETURN = n;
    }),
        xl = Wu("species"),
        Ol = function Ol(t, e) {
      var n,
          r = Jo(t).constructor;
      return void 0 === r || void 0 == (n = Jo(r)[xl]) ? e : $o(n);
    },
        El = Zo.process,
        Cl = Zo.setImmediate,
        jl = Zo.clearImmediate,
        Sl = Zo.MessageChannel,
        Tl = Zo.Dispatch,
        Pl = 0,
        kl = {},
        Ml = function Ml() {
      var t = +this;

      if (kl.hasOwnProperty(t)) {
        var e = kl[t];
        delete kl[t], e();
      }
    },
        zl = function zl(t) {
      Ml.call(t.data);
    };

    Cl && jl || (Cl = function Cl(t) {
      for (var e = [], n = 1; arguments.length > n;) {
        e.push(arguments[n++]);
      }

      return kl[++Pl] = function () {
        !function (t, e, n) {
          var r = void 0 === n;

          switch (e.length) {
            case 0:
              return r ? t() : t.call(n);

            case 1:
              return r ? t(e[0]) : t.call(n, e[0]);

            case 2:
              return r ? t(e[0], e[1]) : t.call(n, e[0], e[1]);

            case 3:
              return r ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]);

            case 4:
              return r ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3]);
          }

          t.apply(n, e);
        }("function" == typeof t ? t : Function(t), e);
      }, ll(Pl), Pl;
    }, jl = function jl(t) {
      delete kl[t];
    }, "process" == yi(El) ? ll = function ll(t) {
      El.nextTick(Xo(Ml, t, 1));
    } : Tl && Tl.now ? ll = function ll(t) {
      Tl.now(Xo(Ml, t, 1));
    } : Sl ? (pl = (fl = new Sl()).port2, fl.port1.onmessage = zl, ll = Xo(pl.postMessage, pl, 1)) : Zo.addEventListener && "function" == typeof postMessage && !Zo.importScripts ? (ll = function ll(t) {
      Zo.postMessage(t + "", "*");
    }, Zo.addEventListener("message", zl, !1)) : ll = "onreadystatechange" in oi("script") ? function (t) {
      Du.appendChild(oi("script")).onreadystatechange = function () {
        Du.removeChild(this), Ml.call(t);
      };
    } : function (t) {
      setTimeout(Xo(Ml, t, 1), 0);
    });
    var Ll = {
      set: Cl,
      clear: jl
    },
        Al = Ll.set,
        Rl = Zo.MutationObserver || Zo.WebKitMutationObserver,
        Nl = Zo.process,
        Fl = Zo.Promise,
        Il = "process" == yi(Nl);

    var Dl = {
      f: function f(t) {
        return new function (t) {
          var e, n;
          this.promise = new t(function (t, r) {
            if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");
            e = t, n = r;
          }), this.resolve = $o(e), this.reject = $o(n);
        }(t);
      }
    },
        Bl = function Bl(t) {
      try {
        return {
          e: !1,
          v: t()
        };
      } catch (t) {
        return {
          e: !0,
          v: t
        };
      }
    },
        Vl = Zo.navigator,
        Hl = Vl && Vl.userAgent || "",
        Ul = function Ul(t, e) {
      if (Jo(t), Qo(e) && e.constructor === t) return e;
      var n = Dl.f(t);
      return (0, n.resolve)(e), n.promise;
    },
        Wl = Wu("species"),
        ql = Wu("iterator"),
        Gl = !1;

    try {
      [7][ql]()["return"] = function () {
        Gl = !0;
      };
    } catch (t) {}

    var Kl,
        Zl,
        Yl,
        $l,
        Xl = Ll.set,
        Ql = function () {
      var t,
          e,
          n,
          r = function r() {
        var r, o;

        for (Il && (r = Nl.domain) && r.exit(); t;) {
          o = t.fn, t = t.next;

          try {
            o();
          } catch (r) {
            throw t ? n() : e = void 0, r;
          }
        }

        e = void 0, r && r.enter();
      };

      if (Il) n = function n() {
        Nl.nextTick(r);
      };else if (!Rl || Zo.navigator && Zo.navigator.standalone) {
        if (Fl && Fl.resolve) {
          var o = Fl.resolve(void 0);

          n = function n() {
            o.then(r);
          };
        } else n = function n() {
          Al.call(Zo, r);
        };
      } else {
        var i = !0,
            a = document.createTextNode("");
        new Rl(r).observe(a, {
          characterData: !0
        }), n = function n() {
          a.data = i = !i;
        };
      }
      return function (r) {
        var o = {
          fn: r,
          next: void 0
        };
        e && (e.next = o), t || (t = o, n()), e = o;
      };
    }(),
        Jl = Zo.TypeError,
        tf = Zo.process,
        ef = tf && tf.versions,
        nf = ef && ef.v8 || "",
        _rf = Zo.Promise,
        of = "process" == vl(tf),
        af = function af() {},
        sf = Zl = Dl.f,
        cf = !!function () {
      try {
        var t = _rf.resolve(1),
            e = (t.constructor = {})[Wu("species")] = function (t) {
          t(af, af);
        };

        return (of || "function" == typeof PromiseRejectionEvent) && t.then(af) instanceof e && 0 !== nf.indexOf("6.6") && -1 === Hl.indexOf("Chrome/66");
      } catch (t) {}
    }(),
        uf = function uf(t) {
      var e;
      return !(!Qo(t) || "function" != typeof (e = t.then)) && e;
    },
        lf = function lf(t, e) {
      if (!t._n) {
        t._n = !0;
        var n = t._c;
        Ql(function () {
          for (var r = t._v, o = 1 == t._s, i = 0, a = function a(e) {
            var n,
                i,
                a,
                s = o ? e.ok : e.fail,
                c = e.resolve,
                u = e.reject,
                l = e.domain;

            try {
              s ? (o || (2 == t._h && hf(t), t._h = 1), !0 === s ? n = r : (l && l.enter(), n = s(r), l && (l.exit(), a = !0)), n === e.promise ? u(Jl("Promise-chain cycle")) : (i = uf(n)) ? i.call(n, c, u) : c(n)) : u(r);
            } catch (t) {
              l && !a && l.exit(), u(t);
            }
          }; n.length > i;) {
            a(n[i++]);
          }

          t._c = [], t._n = !1, e && !t._h && ff(t);
        });
      }
    },
        ff = function ff(t) {
      Xl.call(Zo, function () {
        var e,
            n,
            r,
            o = t._v,
            i = pf(t);
        if (i && (e = Bl(function () {
          of ? tf.emit("unhandledRejection", o, t) : (n = Zo.onunhandledrejection) ? n({
            promise: t,
            reason: o
          }) : (r = Zo.console) && r.error && r.error("Unhandled promise rejection", o);
        }), t._h = of || pf(t) ? 2 : 1), t._a = void 0, i && e.e) throw e.v;
      });
    },
        pf = function pf(t) {
      return 1 !== t._h && 0 === (t._a || t._c).length;
    },
        hf = function hf(t) {
      Xl.call(Zo, function () {
        var e;
        of ? tf.emit("rejectionHandled", t) : (e = Zo.onrejectionhandled) && e({
          promise: t,
          reason: t._v
        });
      });
    },
        df = function df(t) {
      var e = this;
      e._d || (e._d = !0, (e = e._w || e)._v = t, e._s = 2, e._a || (e._a = e._c.slice()), lf(e, !0));
    },
        vf = function vf(t) {
      var e,
          n = this;

      if (!n._d) {
        n._d = !0, n = n._w || n;

        try {
          if (n === t) throw Jl("Promise can't be resolved itself");
          (e = uf(t)) ? Ql(function () {
            var r = {
              _w: n,
              _d: !1
            };

            try {
              e.call(t, Xo(vf, r, 1), Xo(df, r, 1));
            } catch (t) {
              df.call(r, t);
            }
          }) : (n._v = t, n._s = 1, lf(n, !1));
        } catch (t) {
          df.call({
            _w: n,
            _d: !1
          }, t);
        }
      }
    };

    cf || (_rf = function rf(t) {
      !function (t, e, n, r) {
        if (!(t instanceof e) || void 0 !== r && r in t) throw TypeError(n + ": incorrect invocation!");
      }(this, _rf, "Promise", "_h"), $o(t), Kl.call(this);

      try {
        t(Xo(vf, this, 1), Xo(df, this, 1));
      } catch (t) {
        df.call(this, t);
      }
    }, (Kl = function Kl(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }).prototype = function (t, e, n) {
      for (var r in e) {
        n && t[r] ? t[r] = e[r] : ui(t, r, e[r]);
      }

      return t;
    }(_rf.prototype, {
      then: function then(t, e) {
        var n = sf(Ol(this, _rf));
        return n.ok = "function" != typeof t || t, n.fail = "function" == typeof e && e, n.domain = of ? tf.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && lf(this, !1), n.promise;
      },
      "catch": function _catch(t) {
        return this.then(void 0, t);
      }
    }), Yl = function Yl() {
      var t = new Kl();
      this.promise = t, this.resolve = Xo(vf, t, 1), this.reject = Xo(df, t, 1);
    }, Dl.f = sf = function sf(t) {
      return t === _rf || t === $l ? new Yl(t) : Zl(t);
    }), di(di.G + di.W + di.F * !cf, {
      Promise: _rf
    }), Ku(_rf, "Promise"), function (t) {
      var e = "function" == typeof Yo[t] ? Yo[t] : Zo[t];
      ei && e && !e[Wl] && si.f(e, Wl, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    }("Promise"), $l = Yo.Promise, di(di.S + di.F * !cf, "Promise", {
      reject: function reject(t) {
        var e = sf(this);
        return (0, e.reject)(t), e.promise;
      }
    }), di(di.S + !0 * di.F, "Promise", {
      resolve: function resolve(t) {
        return Ul(this === $l ? _rf : this, t);
      }
    }), di(di.S + di.F * !(cf && function (t, e) {
      if (!e && !Gl) return !1;
      var n = !1;

      try {
        var r = [7],
            o = r[ql]();
        o.next = function () {
          return {
            done: n = !0
          };
        }, r[ql] = function () {
          return o;
        }, t(r);
      } catch (t) {}

      return n;
    }(function (t) {
      _rf.all(t)["catch"](af);
    })), "Promise", {
      all: function all(t) {
        var e = this,
            n = sf(e),
            r = n.resolve,
            o = n.reject,
            i = Bl(function () {
          var n = [],
              i = 0,
              a = 1;
          wl(t, !1, function (t) {
            var s = i++,
                c = !1;
            n.push(void 0), a++, e.resolve(t).then(function (t) {
              c || (c = !0, n[s] = t, --a || r(n));
            }, o);
          }), --a || r(n);
        });
        return i.e && o(i.v), n.promise;
      },
      race: function race(t) {
        var e = this,
            n = sf(e),
            r = n.reject,
            o = Bl(function () {
          wl(t, !1, function (t) {
            e.resolve(t).then(n.resolve, r);
          });
        });
        return o.e && r(o.v), n.promise;
      }
    }), di(di.P + di.R, "Promise", {
      "finally": function _finally(t) {
        var e = Ol(this, Yo.Promise || Zo.Promise),
            n = "function" == typeof t;
        return this.then(n ? function (n) {
          return Ul(e, t()).then(function () {
            return n;
          });
        } : t, n ? function (n) {
          return Ul(e, t()).then(function () {
            throw n;
          });
        } : t);
      }
    }), di(di.S, "Promise", {
      "try": function _try(t) {
        var e = Dl.f(this),
            n = Bl(t);
        return (n.e ? e.reject : e.resolve)(n.v), e.promise;
      }
    });

    var yf = Yo.Promise,
        mf = a(s(function (t) {
      t.exports = {
        "default": yf,
        __esModule: !0
      };
    })),
        gf = ("undefined" != typeof window ? window : {}).L,
        bf = gf && gf.GridLayer.extend({
      tiles: {},
      createTile: function createTile(t, e) {
        for (var n = this, r = t.x, o = t.y, i = t.z, a = this.options.params, s = Mu(a.url, Gi({
          x: r,
          y: o,
          z: i
        }, a)), c = Cs(this.tiles), u = 0; u < c.length; u++) {
          this.tiles[c[u]].z !== i && delete this.tiles[c[u]];
        }

        this.done = e;
        var l = gf.DomUtil.create("canvas", "leaflet-tile"),
            f = l.getContext("2d"),
            p = this.getTileSize();
        return l.width = p.x, l.height = p.y, this.getTile({
          x: r,
          y: o,
          z: i
        }).then(function (t) {
          n.cacheTile(Gi({
            id: s,
            tile: l,
            ctx: f,
            image: t
          }, {
            x: r,
            y: o,
            z: i
          })), n.drawCanvas(s), e(null, l);
        })["catch"](function (t) {
          e(t, l);
        }), l;
      },
      getTile: function getTile(t) {
        var e = this,
            n = t.x,
            r = t.y,
            o = t.z,
            i = this.options,
            a = i.params,
            s = i.sqlParams,
            c = a.url,
            u = a.dataMaxZoom,
            l = void 0 === u ? 20 : u,
            f = o - l,
            p = Mu(a.url, Gi({
          x: n,
          y: r,
          z: o
        }, a)),
            h = {
          x: n,
          y: r,
          z: o
        };
        f > 0 && (h = {
          x: Math.floor(n / Math.pow(2, f)),
          y: Math.floor(r / Math.pow(2, f)),
          z: l
        });
        var d = Mu(c, Gi({}, h, a), s);
        return new mf(function (t, n) {
          e.tiles[p] && t(e.tiles[p].image);
          var r = new XMLHttpRequest();
          r.addEventListener("load", function (e) {
            var r = e.currentTarget.response,
                o = URL.createObjectURL(r),
                i = new Image();
            i.src = o, i.onload = function () {
              i.crossOrigin = "", t(i), URL.revokeObjectURL(o);
            }, i.onerror = function () {
              n(new Error("Can't load image"));
            };
          }), r.addEventListener("error", n), r.open("GET", d, !0), r.responseType = "blob", r.send();
        });
      },
      cacheTile: function cacheTile(t) {
        this.tiles[t.id] = Gi({}, this.tiles[t.id], t);
      },
      drawCanvas: function drawCanvas(t) {
        "use asm";

        if (!this.tiles[t]) {
          return;
        }

        var e = this.tiles[t],
            n = e.tile,
            r = e.ctx,
            o = e.image,
            i = e.x,
            a = e.y,
            s = e.z;

        if (!n || !r || !o || !i || !a || !s) {
          delete this.tiles[t];
          return;
        }

        var c = this.options,
            u = c.params,
            l = c.decodeParams,
            f = c.decodeFunction;
        var p = u.dataMaxZoom,
            h = p === undefined ? 20 : p;
        var d = s - h;
        r.clearRect(0, 0, n.width, n.width);

        if (d < 0) {
          r.drawImage(o, 0, 0);
        } else {
          r.imageSmoothingEnabled = false;
          r.mozImageSmoothingEnabled = false;
          var v = n.width / Math.pow(2, d) * (i % Math.pow(2, d)) || 0;
          var y = n.height / Math.pow(2, d) * (a % Math.pow(2, d)) || 0;
          var m = n.width / Math.pow(2, d) || 0;
          var g = n.height / Math.pow(2, d) || 0;
          r.drawImage(o, v, y, m, g, 0, 0, n.width, n.height);
        }

        var b = r.getImageData(0, 0, n.width, n.height);

        if (typeof f === "function") {
          f(b.data, n.width, n.height, s, l);
        }

        r.putImageData(b, 0, 0);
      },
      reDraw: function reDraw(t) {
        var e = this;
        this.options.params = t.params, this.options.sqlParams = t.sqlParams, this.options.decodeParams = t.decodeParams;
        var n = t.params,
            r = t.sqlParams;
        Cs(this.tiles).map(function (t) {
          var o = e.tiles[t],
              i = o.x,
              a = o.y,
              s = o.z,
              c = Mu(n.url, Gi({
            x: i,
            y: a,
            z: s
          }, n, {
            sqlParams: r
          }));
          return e.drawCanvas(c);
        });
      }
    }),
        _f = ("undefined" != typeof window ? window : {}).L,
        wf = eval,
        xf = function xf(t) {
      if (!_f) throw new Error("Leaflet must be defined.");
      var e = t.layerConfig,
          n = t.params,
          r = t.sqlParams,
          i = t.decodeParams,
          a = void 0,
          s = !1 === e.parse ? e : JSON.parse(Mu(Pu(e), n, r));

      switch (s.body.crs && _f.CRS[s.body.crs] && (s.body.crs = _f.CRS[s.body.crs.replace(":", "")], s.body.pane = "tilePane"), s.type) {
        case "wms":
          a = _f.tileLayer.wms(s.url || s.body.url, s.body);
          break;

        case "tileLayer":
          Pu(s.body).indexOf('style: "function') >= 0 && (s.body.style = wf("(" + s.body.style + ")")), a = i ? new bf(Gi({}, t)) : _f.tileLayer(s.url || s.body.url, s.body);
          break;

        default:
          a = _f[s.type](s.body, s.options || {});
      }

      return new o.a(function (t, e) {
        a ? t(a) : e(new Error('"type" specified in layer spec doesn`t exist'));
      });
    },
        Of = ("undefined" != typeof window ? window : {}).L,
        Ef = Of && Of.GridLayer.extend({
      tiles: {},
      cache: {},
      mouseOn: null,
      createTile: function createTile(t) {
        for (var e = t.z, n = Cs(this.tiles), r = 0; r < n.length; r++) {
          this.tiles[n[r]].z !== e && delete this.tiles[n[r]];
        }

        var o = Of.DomUtil.create("div", "leaflet-tile"),
            i = this.getTileSize();
        return o.width = i.x, o.height = i.y, o;
      },
      onAdd: function onAdd(t) {
        Of.GridLayer.prototype.onAdd.call(this, t), this.map = t;
        var e = Math.round(this.map.getZoom());
        e > this.options.maxZoom || e < this.options.minZoom || (t.on("click", this.click, this), t.on("mousemove", this.move, this));
      },
      onRemove: function onRemove() {
        var t = this.map;
        t.off("click", this.click, this), t.off("mousemove", this.move, this);
      },
      click: function click(t) {
        this.fire("click", this.objectForEvent(t));
      },
      move: function move(t) {
        var e = this.objectForEvent(t);
        e.data !== this.mouseOn ? (this.mouseOn && this.fire("mouseout", {
          latlng: t.latlng,
          data: this.mouseOn
        }), e.data && this.fire("mouseover", e), this.mouseOn = e.data) : e.data && this.fire("mousemove", e);
      },
      objectForEvent: function objectForEvent(t) {
        return Of.extend({
          latlng: t.latlng,
          data: null
        }, t);
      }
    }),
        Cf = ("undefined" != typeof window ? window : {}).L,
        jf = eval,
        Sf = function Sf(t) {
      if (!Cf) throw new Error("Leaflet must be defined.");
      if (!Cf.esri) throw new Error("To support this layer you should add esri library for Leaflet.");
      var e = t.layerConfig,
          n = t.interactivity,
          r = t.params,
          i = t.sqlParams,
          a = !1 === e.parse ? e : JSON.parse(Mu(Pu(e), r, i)),
          s = Pu(a.body || {}).replace(/"mosaic-rule":/g, '"mosaicRule":').replace(/"mosaic_rule":/g, '"mosaicRule":').replace(/"use-cors":/g, '"useCors":').replace(/"use_cors":/g, '"useCors":');
      return Cf[a.type] ? new xf(Gi({}, t)) : new o.a(function (e, r) {
        if (!Cf.esri[a.type]) return r(new Error('"type" specified in layer spec doesn`t exist'));
        var o = JSON.parse(s);
        o.pane = "tilePane", o.useCors = !0, o.style && o.style.indexOf("function") >= 0 && (o.style = jf("(" + o.style + ")"));
        var i = void 0;
        if (!(i = Cf.esri[a.type](o))) return r();

        if (i.on("load", function () {
          i.setZIndex(t.zIndex);
        }), i.on("requesterror", function (t) {}), i.setZIndex || (i.setZIndex = function (t) {
          i._currentImage && (i._currentImage._image.style.zIndex = t);
        }), n) {
          var c = new Ef(),
              u = Cf.LayerGroup.extend({
            group: !0,
            setOpacity: function setOpacity(e) {
              t.mapLayer.getLayers().forEach(function (t) {
                t.setOpacity(e);
              });
            }
          });
          i = new u([i, c]);
        }

        return e(i);
      });
    },
        Tf = ("undefined" != typeof window ? window : {}).L,
        Pf = function Pf(t) {
      if (!Tf) throw new Error("Leaflet must be defined.");
      var e = t.id,
          n = t.layerConfig,
          r = t.interactivity,
          i = t.params,
          a = t.sqlParams,
          s = t.decodeParams,
          c = "https://api.resourcewatch.org/v1/layer/" + e + "/tile/gee/{z}/{x}/{y}",
          u = !1 === n.parse ? n : JSON.parse(Mu(Pu(n), i, a)),
          l = void 0;

      switch (u.type) {
        case "tileLayer":
          l = s ? new bf(Gi({}, t)) : Tf.tileLayer(c, u.body);
          break;

        default:
          l = Tf.tileLayer(c, u.body);
      }

      if (r) {
        var f = new Ef(),
            p = Tf.LayerGroup.extend({
          group: !0,
          setOpacity: function setOpacity(e) {
            t.mapLayer.getLayers().forEach(function (t) {
              t.setOpacity(e);
            });
          }
        });
        l = new p([l, f]);
      }

      return new o.a(function (t, e) {
        l ? t(l) : e(new Error('"type" specified in layer spec doesn`t exist'));
      });
    },
        kf = ("undefined" != typeof window ? window : {}).L,
        Mf = kf && new kf.LatLngBounds(new kf.LatLng(49.496674527470454, -66.357421875), new kf.LatLng(24.607069137709683, -131.66015625)),
        zf = function zf(t) {
      var e = t.id,
          n = t.layerConfig,
          r = (n.period || {}).value || "1971",
          i = "https://api.resourcewatch.org/v1/layer/" + e + "/tile/loca/{z}/{x}/{y}?year=" + new Date(r).toISOString(),
          a = kf.tileLayer(i, Gi({}, n.body, {
        minNativeZoom: 4,
        bounds: Mf
      }));
      return new o.a(function (t) {
        t(a);
      });
    },
        Lf = ("undefined" != typeof window ? window : {}).L,
        Af = function Af(t) {
      var e = t.id,
          n = t.layerConfig,
          r = (n.period || {}).value || "1971-01-01",
          i = "https://api.resourcewatch.org/v1/layer/" + e + "/tile/nexgddp/{z}/{x}/{y}?year=" + new Date(r).toISOString(),
          a = Lf.tileLayer(i, n.body);
      return new o.a(function (t) {
        t(a);
      });
    },
        Rf = (function () {
      function t(e) {
        var n = this;
        Xi(this, t), Object.defineProperty(this, "events", {
          enumerable: !0,
          writable: !0,
          value: {}
        }), Object.defineProperty(this, "method", {
          enumerable: !0,
          writable: !0,
          value: {
            cartodb: Au,
            carto: Au,
            arcgis: Sf,
            featureservice: Sf,
            mapservice: Sf,
            tileservice: Sf,
            esrifeatureservice: Sf,
            esrimapservice: Sf,
            esritileservice: Sf,
            gee: Pf,
            loca: zf,
            nexgddp: Af,
            leaflet: xf,
            wms: xf
          }
        }), Object.defineProperty(this, "setEvents", {
          enumerable: !0,
          writable: !0,
          value: ju(function (t) {
            var e = t.mapLayer,
                r = t.events;
            return n.events[t.id] && Cs(n.events[t.id]).forEach(function (t) {
              e.group ? e.eachLayer(function (e) {
                e.off(t);
              }) : e.off(t);
            }), Cs(r).forEach(function (t) {
              e.group ? e.eachLayer(function (e) {
                e.on(t, r[t]);
              }) : e.on(t, r[t]);
            }), n.events[t.id] = r, n;
          }, 200, {
            leading: !0
          })
        }), this.map = e;
      }

      ea(t, [{
        key: "add",
        value: function value(t) {
          var e = t.mapLayer;
          this.map.addLayer(e);
        }
      }, {
        key: "remove",
        value: function value(t) {
          var e = t.mapLayer,
              n = t.events;
          n && e && Cs(n).forEach(function (t) {
            e.group ? e.eachLayer(function (e) {
              e.off(t);
            }) : e.off(t);
          }), e && this.map.removeLayer(e);
        }
      }, {
        key: "getLayerByProvider",
        value: function value(t) {
          return this.method[t];
        }
      }, {
        key: "setZIndex",
        value: function value(t, e) {
          return t.mapLayer.setZIndex(e), this;
        }
      }, {
        key: "setOpacity",
        value: function value(t, e) {
          var n = t.mapLayer;
          return "function" == typeof n.setOpacity && n.setOpacity(e), "function" == typeof n.setStyle && n.setStyle({
            opacity: e
          }), this;
        }
      }, {
        key: "setVisibility",
        value: function value(t, e) {
          var n = t.opacity;
          this.setOpacity(t, e ? n : 0);
        }
      }, {
        key: "setParams",
        value: function value(t) {
          this.remove(t);
        }
      }, {
        key: "setLayerConfig",
        value: function value(t) {
          this.remove(t);
        }
      }, {
        key: "setDecodeParams",
        value: function value(t) {
          var e = t.mapLayer,
              n = t.params,
              r = t.sqlParams,
              o = t.decodeParams,
              i = t.decodeFunction;
          return e.reDraw({
            decodeParams: o,
            decodeFunction: i,
            params: n,
            sqlParams: r
          }), this;
        }
      }]);
    }(), function (t) {
      return function (e) {
        return zu(e).then(function (n) {
          var r = e.layerConfig,
              o = n.cdn_url.templates.https.url + "/" + r.account + "/api/v1/map/" + n.layergroupid + "/{z}/{x}/{y}.png",
              i = new t.UrlTemplateImageryProvider({
            url: o
          });
          return i.errorEvent.addEventListener(function () {
            return !1;
          }), new t.ImageryLayer(i);
        });
      };
    }),
        Nf = function Nf(t) {
      return function (e) {
        return new o.a(function (n) {
          var r = e.layerConfig,
              o = (void 0 === r ? {} : r).body.url,
              i = new t.UrlTemplateImageryProvider({
            url: o
          });
          i.errorEvent.addEventListener(function () {
            return !1;
          }), n(new t.ImageryLayer(i));
        });
      };
    },
        Ff = function () {
      function t(e) {
        Xi(this, t), If.call(this);
        var n = t.Cesium;
        this.map = e, this.eventListener = new n.ScreenSpaceEventHandler(e.scene.canvas), this.method = {
          carto: Rf(n),
          cartodb: Rf(n),
          cesium: Nf(n)
        };
      }

      return ea(t, [{
        key: "add",
        value: function value(t) {
          var e = t.mapLayer;
          this.map.imageryLayers.add(e);
        }
      }, {
        key: "remove",
        value: function value(t) {
          var e = t.mapLayer;
          this.map.imageryLayers.remove(e, !0), this.eventListener.destroy();
        }
      }, {
        key: "getLayerByProvider",
        value: function value(t) {
          return this.method[t];
        }
      }, {
        key: "setZIndex",
        value: function value(t, e) {
          var n = this.map.imageryLayers.length,
              r = t.mapLayer,
              o = e < 0 ? 0 : e >= n ? n - 1 : e,
              i = this.map.imageryLayers.indexOf(r);
          if (i !== o) for (var a = o - i, s = 0; s < Math.abs(a); s++) {
            a > 0 ? this.map.imageryLayers.raise(r) : this.map.imageryLayers.lower(r);
          }
          return this;
        }
      }, {
        key: "setOpacity",
        value: function value(t, e) {
          return t.mapLayer.alpha = e, this;
        }
      }, {
        key: "setVisibility",
        value: function value(t, e) {
          return t.mapLayer.show = e, this;
        }
      }, {
        key: "setEvents",
        value: function value(t) {
          var e = this,
              n = t.events;
          return Cs(n).forEach(function (t) {
            var r = n[t];
            e.eventListener.getInputAction(t) && e.eventListener.removeInputAction(t), e.eventListener.setInputAction(e.getCoordinatesFromEvent(r), t);
          }), this;
        }
      }, {
        key: "setParams",
        value: function value(t) {
          this.remove(t);
        }
      }, {
        key: "setLayerConfig",
        value: function value(t) {
          this.remove(t);
        }
      }, {
        key: "setDecodeParams",
        value: function value(t) {}
      }]), t;
    }();

    Object.defineProperty(Ff, "Cesium", {
      enumerable: !0,
      writable: !0,
      value: "undefined" != typeof window ? window.Cesium : null
    });

    var If = function If() {
      var t = this;
      Object.defineProperty(this, "getCoordinatesFromEvent", {
        enumerable: !0,
        writable: !0,
        value: function value(e) {
          return function (n) {
            var r = n.position,
                o = Ff.Cesium,
                i = new o.Cartesian2(r.x, r.y),
                a = t.map.scene.globe.ellipsoid,
                s = t.map.camera.pickEllipsoid(i, a);

            if (s) {
              var c = a.cartesianToCartographic(s),
                  u = o.Math.toDegrees(c.latitude),
                  l = o.Math.toDegrees(c.longitude);
              e(n, {
                lat: u,
                lng: l
              });
            }
          };
        }
      });
    };
  }).call(this, n(71));
}, function (t, e, n) {
  var r = n(184),
      o = n(186),
      i = n(105),
      a = n(42),
      s = n(72),
      c = n(112),
      u = n(185),
      l = n(113),
      f = "[object Map]",
      p = "[object Set]",
      h = Object.prototype.hasOwnProperty;

  t.exports = function (t) {
    if (null == t) return !0;
    if (s(t) && (a(t) || "string" == typeof t || "function" == typeof t.splice || c(t) || l(t) || i(t))) return !t.length;
    var e = o(t);
    if (e == f || e == p) return !t.size;
    if (u(t)) return !r(t).length;

    for (var n in t) {
      if (h.call(t, n)) return !1;
    }

    return !0;
  };
}, function (t, e, n) {
  "use strict";

  n.r(e);

  var r = n(14),
      o = n.n(r),
      i = n(0),
      a = n.n(i),
      s = n(1),
      c = n.n(s),
      u = n(11),
      l = n.n(u),
      f = n(18),
      p = n(93),
      h = (n(358), Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }),
      d = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }(),
      v = {
    "./styles.scss": {
      "c-timestep": "vizzuality__c-timestep",
      "player-btn": "vizzuality__player-btn",
      "timestep-slider": "vizzuality__timestep-slider",
      "can-play": "vizzuality__can-play"
    }
  };

  var y = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var n = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      m.call(n);
      var r = n.props,
          o = r.playing,
          i = r.start,
          a = r.end,
          s = r.trim,
          c = r.minAbs,
          u = r.maxAbs;
      return n.state = {
        playing: o,
        start: i <= c ? c : i,
        end: a >= u ? u : a,
        trim: s >= u ? u : s
      }, n;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, i["PureComponent"]), d(e, [{
      key: "componentDidUpdate",
      value: function value(t, e) {
        var n = this.state,
            r = n.playing,
            o = n.start,
            i = n.end,
            a = n.trim,
            s = e.playing,
            c = e.start,
            u = e.end,
            l = e.trim,
            f = this.props,
            p = f.playing,
            h = f.start,
            d = f.end,
            v = f.trim,
            y = f.minAbs,
            m = f.maxAbs,
            g = t.playing,
            b = t.start,
            _ = t.end,
            w = t.trim,
            x = t.minAbs,
            O = t.maxAbs;
        p !== g && this.setState({
          playing: p
        }), r && r !== s ? this.startTimeline() : r || r === s ? r && i !== u && this.incrementTimeline() : this.stopTimeline(), h !== b && h !== o && c === o && this.setState({
          start: h <= y ? y : h,
          end: v >= m ? m : v
        }), d !== _ && d !== i && u === i && this.setState({
          end: d >= m ? m : d
        }), v !== w && v !== a && l === a && this.setState({
          trim: v,
          end: v >= m ? m : v
        }), y === x && m === O || this.setState({
          start: h <= y ? y : h,
          trim: v >= m ? m : v,
          end: d >= m ? m : d
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.interval && this.stopTimeline();
      }
    }, {
      key: "getValue",
      value: function value() {
        var t = this.state,
            e = t.start,
            n = t.end,
            r = t.trim;
        return this.props.range ? [e, n, r] : n;
      }
    }, {
      key: "getTrackStyle",
      value: function value() {
        var t = this.state,
            e = t.start,
            n = t.end,
            r = t.trim,
            o = this.props.trackStyle;

        if (Array.isArray(o)) {
          var i = n - e,
              a = r - n,
              s = [];
          return o.map(function (t, o) {
            var c = t.gradient;

            if (c) {
              var u = Object.keys(c);
              return 0 === o && (s = u.filter(function (t, r) {
                var o = u[r + 1] || t;
                return t >= e - (t + o) && t <= n;
              }).map(function (t, n) {
                var r = 0 === n,
                    o = (t - e) / i * 100,
                    a = u.findIndex(function (e) {
                  return e === t;
                });
                return r ? "" + c[t] : c[u[a - 1]] + " " + o + "%, " + c[t] + " " + o + "%";
              })), 1 === o && (s = u.filter(function (t, e) {
                var o = u[e - 1] || t;
                return t > n - (t - o) && t <= r;
              }).map(function (t, e) {
                var r = 0 === e,
                    o = (t - n) / a * 100,
                    i = u.findIndex(function (e) {
                  return e === t;
                });
                return r ? "" + c[t] : c[u[i - 1]] + " " + o + "%, " + c[t] + " " + o + "%";
              })), h({}, t, {
                background: s.length > 1 ? "linear-gradient(to right, " + s.join(",") + ")" : s.toString()
              });
            }

            return t;
          });
        }

        return o;
      }
    }, {
      key: "renderPlay",
      value: function value() {
        var t = this.state.playing,
            e = l()({
          "icon-pause": t,
          "icon-play": !t
        });
        return a.a.createElement("button", {
          type: "button",
          className: (l()({
            "-playing": t
          }) ? l()({
            "-playing": t
          }) + " " : "") + "vizzuality__player-btn",
          onClick: this.handleTogglePlay
        }, a.a.createElement(f["default"], {
          name: e
        }));
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.min,
            n = t.max,
            r = t.marks,
            i = t.formatValue,
            s = t.step,
            c = t.canPlay,
            u = t.customClass,
            f = t.railStyle,
            h = t.handleStyle,
            d = t.range,
            y = t.pushable,
            m = t.PlayButton,
            g = this.state.playing;
        return a.a.createElement("div", {
          className: (u ? u + " " : "") + "vizzuality__c-timestep"
        }, c && !m && this.renderPlay(), c && !!m && m, a.a.createElement("div", {
          className: o()(l()("timestep-slider", {
            "can-play": c
          }), v)
        }, a.a.createElement(p["default"], {
          range: d,
          marks: r,
          disabled: g,
          min: e,
          max: n,
          value: this.getValue(),
          step: s,
          formatValue: i,
          railStyle: f,
          trackStyle: this.getTrackStyle(),
          handleStyle: h,
          showTooltip: function showTooltip(t) {
            return g && 1 === t;
          },
          pushable: y,
          onChange: this.handleOnChange,
          onAfterChange: this.handleOnAfterChange
        })));
      }
    }]), e;
  }();

  y.propTypes = {
    customClass: c.a.string,
    range: c.a.bool,
    pushable: c.a.oneOfType([c.a.bool, c.a.number]),
    canPlay: c.a.bool,
    min: c.a.number.isRequired,
    minAbs: c.a.number,
    max: c.a.number.isRequired,
    maxAbs: c.a.number,
    start: c.a.number.isRequired,
    end: c.a.number.isRequired,
    trim: c.a.number,
    marks: c.a.shape({}).isRequired,
    step: c.a.number,
    speed: c.a.number,
    loop: c.a.bool,
    formatValue: c.a.func.isRequired,
    trackStyle: c.a.arrayOf(c.a.oneOfType([c.a.array, c.a.object])),
    railStyle: c.a.shape({}),
    handleStyle: c.a.shape({}),
    playing: c.a.bool,
    PlayButton: c.a.node,
    handleOnChange: c.a.func,
    handleOnAfterChange: c.a.func,
    handleOnPlay: c.a.func
  }, y.defaultProps = {
    customClass: null,
    range: !0,
    pushable: 0,
    canPlay: !1,
    trim: null,
    minAbs: -1 / 0,
    maxAbs: 1 / 0,
    step: 1,
    speed: 100,
    loop: !1,
    trackStyle: {
      backgroundColor: "#c32d7b",
      borderRadius: "0px"
    },
    railStyle: {
      backgroundColor: "#d9d9d9"
    },
    handleStyle: {
      backgroundColor: "#c32d7b",
      borderRadius: "10px",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.29)",
      border: "0px",
      zIndex: 2
    },
    playing: void 0,
    PlayButton: null,
    handleOnChange: null,
    handleOnAfterChange: null,
    handleOnPlay: null
  };

  var m = function m() {
    var t = this;
    this.startTimeline = function () {
      var e = t.state,
          n = e.start,
          r = e.end,
          o = e.trim;
      r < o ? t.incrementTimeline() : r >= o && t.setState({
        end: n
      }, function () {
        t.incrementTimeline();
      });
    }, this.stopTimeline = function () {
      clearInterval(t.interval);
    }, this.incrementTimeline = function () {
      var e = t.state,
          n = e.start,
          r = e.end,
          o = e.trim,
          i = t.props,
          a = i.speed,
          s = i.step,
          c = i.range,
          u = i.max,
          l = i.maxAbs,
          f = u >= l ? l : u;
      t.interval = setTimeout(function () {
        var e = r + s;
        e > o && c || !c && e >= f ? t.handleResetTimeline() : (t.handleOnChange([n, e, o]), t.handleOnAfterChange([n, e, o]));
      }, a);
    }, this.handleResetTimeline = function () {
      var e = t.props.loop,
          n = t.state.trim;
      t.stopTimeline(), e ? t.startTimeline() : t.setState({
        playing: !1,
        end: n
      });
    }, this.checkRange = function (e) {
      var n = t.state,
          r = n.playing,
          o = n.start,
          i = n.end,
          a = n.trim,
          s = t.props,
          c = s.min,
          u = s.max,
          l = s.minAbs,
          f = s.maxAbs,
          p = s.minGap,
          h = s.maxGap;
      if (!Array.isArray(e)) return [o, e, a];
      var d = e[0] <= l ? l : e[0],
          v = e[2] >= f ? f : e[2];
      return r || e[0] === o ? r || e[1] === e[2] || a === e[2] ? r || e[1] === e[2] || i === e[1] ? r || a === e[0] ? e : (p && v - (d + p) < 0 && (d === l || d === c ? v = d + p : d = v - p), h && (d = v - (d + h) > 0 ? v - h : d), [d, v, v]) : (v = e[1] >= f ? f : e[1], p && v - (d + p) < 0 && (d === l || d === c ? v = d + p : d = v - p), h && (d = v - (d + h) > 0 ? v - h : d), [d, v, v]) : (p && v - (d + p) < 0 && (d === l || d === c ? v = d + p : d = v - p), h && (d = v - (d + h) > 0 ? v - h : d), [d, v, v]) : (p && v - d < p && (v === f || v === u ? d = v - p : v = d + p), h && (v = v - d > h ? d + h : v), [d, v, v]);
    }, this.handleOnChange = function (e) {
      var n = t.props.handleOnChange,
          r = t.checkRange(e);
      t.setState({
        start: r[0],
        end: r[1],
        trim: r[2]
      }), n && n(r);
    }, this.handleOnAfterChange = function (e) {
      var n = t.props.handleOnAfterChange,
          r = t.checkRange(e);
      n && n(r);
    }, this.handleTogglePlay = function () {
      var e = t.props.handleOnPlay,
          n = !t.state.playing;
      t.setState({
        playing: n
      }), e && e(n);
    };
  };

  e["default"] = y;
}, function (t, e, n) {
  var r = n(48),
      o = n(52),
      i = "[object Arguments]";

  t.exports = function (t) {
    return o(t) && r(t) == i;
  };
}, function (t, e) {
  t.exports = function (t, e) {
    for (var n = -1, r = null == t ? 0 : t.length, o = Array(r); ++n < r;) {
      o[n] = e(t[n], n, t);
    }

    return o;
  };
}, function (t, e) {
  t.exports = function () {
    this.__data__ = [], this.size = 0;
  };
}, function (t, e, n) {
  var r = n(88),
      o = Array.prototype.splice;

  t.exports = function (t) {
    var e = this.__data__,
        n = r(e, t);
    return !(n < 0 || (n == e.length - 1 ? e.pop() : o.call(e, n, 1), --this.size, 0));
  };
}, function (t, e, n) {
  var r = n(88);

  t.exports = function (t) {
    var e = this.__data__,
        n = r(e, t);
    return n < 0 ? void 0 : e[n][1];
  };
}, function (t, e, n) {
  var r = n(88);

  t.exports = function (t) {
    return r(this.__data__, t) > -1;
  };
}, function (t, e, n) {
  var r = n(88);

  t.exports = function (t, e) {
    var n = this.__data__,
        o = r(n, t);
    return o < 0 ? (++this.size, n.push([t, e])) : n[o][1] = e, this;
  };
}, function (t, e, n) {
  var r = n(87);

  t.exports = function () {
    this.__data__ = new r(), this.size = 0;
  };
}, function (t, e) {
  t.exports = function (t) {
    var e = this.__data__,
        n = e["delete"](t);
    return this.size = e.size, n;
  };
}, function (t, e) {
  t.exports = function (t) {
    return this.__data__.get(t);
  };
}, function (t, e) {
  t.exports = function (t) {
    return this.__data__.has(t);
  };
}, function (t, e, n) {
  var r = n(87),
      o = n(106),
      i = n(111),
      a = 200;

  t.exports = function (t, e) {
    var n = this.__data__;

    if (n instanceof r) {
      var s = n.__data__;
      if (!o || s.length < a - 1) return s.push([t, e]), this.size = ++n.size, this;
      n = this.__data__ = new i(s);
    }

    return n.set(t, e), this.size = n.size, this;
  };
}, function (t, e, n) {
  var r = n(103),
      o = n(232),
      i = n(50),
      a = n(178),
      s = /^\[object .+?Constructor\]$/,
      c = Function.prototype,
      u = Object.prototype,
      l = c.toString,
      f = u.hasOwnProperty,
      p = RegExp("^" + l.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

  t.exports = function (t) {
    return !(!i(t) || o(t)) && (r(t) ? p : s).test(a(t));
  };
}, function (t, e, n) {
  var r,
      o = n(233),
      i = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";

  t.exports = function (t) {
    return !!i && i in t;
  };
}, function (t, e, n) {
  var r = n(36)["__core-js_shared__"];
  t.exports = r;
}, function (t, e) {
  t.exports = function (t, e) {
    return null == t ? void 0 : t[e];
  };
}, function (t, e, n) {
  var r = n(236),
      o = n(87),
      i = n(106);

  t.exports = function () {
    this.size = 0, this.__data__ = {
      hash: new r(),
      map: new (i || o)(),
      string: new r()
    };
  };
}, function (t, e, n) {
  var r = n(237),
      o = n(238),
      i = n(239),
      a = n(240),
      s = n(241);

  function c(t) {
    var e = -1,
        n = null == t ? 0 : t.length;

    for (this.clear(); ++e < n;) {
      var r = t[e];
      this.set(r[0], r[1]);
    }
  }

  c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = i, c.prototype.has = a, c.prototype.set = s, t.exports = c;
}, function (t, e, n) {
  var r = n(90);

  t.exports = function () {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  };
}, function (t, e) {
  t.exports = function (t) {
    var e = this.has(t) && delete this.__data__[t];
    return this.size -= e ? 1 : 0, e;
  };
}, function (t, e, n) {
  var r = n(90),
      o = "__lodash_hash_undefined__",
      i = Object.prototype.hasOwnProperty;

  t.exports = function (t) {
    var e = this.__data__;

    if (r) {
      var n = e[t];
      return n === o ? void 0 : n;
    }

    return i.call(e, t) ? e[t] : void 0;
  };
}, function (t, e, n) {
  var r = n(90),
      o = Object.prototype.hasOwnProperty;

  t.exports = function (t) {
    var e = this.__data__;
    return r ? void 0 !== e[t] : o.call(e, t);
  };
}, function (t, e, n) {
  var r = n(90),
      o = "__lodash_hash_undefined__";

  t.exports = function (t, e) {
    var n = this.__data__;
    return this.size += this.has(t) ? 0 : 1, n[t] = r && void 0 === e ? o : e, this;
  };
}, function (t, e, n) {
  var r = n(91);

  t.exports = function (t) {
    var e = r(this, t)["delete"](t);
    return this.size -= e ? 1 : 0, e;
  };
}, function (t, e) {
  t.exports = function (t) {
    var e = _typeof(t);

    return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
  };
}, function (t, e, n) {
  var r = n(91);

  t.exports = function (t) {
    return r(this, t).get(t);
  };
}, function (t, e, n) {
  var r = n(91);

  t.exports = function (t) {
    return r(this, t).has(t);
  };
}, function (t, e, n) {
  var r = n(91);

  t.exports = function (t, e) {
    var n = r(this, t),
        o = n.size;
    return n.set(t, e), this.size += n.size == o ? 0 : 1, this;
  };
}, function (t, e, n) {
  var r = n(182),
      o = n(179),
      i = n(253),
      a = n(257),
      s = n(186),
      c = n(42),
      u = n(112),
      l = n(113),
      f = 1,
      p = "[object Arguments]",
      h = "[object Array]",
      d = "[object Object]",
      v = Object.prototype.hasOwnProperty;

  t.exports = function (t, e, n, y, m, g) {
    var b = c(t),
        _ = c(e),
        w = b ? h : s(t),
        x = _ ? h : s(e),
        O = (w = w == p ? d : w) == d,
        E = (x = x == p ? d : x) == d,
        C = w == x;

    if (C && u(t)) {
      if (!u(e)) return !1;
      b = !0, O = !1;
    }

    if (C && !O) return g || (g = new r()), b || l(t) ? o(t, e, n, y, m, g) : i(t, e, w, n, y, m, g);

    if (!(n & f)) {
      var j = O && v.call(t, "__wrapped__"),
          S = E && v.call(e, "__wrapped__");

      if (j || S) {
        var T = j ? t.value() : t,
            P = S ? e.value() : e;
        return g || (g = new r()), m(T, P, n, y, g);
      }
    }

    return !!C && (g || (g = new r()), a(t, e, n, y, m, g));
  };
}, function (t, e, n) {
  var r = n(111),
      o = n(249),
      i = n(250);

  function a(t) {
    var e = -1,
        n = null == t ? 0 : t.length;

    for (this.__data__ = new r(); ++e < n;) {
      this.add(t[e]);
    }
  }

  a.prototype.add = a.prototype.push = o, a.prototype.has = i, t.exports = a;
}, function (t, e) {
  var n = "__lodash_hash_undefined__";

  t.exports = function (t) {
    return this.__data__.set(t, n), this;
  };
}, function (t, e) {
  t.exports = function (t) {
    return this.__data__.has(t);
  };
}, function (t, e) {
  t.exports = function (t, e) {
    for (var n = -1, r = null == t ? 0 : t.length; ++n < r;) {
      if (e(t[n], n, t)) return !0;
    }

    return !1;
  };
}, function (t, e) {
  t.exports = function (t, e) {
    return t.has(e);
  };
}, function (t, e, n) {
  var r = n(51),
      o = n(254),
      i = n(89),
      a = n(179),
      s = n(255),
      c = n(256),
      u = 1,
      l = 2,
      f = "[object Boolean]",
      p = "[object Date]",
      h = "[object Error]",
      d = "[object Map]",
      v = "[object Number]",
      y = "[object RegExp]",
      m = "[object Set]",
      g = "[object String]",
      b = "[object Symbol]",
      _ = "[object ArrayBuffer]",
      w = "[object DataView]",
      x = r ? r.prototype : void 0,
      O = x ? x.valueOf : void 0;

  t.exports = function (t, e, n, r, x, E, C) {
    switch (n) {
      case w:
        if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
        t = t.buffer, e = e.buffer;

      case _:
        return !(t.byteLength != e.byteLength || !E(new o(t), new o(e)));

      case f:
      case p:
      case v:
        return i(+t, +e);

      case h:
        return t.name == e.name && t.message == e.message;

      case y:
      case g:
        return t == e + "";

      case d:
        var j = s;

      case m:
        var S = r & u;
        if (j || (j = c), t.size != e.size && !S) return !1;
        var T = C.get(t);
        if (T) return T == e;
        r |= l, C.set(t, e);
        var P = a(j(t), j(e), r, x, E, C);
        return C["delete"](t), P;

      case b:
        if (O) return O.call(t) == O.call(e);
    }

    return !1;
  };
}, function (t, e, n) {
  var r = n(36).Uint8Array;
  t.exports = r;
}, function (t, e) {
  t.exports = function (t) {
    var e = -1,
        n = Array(t.size);
    return t.forEach(function (t, r) {
      n[++e] = [r, t];
    }), n;
  };
}, function (t, e) {
  t.exports = function (t) {
    var e = -1,
        n = Array(t.size);
    return t.forEach(function (t) {
      n[++e] = t;
    }), n;
  };
}, function (t, e, n) {
  var r = n(258),
      o = 1,
      i = Object.prototype.hasOwnProperty;

  t.exports = function (t, e, n, a, s, c) {
    var u = n & o,
        l = r(t),
        f = l.length;
    if (f != r(e).length && !u) return !1;

    for (var p = f; p--;) {
      var h = l[p];
      if (!(u ? h in e : i.call(e, h))) return !1;
    }

    var d = c.get(t);
    if (d && c.get(e)) return d == e;
    var v = !0;
    c.set(t, e), c.set(e, t);

    for (var y = u; ++p < f;) {
      var m = t[h = l[p]],
          g = e[h];
      if (a) var b = u ? a(g, m, h, e, t, c) : a(m, g, h, t, e, c);

      if (!(void 0 === b ? m === g || s(m, g, n, a, c) : b)) {
        v = !1;
        break;
      }

      y || (y = "constructor" == h);
    }

    if (v && !y) {
      var _ = t.constructor,
          w = e.constructor;
      _ != w && "constructor" in t && "constructor" in e && !("function" == typeof _ && _ instanceof _ && "function" == typeof w && w instanceof w) && (v = !1);
    }

    return c["delete"](t), c["delete"](e), v;
  };
}, function (t, e, n) {
  var r = n(259),
      o = n(260),
      i = n(173);

  t.exports = function (t) {
    return r(t, i, o);
  };
}, function (t, e, n) {
  var r = n(181),
      o = n(42);

  t.exports = function (t, e, n) {
    var i = e(t);
    return o(t) ? i : r(i, n(t));
  };
}, function (t, e, n) {
  var r = n(261),
      o = n(262),
      i = Object.prototype.propertyIsEnumerable,
      a = Object.getOwnPropertySymbols,
      s = a ? function (t) {
    return null == t ? [] : (t = Object(t), r(a(t), function (e) {
      return i.call(t, e);
    }));
  } : o;
  t.exports = s;
}, function (t, e) {
  t.exports = function (t, e) {
    for (var n = -1, r = null == t ? 0 : t.length, o = 0, i = []; ++n < r;) {
      var a = t[n];
      e(a, n, t) && (i[o++] = a);
    }

    return i;
  };
}, function (t, e) {
  t.exports = function () {
    return [];
  };
}, function (t, e, n) {
  var r = n(264),
      o = n(105),
      i = n(42),
      a = n(112),
      s = n(100),
      c = n(113),
      u = Object.prototype.hasOwnProperty;

  t.exports = function (t, e) {
    var n = i(t),
        l = !n && o(t),
        f = !n && !l && a(t),
        p = !n && !l && !f && c(t),
        h = n || l || f || p,
        d = h ? r(t.length, String) : [],
        v = d.length;

    for (var y in t) {
      !e && !u.call(t, y) || h && ("length" == y || f && ("offset" == y || "parent" == y) || p && ("buffer" == y || "byteLength" == y || "byteOffset" == y) || s(y, v)) || d.push(y);
    }

    return d;
  };
}, function (t, e) {
  t.exports = function (t, e) {
    for (var n = -1, r = Array(t); ++n < t;) {
      r[n] = e(n);
    }

    return r;
  };
}, function (t, e) {
  t.exports = function () {
    return !1;
  };
}, function (t, e, n) {
  var r = n(48),
      o = n(92),
      i = n(52),
      a = {};
  a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = !0, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = !1, t.exports = function (t) {
    return i(t) && o(t.length) && !!a[r(t)];
  };
}, function (t, e, n) {
  (function (t) {
    var r = n(102),
        o = "object" == _typeof(e) && e && !e.nodeType && e,
        i = o && "object" == _typeof(t) && t && !t.nodeType && t,
        a = i && i.exports === o && r.process,
        s = function () {
      try {
        var t = i && i.require && i.require("util").types;

        return t || a && a.binding && a.binding("util");
      } catch (t) {}
    }();

    t.exports = s;
  }).call(this, n(180)(t));
}, function (t, e, n) {
  var r = n(269)(Object.keys, Object);
  t.exports = r;
}, function (t, e) {
  t.exports = function (t, e) {
    return function (n) {
      return t(e(n));
    };
  };
}, function (t, e, n) {
  var r = n(49)(n(36), "DataView");
  t.exports = r;
}, function (t, e, n) {
  var r = n(49)(n(36), "Promise");
  t.exports = r;
}, function (t, e, n) {
  var r = n(49)(n(36), "Set");
  t.exports = r;
}, function (t, e, n) {
  var r = n(49)(n(36), "WeakMap");
  t.exports = r;
}, function (t, e, n) {
  var r = n(50);

  t.exports = function (t) {
    return t == t && !r(t);
  };
}, function (t, e) {
  t.exports = function (t, e) {
    return function (n) {
      return null != n && n[t] === e && (void 0 !== e || t in Object(n));
    };
  };
}, function (t, e, n) {
  var r = n(277),
      o = n(174);

  t.exports = function (t, e) {
    for (var n = 0, i = (e = r(e, t)).length; null != t && n < i;) {
      t = t[o(e[n++])];
    }

    return n && n == i ? t : void 0;
  };
}, function (t, e, n) {
  var r = n(42),
      o = n(187),
      i = n(304),
      a = n(307);

  t.exports = function (t, e) {
    return r(t) ? t : o(t, e) ? [t] : i(a(t));
  };
}, function (t, e) {
  var n,
      r,
      o = t.exports = {};

  function i() {
    throw new Error("setTimeout has not been defined");
  }

  function a() {
    throw new Error("clearTimeout has not been defined");
  }

  function s(t) {
    if (n === setTimeout) return setTimeout(t, 0);
    if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);

    try {
      return n(t, 0);
    } catch (e) {
      try {
        return n.call(null, t, 0);
      } catch (e) {
        return n.call(this, t, 0);
      }
    }
  }

  !function () {
    try {
      n = "function" == typeof setTimeout ? setTimeout : i;
    } catch (t) {
      n = i;
    }

    try {
      r = "function" == typeof clearTimeout ? clearTimeout : a;
    } catch (t) {
      r = a;
    }
  }();
  var c,
      u = [],
      l = !1,
      f = -1;

  function p() {
    l && c && (l = !1, c.length ? u = c.concat(u) : f = -1, u.length && h());
  }

  function h() {
    if (!l) {
      var t = s(p);
      l = !0;

      for (var e = u.length; e;) {
        for (c = u, u = []; ++f < e;) {
          c && c[f].run();
        }

        f = -1, e = u.length;
      }

      c = null, l = !1, function (t) {
        if (r === clearTimeout) return clearTimeout(t);
        if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);

        try {
          r(t);
        } catch (e) {
          try {
            return r.call(null, t);
          } catch (e) {
            return r.call(this, t);
          }
        }
      }(t);
    }
  }

  function d(t, e) {
    this.fun = t, this.array = e;
  }

  function v() {}

  o.nextTick = function (t) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
      e[n - 1] = arguments[n];
    }
    u.push(new d(t, e)), 1 !== u.length || l || s(h);
  }, d.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = v, o.addListener = v, o.once = v, o.off = v, o.removeListener = v, o.removeAllListeners = v, o.emit = v, o.prependListener = v, o.prependOnceListener = v, o.listeners = function (t) {
    return [];
  }, o.binding = function (t) {
    throw new Error("process.binding is not supported");
  }, o.cwd = function () {
    return "/";
  }, o.chdir = function (t) {
    throw new Error("process.chdir is not supported");
  }, o.umask = function () {
    return 0;
  };
}, function (t, e, n) {
  t.exports = {
    "c-spinner": "vizzuality__c-spinner",
    "spinner-box": "vizzuality__spinner-box",
    "spinner-icon": "vizzuality__spinner-icon",
    rotate: "vizzuality__rotate",
    "spinner-circle": "vizzuality__spinner-circle",
    dash: "vizzuality__dash",
    color: "vizzuality__color",
    "-absolute": "vizzuality__-absolute",
    "-fixed": "vizzuality__-fixed",
    "-relative": "vizzuality__-relative"
  };
},, function (t, e, n) {
  "use strict";

  var r = function r(t, e, n) {
    t.splice(n < 0 ? t.length + n : n, 0, t.splice(e, 1)[0]);
  },
      o = function o(t, e, n) {
    return t = t.slice(), r(t, e, n), t;
  };

  t.exports = o, t.exports["default"] = o, t.exports.mutate = r;
}, function (t, e, n) {
  var r = n(295),
      o = n(297),
      i = n(324),
      a = n(176),
      s = i(function (t, e) {
    if (null == t) return [];
    var n = e.length;
    return n > 1 && a(t, e[0], e[1]) ? e = [] : n > 2 && a(e[0], e[1], e[2]) && (e = [e[0]]), o(t, r(e, 1), []);
  });
  t.exports = s;
}, function (t, e, n) {
  "use strict";

  n.r(e);
  var r = n(0),
      o = n.n(r);

  e["default"] = function () {
    return o.a.createElement("svg", {
      "aria-hidden": "true",
      style: {
        position: "absolute",
        width: 0,
        height: 0,
        overflow: "hidden"
      }
    }, o.a.createElement("defs", null, o.a.createElement("symbol", {
      id: "icon-pause",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "pause"), o.a.createElement("path", {
      d: "M10.864 4h-5.16c-1.008 0-1.704 0.696-1.704 1.704v20.568c0 1.032 0.696 1.728 1.704 1.728h5.136c1.032 0 1.704-0.696 1.704-1.704v-20.592c0.024-1.008-0.648-1.704-1.68-1.704z"
    }), o.a.createElement("path", {
      d: "M26.296 4h-5.136c-1.032 0-1.704 0.696-1.704 1.704v20.568c0 1.032 0.696 1.704 1.704 1.704h5.136c1.032 0 1.704-0.696 1.704-1.704v-20.568c0-1.008-0.696-1.704-1.704-1.704z"
    })), o.a.createElement("symbol", {
      id: "icon-play",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "play"), o.a.createElement("path", {
      d: "M8.827 2.76l19.487 13.24-19.487 13.24z"
    })), o.a.createElement("symbol", {
      id: "icon-external",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "external"), o.a.createElement("path", {
      d: "M22.068 5.818h-4.613v-5.818h14.545v14.545h-5.818v-4.613l-11.034 11.034-4.114-4.114 11.034-11.034zM26.182 26.182v-5.818h5.818v11.636h-32v-32h11.636v5.818h-5.818v20.364h20.364z"
    })), o.a.createElement("symbol", {
      id: "icon-search",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "search"), o.a.createElement("path", {
      d: "M29.853 31.869l-7.672-7.45c-2.338 1.879-5.297 3.010-8.518 3.010-7.534 0-13.662-6.152-13.662-13.713 0-7.563 6.129-13.716 13.662-13.716s13.662 6.153 13.662 13.716c0 3.232-1.126 6.202-2.997 8.549l7.672 7.45-2.147 2.155zM3.035 13.716c0 5.88 4.766 10.665 10.627 10.665 5.859 0 10.627-4.785 10.627-10.665 0-5.882-4.768-10.668-10.627-10.668-5.861 0-10.627 4.786-10.627 10.668z"
    })), o.a.createElement("symbol", {
      id: "icon-user",
      viewBox: "0 0 29 32"
    }, o.a.createElement("title", null, "user"), o.a.createElement("path", {
      d: "M14.598 14.58c3.245 0 5.87-2.615 5.87-5.835s-2.626-5.835-5.87-5.835c-3.245 0-5.87 2.615-5.87 5.835s2.626 5.835 5.87 5.835zM14.598 17.489c-4.849 0-8.779-3.915-8.779-8.745s3.931-8.745 8.779-8.745c4.849 0 8.779 3.915 8.779 8.745s-3.931 8.745-8.779 8.745zM2.934 31.975l-2.934 0.025v-4.565c0-5.858 6.512-7.071 14.545-7.071s14.545 1.213 14.545 7.071v4.319c-1.956 0.006-2.934 0.006-2.934 0v-4.319c0-2.792-3.364-4.115-11.611-4.115s-11.611 1.323-11.611 4.115v4.54z"
    })), o.a.createElement("symbol", {
      id: "icon-list-mode",
      viewBox: "0 0 37 32"
    }, o.a.createElement("title", null, "list-mode"), o.a.createElement("path", {
      d: "M0 0h36.923v14.769h-36.923v-14.769zM0 17.231h36.923v14.769h-36.923v-14.769z"
    })), o.a.createElement("symbol", {
      id: "icon-cross",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "cross"), o.a.createElement("path", {
      d: "M16 11.636l-11.636-11.636-4.364 4.364 11.636 11.636-11.636 11.636 4.364 4.364 11.636-11.636 11.636 11.636 4.364-4.364-11.636-11.636 11.636-11.636-4.364-4.364z"
    })), o.a.createElement("symbol", {
      id: "icon-layers",
      viewBox: "0 0 34 32"
    }, o.a.createElement("title", null, "layers"), o.a.createElement("path", {
      d: "M29.995 17.712l4.29 2.859-17.143 11.429-17.136-11.429 4.286-2.857 12.855 8.571 12.85-8.574zM34.281 11.429l-17.136 11.429-17.145-11.429 17.143-11.429 17.138 11.429z"
    })), o.a.createElement("symbol", {
      id: "icon-opacity",
      viewBox: "0 0 29 32"
    }, o.a.createElement("title", null, "opacity"), o.a.createElement("path", {
      d: "M29.333 7.92c-0.761-1.345-1.646-2.503-2.667-3.526l0 0v23.211c1.040-1.040 1.939-2.224 2.667-3.525v-16.16zM21.333 0.88c-0.752-0.308-1.646-0.577-2.569-0.762l-0.098-0.016v31.797c0.92-0.179 1.813-0.443 2.667-0.779v-30.24zM13.333 32c-7.547-1.181-13.333-7.893-13.333-16s5.787-14.819 13.333-16v32z"
    })), o.a.createElement("symbol", {
      id: "icon-hide",
      viewBox: "0 0 47 32"
    }, o.a.createElement("title", null, "hide"), o.a.createElement("path", {
      d: "M17.149 16c-0.002 0.056-0.003 0.122-0.003 0.189 0 3.384 2.743 6.127 6.127 6.127s6.127-2.743 6.127-6.127c0-0.066-0.001-0.133-0.003-0.198l0 0.010c0.002-0.056 0.003-0.122 0.003-0.189 0-3.384-2.743-6.127-6.127-6.127s-6.127 2.743-6.127 6.127c0 0.066 0.001 0.133 0.003 0.198l-0-0.010zM46.545 16c-4.46-7.948-13.204-16-23.273-16-10.045 0-18.813 8.052-23.273 16 4.46 7.948 13.228 16 23.273 16 10.068 0 18.813-8.052 23.273-16zM23.273 4.922c6.080 0 11.025 4.96 11.025 11.078s-4.945 11.078-11.025 11.078-11.025-4.96-11.025-11.078c0-6.118 4.945-11.078 11.025-11.078z"
    })), o.a.createElement("symbol", {
      id: "icon-show",
      viewBox: "0 0 39 32"
    }, o.a.createElement("title", null, "show"), o.a.createElement("path", {
      d: "M26.905 4.994l5.125-4.994 3.481 3.392-29.356 28.608-3.481-3.392 4.076-3.973c-2.675-2.25-4.921-4.902-6.672-7.88l-0.077-0.142c3.774-6.553 11.193-13.194 19.692-13.194 2.523 0 4.948 0.583 7.212 1.575zM11.168 20.33l3.36-3.274c-0.011-0.125-0.017-0.271-0.017-0.419 0-0.009 0-0.017 0-0.026v0.001c0-2.806 2.306-5.073 5.182-5.073 0.16 0 0.32 0.007 0.475 0.020l3.36-3.274c-1.122-0.507-2.432-0.803-3.812-0.803-0.008 0-0.016 0-0.024 0h0.001c-5.145 0-9.329 4.086-9.329 9.132 0 1.324 0.288 2.58 0.805 3.717zM34.454 10.24c1.876 1.855 3.51 3.948 4.853 6.233l0.077 0.143c-3.774 6.55-11.173 13.194-19.692 13.194-1.656-0.005-3.254-0.245-4.766-0.688l0.121 0.030 3.557-3.466c0.357 0.039 0.721 0.062 1.088 0.062 5.145 0 9.329-4.089 9.329-9.132 0-0.345-0.020-0.689-0.059-1.022l5.492-5.354z"
    })), o.a.createElement("symbol", {
      id: "icon-item-unknown",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "item-unknown"), o.a.createElement("path", {
      d: "M13.692 29.77v-7.266c0-0.56 0.035-1.127 0.105-1.701s0.189-1.099 0.357-1.575c-0.364 0.392-0.77 0.742-1.218 1.050s-0.924 0.616-1.428 0.924l-6.132 3.57-3.024-4.998 6.132-3.57c0.532-0.308 1.064-0.574 1.596-0.798s1.078-0.392 1.638-0.504c-0.56-0.112-1.106-0.287-1.638-0.525s-1.064-0.511-1.596-0.819l-6.132-3.654 3.024-5.040 6.132 3.696c0.504 0.308 0.987 0.623 1.449 0.945s0.875 0.679 1.239 1.071c-0.336-0.952-0.504-2.030-0.504-3.234v-7.35h6.132v7.266c0 0.588-0.035 1.162-0.105 1.722s-0.189 1.092-0.357 1.596c0.364-0.392 0.77-0.749 1.218-1.071s0.924-0.637 1.428-0.945l6.132-3.612 3.024 5.040-6.132 3.57c-0.56 0.308-1.106 0.574-1.638 0.798s-1.078 0.392-1.638 0.504c0.56 0.112 1.113 0.287 1.659 0.525s1.085 0.511 1.617 0.819l6.132 3.654-3.024 4.998-6.132-3.654c-0.532-0.308-1.022-0.623-1.47-0.945s-0.868-0.679-1.26-1.071c0.364 0.98 0.546 2.058 0.546 3.234v7.35h-6.132z"
    })), o.a.createElement("symbol", {
      id: "icon-item-date",
      viewBox: "0 0 28 32"
    }, o.a.createElement("title", null, "item-date"), o.a.createElement("path", {
      d: "M21.333 3.556h7.111v28.444h-28.444v-28.444h7.111v-3.556h3.556v3.556h7.111v-3.556h3.556v3.556zM3.556 14.222v14.222h21.333v-14.222h-21.333z"
    })), o.a.createElement("symbol", {
      id: "icon-item-category",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "item-category"), o.a.createElement("path", {
      d: "M0 0h11.2l20.8 20.8-11.2 11.2-20.8-20.8v-11.2zM8 11.2c1.767 0 3.2-1.433 3.2-3.2s-1.433-3.2-3.2-3.2c-1.767 0-3.2 1.433-3.2 3.2s1.433 3.2 3.2 3.2z"
    })), o.a.createElement("symbol", {
      id: "icon-item-number",
      viewBox: "0 0 26 32"
    }, o.a.createElement("title", null, "item-number"), o.a.createElement("path", {
      d: "M17.285 23.514l-1.602 8.486h-2.35c-0.416 0-0.777-0.166-1.082-0.499s-0.458-0.742-0.458-1.227c0-0.069 0.003-0.135 0.010-0.198s0.017-0.128 0.031-0.198l1.227-6.365h-4.264l-1.206 6.614c-0.125 0.666-0.409 1.144-0.853 1.435s-0.936 0.437-1.477 0.437h-2.267l1.581-8.486h-2.392c-0.444 0-0.783-0.107-1.019-0.322s-0.354-0.572-0.354-1.071c0-0.194 0.021-0.416 0.062-0.666l0.27-1.643h3.952l1.082-5.741h-4.451l0.395-2.142c0.097-0.527 0.312-0.919 0.645-1.175s0.874-0.385 1.622-0.385h2.309l1.29-6.698c0.111-0.555 0.367-0.985 0.77-1.29s0.874-0.458 1.414-0.458h2.33l-1.581 8.445h4.243l1.602-8.445h2.288c0.485 0 0.881 0.139 1.186 0.416s0.458 0.631 0.458 1.061c0 0.139-0.007 0.243-0.021 0.312l-1.29 6.656h4.222l-0.395 2.142c-0.097 0.527-0.315 0.919-0.655 1.175s-0.877 0.385-1.612 0.385h-2.080l-1.061 5.741h2.954c0.444 0 0.78 0.107 1.009 0.322s0.343 0.579 0.343 1.092c0 0.194-0.021 0.416-0.062 0.666l-0.25 1.622h-4.514zM9.318 19.811h4.264l1.061-5.741h-4.243l-1.082 5.741z"
    })), o.a.createElement("symbol", {
      id: "icon-logo-cms",
      viewBox: "0 0 193 32"
    }, o.a.createElement("title", null, "logo-cms"), o.a.createElement("path", {
      d: "M46.16 25.987c-0.047 0-0.095 0.021-0.145 0.064-0.111 0.097-0.221 0.18-0.331 0.249s-0.228 0.127-0.355 0.173c-0.127 0.045-0.265 0.079-0.414 0.1s-0.317 0.032-0.504 0.032c-0.307 0-0.593-0.054-0.859-0.162s-0.496-0.265-0.69-0.471c-0.194-0.206-0.348-0.458-0.46-0.756s-0.169-0.638-0.169-1.019c0-0.369 0.056-0.703 0.169-1.002s0.27-0.551 0.471-0.759c0.202-0.207 0.442-0.367 0.721-0.479s0.586-0.168 0.922-0.168c0.187 0 0.352 0.014 0.495 0.040s0.269 0.060 0.377 0.1c0.108 0.040 0.202 0.082 0.28 0.128s0.148 0.088 0.206 0.128c0.058 0.040 0.109 0.073 0.151 0.1s0.083 0.041 0.12 0.041c0.050 0 0.088-0.009 0.114-0.028s0.050-0.042 0.070-0.070l0.276-0.379c-0.26-0.239-0.557-0.428-0.892-0.567s-0.733-0.209-1.194-0.209c-0.467 0-0.895 0.076-1.282 0.228s-0.719 0.366-0.997 0.641c-0.278 0.276-0.493 0.605-0.646 0.989s-0.23 0.806-0.23 1.266c0 0.46 0.072 0.882 0.215 1.266s0.345 0.712 0.605 0.987c0.26 0.274 0.574 0.487 0.942 0.639s0.779 0.228 1.231 0.228c0.517 0 0.959-0.081 1.326-0.243s0.678-0.388 0.936-0.678l-0.333-0.354c-0.038-0.037-0.080-0.055-0.127-0.055zM53.362 24.197c0 0.457-0.075 0.877-0.223 1.259s-0.359 0.711-0.631 0.987c-0.272 0.276-0.598 0.489-0.979 0.641s-0.803 0.228-1.264 0.228c-0.462 0-0.882-0.076-1.262-0.228s-0.706-0.366-0.977-0.641c-0.272-0.276-0.482-0.605-0.631-0.987s-0.223-0.802-0.223-1.259c0-0.457 0.075-0.877 0.223-1.259s0.359-0.712 0.631-0.989c0.272-0.277 0.597-0.492 0.977-0.646s0.8-0.23 1.262-0.23c0.462 0 0.883 0.077 1.264 0.23s0.708 0.369 0.979 0.646c0.272 0.277 0.482 0.607 0.631 0.989s0.223 0.802 0.223 1.259zM52.49 24.197c0-0.375-0.053-0.712-0.158-1.010s-0.254-0.55-0.447-0.756c-0.193-0.206-0.427-0.364-0.701-0.475s-0.581-0.166-0.92-0.166c-0.336 0-0.641 0.055-0.916 0.166s-0.509 0.269-0.703 0.475c-0.194 0.206-0.344 0.458-0.449 0.756s-0.158 0.635-0.158 1.010c0 0.375 0.053 0.711 0.158 1.008s0.255 0.548 0.449 0.754c0.194 0.206 0.429 0.364 0.703 0.473s0.58 0.164 0.916 0.164c0.339 0 0.646-0.055 0.92-0.164s0.508-0.267 0.701-0.473c0.193-0.206 0.342-0.457 0.447-0.754s0.158-0.633 0.158-1.008zM54.754 21.141h-0.438v6.108h0.745v-4.352c0-0.057-0.001-0.119-0.004-0.188s-0.007-0.138-0.013-0.209l3.633 4.599c0.044 0.054 0.088 0.092 0.134 0.115s0.102 0.034 0.169 0.034h0.429v-6.108h-0.745v4.326c0 0.065 0.001 0.133 0.004 0.202s0.009 0.141 0.018 0.215l-3.637-4.603c-0.047-0.057-0.088-0.094-0.125-0.113s-0.093-0.028-0.169-0.028zM65.011 21.141h-4.917v0.695h2.038v5.413h0.85v-5.413h2.029v-0.695zM69.567 21.141h-3.869v6.108h3.869v-0.673h-3.015v-2.084h2.441v-0.648h-2.441v-2.029h3.015v-0.673zM71.020 21.141h-0.438v6.108h0.745v-4.352c0-0.057-0.001-0.119-0.004-0.188s-0.007-0.138-0.013-0.209l3.633 4.599c0.044 0.054 0.088 0.092 0.134 0.115s0.102 0.034 0.169 0.034h0.429v-6.108h-0.745v4.326c0 0.065 0.001 0.133 0.004 0.202s0.009 0.141 0.018 0.215l-3.637-4.603c-0.047-0.057-0.088-0.094-0.125-0.113s-0.093-0.028-0.169-0.028zM81.277 21.141h-4.917v0.695h2.038v5.413h0.85v-5.413h2.029v-0.695zM86.536 25.041l-2.169-3.759c-0.038-0.065-0.077-0.105-0.118-0.119s-0.099-0.021-0.175-0.021h-0.627v6.108h0.745v-4.488c0-0.060-0.002-0.125-0.007-0.196s-0.011-0.143-0.020-0.217l2.2 3.832c0.073 0.128 0.175 0.192 0.307 0.192h0.123c0.131 0 0.234-0.064 0.307-0.192l2.152-3.819c-0.006 0.071-0.010 0.141-0.013 0.209s-0.004 0.132-0.004 0.192v4.488h0.745v-6.108h-0.627c-0.076 0-0.134 0.007-0.175 0.021s-0.080 0.054-0.118 0.119l-2.125 3.755c-0.041 0.074-0.077 0.147-0.11 0.22s-0.063 0.148-0.092 0.228c-0.029-0.077-0.059-0.153-0.090-0.228s-0.066-0.147-0.107-0.215zM96.469 27.249h-0.657c-0.076 0-0.137-0.018-0.184-0.055s-0.082-0.084-0.105-0.141l-0.587-1.475h-2.818l-0.587 1.475c-0.020 0.051-0.055 0.097-0.105 0.136s-0.111 0.060-0.184 0.060h-0.657l2.511-6.108h0.863l2.511 6.108zM92.354 24.981h2.344l-0.986-2.485c-0.064-0.153-0.127-0.345-0.188-0.575-0.032 0.116-0.064 0.224-0.094 0.322s-0.061 0.184-0.090 0.258l-0.986 2.48zM97.492 21.141h-0.438v6.108h0.745v-4.352c0-0.057-0.001-0.119-0.004-0.188s-0.007-0.138-0.013-0.209l3.633 4.599c0.044 0.054 0.088 0.092 0.134 0.115s0.102 0.034 0.169 0.034h0.429v-6.108h-0.745v4.326c0 0.065 0.001 0.133 0.004 0.202s0.009 0.141 0.018 0.215l-3.637-4.603c-0.047-0.057-0.088-0.094-0.125-0.113s-0.093-0.028-0.169-0.028zM108.639 27.249h-0.657c-0.076 0-0.137-0.018-0.184-0.055s-0.082-0.084-0.105-0.141l-0.587-1.475h-2.818l-0.587 1.475c-0.020 0.051-0.055 0.097-0.105 0.136s-0.111 0.060-0.184 0.060h-0.657l2.511-6.108h0.863l2.511 6.108zM104.524 24.981h2.344l-0.986-2.485c-0.064-0.153-0.127-0.345-0.188-0.575-0.032 0.116-0.064 0.224-0.094 0.322s-0.061 0.184-0.090 0.258l-0.986 2.48zM111.84 26.648c-0.339 0-0.649-0.055-0.929-0.166s-0.523-0.271-0.727-0.482c-0.204-0.21-0.363-0.467-0.475-0.769s-0.169-0.647-0.169-1.034c0-0.369 0.054-0.703 0.162-0.999s0.263-0.55 0.465-0.759c0.202-0.209 0.445-0.369 0.732-0.482s0.606-0.168 0.96-0.168c0.242 0 0.452 0.018 0.629 0.055s0.33 0.082 0.46 0.134c0.13 0.053 0.24 0.107 0.331 0.164s0.172 0.105 0.245 0.145c0.055 0.031 0.107 0.047 0.153 0.047 0.079 0 0.143-0.038 0.193-0.115l0.241-0.375c-0.134-0.119-0.279-0.227-0.434-0.322s-0.324-0.176-0.506-0.243c-0.183-0.067-0.38-0.118-0.594-0.153s-0.444-0.053-0.692-0.053c-0.491 0-0.934 0.075-1.33 0.226s-0.733 0.363-1.012 0.637c-0.279 0.274-0.494 0.603-0.644 0.987s-0.226 0.808-0.226 1.274c0 0.46 0.077 0.882 0.23 1.266s0.367 0.712 0.642 0.987c0.275 0.274 0.602 0.487 0.982 0.639s0.798 0.228 1.253 0.228c0.26 0 0.501-0.014 0.723-0.041s0.43-0.068 0.624-0.124c0.194-0.055 0.377-0.124 0.548-0.207s0.335-0.179 0.493-0.29v-2.344h-1.928v0.469c0 0.045 0.017 0.084 0.050 0.115s0.078 0.047 0.134 0.047h0.973v1.347c-0.111 0.057-0.222 0.107-0.333 0.151s-0.229 0.082-0.355 0.113c-0.126 0.031-0.259 0.055-0.401 0.070s-0.297 0.023-0.467 0.023zM119.135 21.141h-3.869v6.108h3.869v-0.673h-3.015v-2.084h2.441v-0.648h-2.441v-2.029h3.015v-0.673zM121.083 24.7h0.644c0.117 0 0.204 0.015 0.263 0.045s0.112 0.079 0.162 0.147l1.63 2.182c0.073 0.116 0.187 0.175 0.342 0.175h0.754l-1.832-2.425c-0.082-0.114-0.175-0.2-0.28-0.26 0.242-0.054 0.459-0.134 0.651-0.239s0.353-0.232 0.486-0.381c0.133-0.149 0.234-0.318 0.305-0.505s0.105-0.389 0.105-0.605c0-0.259-0.045-0.492-0.136-0.701s-0.23-0.387-0.418-0.535c-0.188-0.148-0.427-0.261-0.716-0.339s-0.632-0.117-1.030-0.117h-1.775v6.108h0.846v-2.549zM121.083 24.099v-2.306h0.929c0.488 0 0.855 0.092 1.102 0.277s0.37 0.459 0.37 0.823c0 0.179-0.032 0.342-0.096 0.49s-0.16 0.275-0.287 0.381c-0.127 0.107-0.285 0.189-0.473 0.247s-0.407 0.087-0.655 0.087h-0.89zM50.060 9.551c-0.46 0.624-1.131 1.036-2.016 1.203l3.183 5.349h-3.307l-2.617-5.157h-1.185v5.157h-2.753v-12.693h4.663c0.637 0 1.241 0.079 1.813 0.204s1.072 0.35 1.503 0.641c0.43 0.292 0.772 0.684 1.026 1.177 0.253 0.493 0.38 1.109 0.38 1.846 0 0.892-0.23 1.65-0.69 2.274zM55.131 10.946v2.38h5.899v2.777h-8.652v-12.693h8.259v2.777h-5.506v1.983h5.506v2.777h-5.506zM69.43 9.417c0.43 0.261 0.787 0.612 1.070 1.052s0.424 1.029 0.424 1.766c0 0.701-0.13 1.313-0.389 1.837s-0.61 0.958-1.052 1.302-0.955 0.6-1.538 0.766c-0.583 0.167-1.2 0.25-1.848 0.25-0.814 0-1.568-0.125-2.263-0.374s-1.344-0.654-1.945-1.213l1.962-2.175c0.283 0.38 0.639 0.675 1.070 0.882 0.43 0.209 0.875 0.313 1.335 0.313 0.224 0 0.451-0.027 0.681-0.081s0.436-0.134 0.619-0.241 0.33-0.243 0.442-0.41c0.112-0.167 0.168-0.363 0.168-0.589 0-0.38-0.145-0.68-0.433-0.9s-0.651-0.407-1.087-0.562-0.908-0.309-1.414-0.464c-0.507-0.154-0.979-0.363-1.415-0.624s-0.799-0.607-1.087-1.034c-0.289-0.428-0.433-0.993-0.433-1.694 0-0.678 0.133-1.272 0.398-1.783s0.619-0.939 1.061-1.284c0.442-0.344 0.952-0.603 1.529-0.775s1.173-0.259 1.786-0.259c0.707 0 1.391 0.101 2.051 0.303s1.256 0.541 1.786 1.016l-1.892 2.086c-0.224-0.285-0.528-0.496-0.911-0.633s-0.745-0.205-1.087-0.205c-0.201 0-0.407 0.024-0.619 0.071s-0.413 0.122-0.601 0.223c-0.188 0.101-0.342 0.235-0.46 0.401s-0.177 0.369-0.177 0.606c0 0.381 0.141 0.672 0.424 0.874s0.639 0.374 1.070 0.517c0.43 0.143 0.893 0.285 1.388 0.428s0.958 0.345 1.388 0.607zM83.425 4.914c0.602 0.577 1.070 1.275 1.406 2.096s0.504 1.736 0.504 2.746c0 1.011-0.168 1.926-0.504 2.746s-0.805 1.519-1.406 2.096c-0.601 0.577-1.314 1.019-2.139 1.328s-1.727 0.464-2.705 0.464c-0.978 0-1.88-0.155-2.705-0.464s-1.538-0.752-2.139-1.328-1.070-1.275-1.406-2.096c-0.335-0.82-0.504-1.735-0.504-2.746s0.168-1.926 0.504-2.746c0.336-0.821 0.805-1.519 1.406-2.096s1.314-1.019 2.139-1.329c0.825-0.309 1.727-0.464 2.705-0.464s1.88 0.155 2.705 0.464c0.825 0.309 1.538 0.752 2.139 1.329zM94.459 11.094v-7.684h2.753v7.791c0 0.749-0.076 1.439-0.299 2.069s-0.52 1.177-0.962 1.641c-0.442 0.464-0.996 0.826-1.656 1.088s-1.425 0.392-2.285 0.392c-0.872 0-1.647-0.131-2.307-0.392s-1.228-0.624-1.67-1.088-0.81-1.011-1.034-1.641c-0.224-0.63-0.405-1.32-0.405-2.069v-7.791h2.753v7.684c0 0.392 0.133 0.755 0.257 1.088s0.369 0.621 0.593 0.865c0.224 0.244 0.491 0.434 0.803 0.571s0.649 0.205 1.015 0.205c0.365 0 0.697-0.068 1.003-0.205s0.563-0.327 0.787-0.571c0.224-0.244 0.38-0.532 0.504-0.865s0.151-0.696 0.151-1.088zM108.233 9.551c-0.46 0.624-1.131 1.036-2.016 1.203l3.183 5.349h-3.307l-2.617-5.157h-1.545v5.157h-2.753v-12.693h5.022c0.637 0 1.241 0.079 1.813 0.204s1.073 0.35 1.503 0.641c0.43 0.292 0.772 0.684 1.026 1.177 0.253 0.493 0.38 1.109 0.38 1.846 0 0.892-0.23 1.65-0.689 2.274zM117.569 13.465c0.436-0.238 0.796-0.57 1.079-0.998l2.299 1.73c-0.531 0.749-1.203 1.302-2.016 1.659s-1.651 0.535-2.511 0.535c-0.978 0-1.88-0.155-2.705-0.464s-1.538-0.752-2.139-1.328-1.070-1.275-1.406-2.096c-0.335-0.82-0.504-1.735-0.504-2.746s0.168-1.926 0.504-2.746c0.336-0.821 0.805-1.519 1.406-2.096s1.314-1.019 2.139-1.329c0.825-0.309 1.727-0.464 2.705-0.464 0.354 0 0.722 0.033 1.105 0.098s0.76 0.17 1.131 0.312c0.372 0.142 0.728 0.333 1.070 0.571s0.648 0.529 0.919 0.874l-2.122 1.748c-0.271-0.333-0.604-0.588-0.999-0.767s-0.852-0.267-1.371-0.267-0.999 0.101-1.441 0.303c-0.442 0.203-0.825 0.485-1.149 0.847s-0.578 0.794-0.76 1.293c-0.183 0.499-0.274 1.040-0.274 1.623 0 0.595 0.091 1.139 0.274 1.632s0.433 0.921 0.752 1.284c0.318 0.363 0.692 0.645 1.122 0.847s0.893 0.303 1.388 0.303c0.566 0 1.067-0.119 1.503-0.357zM124.742 10.946v2.38h6.293v2.777h-9.046v-12.693h8.652v2.777h-5.899v1.983h5.506v2.777h-5.506zM147.468 3.41h1.203l-3.643 12.693h-1.432l-3.165-11.107h-0.035l-3.165 11.107h-1.432l-3.642-12.693h1.202l3.112 11.107h0.035l3.165-11.107h1.485l3.165 11.107h0.035l3.112-11.107zM153.833 3.41h1.202l5.269 12.693h-1.308l-1.362-3.57h-6.631l-1.414 3.57h-1.22l5.464-12.693zM160.138 4.599v-1.19h9.832v1.19h-4.326v11.503h-1.18v-11.503h-4.326zM179.878 14.241c0.295-0.244 0.555-0.537 0.778-0.883l0.954 0.731c-0.601 0.821-1.297 1.409-2.086 1.766s-1.645 0.535-2.564 0.535c-0.954 0-1.83-0.164-2.626-0.49s-1.476-0.785-2.042-1.373c-0.566-0.589-1.008-1.29-1.326-2.105s-0.477-1.703-0.477-2.666c0-0.963 0.159-1.849 0.477-2.657s0.761-1.507 1.326-2.096c0.566-0.588 1.247-1.049 2.042-1.382s1.671-0.499 2.626-0.499c0.849 0 1.642 0.152 2.378 0.455s1.382 0.812 1.936 1.525l-0.955 0.803c-0.389-0.594-0.887-1.028-1.494-1.302-0.608-0.273-1.229-0.41-1.866-0.41-0.813 0-1.547 0.143-2.201 0.428s-1.211 0.678-1.671 1.177c-0.46 0.499-0.814 1.088-1.061 1.766s-0.371 1.409-0.371 2.194 0.124 1.516 0.371 2.194c0.248 0.678 0.602 1.266 1.061 1.766s1.017 0.892 1.671 1.177c0.654 0.286 1.388 0.428 2.201 0.428 0.319 0 0.649-0.038 0.99-0.116s0.675-0.196 0.999-0.357 0.634-0.363 0.928-0.607zM191.601 3.41h1.18v12.693h-1.18v-5.95h-7.079v5.95h-1.18v-12.693h1.18v5.553h7.079v-5.553zM10.298 5.647l7.271 7.27-10.299 10.299-7.27-7.27 10.298-10.299zM19.054 11.294l-7.133-7.133 4.161-4.161 7.133 7.133-4.161 4.161zM21.701 26.353l-7.27-7.27 10.299-10.299 7.27 7.27-10.299 10.299zM12.945 20.706l7.133 7.133-4.161 4.161-7.133-7.133 4.161-4.161zM47.665 8.062c0.147-0.19 0.221-0.458 0.221-0.803 0-0.321-0.065-0.577-0.194-0.767s-0.295-0.336-0.495-0.438c-0.2-0.101-0.43-0.171-0.69-0.207s-0.512-0.057-0.76-0.057h-1.627v2.777h1.45c0.247 0 0.509 0.042 0.787 0.024s0.527-0.020 0.752-0.109c0.223-0.090 0.409-0.229 0.557-0.419zM82.197 11.388c0.182-0.493 0.274-1.037 0.274-1.632 0-0.582-0.092-1.123-0.274-1.623s-0.445-0.93-0.787-1.293c-0.342-0.363-0.752-0.645-1.229-0.847s-1.011-0.303-1.6-0.303c-0.59 0-1.123 0.101-1.6 0.303s-0.887 0.485-1.229 0.847c-0.342 0.363-0.604 0.794-0.787 1.293s-0.274 1.040-0.274 1.623c0 0.595 0.091 1.139 0.274 1.632s0.445 0.921 0.787 1.284c0.342 0.363 0.752 0.645 1.229 0.847s1.011 0.303 1.6 0.303c0.589 0 1.122-0.101 1.6-0.303s0.887-0.485 1.229-0.847c0.342-0.363 0.604-0.791 0.787-1.284zM105.837 8.062c0.147-0.19 0.221-0.458 0.221-0.803 0-0.321-0.065-0.577-0.194-0.767s-0.295-0.336-0.495-0.438c-0.2-0.101-0.43-0.171-0.69-0.207s-0.512-0.057-0.76-0.057h-1.987v2.777h1.81c0.247 0 0.51 0.042 0.787 0.024s0.527-0.020 0.752-0.109c0.223-0.090 0.409-0.229 0.557-0.419zM151.464 11.739h5.747l-2.829-6.919-2.917 6.919z"
    })), o.a.createElement("symbol", {
      id: "icon-arrow-down",
      viewBox: "0 0 38 32"
    }, o.a.createElement("title", null, "arrow-down"), o.a.createElement("path", {
      d: "M22.2 18.636l9.879-9.879 5.121 4.243-18 18-18-18 5.121-4.243 9.879 9.879v-17.636h6v17.636z"
    })), o.a.createElement("symbol", {
      id: "icon-arrow-up",
      viewBox: "0 0 38 32"
    }, o.a.createElement("title", null, "arrow-up"), o.a.createElement("path", {
      d: "M22.2 13.364l9.879 9.879 5.121-4.243-18-18-18 18 5.121 4.243 9.879-9.879v17.636h6v-17.636z"
    })), o.a.createElement("symbol", {
      id: "icon-view-grid",
      viewBox: "0 0 37 32"
    }, o.a.createElement("title", null, "view-grid"), o.a.createElement("path", {
      d: "M4.617 4h12.923v11.077h-12.923v-11.077zM19.386 4h12.923v11.077h-12.923v-11.077zM19.386 16.923h12.923v11.077h-12.923v-11.077zM4.617 16.923h12.923v11.077h-12.923v-11.077z"
    })), o.a.createElement("symbol", {
      id: "icon-view-list",
      viewBox: "0 0 34 32"
    }, o.a.createElement("title", null, "view-list"), o.a.createElement("path", {
      d: "M4.309 4h5.538v5.538h-5.538v-5.538zM13.539 4h16.615v5.538h-16.615v-5.538zM13.539 13.231h16.615v5.538h-16.615v-5.538zM4.309 13.231h5.538v5.538h-5.538v-5.538zM13.539 22.462h16.615v5.538h-16.615v-5.538zM4.309 22.462h5.538v5.538h-5.538v-5.538z"
    })), o.a.createElement("symbol", {
      id: "icon-info",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "info"), o.a.createElement("path", {
      d: "M18.107 14.899v-1.101h-6.603v2.201h2.201v6.603h-2.201v2.201h8.804v-2.201h-2.201v-7.703zM15.906 31.407c-8.509 0-15.407-6.898-15.407-15.407s6.898-15.407 15.407-15.407c8.509 0 15.407 6.898 15.407 15.407s-6.898 15.407-15.407 15.407zM13.705 7.196v4.402h4.402v-4.402h-4.402z"
    })), o.a.createElement("symbol", {
      id: "icon-layers2",
      viewBox: "0 0 34 32"
    }, o.a.createElement("title", null, "layers2"), o.a.createElement("path", {
      d: "M27.616 17.497l3.643 2.503-14.556 10-14.556-10 3.641-2.501 10.916 7.501 10.913-7.503zM31.255 12l-14.553 10-14.56-10 14.56-10 14.553 10z"
    })), o.a.createElement("symbol", {
      id: "icon-metadata",
      viewBox: "0 0 48 32"
    }, o.a.createElement("title", null, "metadata"), o.a.createElement("path", {
      d: "M20.7 7.2h19.8v4.4h-19.8v-4.4zM20.7 20.4h15.4v4.4h-15.4v-4.4zM11.9 13.8c-2.43 0-4.4-1.97-4.4-4.4s1.97-4.4 4.4-4.4c2.43 0 4.4 1.97 4.4 4.4s-1.97 4.4-4.4 4.4zM11.9 27c-2.43 0-4.4-1.97-4.4-4.4s1.97-4.4 4.4-4.4c2.43 0 4.4 1.97 4.4 4.4s-1.97 4.4-4.4 4.4z"
    })), o.a.createElement("symbol", {
      id: "icon-check",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "check"), o.a.createElement("path", {
      d: "M28 6.667q0.573 0 0.953 0.38t0.38 0.953q0 0.563-0.385 0.948l-16 16q-0.385 0.385-0.948 0.385t-0.948-0.385l-8-8q-0.385-0.385-0.385-0.948 0-0.573 0.38-0.953t0.953-0.38q0.563 0 0.948 0.385l7.052 7.063 15.052-15.063q0.385-0.385 0.948-0.385z"
    })), o.a.createElement("symbol", {
      id: "icon-drag-dots",
      viewBox: "0 0 19 32"
    }, o.a.createElement("title", null, "drag-dots"), o.a.createElement("path", {
      d: "M3.2 12.8c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z"
    }), o.a.createElement("path", {
      d: "M16 12.8c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z"
    }), o.a.createElement("path", {
      d: "M3.2 0c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z"
    }), o.a.createElement("path", {
      d: "M16 0c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z"
    }), o.a.createElement("path", {
      d: "M3.2 25.6c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z"
    }), o.a.createElement("path", {
      d: "M16 25.6c1.767 0 3.2 1.433 3.2 3.2s-1.433 3.2-3.2 3.2c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2z"
    })), o.a.createElement("symbol", {
      id: "icon-twitter",
      viewBox: "0 0 33 32"
    }, o.a.createElement("title", null, "twitter"), o.a.createElement("path", {
      d: "M26.446 8.727c1.058-0.793 1.851-1.851 2.38-2.909-1.058 0.529-2.116 1.058-3.438 1.322-1.058-1.322-2.38-1.851-3.967-1.851-2.909 0-5.289 2.38-5.289 5.289 0 0.529 0 0.793 0.264 1.322-4.76-0.264-8.727-2.38-11.372-5.554-0.529 0.793-0.793 1.587-0.793 2.645 0 1.851 1.058 3.438 2.38 4.496-0.793 0-1.587-0.264-2.38-0.793 0 0 0 0 0 0 0 2.645 1.851 4.76 4.231 5.289-0.264 0.264-0.793 0.529-1.322 0.529-0.264 0-0.793 0-1.058 0 0.793 2.116 2.645 3.702 5.025 3.702-1.851 1.322-3.967 2.116-6.612 2.116-0.529 0-0.793 0-1.322 0 2.38 1.587 5.289 2.38 8.198 2.38 10.050 0 15.339-8.198 15.339-15.339 0-0.264 0-0.529 0-0.793 1.058-0.793 1.851-1.851 2.645-2.909-0.793 0.529-1.851 0.793-2.909 1.058z"
    })), o.a.createElement("symbol", {
      id: "icon-facebook",
      viewBox: "0 0 33 32"
    }, o.a.createElement("title", null, "facebook"), o.a.createElement("path", {
      d: "M22.155 11.352h-3.983v-2.656c0-0.885 0.443-1.328 0.885-1.328h2.656v-4.426l-3.541-0.443c-4.426 0-5.311 3.541-5.311 5.754v3.098h-2.656v4.869h2.656v13.279h5.311v-13.279h3.541l0.443-4.869z"
    })), o.a.createElement("symbol", {
      id: "icon-linkedin",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "linkedin"), o.a.createElement("path", {
      d: "M12 9h5.535v2.837h0.079c0.77-1.381 2.655-2.837 5.464-2.837 5.842 0 6.922 3.637 6.922 8.367v9.633h-5.769v-8.54c0-2.037-0.042-4.657-3.001-4.657-3.005 0-3.463 2.218-3.463 4.509v8.688h-5.767v-18z"
    }), o.a.createElement("path", {
      d: "M2 9h6v18h-6v-18z"
    }), o.a.createElement("path", {
      d: "M8 4c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"
    })), o.a.createElement("symbol", {
      id: "icon-cog",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "cog"), o.a.createElement("path", {
      d: "M29.181 19.070c-1.679-2.908-0.669-6.634 2.255-8.328l-3.145-5.447c-0.898 0.527-1.943 0.829-3.058 0.829-3.361 0-6.085-2.742-6.085-6.125h-6.289c0.008 1.044-0.252 2.103-0.811 3.070-1.679 2.908-5.411 3.897-8.339 2.211l-3.144 5.447c0.905 0.515 1.689 1.268 2.246 2.234 1.676 2.903 0.672 6.623-2.241 8.319l3.145 5.447c0.895-0.522 1.935-0.82 3.044-0.82 3.35 0 6.067 2.725 6.084 6.092h6.289c-0.003-1.034 0.259-2.080 0.811-3.038 1.676-2.903 5.399-3.894 8.325-2.219l3.145-5.447c-0.899-0.515-1.678-1.266-2.232-2.226zM16 22.479c-3.578 0-6.479-2.901-6.479-6.479s2.901-6.479 6.479-6.479c3.578 0 6.479 2.901 6.479 6.479s-2.901 6.479-6.479 6.479z"
    })), o.a.createElement("symbol", {
      id: "icon-info2",
      viewBox: "0 0 13 32"
    }, o.a.createElement("title", null, "info2"), o.a.createElement("path", {
      d: "M10.536 10.806l-3.924 14.082c-0.231 0.693-0.231 1.385-0.231 1.616s0 0.231 0.231 0.462c0 0.231 0.231 0.231 0.462 0.231s0.462 0 0.693-0.231c0.693-0.462 1.385-1.385 2.078-2.77l0.693 0.462c-2.309 3.232-4.386 5.079-6.695 5.079-0.923 0-1.616-0.231-2.078-0.693s-0.693-1.154-0.693-1.847c0-0.462 0-1.154 0.231-1.847l2.77-9.465c0.462-1.154 0.462-1.847 0.462-2.309 0-0.231-0.231-0.462-0.462-0.693s-0.462-0.231-0.923-0.231c-0.231 0-0.462 0-0.693 0l0.231-0.693z"
    }), o.a.createElement("path", {
      d: "M11.459 7.343c-0.462 0.462-1.154 0.923-2.078 0.923-0.693 0-1.385-0.231-2.078-0.923-0.462-0.693-0.693-1.385-0.693-2.078s0.231-1.385 0.923-2.078c0.462-0.462 1.154-0.923 2.078-0.923s1.616 0.231 2.078 0.923c0.462 0.462 0.693 1.154 0.693 2.078 0 0.693-0.231 1.385-0.923 2.078z"
    })), o.a.createElement("symbol", {
      id: "icon-share",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "share"), o.a.createElement("path", {
      d: "M17.254 18.877v6.491l10.622-10.622-10.622-10.622v6.491c-4.721 0.147-13.278 2.213-13.278 13.278v3.836l1.918-3.246c2.508-4.131 5.016-5.459 11.36-5.606z"
    })), o.a.createElement("symbol", {
      id: "icon-logo",
      viewBox: "0 0 194 32"
    }, o.a.createElement("title", null, "logo"), o.a.createElement("path", {
      d: "M50.924 15.615c0.462-0.62 0.694-1.373 0.694-2.258 0-0.732-0.128-1.344-0.382-1.834-0.256-0.49-0.599-0.879-1.032-1.169s-0.936-0.513-1.511-0.637-1.183-0.203-1.823-0.203h-4.69v12.608h2.769v-5.122h1.192l2.632 5.122h3.326l-3.201-5.313c0.89-0.165 1.565-0.575 2.027-1.195v0zM48.514 14.136c-0.148 0.189-0.335 0.327-0.56 0.416-0.226 0.088-0.477 0.091-0.756 0.108s-0.542-0.024-0.791-0.024h-1.459v-2.758h1.637c0.249 0 0.504 0.022 0.764 0.057s0.492 0.106 0.694 0.206c0.201 0.101 0.367 0.246 0.498 0.435s0.195 0.443 0.195 0.762c0 0.343-0.074 0.609-0.222 0.798zM56.024 17.001h5.538v-2.758h-5.538v-1.97h5.538v-2.758h-8.307v12.608h8.703v-2.758h-5.934v-2.364zM70.407 15.482c-0.433-0.26-0.898-0.461-1.396-0.602s-0.964-0.283-1.396-0.425c-0.433-0.142-0.792-0.312-1.076-0.514s-0.427-0.49-0.427-0.868c0-0.236 0.059-0.437 0.178-0.602s0.273-0.298 0.462-0.398c0.19-0.1 0.391-0.174 0.605-0.221s0.421-0.071 0.623-0.071c0.344 0 0.708 0.068 1.093 0.203s0.691 0.346 0.916 0.629l1.903-2.072c-0.533-0.472-1.132-0.809-1.796-1.009s-1.352-0.301-2.063-0.301c-0.616 0-1.215 0.086-1.796 0.257s-1.093 0.428-1.538 0.77c-0.445 0.343-0.801 0.768-1.067 1.276s-0.4 1.098-0.4 1.771c0 0.697 0.145 1.258 0.436 1.683s0.655 0.768 1.094 1.028c0.438 0.26 0.913 0.466 1.423 0.62s0.984 0.307 1.422 0.461 0.803 0.34 1.094 0.558c0.29 0.219 0.436 0.517 0.436 0.894 0 0.225-0.057 0.42-0.169 0.585s-0.261 0.301-0.445 0.407-0.392 0.186-0.623 0.239c-0.231 0.053-0.46 0.080-0.685 0.080-0.462 0-0.91-0.103-1.343-0.31s-0.792-0.498-1.076-0.876l-1.974 2.161c0.604 0.555 1.256 0.957 1.956 1.205s1.458 0.372 2.276 0.372c0.651 0 1.272-0.083 1.858-0.248s1.102-0.419 1.547-0.761 0.797-0.773 1.058-1.294c0.261-0.52 0.391-1.128 0.391-1.824 0-0.732-0.142-1.317-0.427-1.754s-0.643-0.785-1.076-1.045zM84.483 11.009c-0.604-0.573-1.322-1.013-2.152-1.32s-1.737-0.461-2.721-0.461c-0.984 0-1.891 0.154-2.721 0.461s-1.547 0.747-2.152 1.32-1.076 1.266-1.414 2.082c-0.337 0.814-0.507 1.724-0.507 2.728s0.169 1.913 0.507 2.728c0.338 0.815 0.809 1.509 1.414 2.082s1.322 1.013 2.152 1.32c0.83 0.307 1.737 0.461 2.721 0.461s1.891-0.154 2.721-0.461c0.83-0.307 1.547-0.747 2.152-1.32s1.076-1.267 1.415-2.082c0.337-0.814 0.507-1.724 0.507-2.728s-0.169-1.913-0.507-2.728c-0.338-0.815-0.809-1.509-1.415-2.082zM83.247 17.44c-0.184 0.49-0.448 0.915-0.792 1.275s-0.756 0.641-1.236 0.842c-0.48 0.201-1.017 0.301-1.609 0.301s-1.129-0.1-1.61-0.301-0.892-0.481-1.236-0.842c-0.344-0.36-0.608-0.785-0.791-1.275s-0.276-1.030-0.276-1.621c0-0.578 0.092-1.116 0.276-1.612s0.447-0.924 0.791-1.284c0.344-0.36 0.756-0.64 1.236-0.842s1.017-0.301 1.61-0.301c0.593 0 1.129 0.1 1.609 0.301s0.892 0.481 1.236 0.842c0.344 0.361 0.608 0.788 0.792 1.284s0.276 1.033 0.276 1.612c0 0.591-0.092 1.131-0.276 1.621zM95.581 17.147c0 0.39-0.027 0.75-0.151 1.081s-0.282 0.617-0.507 0.859c-0.225 0.242-0.483 0.431-0.792 0.567s-0.642 0.204-1.009 0.204c-0.367 0-0.707-0.068-1.021-0.204s-0.583-0.325-0.808-0.567c-0.225-0.242-0.472-0.528-0.596-0.859s-0.258-0.691-0.258-1.081v-7.633h-2.769v7.739c0 0.744 0.182 1.429 0.407 2.055s0.595 1.169 1.040 1.63 1.016 0.821 1.68 1.080c0.664 0.26 1.443 0.39 2.321 0.39 0.865 0 1.635-0.13 2.299-0.39s1.22-0.62 1.665-1.080c0.445-0.461 0.743-1.004 0.968-1.63s0.301-1.311 0.301-2.055v-7.739h-2.769v7.633zM109.435 15.615c0.462-0.62 0.693-1.373 0.693-2.258 0-0.732-0.128-1.344-0.382-1.834-0.256-0.49-0.599-0.879-1.032-1.169s-0.936-0.513-1.511-0.637-1.182-0.203-1.823-0.203h-5.051v12.608h2.769v-5.122h1.554l2.632 5.122h3.326l-3.201-5.313c0.89-0.165 1.565-0.575 2.028-1.195zM107.025 14.136c-0.148 0.189-0.335 0.327-0.56 0.416-0.226 0.088-0.477 0.091-0.756 0.108s-0.543-0.024-0.792-0.024h-1.82v-2.758h1.998c0.249 0 0.504 0.022 0.764 0.057s0.493 0.106 0.694 0.206c0.201 0.101 0.367 0.246 0.498 0.435s0.195 0.443 0.195 0.762c0 0.343-0.074 0.609-0.222 0.798zM118.825 19.503c-0.439 0.237-0.943 0.355-1.511 0.355-0.498 0-0.964-0.1-1.396-0.301s-0.809-0.481-1.129-0.842c-0.32-0.36-0.572-0.785-0.756-1.275s-0.276-1.030-0.276-1.621c0-0.578 0.092-1.116 0.276-1.612s0.438-0.924 0.765-1.284c0.326-0.36 0.711-0.64 1.156-0.842s0.928-0.301 1.449-0.301 0.981 0.088 1.379 0.265c0.397 0.178 0.732 0.431 1.005 0.762l2.134-1.736c-0.273-0.342-0.581-0.632-0.925-0.868s-0.702-0.426-1.076-0.567c-0.373-0.141-0.753-0.245-1.138-0.31s-0.756-0.097-1.112-0.097c-0.984 0-1.891 0.154-2.721 0.461s-1.547 0.747-2.152 1.32-1.076 1.266-1.414 2.082c-0.337 0.814-0.507 1.724-0.507 2.728s0.169 1.913 0.507 2.728c0.338 0.815 0.809 1.509 1.414 2.082s1.322 1.013 2.152 1.32c0.83 0.307 1.737 0.461 2.721 0.461 0.865 0 1.707-0.177 2.525-0.531s1.494-0.903 2.028-1.648l-2.312-1.718c-0.285 0.425-0.646 0.756-1.085 0.992zM126.040 17.001h5.538v-2.758h-5.538v-1.97h5.934v-2.758h-8.703v12.608h9.098v-2.758h-6.329v-2.364zM148.899 9.515l-3.13 11.032h-0.036l-3.184-11.032h-1.494l-3.183 11.032h-0.036l-3.13-11.032h-1.209l3.663 12.608h1.441l3.184-11.032h0.036l3.184 11.032h1.44l3.664-12.608h-1.21zM155.301 9.515l-5.496 12.608h1.227l1.422-3.546h6.669l1.369 3.546h1.316l-5.3-12.608h-1.209zM152.918 17.789l2.934-6.873 2.846 6.873h-5.78zM161.642 10.697h4.351v11.426h1.187v-11.426h4.351v-1.182h-9.889v1.182zM181.497 20.274c-0.296 0.242-0.608 0.443-0.934 0.602s-0.661 0.278-1.005 0.354c-0.344 0.077-0.676 0.115-0.996 0.115-0.818 0-1.556-0.141-2.214-0.425s-1.218-0.673-1.68-1.169c-0.462-0.496-0.818-1.080-1.068-1.754s-0.373-1.399-0.373-2.179 0.125-1.506 0.373-2.179c0.249-0.673 0.605-1.258 1.068-1.754s1.023-0.886 1.68-1.169c0.658-0.283 1.396-0.425 2.214-0.425 0.64 0 1.265 0.136 1.877 0.407 0.61 0.272 1.111 0.703 1.502 1.293l0.96-0.797c-0.557-0.708-1.207-1.213-1.947-1.515s-1.538-0.451-2.392-0.451c-0.96 0-1.841 0.165-2.641 0.496s-1.485 0.788-2.054 1.373c-0.569 0.585-1.013 1.279-1.334 2.082s-0.48 1.683-0.48 2.639c0 0.956 0.16 1.84 0.48 2.648s0.765 1.506 1.334 2.091c0.569 0.584 1.254 1.039 2.054 1.364s1.681 0.487 2.641 0.487c0.925 0 1.784-0.177 2.579-0.531s1.494-0.939 2.098-1.754l-0.96-0.726c-0.225 0.343-0.487 0.635-0.783 0.877zM193.288 9.515v5.516h-7.12v-5.516h-1.187v12.608h1.187v-5.91h7.12v5.91h1.187v-12.608h-1.187z"
    }), o.a.createElement("path", {
      d: "M10.296 5.764l-10.296 10.256 7.268 7.24 10.297-10.256-7.269-7.24z"
    }), o.a.createElement("path", {
      d: "M19.051 11.387l4.161-4.144-7.131-7.104-4.161 4.144 7.131 7.104z"
    }), o.a.createElement("path", {
      d: "M21.697 26.384l10.297-10.256-7.268-7.24-10.297 10.256 7.268 7.24z"
    }), o.a.createElement("path", {
      d: "M12.943 20.76l-4.16 4.144 7.132 7.104 4.16-4.144-7.132-7.104z"
    })), o.a.createElement("symbol", {
      id: "icon-hash",
      viewBox: "0 0 28 32"
    }, o.a.createElement("title", null, "hash"), o.a.createElement("path", {
      d: "M26.25 12.5v-3.5h-4.378l0.875-7h-3.5l-0.875 7h-6.998l0.875-7h-3.5l-0.875 7h-6.123v3.5h5.686l-0.873 7h-4.813v3.5h4.375l-0.875 7h3.5l0.875-7h6.998l-0.875 7h3.502l0.875-7h6.125v-3.5h-5.688l0.872-7h4.816zM17.061 19.5h-6.998l0.873-7h6.998l-0.873 7z"
    })), o.a.createElement("symbol", {
      id: "icon-type",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "type"), o.a.createElement("path", {
      d: "M26.5 2h-21c-0.483 0-0.875 0.392-0.875 0.875v5.25c0 0.483 0.392 0.875 0.875 0.875h0.875c0.483 0 0.875-0.392 0.875-0.875l1.75-2.625h5.25v21l-4.375 1.75c-0.483 0-0.875 0.391-0.875 0.875s0.392 0.875 0.875 0.875h12.25c0.484 0 0.875-0.391 0.875-0.875s-0.391-0.875-0.875-0.875l-4.375-1.75v-21h5.25l1.75 2.625c0 0.483 0.391 0.875 0.875 0.875h0.875c0.484 0 0.875-0.392 0.875-0.875v-5.25c0-0.483-0.391-0.875-0.875-0.875z"
    })), o.a.createElement("symbol", {
      id: "icon-minus",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "minus"), o.a.createElement("path", {
      d: "M5.5 17.909h20.894v-3.818h-20.894z"
    })), o.a.createElement("symbol", {
      id: "icon-plus",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "plus"), o.a.createElement("path", {
      d: "M13.865 5v8.8h-8.865v4.4h8.865v8.8h4.271v-8.8h8.865v-4.4h-8.865v-8.8z"
    })), o.a.createElement("symbol", {
      id: "icon-filter",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "filter"), o.a.createElement("path", {
      d: "M16 2c-7.732 0-14 1.959-14 4.375v2.625l10.5 10.5v8.75c0 0.966 1.567 1.75 3.5 1.75s3.5-0.784 3.5-1.75v-8.75l10.5-10.5v-2.625c0-2.416-6.268-4.375-14-4.375zM4.581 5.796c0.655-0.373 1.575-0.728 2.66-1.025 2.405-0.658 5.515-1.021 8.759-1.021s6.355 0.363 8.759 1.021c1.085 0.297 2.005 0.652 2.66 1.025 0.432 0.246 0.665 0.455 0.774 0.579-0.109 0.124-0.342 0.333-0.774 0.579-0.655 0.373-1.575 0.728-2.66 1.025-2.405 0.658-5.515 1.021-8.759 1.021s-6.354-0.363-8.759-1.021c-1.085-0.297-2.005-0.652-2.66-1.025-0.432-0.246-0.665-0.455-0.774-0.579 0.109-0.124 0.342-0.333 0.774-0.579z"
    })), o.a.createElement("symbol", {
      id: "icon-star-empty",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "star-empty"), o.a.createElement("path", {
      d: "M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798zM16 23.547l-6.983 3.671 1.334-7.776-5.65-5.507 7.808-1.134 3.492-7.075 3.492 7.075 7.807 1.134-5.65 5.507 1.334 7.776-6.983-3.671z"
    })), o.a.createElement("symbol", {
      id: "icon-star-full",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "star-full"), o.a.createElement("path", {
      d: "M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z"
    })), o.a.createElement("symbol", {
      id: "icon-stop2",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "stop2"), o.a.createElement("path", {
      d: "M4 4h24v24h-24z"
    })), o.a.createElement("symbol", {
      id: "icon-table2",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "table2"), o.a.createElement("path", {
      d: "M0 2v28h32v-28h-32zM12 20v-6h8v6h-8zM20 22v6h-8v-6h8zM20 6v6h-8v-6h8zM10 6v6h-8v-6h8zM2 14h8v6h-8v-6zM22 14h8v6h-8v-6zM22 12v-6h8v6h-8zM2 22h8v6h-8v-6zM22 28v-6h8v6h-8z"
    })), o.a.createElement("symbol", {
      id: "icon-arrow-down-2",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "arrow-down-2"), o.a.createElement("path", {
      d: "M3.75 4.875l12.25 12.25 12.25-12.25 3.75 3.75-16 16-16-16z"
    })), o.a.createElement("symbol", {
      id: "icon-arrow-up-2",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "arrow-up-2"), o.a.createElement("path", {
      d: "M3.75 25.125l-3.75-3.75 16-16 16 16-3.75 3.75-12.25-12.25z"
    })), o.a.createElement("symbol", {
      id: "icon-arrow-left-2",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "arrow-left-2"), o.a.createElement("path", {
      d: "M25.125 3.75l-12.25 12.25 12.25 12.25-3.75 3.75-16-16 16-16z"
    })), o.a.createElement("symbol", {
      id: "icon-arrow-right-2",
      viewBox: "0 0 32 32"
    }, o.a.createElement("title", null, "arrow-right-2"), o.a.createElement("path", {
      d: "M10.625 0l16 16-16 16-3.75-3.75 12.25-12.25-12.25-12.25z"
    }))));
  };
}, function (t, e, n) {
  "use strict";

  n.r(e);
  var r = n(0),
      o = n.n(r),
      i = n(11),
      a = n.n(i),
      s = n(1),
      c = n.n(s),
      u = n(39),
      l = n.n(u),
      f = (n(352), n(212));
  n.d(e, "MapPopup", function () {
    return f.a;
  });
  var p = n(213);
  n.d(e, "MapControls", function () {
    return p.a;
  });
  var h = n(214);
  n.d(e, "ZoomControl", function () {
    return h.a;
  });

  var d = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  },
      v = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }();

  function y(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
  }

  var m,
      g = ("undefined" != typeof window ? window : {}).L;
  "undefined" != typeof window && (m = g && g.GridLayer.prototype._initTile, g && g.GridLayer.include({
    _initTile: function _initTile(t) {
      m.call(this, t);
      var e = this.getTileSize();
      t.style.width = e.x + 1 + "px", t.style.height = e.y + 1 + "px";
    }
  }));

  var b = function (t) {
    function e() {
      var t, n, r;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) {
        i[a] = arguments[a];
      }

      return n = r = y(this, (t = e.__proto__ || Object.getPrototypeOf(e)).call.apply(t, [this].concat(i))), r.events = {}, r.setMap = function () {
        var t = r.props.mapOptions;
        r.map = g.map(r.mapNode, d({}, e.defaultProps.mapOptions, t));
      }, r.setMapOptions = function () {
        var t = r.props.mapOptions,
            e = t.center,
            n = t.zoom;
        r.map.setView(d({}, e), n);
      }, r.setBasemap = function () {
        var t = r.props.basemap;
        r.basemapLayer && r.basemapLayer.remove(), r.basemapLayer = g.tileLayer(t.url, t.options).addTo(r.map).setZIndex(0);
      }, r.setLabel = function () {
        var t = r.props.label;
        r.labelLayer && r.labelLayer.remove(), r.labelLayer = g.tileLayer(t.url, t.options).addTo(r.map).setZIndex(1100);
      }, r.setBounds = function () {
        var t = r.props.bounds,
            e = t.bbox,
            n = t.options;

        if (e) {
          var o = [[e[1], e[0]], [e[3], e[2]]];
          r.map.fitBounds(o, n);
        }
      }, y(r, n);
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, r["Component"]), v(e, [{
      key: "componentDidMount",
      value: function value() {
        if (void 0 !== g && this.mapNode) {
          var t = this.props,
              e = t.interactionEnabled,
              n = t.scrollZoomEnabled,
              r = t.onReady;
          this.setMap(), this.setBasemap(), this.setLabel(), this.setBounds(), this.setEvents(), e || (this.map.dragging.disable(), this.map.touchZoom.disable(), this.map.doubleClickZoom.disable(), this.map.scrollWheelZoom.disable(), this.map.boxZoom.disable(), this.map.keyboard.disable()), n || this.map.scrollWheelZoom.disable(), r(this.map), this.forceUpdate();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function value(t) {
        var e = t.basemap,
            n = t.label,
            r = t.bounds,
            o = t.events,
            i = t.mapOptions,
            a = this.props,
            s = a.basemap,
            c = a.label,
            u = a.bounds,
            f = a.events,
            p = a.mapOptions;
        l()(e, s) || this.setBasemap(), l()(n, c) || this.setLabel(), l()(r, u) || this.setBounds(), l()(o, f) || this.setEvents(), l()(i, p) || this.setMapOptions();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.removeEvents();
      }
    }, {
      key: "setEvents",
      value: function value() {
        var t = this,
            e = this.props.events;
        this.removeEvents(), Object.keys(e).forEach(function (n) {
          t.events[n] = function (r) {
            e[n](r, t.map);
          }, t.map.on(n, t.events[n]);
        });
      }
    }, {
      key: "removeEvents",
      value: function value() {
        var t = this;
        Object.keys(this.events).forEach(function (e) {
          t.map.off(e, t.events[e]);
        });
      }
    }, {
      key: "render",
      value: function value() {
        var t,
            e,
            n,
            r = this,
            i = this.props,
            s = i.customClass,
            c = i.children,
            u = a()((n = !!s, (e = s) in (t = {}) ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t));
        return o.a.createElement("div", {
          className: (u ? u + " " : "") + "vizzuality__c-map"
        }, o.a.createElement("div", {
          ref: function ref(t) {
            r.mapNode = t;
          },
          className: "vizzuality__map-container"
        }), !!this.map && "function" == typeof c && c(this.map));
      }
    }]), e;
  }();

  b.propTypes = {
    children: c.a.func,
    customClass: c.a.string,
    mapOptions: c.a.object,
    basemap: c.a.object,
    label: c.a.object,
    bounds: c.a.object,
    events: c.a.object,
    interactionEnabled: c.a.bool,
    scrollZoomEnabled: c.a.bool,
    onReady: c.a.func
  }, b.defaultProps = {
    children: null,
    customClass: null,
    mapOptions: {
      zoomControl: !1,
      center: [27, 12],
      zoom: 3,
      maxZoom: 20,
      minZoom: 2
    },
    basemap: {
      url: "http://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png",
      options: {
        maxZoom: 20,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }
    },
    label: {
      url: "http://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png",
      options: {
        maxZoom: 20,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }
    },
    bounds: {
      bbox: null,
      options: {}
    },
    events: {},
    interactionEnabled: !0,
    scrollZoomEnabled: !0,
    onReady: function onReady() {}
  }, e["default"] = b;
}, function (t, e, n) {
  "use strict";

  n.r(e);
  var r = n(14),
      o = n.n(r),
      i = n(0),
      a = n.n(i),
      s = n(1),
      c = n.n(s),
      u = n(11),
      l = n.n(u),
      f = n(281),
      p = n.n(f),
      h = n(18),
      d = n(101),
      v = (n(286), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }());

  var y = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var n = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      return n.onScroll = function (t) {
        if ("vizzuality-legend-list" !== t.target.id) return !1;
        var e = n.state.scrolling;
        n.timeout && clearTimeout(n.timeout), n.timeout = setTimeout(function () {
          n.timeout = null, n.setState({
            scrolling: !1
          });
        }, 250), e || n.setState({
          scrolling: !0
        });
      }, n.state = {
        scrolling: !1
      }, n.timeout = null, n;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, i["PureComponent"]), v(e, [{
      key: "render",
      value: function value() {
        var t = this.props,
            e = t.sortable,
            n = t.children,
            r = this.state.scrolling;
        return a.a.createElement("ul", {
          id: "vizzuality-legend-list",
          className: "vizzuality__c-legend-list",
          onScroll: this.onScroll
        }, a.a.Children.map(n, function (t, n) {
          return a.a.cloneElement(t, {
            sortable: e,
            index: n,
            i: n,
            scrolling: r
          });
        }));
      }
    }]), e;
  }();

  y.propTypes = {
    sortable: c.a.bool,
    children: c.a.node
  }, y.defaultProps = {
    sortable: !0,
    children: []
  };

  var m = Object(d.SortableContainer)(y),
      g = (n(288), n(215)),
      b = n(43),
      _ = n(65);

  n.d(e, "LegendListItem", function () {
    return g.a;
  }), n.d(e, "LegendItemToolbar", function () {
    return b.g;
  }), n.d(e, "LegendItemButtonBBox", function () {
    return b.a;
  }), n.d(e, "LegendItemButtonLayers", function () {
    return b.c;
  }), n.d(e, "LegendItemButtonOpacity", function () {
    return b.d;
  }), n.d(e, "LegendItemButtonVisibility", function () {
    return b.f;
  }), n.d(e, "LegendItemButtonInfo", function () {
    return b.b;
  }), n.d(e, "LegendItemButtonRemove", function () {
    return b.e;
  }), n.d(e, "LegendItemTypes", function () {
    return _.e;
  }), n.d(e, "LegendItemTypeBasic", function () {
    return _.a;
  }), n.d(e, "LegendItemTypeChoropleth", function () {
    return _.b;
  }), n.d(e, "LegendItemTypeGradient", function () {
    return _.c;
  }), n.d(e, "LegendItemTypeProportional", function () {
    return _.d;
  });

  var w = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }(),
      x = {
    "./styles.scss": {
      "c-legend-map": "vizzuality__c-legend-map",
      "legend-title": "vizzuality__legend-title",
      "toggle-legend": "vizzuality__toggle-legend",
      "open-legend": "vizzuality__open-legend",
      "-active": "vizzuality__-active",
      "close-legend": "vizzuality__close-legend"
    }
  };

  var O = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var n = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      n.onToggleLegend = function (t) {
        n.setState({
          expanded: t
        });
      }, n.onSortEnd = function (t) {
        var e = t.oldIndex,
            r = t.newIndex,
            o = n.props,
            i = o.onChangeOrder,
            a = o.children,
            s = [].concat(function (t) {
          if (Array.isArray(t)) {
            for (var e = 0, n = Array(t.length); e < t.length; e++) {
              n[e] = t[e];
            }

            return n;
          }

          return Array.from(t);
        }(a.map(function (t) {
          return t.props.layerGroup.dataset;
        })));
        i(p()(s, e, r));
      };
      var r = t.expanded;
      return n.state = {
        expanded: r
      }, n;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, i["PureComponent"]), w(e, [{
      key: "render",
      value: function value() {
        var t = this,
            e = this.props,
            n = e.title,
            r = e.sortable,
            i = e.collapsable,
            s = e.maxWidth,
            c = e.maxHeight,
            u = e.children,
            f = this.state.expanded;
        return u && a.a.Children.count(u) ? a.a.createElement("div", {
          className: "vizzuality__c-legend-map",
          style: {
            maxWidth: s
          }
        }, a.a.createElement("div", {
          style: {
            maxHeight: c
          },
          className: o()("open-legend " + l()({
            "-active": f
          }), x)
        }, i && a.a.createElement("button", {
          type: "button",
          className: "vizzuality__toggle-legend",
          onClick: function onClick() {
            return t.onToggleLegend(!1);
          }
        }, a.a.createElement(h["default"], {
          name: "icon-arrow-down",
          className: "-small"
        })), f && a.a.createElement(m, {
          helperClass: "c-legend-item -sortable",
          onSortStart: function onSortStart(t, e) {
            return e.preventDefault();
          },
          onSortEnd: this.onSortEnd,
          axis: "y",
          lockAxis: "y",
          lockToContainerEdges: !0,
          lockOffset: "50%",
          useDragHandle: !0,
          sortable: r
        }, a.a.Children.map(u, function (t, e) {
          return a.a.isValidElement(t) && "LegendItemList" === t.type ? a.a.cloneElement(t, {
            sortable: r,
            index: e
          }) : t;
        }))), a.a.createElement("button", {
          type: "button",
          onClick: function onClick() {
            return t.onToggleLegend(!0);
          },
          className: o()("close-legend " + l()({
            "-active": !f
          }), x)
        }, a.a.createElement("h1", {
          className: "vizzuality__legend-title"
        }, n, a.a.createElement("div", {
          className: "vizzuality__toggle-legend"
        }, a.a.createElement(h["default"], {
          name: "icon-arrow-up",
          className: "-small"
        }))))) : null;
      }
    }]), e;
  }();

  O.propTypes = {
    title: c.a.string,
    sortable: c.a.bool,
    maxWidth: c.a.oneOfType([c.a.number, c.a.string]),
    maxHeight: c.a.oneOfType([c.a.number, c.a.string]),
    expanded: c.a.bool,
    collapsable: c.a.bool,
    onChangeOrder: c.a.func,
    children: c.a.node
  }, O.defaultProps = {
    title: "Legend",
    sortable: !0,
    expanded: !0,
    collapsable: !0,
    maxWidth: null,
    maxHeight: null,
    children: [],
    onChangeOrder: function onChangeOrder(t) {}
  };
  e["default"] = O;
}, function (t, e, n) {
  t.exports = {
    "c-legend-list": "vizzuality__c-legend-list"
  };
},, function (t, e, n) {
  t.exports = {
    "c-legend-map": "vizzuality__c-legend-map",
    "legend-title": "vizzuality__legend-title",
    "toggle-legend": "vizzuality__toggle-legend",
    "open-legend": "vizzuality__open-legend",
    "-active": "vizzuality__-active",
    "close-legend": "vizzuality__close-legend"
  };
},, function (t, e, n) {
  t.exports = {
    "c-legend-handler": "vizzuality__c-legend-handler"
  };
},, function (t, e, n) {
  t.exports = {
    "c-legend-item": "vizzuality__c-legend-item",
    "legend-item-container": "vizzuality__legend-item-container",
    "-sortable": "vizzuality__-sortable",
    "legend-info": "vizzuality__legend-info",
    "legend-item-header": "vizzuality__legend-item-header",
    "-dark": "vizzuality__-dark",
    category: "vizzuality__category",
    "-sort": "vizzuality__-sort"
  };
},,, function (t, e, n) {
  var r = n(181),
      o = n(296);

  t.exports = function t(e, n, i, a, s) {
    var c = -1,
        u = e.length;

    for (i || (i = o), s || (s = []); ++c < u;) {
      var l = e[c];
      n > 0 && i(l) ? n > 1 ? t(l, n - 1, i, a, s) : r(s, l) : a || (s[s.length] = l);
    }

    return s;
  };
}, function (t, e, n) {
  var r = n(51),
      o = n(105),
      i = n(42),
      a = r ? r.isConcatSpreadable : void 0;

  t.exports = function (t) {
    return i(t) || o(t) || !!(a && t && t[a]);
  };
}, function (t, e, n) {
  var r = n(220),
      o = n(298),
      i = n(315),
      a = n(321),
      s = n(183),
      c = n(322),
      u = n(175);

  t.exports = function (t, e, n) {
    var l = -1;
    e = r(e.length ? e : [u], s(o));
    var f = i(t, function (t, n, o) {
      return {
        criteria: r(e, function (e) {
          return e(t);
        }),
        index: ++l,
        value: t
      };
    });
    return a(f, function (t, e) {
      return c(t, e, n);
    });
  };
}, function (t, e, n) {
  var r = n(299),
      o = n(302),
      i = n(175),
      a = n(42),
      s = n(312);

  t.exports = function (t) {
    return "function" == typeof t ? t : null == t ? i : "object" == _typeof(t) ? a(t) ? o(t[0], t[1]) : r(t) : s(t);
  };
}, function (t, e, n) {
  var r = n(300),
      o = n(301),
      i = n(275);

  t.exports = function (t) {
    var e = o(t);
    return 1 == e.length && e[0][2] ? i(e[0][0], e[0][1]) : function (n) {
      return n === t || r(n, t, e);
    };
  };
}, function (t, e, n) {
  var r = n(182),
      o = n(172),
      i = 1,
      a = 2;

  t.exports = function (t, e, n, s) {
    var c = n.length,
        u = c,
        l = !s;
    if (null == t) return !u;

    for (t = Object(t); c--;) {
      var f = n[c];
      if (l && f[2] ? f[1] !== t[f[0]] : !(f[0] in t)) return !1;
    }

    for (; ++c < u;) {
      var p = (f = n[c])[0],
          h = t[p],
          d = f[1];

      if (l && f[2]) {
        if (void 0 === h && !(p in t)) return !1;
      } else {
        var v = new r();
        if (s) var y = s(h, d, p, t, e, v);
        if (!(void 0 === y ? o(d, h, i | a, s, v) : y)) return !1;
      }
    }

    return !0;
  };
}, function (t, e, n) {
  var r = n(274),
      o = n(173);

  t.exports = function (t) {
    for (var e = o(t), n = e.length; n--;) {
      var i = e[n],
          a = t[i];
      e[n] = [i, a, r(a)];
    }

    return e;
  };
}, function (t, e, n) {
  var r = n(172),
      o = n(303),
      i = n(309),
      a = n(187),
      s = n(274),
      c = n(275),
      u = n(174),
      l = 1,
      f = 2;

  t.exports = function (t, e) {
    return a(t) && s(e) ? c(u(t), e) : function (n) {
      var a = o(n, t);
      return void 0 === a && a === e ? i(n, t) : r(e, a, l | f);
    };
  };
}, function (t, e, n) {
  var r = n(276);

  t.exports = function (t, e, n) {
    var o = null == t ? void 0 : r(t, e);
    return void 0 === o ? n : o;
  };
}, function (t, e, n) {
  var r = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      o = /\\(\\)?/g,
      i = n(305)(function (t) {
    var e = [];
    return 46 === t.charCodeAt(0) && e.push(""), t.replace(r, function (t, n, r, i) {
      e.push(r ? i.replace(o, "$1") : n || t);
    }), e;
  });
  t.exports = i;
}, function (t, e, n) {
  var r = n(306),
      o = 500;

  t.exports = function (t) {
    var e = r(t, function (t) {
      return n.size === o && n.clear(), t;
    }),
        n = e.cache;
    return e;
  };
}, function (t, e, n) {
  var r = n(111),
      o = "Expected a function";

  function i(t, e) {
    if ("function" != typeof t || null != e && "function" != typeof e) throw new TypeError(o);

    var n = function n() {
      var r = arguments,
          o = e ? e.apply(this, r) : r[0],
          i = n.cache;
      if (i.has(o)) return i.get(o);
      var a = t.apply(this, r);
      return n.cache = i.set(o, a) || i, a;
    };

    return n.cache = new (i.Cache || r)(), n;
  }

  i.Cache = r, t.exports = i;
}, function (t, e, n) {
  var r = n(308);

  t.exports = function (t) {
    return null == t ? "" : r(t);
  };
}, function (t, e, n) {
  var r = n(51),
      o = n(220),
      i = n(42),
      a = n(76),
      s = 1 / 0,
      c = r ? r.prototype : void 0,
      u = c ? c.toString : void 0;

  t.exports = function t(e) {
    if ("string" == typeof e) return e;
    if (i(e)) return o(e, t) + "";
    if (a(e)) return u ? u.call(e) : "";
    var n = e + "";
    return "0" == n && 1 / e == -s ? "-0" : n;
  };
}, function (t, e, n) {
  var r = n(310),
      o = n(311);

  t.exports = function (t, e) {
    return null != t && o(t, e, r);
  };
}, function (t, e) {
  t.exports = function (t, e) {
    return null != t && e in Object(t);
  };
}, function (t, e, n) {
  var r = n(277),
      o = n(105),
      i = n(42),
      a = n(100),
      s = n(92),
      c = n(174);

  t.exports = function (t, e, n) {
    for (var u = -1, l = (e = r(e, t)).length, f = !1; ++u < l;) {
      var p = c(e[u]);
      if (!(f = null != t && n(t, p))) break;
      t = t[p];
    }

    return f || ++u != l ? f : !!(l = null == t ? 0 : t.length) && s(l) && a(p, l) && (i(t) || o(t));
  };
}, function (t, e, n) {
  var r = n(313),
      o = n(314),
      i = n(187),
      a = n(174);

  t.exports = function (t) {
    return i(t) ? r(a(t)) : o(t);
  };
}, function (t, e) {
  t.exports = function (t) {
    return function (e) {
      return null == e ? void 0 : e[t];
    };
  };
}, function (t, e, n) {
  var r = n(276);

  t.exports = function (t) {
    return function (e) {
      return r(e, t);
    };
  };
}, function (t, e, n) {
  var r = n(316),
      o = n(72);

  t.exports = function (t, e) {
    var n = -1,
        i = o(t) ? Array(t.length) : [];
    return r(t, function (t, r, o) {
      i[++n] = e(t, r, o);
    }), i;
  };
}, function (t, e, n) {
  var r = n(317),
      o = n(320)(r);
  t.exports = o;
}, function (t, e, n) {
  var r = n(318),
      o = n(173);

  t.exports = function (t, e) {
    return t && r(t, e, o);
  };
}, function (t, e, n) {
  var r = n(319)();
  t.exports = r;
}, function (t, e) {
  t.exports = function (t) {
    return function (e, n, r) {
      for (var o = -1, i = Object(e), a = r(e), s = a.length; s--;) {
        var c = a[t ? s : ++o];
        if (!1 === n(i[c], c, i)) break;
      }

      return e;
    };
  };
}, function (t, e, n) {
  var r = n(72);

  t.exports = function (t, e) {
    return function (n, o) {
      if (null == n) return n;
      if (!r(n)) return t(n, o);

      for (var i = n.length, a = e ? i : -1, s = Object(n); (e ? a-- : ++a < i) && !1 !== o(s[a], a, s);) {
        ;
      }

      return n;
    };
  };
}, function (t, e) {
  t.exports = function (t, e) {
    var n = t.length;

    for (t.sort(e); n--;) {
      t[n] = t[n].value;
    }

    return t;
  };
}, function (t, e, n) {
  var r = n(323);

  t.exports = function (t, e, n) {
    for (var o = -1, i = t.criteria, a = e.criteria, s = i.length, c = n.length; ++o < s;) {
      var u = r(i[o], a[o]);
      if (u) return o >= c ? u : u * ("desc" == n[o] ? -1 : 1);
    }

    return t.index - e.index;
  };
}, function (t, e, n) {
  var r = n(76);

  t.exports = function (t, e) {
    if (t !== e) {
      var n = void 0 !== t,
          o = null === t,
          i = t == t,
          a = r(t),
          s = void 0 !== e,
          c = null === e,
          u = e == e,
          l = r(e);
      if (!c && !l && !a && t > e || a && s && u && !c && !l || o && s && u || !n && u || !i) return 1;
      if (!o && !a && !l && t < e || l && n && i && !o && !a || c && n && i || !s && i || !u) return -1;
    }

    return 0;
  };
}, function (t, e, n) {
  var r = n(175),
      o = n(325),
      i = n(327);

  t.exports = function (t, e) {
    return i(o(t, e, r), t + "");
  };
}, function (t, e, n) {
  var r = n(326),
      o = Math.max;

  t.exports = function (t, e, n) {
    return e = o(void 0 === e ? t.length - 1 : e, 0), function () {
      for (var i = arguments, a = -1, s = o(i.length - e, 0), c = Array(s); ++a < s;) {
        c[a] = i[e + a];
      }

      a = -1;

      for (var u = Array(e + 1); ++a < e;) {
        u[a] = i[a];
      }

      return u[e] = n(c), r(t, this, u);
    };
  };
}, function (t, e) {
  t.exports = function (t, e, n) {
    switch (n.length) {
      case 0:
        return t.call(e);

      case 1:
        return t.call(e, n[0]);

      case 2:
        return t.call(e, n[0], n[1]);

      case 3:
        return t.call(e, n[0], n[1], n[2]);
    }

    return t.apply(e, n);
  };
}, function (t, e, n) {
  var r = n(328),
      o = n(331)(r);
  t.exports = o;
}, function (t, e, n) {
  var r = n(329),
      o = n(330),
      i = n(175),
      a = o ? function (t, e) {
    return o(t, "toString", {
      configurable: !0,
      enumerable: !1,
      value: r(e),
      writable: !0
    });
  } : i;
  t.exports = a;
}, function (t, e) {
  t.exports = function (t) {
    return function () {
      return t;
    };
  };
}, function (t, e, n) {
  var r = n(49),
      o = function () {
    try {
      var t = r(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch (t) {}
  }();

  t.exports = o;
}, function (t, e) {
  var n = 800,
      r = 16,
      o = Date.now;

  t.exports = function (t) {
    var e = 0,
        i = 0;
    return function () {
      var a = o(),
          s = r - (a - i);

      if (i = a, s > 0) {
        if (++e >= n) return arguments[0];
      } else e = 0;

      return t.apply(void 0, arguments);
    };
  };
}, function (t, e, n) {
  t.exports = {
    "c-legend-item-button-layers-tooltip": "vizzuality__c-legend-item-button-layers-tooltip",
    "layers-list": "vizzuality__layers-list",
    "layers-list-item": "vizzuality__layers-list-item",
    "-active": "vizzuality__-active"
  };
},, function (t, e, n) {
  t.exports = {
    "c-legend-item-button-opacity-tooltip": "vizzuality__c-legend-item-button-opacity-tooltip",
    "slider-tooltip-container": "vizzuality__slider-tooltip-container"
  };
},, function (t, e, n) {
  t.exports = {
    "c-legend-item-toolbar": "vizzuality__c-legend-item-toolbar"
  };
},, function (t, e, n) {
  (function (t) {
    var r = Function.prototype.apply;

    function o(t, e) {
      this._id = t, this._clearFn = e;
    }

    e.setTimeout = function () {
      return new o(r.call(setTimeout, window, arguments), clearTimeout);
    }, e.setInterval = function () {
      return new o(r.call(setInterval, window, arguments), clearInterval);
    }, e.clearTimeout = e.clearInterval = function (t) {
      t && t.close();
    }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
      this._clearFn.call(window, this._id);
    }, e.enroll = function (t, e) {
      clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
    }, e.unenroll = function (t) {
      clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
    }, e._unrefActive = e.active = function (t) {
      clearTimeout(t._idleTimeoutId);
      var e = t._idleTimeout;
      e >= 0 && (t._idleTimeoutId = setTimeout(function () {
        t._onTimeout && t._onTimeout();
      }, e));
    }, n(339), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
  }).call(this, n(71));
}, function (t, e, n) {
  (function (t, e) {
    !function (t, n) {
      "use strict";

      if (!t.setImmediate) {
        var r,
            o,
            i,
            a,
            s,
            c = 1,
            u = {},
            l = !1,
            f = t.document,
            p = Object.getPrototypeOf && Object.getPrototypeOf(t);
        p = p && p.setTimeout ? p : t, "[object process]" === {}.toString.call(t.process) ? r = function r(t) {
          e.nextTick(function () {
            d(t);
          });
        } : !function () {
          if (t.postMessage && !t.importScripts) {
            var e = !0,
                n = t.onmessage;
            return t.onmessage = function () {
              e = !1;
            }, t.postMessage("", "*"), t.onmessage = n, e;
          }
        }() ? t.MessageChannel ? ((i = new MessageChannel()).port1.onmessage = function (t) {
          d(t.data);
        }, r = function r(t) {
          i.port2.postMessage(t);
        }) : f && "onreadystatechange" in f.createElement("script") ? (o = f.documentElement, r = function r(t) {
          var e = f.createElement("script");
          e.onreadystatechange = function () {
            d(t), e.onreadystatechange = null, o.removeChild(e), e = null;
          }, o.appendChild(e);
        }) : r = function r(t) {
          setTimeout(d, 0, t);
        } : (a = "setImmediate$" + Math.random() + "$", s = function s(e) {
          e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(a) && d(+e.data.slice(a.length));
        }, t.addEventListener ? t.addEventListener("message", s, !1) : t.attachEvent("onmessage", s), r = function r(e) {
          t.postMessage(a + e, "*");
        }), p.setImmediate = function (t) {
          "function" != typeof t && (t = new Function("" + t));

          for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) {
            e[n] = arguments[n + 1];
          }

          var o = {
            callback: t,
            args: e
          };
          return u[c] = o, r(c), c++;
        }, p.clearImmediate = h;
      }

      function h(t) {
        delete u[t];
      }

      function d(t) {
        if (l) setTimeout(d, 0, t);else {
          var e = u[t];

          if (e) {
            l = !0;

            try {
              !function (t) {
                var e = t.callback,
                    r = t.args;

                switch (r.length) {
                  case 0:
                    e();
                    break;

                  case 1:
                    e(r[0]);
                    break;

                  case 2:
                    e(r[0], r[1]);
                    break;

                  case 3:
                    e(r[0], r[1], r[2]);
                    break;

                  default:
                    e.apply(n, r);
                }
              }(e);
            } finally {
              h(t), l = !1;
            }
          }
        }
      }
    }("undefined" == typeof self ? void 0 === t ? this : t : self);
  }).call(this, n(71), n(278));
}, function (t, e, n) {
  t.exports = {
    "c-legend-item-basic": "vizzuality__c-legend-item-basic",
    name: "vizzuality__name",
    unit: "vizzuality__unit",
    "icon-square": "vizzuality__icon-square",
    "icon-line": "vizzuality__icon-line",
    "icon-circle": "vizzuality__icon-circle",
    "icon-triangle": "vizzuality__icon-triangle",
    "custom-icon": "vizzuality__custom-icon"
  };
},, function (t, e, n) {
  t.exports = {
    "c-legend-type-basic": "vizzuality__c-legend-type-basic",
    columns: "vizzuality__columns",
    horizontal: "vizzuality__horizontal",
    vertical: "vizzuality__vertical",
    "legend-basic-group": "vizzuality__legend-basic-group"
  };
},, function (t, e, n) {
  t.exports = {
    "c-legend-type-choropleth": "vizzuality__c-legend-type-choropleth",
    name: "vizzuality__name",
    "icon-choropleth": "vizzuality__icon-choropleth"
  };
},, function (t, e, n) {
  t.exports = {
    "c-legend-type-gradient": "vizzuality__c-legend-type-gradient",
    name: "vizzuality__name",
    "legend-gradient-icon": "vizzuality__legend-gradient-icon",
    "icon-gradient": "vizzuality__icon-gradient",
    "icon-gradient-transparent": "vizzuality__icon-gradient-transparent"
  };
},, function (t, e, n) {
  t.exports = {
    "c-legend-type-proportional": "vizzuality__c-legend-type-proportional",
    name: "vizzuality__name",
    "icon-proportional": "vizzuality__icon-proportional"
  };
},, function (t, e, n) {
  t.exports = {
    "c-legend-item-types": "vizzuality__c-legend-item-types"
  };
},, function (t, e, n) {
  t.exports = {
    "c-map": "vizzuality__c-map",
    "map-container": "vizzuality__map-container"
  };
},, function (t, e, n) {
  t.exports = {
    "c-map-controls": "vizzuality__c-map-controls",
    "map-controls-list": "vizzuality__map-controls-list",
    "map-controls-list-item": "vizzuality__map-controls-list-item"
  };
},, function (t, e, n) {
  t.exports = {
    "c-zoom-control": "vizzuality__c-zoom-control",
    "zoom-control-btn": "vizzuality__zoom-control-btn",
    "-disabled": "vizzuality__-disabled"
  };
},, function (t, e, n) {
  t.exports = {
    "c-slider": "vizzuality__c-slider",
    "player-btn": "vizzuality__player-btn",
    "timestep-slider": "vizzuality__timestep-slider",
    "can-play": "vizzuality__can-play",
    "c-timestep": "vizzuality__c-timestep",
    rcSliderTooltipZoomDownIn: "vizzuality__rcSliderTooltipZoomDownIn",
    rcSliderTooltipZoomDownOut: "vizzuality__rcSliderTooltipZoomDownOut"
  };
},, function (t, e) {
  var n = ("undefined" != typeof window ? window : {}).L;

  t.exports = function () {
    if (void 0 === n) return !1;
    var t = void 0,
        e = void 0;

    function r(t, e, r, o) {
      e.split(" ").forEach(function (e) {
        n.DomEvent.on(t, e, r, o);
      });
    }

    function o(t, e, r, o) {
      e.split(" ").forEach(function (e) {
        n.DomEvent.off(t, e, r, o);
      });
    }

    function i(t) {
      return "oninput" in t ? "input" : "change";
    }

    function a() {
      t = this._map.dragging.enabled(), e = this._map.tap && this._map.tap.enabled(), this._map.dragging.disable(), this._map.tap && this._map.tap.disable();
    }

    function s(n) {
      this._refocusOnMap(n), t && this._map.dragging.enable(), e && this._map.tap.enable();
    }

    function c(t) {
      return "undefined" === t ? [] : Array.isArray(t) ? t : [t];
    }

    return n.Control.SideBySide = n.Control.extend({
      options: {
        thumbSize: 42,
        padding: 0
      },
      initialize: function initialize(t, e, r) {
        this.setLeftLayers(t), this.setRightLayers(e), n.setOptions(this, r);
      },
      getPosition: function getPosition() {
        var t = this._range.value,
            e = (.5 - t) * (2 * this.options.padding + this.options.thumbSize);
        return this._map.getSize().x * t + e;
      },
      setPosition: function setPosition() {},
      includes: n.Evented.prototype || n.Mixin.Events,
      addTo: function addTo(t) {
        this.remove(), this._map = t;
        var e = this._container = n.DomUtil.create("div", "leaflet-sbs", t._controlContainer);
        this._divider = n.DomUtil.create("div", "leaflet-sbs-divider", e);
        var r = this._range = n.DomUtil.create("input", "leaflet-sbs-range", e);
        return r.type = "range", r.min = 0, r.max = 1, r.step = "any", r.value = .5, r.style.paddingLeft = r.style.paddingRight = this.options.padding + "px", this._addEvents(), this._updateLayers(), this;
      },
      remove: function remove() {
        return this._map ? (this._leftLayer && (this._leftLayer.getContainer().style.clip = ""), this._rightLayer && (this._rightLayer.getContainer().style.clip = ""), this._removeEvents(), n.DomUtil.remove(this._container), this._map = null, this) : this;
      },
      setLeftLayers: function setLeftLayers(t) {
        return this._leftLayers = c(t), this._updateLayers(), this;
      },
      setRightLayers: function setRightLayers(t) {
        return this._rightLayers = c(t), this._updateLayers(), this;
      },
      _updateClip: function _updateClip() {
        var t = this._map,
            e = t.containerPointToLayerPoint([0, 0]),
            n = t.containerPointToLayerPoint(t.getSize()),
            r = e.x + this.getPosition(),
            o = this.getPosition();
        this._divider.style.left = o + "px", this.fire("dividermove", {
          x: o
        });
        var i = "rect(" + [e.y, r, n.y, e.x].join("px,") + "px)",
            a = "rect(" + [e.y, n.x, n.y, r].join("px,") + "px)";
        this._leftLayer && (this._leftLayer.getContainer().style.clip = i), this._rightLayer && (this._rightLayer.getContainer().style.clip = a);
      },
      _updateLayers: function _updateLayers() {
        var t = this;
        if (!this._map) return this;
        var e = this._leftLayer,
            n = this._rightLayer;
        this._leftLayer = this._rightLayer = null, this._leftLayers.forEach(function (e) {
          t._map.hasLayer(e) && (t._leftLayer = e);
        }, this), this._rightLayers.forEach(function (e) {
          t._map.hasLayer(e) && (t._rightLayer = e);
        }, this), e !== this._leftLayer && (e && this.fire("leftlayerremove", {
          layer: e
        }), this._leftLayer && this.fire("leftlayeradd", {
          layer: this._leftLayer
        })), n !== this._rightLayer && (n && this.fire("rightlayerremove", {
          layer: n
        }), this._rightLayer && this.fire("rightlayeradd", {
          layer: this._rightLayer
        })), this._updateClip();
      },
      _addEvents: function _addEvents() {
        var t = this._range,
            e = this._map;
        e && t && (e.on("move", this._updateClip, this), e.on("layeradd layerremove", this._updateLayers, this), r(t, i(t), this._updateClip, this), r(t, n.Browser.touch ? "touchstart" : "mousedown", a, this), r(t, n.Browser.touch ? "touchend" : "mouseup", s, this));
      },
      _removeEvents: function _removeEvents() {
        var t = this._range,
            e = this._map;
        t && (o(t, i(t), this._updateClip, this), o(t, n.Browser.touch ? "touchstart" : "mousedown", a, this), o(t, n.Browser.touch ? "touchend" : "mouseup", s, this)), e && (e.off("layeradd layerremove", this._updateLayers, this), e.off("move", this._updateClip, this));
      }
    }), n.control.sideBySide = function (t, e, r) {
      return new n.Control.SideBySide(t, e, r);
    }, n.Control.SideBySide;
  }();
}, function (t, e, n) {},, function (t, e, n) {
  t.exports = {
    "c-legend-timestep": "vizzuality__c-legend-timestep",
    "-can-play": "vizzuality__-can-play"
  };
},, function (t, e, n) {
  "use strict";

  n.r(e);
  var r = n(18),
      o = n(283),
      i = n(24),
      a = n(177),
      s = n(93),
      c = n(218),
      u = n(284),
      l = n(212),
      f = n(213),
      p = n(214),
      h = n(0),
      d = n.n(h),
      v = n(1),
      y = n.n(v),
      m = (n(360), n(361), function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }());

  var g = ("undefined" != typeof window ? window : {}).L,
      b = function (t) {
    function e() {
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, d.a.PureComponent), m(e, [{
      key: "componentDidMount",
      value: function value() {
        var t = this.props,
            e = t.map,
            n = t.onReady;
        void 0 !== g && e && g.control.sideBySide && "function" == typeof g.control.sideBySide && (this.sideBySideControl = g.control.sideBySide(), this.sideBySideControl.addTo(e), n && n(this.sideBySideControl));
      }
    }, {
      key: "render",
      value: function value() {
        return null;
      }
    }]), e;
  }();

  b.propTypes = {
    map: y.a.object.isRequired,
    onReady: y.a.func.isRequired
  };

  var _ = b,
      w = n(285),
      x = n(215),
      O = n(43),
      E = n(65),
      C = n(14),
      j = n.n(C),
      S = n(39),
      T = n.n(S),
      P = n(11),
      k = n.n(P),
      M = n(104),
      z = n.n(M),
      L = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  };

  function A(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  var R = function R(t, e) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "days",
        r = arguments[3],
        o = z.a.utc(t);
    return r ? o.add(e, n).endOf(n) : o.add(e, n);
  },
      N = function N(t, e, n) {
    return -1 * z.a.utc(e).diff(z.a.utc(t), n);
  },
      F = function F(t, e, n) {
    return Object.keys(t).reduce(function (r, o) {
      return L({}, r, A({}, N(o, e, n), t[o]));
    }, {});
  },
      I = (n(363), Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
      }
    }

    return t;
  }),
      D = function () {
    function t(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    return function (e, n, r) {
      return n && t(e.prototype, n), r && t(e, r), e;
    };
  }(),
      B = {
    "./styles.scss": {
      "c-legend-timestep": "vizzuality__c-legend-timestep",
      "-can-play": "vizzuality__-can-play"
    }
  };

  var V = function (t) {
    function e(t) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var n = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != _typeof(e) && "function" != typeof e ? t : e;
      }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));

      H.call(n);
      var r = t.activeLayer.timelineParams;
      return n.timelineParams = r, n;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + _typeof(e));
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, h["PureComponent"]), D(e, [{
      key: "componentDidUpdate",
      value: function value(t) {
        var e = this.props.activeLayer,
            n = t.activeLayer,
            r = e.timelineParams,
            o = n.timelineParams;
        T()(r, o) || (this.timelineParams = r, this.forceUpdate());
      }
    }, {
      key: "render",
      value: function value() {
        if (!this.timelineParams) return null;
        var t = this.props.defaultStyles,
            e = this.timelineParams,
            n = e.marks,
            r = e.maxDate,
            o = e.maxAbsoluteDate,
            i = e.minDate,
            a = e.minAbsoluteDate,
            s = e.interval,
            u = e.startDate,
            l = e.endDate,
            f = e.trimEndDate,
            p = e.canPlay;
        return d.a.createElement("div", {
          className: j()(k()({
            "c-legend-timestep": !0,
            "-can-play": p
          }), B)
        }, d.a.createElement(c["default"], I({}, this.props, t, this.timelineParams, {
          trackStyle: this.getTrackStyle(),
          min: 0,
          minAbs: N(a || i, i, s),
          max: N(r, i, s),
          maxAbs: N(o || r, i, s),
          start: N(u, i, s),
          end: N(l, i, s),
          trim: N(f, i, s),
          marks: n || function () {
            var t,
                e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                n = e.minDate,
                r = e.maxDate,
                o = e.interval,
                i = e.marks,
                a = e.dateFormat;
            if (i) return Object.keys(i).reduce(function (t, e) {
              if ("string" == typeof e) {
                var r = z.a.utc(e).diff(z.a.utc(n), o);
                return L({}, t, A({}, r, i[e]));
              }

              return L({}, t, A({}, e, i[e]));
            }, {});
            var s = z.a.utc(r).diff(z.a.utc(n), o);
            return A(t = {}, 0, {
              label: z.a.utc(n).format(a)
            }), A(t, s, {
              label: z.a.utc(r).format(a)
            }), t;
          }(this.timelineParams),
          formatValue: this.formatValue,
          handleOnAfterChange: this.handleOnAfterChange
        })));
      }
    }]), e;
  }();

  V.propTypes = {
    defaultStyles: y.a.shape({}),
    activeLayer: y.a.shape({}),
    handleChange: y.a.func.isRequired
  }, V.defaultProps = {
    defaultStyles: {},
    activeLayer: {}
  };

  var H = function H() {
    var t = this;
    this.timelineParams = null, this.getTrackStyle = function () {
      var e = t.timelineParams,
          n = e.minDate,
          r = e.interval,
          o = e.trackStyle;
      if (Array.isArray(o)) return o.map(function (t) {
        var e = (t || {}).gradient;
        return e ? I({}, t, {
          gradient: F(e, n, r)
        }) : t;
      });
      var i = (o || {}).gradient;
      return i ? I({}, o, {
        gradient: F(i, n, r)
      }) : o;
    }, this.handleOnAfterChange = function (e) {
      var n = t.props,
          r = n.activeLayer;
      (0, n.handleChange)(t.formatRange([e[0], e[1], e[2]]), r);
    }, this.formatRange = function (e) {
      var n = t.timelineParams,
          r = n.minDate,
          o = n.interval;
      return e.map(function (t, e) {
        return function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "YYYY-MM-DD";
          return z.a.utc(t).format(e);
        }(R(r, t, o, 0 !== e));
      });
    }, this.formatValue = function (e) {
      var n = t.timelineParams,
          r = n.minDate,
          o = n.dateFormat,
          i = n.interval;
      return function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "YYYY-MM-DD",
            n = z.a.utc(t),
            r = e.includes("DD"),
            o = e.includes("MM"),
            i = n.format("DD"),
            a = n.month(),
            s = n.year();
        return (r ? i + " " : "") + (o ? ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEPT", "OCT", "NOV", "DEC"][a] + " " : "") + s;
      }(R(r, e, i), o);
    };
  },
      U = V;

  n.d(e, "Icon", function () {
    return r["default"];
  }), n.d(e, "Icons", function () {
    return o["default"];
  }), n.d(e, "Tooltip", function () {
    return i["default"];
  }), n.d(e, "Spinner", function () {
    return a["default"];
  }), n.d(e, "Slider", function () {
    return s["default"];
  }), n.d(e, "Timestep", function () {
    return c["default"];
  }), n.d(e, "Map", function () {
    return u["default"];
  }), n.d(e, "MapPopup", function () {
    return l.a;
  }), n.d(e, "MapControls", function () {
    return f.a;
  }), n.d(e, "ZoomControl", function () {
    return p.a;
  }), n.d(e, "MapSideBySide", function () {
    return _;
  }), n.d(e, "Legend", function () {
    return w["default"];
  }), n.d(e, "LegendListItem", function () {
    return x.a;
  }), n.d(e, "LegendItemToolbar", function () {
    return O.g;
  }), n.d(e, "LegendItemButtonBBox", function () {
    return O.a;
  }), n.d(e, "LegendItemButtonLayers", function () {
    return O.c;
  }), n.d(e, "LegendItemButtonOpacity", function () {
    return O.d;
  }), n.d(e, "LegendItemButtonVisibility", function () {
    return O.f;
  }), n.d(e, "LegendItemButtonInfo", function () {
    return O.b;
  }), n.d(e, "LegendItemButtonRemove", function () {
    return O.e;
  }), n.d(e, "LegendItemTypes", function () {
    return E.e;
  }), n.d(e, "LegendItemTypeBasic", function () {
    return E.a;
  }), n.d(e, "LegendItemTypeChoropleth", function () {
    return E.b;
  }), n.d(e, "LegendItemTypeGradient", function () {
    return E.c;
  }), n.d(e, "LegendItemTypeProportional", function () {
    return E.d;
  }), n.d(e, "LegendItemTimeStep", function () {
    return U;
  });
}]);